// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type ClientMeta, formDataBodySerializer, type Options as Options2, type RequestResult, type TDataShape } from './client';
import { client } from './client.gen';
import type { AcceptInviteEndpointApiV1OrganizationInvitesInviteIdAcceptPostData, AcceptInviteEndpointApiV1OrganizationInvitesInviteIdAcceptPostErrors, AcceptInviteEndpointApiV1OrganizationInvitesInviteIdAcceptPostResponses, AddAllowedEmailApiV1AdminAllowedEmailsPostData, AddAllowedEmailApiV1AdminAllowedEmailsPostErrors, AddAllowedEmailApiV1AdminAllowedEmailsPostResponses, AddOrganizationMemberApiV1AdminOrganizationsOrgIdMembersPostData, AddOrganizationMemberApiV1AdminOrganizationsOrgIdMembersPostErrors, AddOrganizationMemberApiV1AdminOrganizationsOrgIdMembersPostResponses, AddPurchaseCreditsApiV1AdminPurchaseWalletsUserIdCreditsPostData, AddPurchaseCreditsApiV1AdminPurchaseWalletsUserIdCreditsPostErrors, AddPurchaseCreditsApiV1AdminPurchaseWalletsUserIdCreditsPostResponses, AddRedactedEntriesEndpointApiV1OrganizationRedactedEntriesPostData, AddRedactedEntriesEndpointApiV1OrganizationRedactedEntriesPostErrors, AddRedactedEntriesEndpointApiV1OrganizationRedactedEntriesPostResponses, AdminTestFullCycleApiV1HotelsTestFullCyclePostData, AdminTestFullCycleApiV1HotelsTestFullCyclePostErrors, AdminTestFullCycleApiV1HotelsTestFullCyclePostResponses, AdoptLegacyDbosWorkflowsApiV1AdminDbosLegacyAdoptionPostData, AdoptLegacyDbosWorkflowsApiV1AdminDbosLegacyAdoptionPostErrors, AdoptLegacyDbosWorkflowsApiV1AdminDbosLegacyAdoptionPostResponses, AgentToolApiV1PhoneElevenlabsToolToolNamePostData, AgentToolApiV1PhoneElevenlabsToolToolNamePostErrors, AgentToolApiV1PhoneElevenlabsToolToolNamePostResponses, AirwallexWebhookApiV1AirwallexWebhookPostData, AirwallexWebhookApiV1AirwallexWebhookPostErrors, AirwallexWebhookApiV1AirwallexWebhookPostResponses, ApolloPhoneWebhookApiV1ApolloWebhookPostData, ApolloPhoneWebhookApiV1ApolloWebhookPostErrors, ApolloPhoneWebhookApiV1ApolloWebhookPostResponses, AppLinkEntryApiV1AuthAppLinkGetData, AppLinkEntryApiV1AuthAppLinkGetErrors, AppLinkEntryApiV1AuthAppLinkGetResponses, ApplyPromotionCodeApiV1BillingPromotionCodePostData, ApplyPromotionCodeApiV1BillingPromotionCodePostErrors, ApplyPromotionCodeApiV1BillingPromotionCodePostResponses, ApprovePendingUserApiV1AdminPendingUsersPendingUserIdApprovePostData, ApprovePendingUserApiV1AdminPendingUsersPendingUserIdApprovePostErrors, ApprovePendingUserApiV1AdminPendingUsersPendingUserIdApprovePostResponses, ApproveSalesLeadApiV1AdminSalesLeadsLeadIdApprovePostData, ApproveSalesLeadApiV1AdminSalesLeadsLeadIdApprovePostErrors, ApproveSalesLeadApiV1AdminSalesLeadsLeadIdApprovePostResponses, ArchiveCustomIntegrationApiV1AdminCustomIntegrationsSpecIdArchivePostData, ArchiveCustomIntegrationApiV1AdminCustomIntegrationsSpecIdArchivePostErrors, ArchiveCustomIntegrationApiV1AdminCustomIntegrationsSpecIdArchivePostResponses, ArmUserProviderSwitchApiV1AdminUsersUserIdProviderSwitchPostData, ArmUserProviderSwitchApiV1AdminUsersUserIdProviderSwitchPostErrors, ArmUserProviderSwitchApiV1AdminUsersUserIdProviderSwitchPostResponses, AuthCallbackApiV1AuthCallbackGetData, AuthCallbackApiV1AuthCallbackGetResponses, AutomaticApprovalsStatusApiV1AutomaticApprovalsGetData, AutomaticApprovalsStatusApiV1AutomaticApprovalsGetResponses, BlockMobileChatIdentifierApiV1AdminMobileChatConversationsChannelIdentifierBlockPostData, BlockMobileChatIdentifierApiV1AdminMobileChatConversationsChannelIdentifierBlockPostErrors, BlockMobileChatIdentifierApiV1AdminMobileChatConversationsChannelIdentifierBlockPostResponses, BookPublicSlotApiV1SchedulingPublicLinkIdBookPostData, BookPublicSlotApiV1SchedulingPublicLinkIdBookPostErrors, BookPublicSlotApiV1SchedulingPublicLinkIdBookPostResponses, BrexWebhookApiV1BrexWebhookPostData, BrexWebhookApiV1BrexWebhookPostErrors, BrexWebhookApiV1BrexWebhookPostResponses, BulkDeleteMessagesApiV1AdminUsersUserIdMessagesBulkDeletePostData, BulkDeleteMessagesApiV1AdminUsersUserIdMessagesBulkDeletePostErrors, BulkDeleteMessagesApiV1AdminUsersUserIdMessagesBulkDeletePostResponses, CancelBookingApiV1HotelsCancelBookingPkPostData, CancelBookingApiV1HotelsCancelBookingPkPostErrors, CancelBookingApiV1HotelsCancelBookingPkPostResponses, CancelOrganizationSubscriptionApiV1AdminOrganizationsOrgIdSubscriptionCancelPostData, CancelOrganizationSubscriptionApiV1AdminOrganizationsOrgIdSubscriptionCancelPostErrors, CancelOrganizationSubscriptionApiV1AdminOrganizationsOrgIdSubscriptionCancelPostResponses, CancelRestorationJobEndpointApiV1AdminRestorationJobsJobIdCancelPostData, CancelRestorationJobEndpointApiV1AdminRestorationJobsJobIdCancelPostErrors, CancelRestorationJobEndpointApiV1AdminRestorationJobsJobIdCancelPostResponses, CastPublicPollVotesApiV1SchedulingPublicLinkIdVotesPostData, CastPublicPollVotesApiV1SchedulingPublicLinkIdVotesPostErrors, CastPublicPollVotesApiV1SchedulingPublicLinkIdVotesPostResponses, ChangeHandleApiV1AssistantEmailHandlePutData, ChangeHandleApiV1AssistantEmailHandlePutErrors, ChangeHandleApiV1AssistantEmailHandlePutResponses, ChangeUserEmailApiV1AdminUsersUserIdEmailPostData, ChangeUserEmailApiV1AdminUsersUserIdEmailPostErrors, ChangeUserEmailApiV1AdminUsersUserIdEmailPostResponses, ChargeSavedMethodApiV1AdminCatchPaidInvoicingItemsItemIdChargeSavedMethodPostData, ChargeSavedMethodApiV1AdminCatchPaidInvoicingItemsItemIdChargeSavedMethodPostErrors, ChargeSavedMethodApiV1AdminCatchPaidInvoicingItemsItemIdChargeSavedMethodPostResponses, CheckoutApiV1BillingCheckoutPostData, CheckoutApiV1BillingCheckoutPostErrors, CheckoutApiV1BillingCheckoutPostResponses, ClearUserHistoryApiV1AdminUsersUserIdClearHistoryPostData, ClearUserHistoryApiV1AdminUsersUserIdClearHistoryPostErrors, ClearUserHistoryApiV1AdminUsersUserIdClearHistoryPostResponses, CliLoginApiV1AuthCliLoginGetData, CliLoginApiV1AuthCliLoginGetErrors, CliLoginApiV1AuthCliLoginGetResponses, CliTokenApiV1AuthCliTokenPostData, CliTokenApiV1AuthCliTokenPostErrors, CliTokenApiV1AuthCliTokenPostResponses, CompleteBookingApiV1HotelsCompleteBookingPostData, CompleteBookingApiV1HotelsCompleteBookingPostErrors, CompleteBookingApiV1HotelsCompleteBookingPostResponses, CompleteSetupApiV1AuthMeCompleteSetupPostData, CompleteSetupApiV1AuthMeCompleteSetupPostResponses, ConnectDiscoveredIntegrationApiV1IntegrationsIntegrationTypeConnectPostData, ConnectDiscoveredIntegrationApiV1IntegrationsIntegrationTypeConnectPostErrors, ConnectDiscoveredIntegrationApiV1IntegrationsIntegrationTypeConnectPostResponses, ConnectEmailAssistantGoogleAuthorizeApiV1AuthConnectEmailAssistantGoogleAuthorizeGetData, ConnectEmailAssistantGoogleAuthorizeApiV1AuthConnectEmailAssistantGoogleAuthorizeGetResponses, ConnectEmailAssistantMicrosoftAuthorizeApiV1AuthConnectEmailAssistantMicrosoftAuthorizeGetData, ConnectEmailAssistantMicrosoftAuthorizeApiV1AuthConnectEmailAssistantMicrosoftAuthorizeGetResponses, ConnectEmailGoogleAuthorizeApiV1AuthConnectEmailGoogleAuthorizeGetData, ConnectEmailGoogleAuthorizeApiV1AuthConnectEmailGoogleAuthorizeGetResponses, ConnectEmailGoogleCallbackApiV1AuthConnectEmailGoogleCallbackGetData, ConnectEmailGoogleCallbackApiV1AuthConnectEmailGoogleCallbackGetErrors, ConnectEmailGoogleCallbackApiV1AuthConnectEmailGoogleCallbackGetResponses, ConnectEmailMicrosoftAuthorizeApiV1AuthConnectEmailMicrosoftAuthorizeGetData, ConnectEmailMicrosoftAuthorizeApiV1AuthConnectEmailMicrosoftAuthorizeGetResponses, ConnectEmailMicrosoftCallbackApiV1AuthConnectEmailMicrosoftCallbackGetData, ConnectEmailMicrosoftCallbackApiV1AuthConnectEmailMicrosoftCallbackGetErrors, ConnectEmailMicrosoftCallbackApiV1AuthConnectEmailMicrosoftCallbackGetResponses, ConnectImapInboxApiV1AuthConnectEmailImapPostData, ConnectImapInboxApiV1AuthConnectEmailImapPostErrors, ConnectImapInboxApiV1AuthConnectEmailImapPostResponses, ConnectInboxApiV1AuthConnectInboxGetData, ConnectInboxApiV1AuthConnectInboxGetErrors, ConnectInboxApiV1AuthConnectInboxGetResponses, ContactLinkOwnerApiV1SchedulingPublicLinkIdContactPostData, ContactLinkOwnerApiV1SchedulingPublicLinkIdContactPostErrors, ContactLinkOwnerApiV1SchedulingPublicLinkIdContactPostResponses, ConversationInitiationApiV1PhoneElevenlabsConversationInitiationPostData, ConversationInitiationApiV1PhoneElevenlabsConversationInitiationPostErrors, ConversationInitiationApiV1PhoneElevenlabsConversationInitiationPostResponses, CreateAdminNoteApiV1AdminUsersUserIdAdminNotesPostData, CreateAdminNoteApiV1AdminUsersUserIdAdminNotesPostErrors, CreateAdminNoteApiV1AdminUsersUserIdAdminNotesPostResponses, CreateAssistantV2PlanStepApiV1AdminUsersUserIdAssistantV2PlanPostData, CreateAssistantV2PlanStepApiV1AdminUsersUserIdAssistantV2PlanPostErrors, CreateAssistantV2PlanStepApiV1AdminUsersUserIdAssistantV2PlanPostResponses, CreateAssistantV2TriggerApiV1AdminUsersUserIdAssistantV2TriggersPostData, CreateAssistantV2TriggerApiV1AdminUsersUserIdAssistantV2TriggersPostErrors, CreateAssistantV2TriggerApiV1AdminUsersUserIdAssistantV2TriggersPostResponses, CreateCustomCharacterApiV1AuthCharactersCustomPostData, CreateCustomCharacterApiV1AuthCharactersCustomPostErrors, CreateCustomCharacterApiV1AuthCharactersCustomPostResponses, CreateCustomIntegrationConnectLinkApiV1AdminCustomIntegrationsSpecIdConnectLinkPostData, CreateCustomIntegrationConnectLinkApiV1AdminCustomIntegrationsSpecIdConnectLinkPostErrors, CreateCustomIntegrationConnectLinkApiV1AdminCustomIntegrationsSpecIdConnectLinkPostResponses, CreateCustomSecretRequestEndpointApiV1IntegrationsCustomSpecIdSecretRequestPostData, CreateCustomSecretRequestEndpointApiV1IntegrationsCustomSpecIdSecretRequestPostErrors, CreateCustomSecretRequestEndpointApiV1IntegrationsCustomSpecIdSecretRequestPostResponses, CreateGenericPipedreamConnectUrlApiV1IntegrationsPipedreamAppsAppSlugConnectTokenPostData, CreateGenericPipedreamConnectUrlApiV1IntegrationsPipedreamAppsAppSlugConnectTokenPostErrors, CreateGenericPipedreamConnectUrlApiV1IntegrationsPipedreamAppsAppSlugConnectTokenPostResponses, CreateIntegrationApiV1WebhooksIntegrationsPostData, CreateIntegrationApiV1WebhooksIntegrationsPostErrors, CreateIntegrationApiV1WebhooksIntegrationsPostResponses, CreateInvitesApiV1OrganizationInvitesPostData, CreateInvitesApiV1OrganizationInvitesPostErrors, CreateInvitesApiV1OrganizationInvitesPostResponses, CreateLinkApiV1SchedulingLinksPostData, CreateLinkApiV1SchedulingLinksPostErrors, CreateLinkApiV1SchedulingLinksPostResponses, CreateOrganizationEndpointApiV1OrganizationPostData, CreateOrganizationEndpointApiV1OrganizationPostErrors, CreateOrganizationEndpointApiV1OrganizationPostResponses, CreatePipedreamConnectUrlApiV1IntegrationsIntegrationTypePipedreamConnectTokenPostData, CreatePipedreamConnectUrlApiV1IntegrationsIntegrationTypePipedreamConnectTokenPostErrors, CreatePipedreamConnectUrlApiV1IntegrationsIntegrationTypePipedreamConnectTokenPostResponses, CreatePrebookApiV1HotelsPrebookPostData, CreatePrebookApiV1HotelsPrebookPostErrors, CreatePrebookApiV1HotelsPrebookPostResponses, CreateRestorationJobApiV1AdminRestorationJobsPostData, CreateRestorationJobApiV1AdminRestorationJobsPostErrors, CreateRestorationJobApiV1AdminRestorationJobsPostResponses, CreateStripePromoCodeApiV1AdminStripePromoCodesPostData, CreateStripePromoCodeApiV1AdminStripePromoCodesPostErrors, CreateStripePromoCodeApiV1AdminStripePromoCodesPostResponses, CreateSystemBroadcastApiV1AdminBroadcastsPostData, CreateSystemBroadcastApiV1AdminBroadcastsPostErrors, CreateSystemBroadcastApiV1AdminBroadcastsPostResponses, CustomOauthCallbackApiV1IntegrationsCustomOauthCallbackGetData, CustomOauthCallbackApiV1IntegrationsCustomOauthCallbackGetErrors, CustomOauthCallbackApiV1IntegrationsCustomOauthCallbackGetResponses, DeactivateMemberApiV1OrganizationMembersUserIdDeactivatePostData, DeactivateMemberApiV1OrganizationMembersUserIdDeactivatePostErrors, DeactivateMemberApiV1OrganizationMembersUserIdDeactivatePostResponses, DeactivateStripePromoCodeApiV1AdminStripePromoCodesPromoCodeIdDeactivatePostData, DeactivateStripePromoCodeApiV1AdminStripePromoCodesPromoCodeIdDeactivatePostErrors, DeactivateStripePromoCodeApiV1AdminStripePromoCodesPromoCodeIdDeactivatePostResponses, DeactivateUserApiV1AdminUsersUserIdDeactivatePostData, DeactivateUserApiV1AdminUsersUserIdDeactivatePostErrors, DeactivateUserApiV1AdminUsersUserIdDeactivatePostResponses, DeclineAutoJoinEndpointApiV1OrganizationAutoJoinDeclinePostData, DeclineAutoJoinEndpointApiV1OrganizationAutoJoinDeclinePostResponses, DeclineInviteEndpointApiV1OrganizationInvitesInviteIdDeclinePostData, DeclineInviteEndpointApiV1OrganizationInvitesInviteIdDeclinePostErrors, DeclineInviteEndpointApiV1OrganizationInvitesInviteIdDeclinePostResponses, DedicatedNumberSmsWebhookApiV1PhoneWebhookDedicatedSmsPostData, DedicatedNumberSmsWebhookApiV1PhoneWebhookDedicatedSmsPostErrors, DedicatedNumberSmsWebhookApiV1PhoneWebhookDedicatedSmsPostResponses, DedicatedNumberStatusApiV1DedicatedNumberGetData, DedicatedNumberStatusApiV1DedicatedNumberGetResponses, DeleteAdminNoteApiV1AdminUsersUserIdAdminNotesNoteIdDeleteData, DeleteAdminNoteApiV1AdminUsersUserIdAdminNotesNoteIdDeleteErrors, DeleteAdminNoteApiV1AdminUsersUserIdAdminNotesNoteIdDeleteResponses, DeleteAllowedEmailApiV1AdminAllowedEmailsEmailIdDeleteData, DeleteAllowedEmailApiV1AdminAllowedEmailsEmailIdDeleteErrors, DeleteAllowedEmailApiV1AdminAllowedEmailsEmailIdDeleteResponses, DeleteAssistantV2MemoryFileApiV1AdminUsersUserIdAssistantV2MemoryPathDeleteData, DeleteAssistantV2MemoryFileApiV1AdminUsersUserIdAssistantV2MemoryPathDeleteErrors, DeleteAssistantV2MemoryFileApiV1AdminUsersUserIdAssistantV2MemoryPathDeleteResponses, DeleteAssistantV2PlanStepApiV1AdminUsersUserIdAssistantV2PlanStepIdDeleteData, DeleteAssistantV2PlanStepApiV1AdminUsersUserIdAssistantV2PlanStepIdDeleteErrors, DeleteAssistantV2PlanStepApiV1AdminUsersUserIdAssistantV2PlanStepIdDeleteResponses, DeleteAutoApprovalPolicyApiV1AdminUsersUserIdAutoApprovalPoliciesPolicyIdDeleteData, DeleteAutoApprovalPolicyApiV1AdminUsersUserIdAutoApprovalPoliciesPolicyIdDeleteErrors, DeleteAutoApprovalPolicyApiV1AdminUsersUserIdAutoApprovalPoliciesPolicyIdDeleteResponses, DeleteCustomCharacterApiV1AuthCharactersCustomDeleteData, DeleteCustomCharacterApiV1AuthCharactersCustomDeleteResponses, DeleteCustomIntegrationEndpointApiV1IntegrationsCustomSpecIdDeleteData, DeleteCustomIntegrationEndpointApiV1IntegrationsCustomSpecIdDeleteErrors, DeleteCustomIntegrationEndpointApiV1IntegrationsCustomSpecIdDeleteResponses, DeleteIntegrationApiV1WebhooksIntegrationsIntegrationIdDeleteData, DeleteIntegrationApiV1WebhooksIntegrationsIntegrationIdDeleteErrors, DeleteIntegrationApiV1WebhooksIntegrationsIntegrationIdDeleteResponses, DeleteLinkApiV1SchedulingLinksLinkIdDeleteData, DeleteLinkApiV1SchedulingLinksLinkIdDeleteErrors, DeleteLinkApiV1SchedulingLinksLinkIdDeleteResponses, DeleteOrganizationSsoApiV1AdminOrganizationsOrgIdSsoDeleteData, DeleteOrganizationSsoApiV1AdminOrganizationsOrgIdSsoDeleteErrors, DeleteOrganizationSsoApiV1AdminOrganizationsOrgIdSsoDeleteResponses, DemoteOrganizationMemberApiV1AdminOrganizationsOrgIdMembersUserIdDemotePostData, DemoteOrganizationMemberApiV1AdminOrganizationsOrgIdMembersUserIdDemotePostErrors, DemoteOrganizationMemberApiV1AdminOrganizationsOrgIdMembersUserIdDemotePostResponses, DetectEmailProviderEndpointApiV1AuthDetectEmailProviderPostData, DetectEmailProviderEndpointApiV1AuthDetectEmailProviderPostErrors, DetectEmailProviderEndpointApiV1AuthDetectEmailProviderPostResponses, DisarmUserProviderSwitchApiV1AdminUsersUserIdProviderSwitchDeleteData, DisarmUserProviderSwitchApiV1AdminUsersUserIdProviderSwitchDeleteErrors, DisarmUserProviderSwitchApiV1AdminUsersUserIdProviderSwitchDeleteResponses, DisconnectConnectedEmailApiV1AuthConnectEmailAccountsAccountIdDeleteData, DisconnectConnectedEmailApiV1AuthConnectEmailAccountsAccountIdDeleteErrors, DisconnectConnectedEmailApiV1AuthConnectEmailAccountsAccountIdDeleteResponses, DisconnectImessageApiV1ImessageDisconnectDeleteData, DisconnectImessageApiV1ImessageDisconnectDeleteErrors, DisconnectImessageApiV1ImessageDisconnectDeleteResponses, DisconnectIntegrationApiV1IntegrationsIntegrationTypeDisconnectDeleteData, DisconnectIntegrationApiV1IntegrationsIntegrationTypeDisconnectDeleteErrors, DisconnectIntegrationApiV1IntegrationsIntegrationTypeDisconnectDeleteResponses, DisconnectPipedreamAppApiV1IntegrationsPipedreamConnectionsConnectionIdDeleteData, DisconnectPipedreamAppApiV1IntegrationsPipedreamConnectionsConnectionIdDeleteErrors, DisconnectPipedreamAppApiV1IntegrationsPipedreamConnectionsConnectionIdDeleteResponses, DisconnectPromotedIntegrationEndpointApiV1IntegrationsPromotedNameDisconnectDeleteData, DisconnectPromotedIntegrationEndpointApiV1IntegrationsPromotedNameDisconnectDeleteErrors, DisconnectPromotedIntegrationEndpointApiV1IntegrationsPromotedNameDisconnectDeleteResponses, DisconnectSlackApiV1SlackDisconnectDeleteData, DisconnectSlackApiV1SlackDisconnectDeleteResponses, DisconnectSlackPersonalApiV1SlackPersonalDisconnectDeleteData, DisconnectSlackPersonalApiV1SlackPersonalDisconnectDeleteResponses, DisconnectSmsApiV1SmsDisconnectDeleteData, DisconnectSmsApiV1SmsDisconnectDeleteResponses, DisconnectUserIntegrationsApiV1AdminUsersUserIdIntegrationsDisconnectPostData, DisconnectUserIntegrationsApiV1AdminUsersUserIdIntegrationsDisconnectPostErrors, DisconnectUserIntegrationsApiV1AdminUsersUserIdIntegrationsDisconnectPostResponses, DisconnectUserPipedreamConnectionApiV1AdminUsersUserIdPipedreamConnectionsConnectionIdDeleteData, DisconnectUserPipedreamConnectionApiV1AdminUsersUserIdPipedreamConnectionsConnectionIdDeleteErrors, DisconnectUserPipedreamConnectionApiV1AdminUsersUserIdPipedreamConnectionsConnectionIdDeleteResponses, DisconnectWhatsappApiV1WhatsappDisconnectDeleteData, DisconnectWhatsappApiV1WhatsappDisconnectDeleteResponses, DisconnectZoomApiV1AuthZoomDisconnectDeleteData, DisconnectZoomApiV1AuthZoomDisconnectDeleteResponses, DismissBroadcastProposalApiV1AdminBroadcastProposalsProposalIdDismissPostData, DismissBroadcastProposalApiV1AdminBroadcastProposalsProposalIdDismissPostErrors, DismissBroadcastProposalApiV1AdminBroadcastProposalsProposalIdDismissPostResponses, DismissContactApiV1ReferralDismissPostData, DismissContactApiV1ReferralDismissPostErrors, DismissContactApiV1ReferralDismissPostResponses, DismissIntegrationSuggestionApiV1IntegrationSuggestionsCatalogKeyDismissPostData, DismissIntegrationSuggestionApiV1IntegrationSuggestionsCatalogKeyDismissPostErrors, DismissIntegrationSuggestionApiV1IntegrationSuggestionsCatalogKeyDismissPostResponses, DispatchEmailCampaignApiV1AdminEmailCampaignsDispatchPostData, DispatchEmailCampaignApiV1AdminEmailCampaignsDispatchPostErrors, DispatchEmailCampaignApiV1AdminEmailCampaignsDispatchPostResponses, DownloadContactCardApiV1DedicatedNumberContactCardGetData, DownloadContactCardApiV1DedicatedNumberContactCardGetResponses, DuffelWebhookApiV1DuffelWebhookPostData, DuffelWebhookApiV1DuffelWebhookPostErrors, DuffelWebhookApiV1DuffelWebhookPostResponses, EnableNumberTextingApiV1AdminDedicatedNumbersNumberIdEnableTextingPostData, EnableNumberTextingApiV1AdminDedicatedNumbersNumberIdEnableTextingPostErrors, EnableNumberTextingApiV1AdminDedicatedNumbersNumberIdEnableTextingPostResponses, EnsurePromotedSpecEndpointApiV1IntegrationsPromotedNameEnsureSpecPostData, EnsurePromotedSpecEndpointApiV1IntegrationsPromotedNameEnsureSpecPostErrors, EnsurePromotedSpecEndpointApiV1IntegrationsPromotedNameEnsureSpecPostResponses, FinalizeReleaseApiV1AdminDedicatedNumbersNumberIdReleasePostData, FinalizeReleaseApiV1AdminDedicatedNumbersNumberIdReleasePostErrors, FinalizeReleaseApiV1AdminDedicatedNumbersNumberIdReleasePostResponses, FinalizeSchedulingPollApiV1SchedulingLinksLinkIdFinalizePostData, FinalizeSchedulingPollApiV1SchedulingLinksLinkIdFinalizePostErrors, FinalizeSchedulingPollApiV1SchedulingLinksLinkIdFinalizePostResponses, GenerateVerificationCodeApiV1ImessageGenerateCodePostData, GenerateVerificationCodeApiV1ImessageGenerateCodePostErrors, GenerateVerificationCodeApiV1ImessageGenerateCodePostResponses, GenerateVerificationCodeApiV1SmsGenerateCodePostData, GenerateVerificationCodeApiV1SmsGenerateCodePostErrors, GenerateVerificationCodeApiV1SmsGenerateCodePostResponses, GenerateVerificationCodeApiV1WhatsappGenerateCodePostData, GenerateVerificationCodeApiV1WhatsappGenerateCodePostResponses, GenericPipedreamConnectCallbackApiV1IntegrationsPipedreamAppsCallbackGetData, GenericPipedreamConnectCallbackApiV1IntegrationsPipedreamAppsCallbackGetErrors, GenericPipedreamConnectCallbackApiV1IntegrationsPipedreamAppsCallbackGetResponses, GetAccountPaymentMethodApiV1AdminCatchPaidInvoicingItemsItemIdAccountPaymentMethodGetData, GetAccountPaymentMethodApiV1AdminCatchPaidInvoicingItemsItemIdAccountPaymentMethodGetErrors, GetAccountPaymentMethodApiV1AdminCatchPaidInvoicingItemsItemIdAccountPaymentMethodGetResponses, GetAddonPricingApiV1AuthConnectEmailAddonPricingGetData, GetAddonPricingApiV1AuthConnectEmailAddonPricingGetResponses, GetAllMessagesApiV1AdminMessagesGetData, GetAllMessagesApiV1AdminMessagesGetErrors, GetAllMessagesApiV1AdminMessagesGetResponses, GetAllowedEmailsApiV1AdminAllowedEmailsGetData, GetAllowedEmailsApiV1AdminAllowedEmailsGetResponses, GetAllUsersApiV1AdminUsersGetData, GetAllUsersApiV1AdminUsersGetErrors, GetAllUsersApiV1AdminUsersGetResponses, GetAssistantEmailStatusApiV1AssistantEmailGetData, GetAssistantEmailStatusApiV1AssistantEmailGetResponses, GetAssistantV2MemoryFileApiV1AdminUsersUserIdAssistantV2MemoryPathGetData, GetAssistantV2MemoryFileApiV1AdminUsersUserIdAssistantV2MemoryPathGetErrors, GetAssistantV2MemoryFileApiV1AdminUsersUserIdAssistantV2MemoryPathGetResponses, GetAssistantV2OverviewApiV1AdminUsersUserIdAssistantV2GetData, GetAssistantV2OverviewApiV1AdminUsersUserIdAssistantV2GetErrors, GetAssistantV2OverviewApiV1AdminUsersUserIdAssistantV2GetResponses, GetAssistantV2PlanApiV1AdminUsersUserIdAssistantV2PlanGetData, GetAssistantV2PlanApiV1AdminUsersUserIdAssistantV2PlanGetErrors, GetAssistantV2PlanApiV1AdminUsersUserIdAssistantV2PlanGetResponses, GetBillingPreviewApiV1AdminCatchPaidInvoicingItemsItemIdBillingPreviewGetData, GetBillingPreviewApiV1AdminCatchPaidInvoicingItemsItemIdBillingPreviewGetErrors, GetBillingPreviewApiV1AdminCatchPaidInvoicingItemsItemIdBillingPreviewGetResponses, GetCalendarEventApiV1CalendarEventsEventIdGetData, GetCalendarEventApiV1CalendarEventsEventIdGetErrors, GetCalendarEventApiV1CalendarEventsEventIdGetResponses, GetCalendarEventsApiV1CalendarEventsGetData, GetCalendarEventsApiV1CalendarEventsGetErrors, GetCalendarEventsApiV1CalendarEventsGetResponses, GetCalendarsApiV1CalendarCalendarsGetData, GetCalendarsApiV1CalendarCalendarsGetErrors, GetCalendarsApiV1CalendarCalendarsGetResponses, GetCatchPaidItemApiV1AdminHotelInvoicingItemsItemIdGetData, GetCatchPaidItemApiV1AdminHotelInvoicingItemsItemIdGetErrors, GetCatchPaidItemApiV1AdminHotelInvoicingItemsItemIdGetResponses, GetCatchPaidSummaryApiV1AdminHotelInvoicingSummaryGetData, GetCatchPaidSummaryApiV1AdminHotelInvoicingSummaryGetResponses, GetCharacterProfilePictureApiV1AuthCharactersCharacterIdPictureGetData, GetCharacterProfilePictureApiV1AuthCharactersCharacterIdPictureGetErrors, GetCharacterProfilePictureApiV1AuthCharactersCharacterIdPictureGetResponses, GetConciergeThreadContextApiV1PublicConciergeTokenGetData, GetConciergeThreadContextApiV1PublicConciergeTokenGetErrors, GetConciergeThreadContextApiV1PublicConciergeTokenGetResponses, GetConnectedCalendarsApiV1CalendarConnectedCalendarsGetData, GetConnectedCalendarsApiV1CalendarConnectedCalendarsGetErrors, GetConnectedCalendarsApiV1CalendarConnectedCalendarsGetResponses, GetContactTextingConsentApiV1ContactTextingGetData, GetContactTextingConsentApiV1ContactTextingGetResponses, GetConversationDetailApiV1AdminConversationsUserIdGetData, GetConversationDetailApiV1AdminConversationsUserIdGetErrors, GetConversationDetailApiV1AdminConversationsUserIdGetResponses, GetConversationsApiV1AdminConversationsGetData, GetConversationsApiV1AdminConversationsGetErrors, GetConversationsApiV1AdminConversationsGetResponses, GetConversationStatisticsApiV1AdminConversationStatisticsGetData, GetConversationStatisticsApiV1AdminConversationStatisticsGetResponses, GetCurrentUserApiV1AuthMeGetData, GetCurrentUserApiV1AuthMeGetResponses, GetCustomIntegrationDetailApiV1AdminCustomIntegrationsSpecIdGetData, GetCustomIntegrationDetailApiV1AdminCustomIntegrationsSpecIdGetErrors, GetCustomIntegrationDetailApiV1AdminCustomIntegrationsSpecIdGetResponses, GetCustomOauthAuthUrlApiV1IntegrationsCustomSpecIdAuthGetData, GetCustomOauthAuthUrlApiV1IntegrationsCustomSpecIdAuthGetErrors, GetCustomOauthAuthUrlApiV1IntegrationsCustomSpecIdAuthGetResponses, GetCustomSecretRequestApiV1IntegrationsCustomSecretRequestTokenGetData, GetCustomSecretRequestApiV1IntegrationsCustomSecretRequestTokenGetErrors, GetCustomSecretRequestApiV1IntegrationsCustomSecretRequestTokenGetResponses, GetDnsInstructionsApiV1AssistantEmailDnsInstructionsGetData, GetDnsInstructionsApiV1AssistantEmailDnsInstructionsGetErrors, GetDnsInstructionsApiV1AssistantEmailDnsInstructionsGetResponses, GetEligibleUsersApiV1OrganizationEligibleUsersGetData, GetEligibleUsersApiV1OrganizationEligibleUsersGetResponses, GetEmailByIdApiV1EmailsMessageIdGetData, GetEmailByIdApiV1EmailsMessageIdGetErrors, GetEmailByIdApiV1EmailsMessageIdGetResponses, GetEmailCampaignAudienceApiV1AdminEmailCampaignsAudiencePostData, GetEmailCampaignAudienceApiV1AdminEmailCampaignsAudiencePostErrors, GetEmailCampaignAudienceApiV1AdminEmailCampaignsAudiencePostResponses, GetEmailCampaignSegmentFieldsApiV1AdminEmailCampaignsSegmentFieldsGetData, GetEmailCampaignSegmentFieldsApiV1AdminEmailCampaignsSegmentFieldsGetResponses, GetEmailCampaignSegmentFieldValuesApiV1AdminEmailCampaignsSegmentFieldValuesPostData, GetEmailCampaignSegmentFieldValuesApiV1AdminEmailCampaignsSegmentFieldValuesPostErrors, GetEmailCampaignSegmentFieldValuesApiV1AdminEmailCampaignsSegmentFieldValuesPostResponses, GetExceptionsApiV1AdminExceptionsGetData, GetExceptionsApiV1AdminExceptionsGetErrors, GetExceptionsApiV1AdminExceptionsGetResponses, GetFlightInvoiceItemApiV1AdminFlightInvoicingItemsItemIdGetData, GetFlightInvoiceItemApiV1AdminFlightInvoicingItemsItemIdGetErrors, GetFlightInvoiceItemApiV1AdminFlightInvoicingItemsItemIdGetResponses, GetFlightOptionsApiV1FlightsOptionsTokenGetData, GetFlightOptionsApiV1FlightsOptionsTokenGetErrors, GetFlightOptionsApiV1FlightsOptionsTokenGetResponses, GetGroupChatApiV1AdminGroupChatsGroupIdGetData, GetGroupChatApiV1AdminGroupChatsGroupIdGetErrors, GetGroupChatApiV1AdminGroupChatsGroupIdGetResponses, GetHeroMetricsApiV1AdminMetricsHeroGetData, GetHeroMetricsApiV1AdminMetricsHeroGetResponses, GetHostedEmailMessageApiV1AdminHostedEmailMessagesMessageIdGetData, GetHostedEmailMessageApiV1AdminHostedEmailMessagesMessageIdGetErrors, GetHostedEmailMessageApiV1AdminHostedEmailMessagesMessageIdGetResponses, GetImessagePhoneStatusApiV1AdminImessageStatusGetData, GetImessagePhoneStatusApiV1AdminImessageStatusGetResponses, GetImessageStatusApiV1ImessageStatusGetData, GetImessageStatusApiV1ImessageStatusGetResponses, GetIntegrationAuthUrlApiV1IntegrationsIntegrationTypeAuthGetData, GetIntegrationAuthUrlApiV1IntegrationsIntegrationTypeAuthGetErrors, GetIntegrationAuthUrlApiV1IntegrationsIntegrationTypeAuthGetResponses, GetIntegrationStatusApiV1IntegrationsIntegrationTypeStatusGetData, GetIntegrationStatusApiV1IntegrationsIntegrationTypeStatusGetErrors, GetIntegrationStatusApiV1IntegrationsIntegrationTypeStatusGetResponses, GetIntegrationSuggestionsApiV1IntegrationSuggestionsGetData, GetIntegrationSuggestionsApiV1IntegrationSuggestionsGetErrors, GetIntegrationSuggestionsApiV1IntegrationSuggestionsGetResponses, GetInvitePreviewApiV1ReferralInvitePreviewGetData, GetInvitePreviewApiV1ReferralInvitePreviewGetErrors, GetInvitePreviewApiV1ReferralInvitePreviewGetResponses, GetInvitesApiV1ReferralInvitesGetData, GetInvitesApiV1ReferralInvitesGetResponses, GetLinkApiV1SchedulingLinksLinkIdGetData, GetLinkApiV1SchedulingLinksLinkIdGetErrors, GetLinkApiV1SchedulingLinksLinkIdGetResponses, GetLinkPollResultsApiV1SchedulingLinksLinkIdPollResultsGetData, GetLinkPollResultsApiV1SchedulingLinksLinkIdPollResultsGetErrors, GetLinkPollResultsApiV1SchedulingLinksLinkIdPollResultsGetResponses, GetMembersApiV1OrganizationMembersGetData, GetMembersApiV1OrganizationMembersGetResponses, GetMobileChatConversationDetailApiV1AdminMobileChatConversationsChannelIdentifierGetData, GetMobileChatConversationDetailApiV1AdminMobileChatConversationsChannelIdentifierGetErrors, GetMobileChatConversationDetailApiV1AdminMobileChatConversationsChannelIdentifierGetResponses, GetMyInvitesApiV1OrganizationInvitesMineGetData, GetMyInvitesApiV1OrganizationInvitesMineGetResponses, GetMyOrganizationApiV1OrganizationGetData, GetMyOrganizationApiV1OrganizationGetResponses, GetMyStatsApiV1StatsMeGetData, GetMyStatsApiV1StatsMeGetResponses, GetMyViewApiV1ViewsViewIdGetData, GetMyViewApiV1ViewsViewIdGetErrors, GetMyViewApiV1ViewsViewIdGetResponses, GetNetworkApiV1ReferralNetworkGetData, GetNetworkApiV1ReferralNetworkGetResponses, GetNonAdminUsersApiV1AdminUsersNonAdminsGetData, GetNonAdminUsersApiV1AdminUsersNonAdminsGetResponses, GetOrganizationAccessApiV1OrganizationAccessGetData, GetOrganizationAccessApiV1OrganizationAccessGetResponses, GetOrganizationDetailApiV1AdminOrganizationsOrgIdGetData, GetOrganizationDetailApiV1AdminOrganizationsOrgIdGetErrors, GetOrganizationDetailApiV1AdminOrganizationsOrgIdGetResponses, GetOrganizationSsoApiV1AdminOrganizationsOrgIdSsoGetData, GetOrganizationSsoApiV1AdminOrganizationsOrgIdSsoGetErrors, GetOrganizationSsoApiV1AdminOrganizationsOrgIdSsoGetResponses, GetOrganizationStatsApiV1OrganizationStatsGetData, GetOrganizationStatsApiV1OrganizationStatsGetResponses, GetPendingInvitesApiV1OrganizationInvitesGetData, GetPendingInvitesApiV1OrganizationInvitesGetResponses, GetPendingUsersApiV1AdminPendingUsersGetData, GetPendingUsersApiV1AdminPendingUsersGetResponses, GetPhoneEnrichmentApiV1AdminPhoneEnrichmentGetData, GetPhoneEnrichmentApiV1AdminPhoneEnrichmentGetErrors, GetPhoneEnrichmentApiV1AdminPhoneEnrichmentGetResponses, GetPricingApiV1BillingPricingGetData, GetPricingApiV1BillingPricingGetResponses, GetPublicAssistantAvatarApiV1PublicAssistantsPublicTokenAvatarGetData, GetPublicAssistantAvatarApiV1PublicAssistantsPublicTokenAvatarGetErrors, GetPublicAssistantAvatarApiV1PublicAssistantsPublicTokenAvatarGetResponses, GetPublicAssistantProfileApiV1PublicAssistantsPublicTokenGetData, GetPublicAssistantProfileApiV1PublicAssistantsPublicTokenGetErrors, GetPublicAssistantProfileApiV1PublicAssistantsPublicTokenGetResponses, GetPublicLinkApiV1SchedulingPublicLinkIdGetData, GetPublicLinkApiV1SchedulingPublicLinkIdGetErrors, GetPublicLinkApiV1SchedulingPublicLinkIdGetResponses, GetPublicLinkForInviteeApiV1SchedulingPublicLinkIdITokenGetData, GetPublicLinkForInviteeApiV1SchedulingPublicLinkIdITokenGetErrors, GetPublicLinkForInviteeApiV1SchedulingPublicLinkIdITokenGetResponses, GetPublicLinkSlotsApiV1SchedulingPublicLinkIdSlotsGetData, GetPublicLinkSlotsApiV1SchedulingPublicLinkIdSlotsGetErrors, GetPublicLinkSlotsApiV1SchedulingPublicLinkIdSlotsGetResponses, GetPurchaseCreditsApiV1BillingPurchaseCreditsGetData, GetPurchaseCreditsApiV1BillingPurchaseCreditsGetResponses, GetPurchaseWalletApiV1AdminPurchaseWalletsUserIdGetData, GetPurchaseWalletApiV1AdminPurchaseWalletsUserIdGetErrors, GetPurchaseWalletApiV1AdminPurchaseWalletsUserIdGetResponses, GetRateInfoApiV1HotelsRateInfoPostData, GetRateInfoApiV1HotelsRateInfoPostErrors, GetRateInfoApiV1HotelsRateInfoPostResponses, GetRecentEmailsApiV1EmailsGetData, GetRecentEmailsApiV1EmailsGetErrors, GetRecentEmailsApiV1EmailsGetResponses, GetRedactedEntriesApiV1OrganizationRedactedEntriesGetData, GetRedactedEntriesApiV1OrganizationRedactedEntriesGetResponses, GetReferralLinkApiV1ReferralLinkGetData, GetReferralLinkApiV1ReferralLinkGetResponses, GetReferralStatusApiV1ReferralStatusGetData, GetReferralStatusApiV1ReferralStatusGetResponses, GetRestorationJobApiV1AdminRestorationJobsJobIdGetData, GetRestorationJobApiV1AdminRestorationJobsJobIdGetErrors, GetRestorationJobApiV1AdminRestorationJobsJobIdGetResponses, GetSalesLeadApiV1AdminSalesLeadsLeadIdGetData, GetSalesLeadApiV1AdminSalesLeadsLeadIdGetErrors, GetSalesLeadApiV1AdminSalesLeadsLeadIdGetResponses, GetSentEmailDetailApiV1AdminSentEmailsEmailIdGetData, GetSentEmailDetailApiV1AdminSentEmailsEmailIdGetErrors, GetSentEmailDetailApiV1AdminSentEmailsEmailIdGetResponses, GetSlackChannelMessagesApiV1AdminUsersUserIdSlackChannelsChannelIdMessagesGetData, GetSlackChannelMessagesApiV1AdminUsersUserIdSlackChannelsChannelIdMessagesGetErrors, GetSlackChannelMessagesApiV1AdminUsersUserIdSlackChannelsChannelIdMessagesGetResponses, GetSlackPersonalStatusApiV1SlackPersonalStatusGetData, GetSlackPersonalStatusApiV1SlackPersonalStatusGetResponses, GetSlackStatusApiV1SlackStatusGetData, GetSlackStatusApiV1SlackStatusGetResponses, GetSlackThreadRepliesApiV1AdminUsersUserIdSlackThreadThreadTsGetData, GetSlackThreadRepliesApiV1AdminUsersUserIdSlackThreadThreadTsGetErrors, GetSlackThreadRepliesApiV1AdminUsersUserIdSlackThreadThreadTsGetResponses, GetSmsStatusApiV1SmsStatusGetData, GetSmsStatusApiV1SmsStatusGetResponses, GetStayOptionsApiV1StaysOptionsTokenGetData, GetStayOptionsApiV1StaysOptionsTokenGetErrors, GetStayOptionsApiV1StaysOptionsTokenGetResponses, GetStripePromoCodeRedemptionsApiV1AdminStripePromoCodesCouponIdRedemptionsGetData, GetStripePromoCodeRedemptionsApiV1AdminStripePromoCodesCouponIdRedemptionsGetErrors, GetStripePromoCodeRedemptionsApiV1AdminStripePromoCodesCouponIdRedemptionsGetResponses, GetStripePromoCodesApiV1AdminStripePromoCodesGetData, GetStripePromoCodesApiV1AdminStripePromoCodesGetErrors, GetStripePromoCodesApiV1AdminStripePromoCodesGetResponses, GetSubagentConversationDetailApiV1AdminSubagentConversationsConversationIdGetData, GetSubagentConversationDetailApiV1AdminSubagentConversationsConversationIdGetErrors, GetSubagentConversationDetailApiV1AdminSubagentConversationsConversationIdGetResponses, GetSubscriptionStatusApiV1BillingSubscriptionGetData, GetSubscriptionStatusApiV1BillingSubscriptionGetResponses, GetSuggestionsApiV1ReferralSuggestionsGetData, GetSuggestionsApiV1ReferralSuggestionsGetResponses, GetTeamsAccessStatusApiV1TeamsAccessStatusGetData, GetTeamsAccessStatusApiV1TeamsAccessStatusGetResponses, GetTeamSkillsApiV1OrganizationTeamSkillsGetData, GetTeamSkillsApiV1OrganizationTeamSkillsGetResponses, GetTrialingUsersApiV1AdminTrialingUsersGetData, GetTrialingUsersApiV1AdminTrialingUsersGetResponses, GetTripsApiV1TripsTokenGetData, GetTripsApiV1TripsTokenGetErrors, GetTripsApiV1TripsTokenGetResponses, GetUserAcquisitionApiV1AdminUsersUserIdAcquisitionGetData, GetUserAcquisitionApiV1AdminUsersUserIdAcquisitionGetErrors, GetUserAcquisitionApiV1AdminUsersUserIdAcquisitionGetResponses, GetUserAgentDraftDiffApiV1AdminUsersUserIdDraftsDraftIdDiffGetData, GetUserAgentDraftDiffApiV1AdminUsersUserIdDraftsDraftIdDiffGetErrors, GetUserAgentDraftDiffApiV1AdminUsersUserIdDraftsDraftIdDiffGetResponses, GetUserAgentDraftsApiV1AdminUsersUserIdDraftsGetData, GetUserAgentDraftsApiV1AdminUsersUserIdDraftsGetErrors, GetUserAgentDraftsApiV1AdminUsersUserIdDraftsGetResponses, GetUserAssistantCharacterApiV1AuthMeAssistantGetData, GetUserAssistantCharacterApiV1AuthMeAssistantGetResponses, GetUserDeletionManifestApiV1AdminUsersUserIdDeletionManifestGetData, GetUserDeletionManifestApiV1AdminUsersUserIdDeletionManifestGetErrors, GetUserDeletionManifestApiV1AdminUsersUserIdDeletionManifestGetResponses, GetUserDetailsApiV1AdminUsersUserIdDetailsGetData, GetUserDetailsApiV1AdminUsersUserIdDetailsGetErrors, GetUserDetailsApiV1AdminUsersUserIdDetailsGetResponses, GetUserEmailConversationApiV1AdminUsersUserIdEmailConversationGetData, GetUserEmailConversationApiV1AdminUsersUserIdEmailConversationGetErrors, GetUserEmailConversationApiV1AdminUsersUserIdEmailConversationGetResponses, GetUserFileContentApiV1AdminUserFilesFileIdGetData, GetUserFileContentApiV1AdminUserFilesFileIdGetErrors, GetUserFileContentApiV1AdminUserFilesFileIdGetResponses, GetUserGoogleCalendarSettingsApiV1AdminUsersUserIdGoogleCalendarSettingsGetData, GetUserGoogleCalendarSettingsApiV1AdminUsersUserIdGoogleCalendarSettingsGetErrors, GetUserGoogleCalendarSettingsApiV1AdminUsersUserIdGoogleCalendarSettingsGetResponses, GetUserImessageConversationApiV1AdminUsersUserIdImessageConversationGetData, GetUserImessageConversationApiV1AdminUsersUserIdImessageConversationGetErrors, GetUserImessageConversationApiV1AdminUsersUserIdImessageConversationGetResponses, GetUserMessagingChannelsApiV1AdminUsersUserIdMessagingChannelsGetData, GetUserMessagingChannelsApiV1AdminUsersUserIdMessagingChannelsGetErrors, GetUserMessagingChannelsApiV1AdminUsersUserIdMessagingChannelsGetResponses, GetUserPhoneCallsApiV1AdminUsersUserIdPhoneCallsGetData, GetUserPhoneCallsApiV1AdminUsersUserIdPhoneCallsGetErrors, GetUserPhoneCallsApiV1AdminUsersUserIdPhoneCallsGetResponses, GetUserRcsConversationApiV1AdminUsersUserIdRcsConversationGetData, GetUserRcsConversationApiV1AdminUsersUserIdRcsConversationGetErrors, GetUserRcsConversationApiV1AdminUsersUserIdRcsConversationGetResponses, GetUserReferralApiV1AdminUsersUserIdReferralGetData, GetUserReferralApiV1AdminUsersUserIdReferralGetErrors, GetUserReferralApiV1AdminUsersUserIdReferralGetResponses, GetUserSlackChannelsApiV1AdminUsersUserIdSlackChannelsGetData, GetUserSlackChannelsApiV1AdminUsersUserIdSlackChannelsGetErrors, GetUserSlackChannelsApiV1AdminUsersUserIdSlackChannelsGetResponses, GetUserSlackConversationApiV1AdminUsersUserIdSlackConversationGetData, GetUserSlackConversationApiV1AdminUsersUserIdSlackConversationGetErrors, GetUserSlackConversationApiV1AdminUsersUserIdSlackConversationGetResponses, GetUserSlackUsersApiV1AdminUsersUserIdSlackUsersGetData, GetUserSlackUsersApiV1AdminUsersUserIdSlackUsersGetErrors, GetUserSlackUsersApiV1AdminUsersUserIdSlackUsersGetResponses, GetUserSmsConversationApiV1AdminUsersUserIdSmsConversationGetData, GetUserSmsConversationApiV1AdminUsersUserIdSmsConversationGetErrors, GetUserSmsConversationApiV1AdminUsersUserIdSmsConversationGetResponses, GetUserStatsApiV1AdminUsersUserIdStatsGetData, GetUserStatsApiV1AdminUsersUserIdStatsGetErrors, GetUserStatsApiV1AdminUsersUserIdStatsGetResponses, GetUserWhatsappConversationApiV1AdminUsersUserIdWhatsappConversationGetData, GetUserWhatsappConversationApiV1AdminUsersUserIdWhatsappConversationGetErrors, GetUserWhatsappConversationApiV1AdminUsersUserIdWhatsappConversationGetResponses, GetVaultSecretRequestApiV1VaultSecretRequestTokenGetData, GetVaultSecretRequestApiV1VaultSecretRequestTokenGetErrors, GetVaultSecretRequestApiV1VaultSecretRequestTokenGetResponses, GetVoicePreviewAudioApiV1AuthCharactersVoicesVoiceNamePreviewGetData, GetVoicePreviewAudioApiV1AuthCharactersVoicesVoiceNamePreviewGetErrors, GetVoicePreviewAudioApiV1AuthCharactersVoicesVoiceNamePreviewGetResponses, GetWebAutomationScriptDetailApiV1AdminWebAutomationsScriptIdGetData, GetWebAutomationScriptDetailApiV1AdminWebAutomationsScriptIdGetErrors, GetWebAutomationScriptDetailApiV1AdminWebAutomationsScriptIdGetResponses, GetWhatsappConversationByPhoneApiV1AdminWhatsappConversationByPhoneGetData, GetWhatsappConversationByPhoneApiV1AdminWhatsappConversationByPhoneGetErrors, GetWhatsappConversationByPhoneApiV1AdminWhatsappConversationByPhoneGetResponses, GetWhatsappStatusApiV1WhatsappStatusGetData, GetWhatsappStatusApiV1WhatsappStatusGetResponses, GetZoomStatusApiV1AuthZoomStatusGetData, GetZoomStatusApiV1AuthZoomStatusGetResponses, GoogleSecurityEventApiV1AuthSecurityEventsGooglePostData, GoogleSecurityEventApiV1AuthSecurityEventsGooglePostResponses, GrantSubscriptionApiV1AdminUsersUserIdGrantSubscriptionPostData, GrantSubscriptionApiV1AdminUsersUserIdGrantSubscriptionPostErrors, GrantSubscriptionApiV1AdminUsersUserIdGrantSubscriptionPostResponses, GrantSubscriptionByEmailApiV1AdminGrantSubscriptionByEmailPostData, GrantSubscriptionByEmailApiV1AdminGrantSubscriptionByEmailPostErrors, GrantSubscriptionByEmailApiV1AdminGrantSubscriptionByEmailPostResponses, HandleInboundEmailApiV1WebhooksInboundEmailPostData, HandleInboundEmailApiV1WebhooksInboundEmailPostResponses, HandleSesEventApiV1WebhooksSesEventsPostData, HandleSesEventApiV1WebhooksSesEventsPostResponses, HandleSlackOauthCallbackApiV1SlackOauthCallbackPostData, HandleSlackOauthCallbackApiV1SlackOauthCallbackPostErrors, HandleSlackOauthCallbackApiV1SlackOauthCallbackPostResponses, HandleSlackPersonalOauthCallbackApiV1SlackPersonalOauthCallbackPostData, HandleSlackPersonalOauthCallbackApiV1SlackPersonalOauthCallbackPostErrors, HandleSlackPersonalOauthCallbackApiV1SlackPersonalOauthCallbackPostResponses, HandleZoomOauthCallbackApiV1AuthZoomOauthCallbackPostData, HandleZoomOauthCallbackApiV1AuthZoomOauthCallbackPostErrors, HandleZoomOauthCallbackApiV1AuthZoomOauthCallbackPostResponses, HealthCheckApiV1HealthGetData, HealthCheckApiV1HealthGetResponses, ImessageWebhookApiV1AssistantWebhooksImessagePostData, ImessageWebhookApiV1AssistantWebhooksImessagePostResponses, ImportSalesLeadsCsvApiV1AdminSalesLeadsImportPostData, ImportSalesLeadsCsvApiV1AdminSalesLeadsImportPostErrors, ImportSalesLeadsCsvApiV1AdminSalesLeadsImportPostResponses, IncomingWebhookApiV1WebhooksIncomingIntegrationIdPostData, IncomingWebhookApiV1WebhooksIncomingIntegrationIdPostErrors, IncomingWebhookApiV1WebhooksIncomingIntegrationIdPostResponses, IngestBroadcastProposalsApiV1InternalBroadcastProposalsPostData, IngestBroadcastProposalsApiV1InternalBroadcastProposalsPostErrors, IngestBroadcastProposalsApiV1InternalBroadcastProposalsPostResponses, InitiateSlackOauthApiV1SlackOauthInitiatePostData, InitiateSlackOauthApiV1SlackOauthInitiatePostResponses, InitiateSlackPersonalOauthApiV1SlackPersonalOauthInitiatePostData, InitiateSlackPersonalOauthApiV1SlackPersonalOauthInitiatePostResponses, InitiateZoomOauthApiV1AuthZoomOauthInitiatePostData, InitiateZoomOauthApiV1AuthZoomOauthInitiatePostResponses, IntegrationOauthCallbackApiV1IntegrationsIntegrationTypeCallbackGetData, IntegrationOauthCallbackApiV1IntegrationsIntegrationTypeCallbackGetErrors, IntegrationOauthCallbackApiV1IntegrationsIntegrationTypeCallbackGetResponses, IssueFlightInvoiceApiV1AdminFlightInvoicingItemsItemIdIssueInvoicePostData, IssueFlightInvoiceApiV1AdminFlightInvoicingItemsItemIdIssueInvoicePostErrors, IssueFlightInvoiceApiV1AdminFlightInvoicingItemsItemIdIssueInvoicePostResponses, IssueInvoiceApiV1AdminHotelInvoicingItemsItemIdIssueInvoicePostData, IssueInvoiceApiV1AdminHotelInvoicingItemsItemIdIssueInvoicePostErrors, IssueInvoiceApiV1AdminHotelInvoicingItemsItemIdIssueInvoicePostResponses, IssueWebPurchaseInvoiceApiV1AdminWebPurchaseInvoicingItemsItemIdIssueInvoicePostData, IssueWebPurchaseInvoiceApiV1AdminWebPurchaseInvoicingItemsItemIdIssueInvoicePostErrors, IssueWebPurchaseInvoiceApiV1AdminWebPurchaseInvoicingItemsItemIdIssueInvoicePostResponses, KeepaliveCheckApiV1KeepaliveGetData, KeepaliveCheckApiV1KeepaliveGetErrors, KeepaliveCheckApiV1KeepaliveGetResponses, LeaveOrganizationEndpointApiV1OrganizationLeavePostData, LeaveOrganizationEndpointApiV1OrganizationLeavePostResponses, LiftSuppressedEmailApiV1AdminEmailSuppressionsLiftPostData, LiftSuppressedEmailApiV1AdminEmailSuppressionsLiftPostErrors, LiftSuppressedEmailApiV1AdminEmailSuppressionsLiftPostResponses, ListAssistantCharactersApiV1AuthCharactersGetData, ListAssistantCharactersApiV1AuthCharactersGetResponses, ListAssistantV2EventsApiV1AdminUsersUserIdAssistantV2EventsGetData, ListAssistantV2EventsApiV1AdminUsersUserIdAssistantV2EventsGetErrors, ListAssistantV2EventsApiV1AdminUsersUserIdAssistantV2EventsGetResponses, ListAssistantV2MemoryApiV1AdminUsersUserIdAssistantV2MemoryGetData, ListAssistantV2MemoryApiV1AdminUsersUserIdAssistantV2MemoryGetErrors, ListAssistantV2MemoryApiV1AdminUsersUserIdAssistantV2MemoryGetResponses, ListAssistantV2TriggerRunsApiV1AdminUsersUserIdAssistantV2TriggerRunsGetData, ListAssistantV2TriggerRunsApiV1AdminUsersUserIdAssistantV2TriggerRunsGetErrors, ListAssistantV2TriggerRunsApiV1AdminUsersUserIdAssistantV2TriggerRunsGetResponses, ListAssistantV2TriggersApiV1AdminUsersUserIdAssistantV2TriggersGetData, ListAssistantV2TriggersApiV1AdminUsersUserIdAssistantV2TriggersGetErrors, ListAssistantV2TriggersApiV1AdminUsersUserIdAssistantV2TriggersGetResponses, ListAutoApprovalPoliciesApiV1AdminUsersUserIdAutoApprovalPoliciesGetData, ListAutoApprovalPoliciesApiV1AdminUsersUserIdAutoApprovalPoliciesGetErrors, ListAutoApprovalPoliciesApiV1AdminUsersUserIdAutoApprovalPoliciesGetResponses, ListBroadcastProposalsApiV1AdminBroadcastProposalsGetData, ListBroadcastProposalsApiV1AdminBroadcastProposalsGetErrors, ListBroadcastProposalsApiV1AdminBroadcastProposalsGetResponses, ListCatchPaidItemsApiV1AdminHotelInvoicingItemsGetData, ListCatchPaidItemsApiV1AdminHotelInvoicingItemsGetErrors, ListCatchPaidItemsApiV1AdminHotelInvoicingItemsGetResponses, ListCharacterVoicesApiV1AuthCharactersVoicesGetData, ListCharacterVoicesApiV1AuthCharactersVoicesGetResponses, ListConnectedEmailAccountsApiV1AuthConnectEmailAccountsGetData, ListConnectedEmailAccountsApiV1AuthConnectEmailAccountsGetResponses, ListCustomIntegrationBuildsApiV1AdminCustomIntegrationsBuildsGetData, ListCustomIntegrationBuildsApiV1AdminCustomIntegrationsBuildsGetErrors, ListCustomIntegrationBuildsApiV1AdminCustomIntegrationsBuildsGetResponses, ListCustomIntegrationsApiV1AdminCustomIntegrationsGetData, ListCustomIntegrationsApiV1AdminCustomIntegrationsGetErrors, ListCustomIntegrationsApiV1AdminCustomIntegrationsGetResponses, ListCustomIntegrationsEndpointApiV1IntegrationsCustomGetData, ListCustomIntegrationsEndpointApiV1IntegrationsCustomGetResponses, ListCustomIntegrationSharesApiV1AdminCustomIntegrationsSpecIdSharesGetData, ListCustomIntegrationSharesApiV1AdminCustomIntegrationsSpecIdSharesGetErrors, ListCustomIntegrationSharesApiV1AdminCustomIntegrationsSpecIdSharesGetResponses, ListDedicatedNumbersApiV1AdminDedicatedNumbersGetData, ListDedicatedNumbersApiV1AdminDedicatedNumbersGetResponses, ListFeaturedIntegrationsApiV1IntegrationsFeaturedGetData, ListFeaturedIntegrationsApiV1IntegrationsFeaturedGetResponses, ListFlightInvoiceItemsApiV1AdminFlightInvoicingItemsGetData, ListFlightInvoiceItemsApiV1AdminFlightInvoicingItemsGetErrors, ListFlightInvoiceItemsApiV1AdminFlightInvoicingItemsGetResponses, ListGroupChatsApiV1AdminGroupChatsGetData, ListGroupChatsApiV1AdminGroupChatsGetErrors, ListGroupChatsApiV1AdminGroupChatsGetResponses, ListHostedMailboxesApiV1AdminHostedEmailMailboxesGetData, ListHostedMailboxesApiV1AdminHostedEmailMailboxesGetErrors, ListHostedMailboxesApiV1AdminHostedEmailMailboxesGetResponses, ListHostedMailboxMessagesApiV1AdminHostedEmailMailboxesMailboxIdMessagesGetData, ListHostedMailboxMessagesApiV1AdminHostedEmailMailboxesMailboxIdMessagesGetErrors, ListHostedMailboxMessagesApiV1AdminHostedEmailMailboxesMailboxIdMessagesGetResponses, ListIntegrationInstancesApiV1IntegrationsIntegrationTypeInstancesGetData, ListIntegrationInstancesApiV1IntegrationsIntegrationTypeInstancesGetErrors, ListIntegrationInstancesApiV1IntegrationsIntegrationTypeInstancesGetResponses, ListIntegrationsApiV1WebhooksIntegrationsGetData, ListIntegrationsApiV1WebhooksIntegrationsGetResponses, ListLinksApiV1SchedulingLinksGetData, ListLinksApiV1SchedulingLinksGetResponses, ListMobileChatConversationsApiV1AdminMobileChatConversationsGetData, ListMobileChatConversationsApiV1AdminMobileChatConversationsGetErrors, ListMobileChatConversationsApiV1AdminMobileChatConversationsGetResponses, ListMyBookingsApiV1HotelsBookingsGetData, ListMyBookingsApiV1HotelsBookingsGetResponses, ListMyViewsApiV1ViewsGetData, ListMyViewsApiV1ViewsGetErrors, ListMyViewsApiV1ViewsGetResponses, ListOrganizationsApiV1AdminOrganizationsGetData, ListOrganizationsApiV1AdminOrganizationsGetErrors, ListOrganizationsApiV1AdminOrganizationsGetResponses, ListOrphanedDedicatedNumbersApiV1AdminDedicatedNumbersOrphansGetData, ListOrphanedDedicatedNumbersApiV1AdminDedicatedNumbersOrphansGetResponses, ListPendingApprovalsApiV1SchedulingApprovalsPendingGetData, ListPendingApprovalsApiV1SchedulingApprovalsPendingGetResponses, ListPipedreamAppsApiV1IntegrationsPipedreamAppsGetData, ListPipedreamAppsApiV1IntegrationsPipedreamAppsGetErrors, ListPipedreamAppsApiV1IntegrationsPipedreamAppsGetResponses, ListPipedreamConnectionsApiV1IntegrationsPipedreamConnectionsGetData, ListPipedreamConnectionsApiV1IntegrationsPipedreamConnectionsGetResponses, ListPromotedIntegrationsApiV1IntegrationsPromotedGetData, ListPromotedIntegrationsApiV1IntegrationsPromotedGetResponses, ListPurchaseWalletsApiV1AdminPurchaseWalletsGetData, ListPurchaseWalletsApiV1AdminPurchaseWalletsGetErrors, ListPurchaseWalletsApiV1AdminPurchaseWalletsGetResponses, ListRestorationJobsApiV1AdminRestorationJobsGetData, ListRestorationJobsApiV1AdminRestorationJobsGetErrors, ListRestorationJobsApiV1AdminRestorationJobsGetResponses, ListSalesLeadsApiV1AdminSalesLeadsGetData, ListSalesLeadsApiV1AdminSalesLeadsGetErrors, ListSalesLeadsApiV1AdminSalesLeadsGetResponses, ListSentEmailsApiV1AdminSentEmailsGetData, ListSentEmailsApiV1AdminSentEmailsGetErrors, ListSentEmailsApiV1AdminSentEmailsGetResponses, ListSentEmailTypesApiV1AdminSentEmailsTypesGetData, ListSentEmailTypesApiV1AdminSentEmailsTypesGetResponses, ListSharedIntegrationsApiV1IntegrationsSharedGetData, ListSharedIntegrationsApiV1IntegrationsSharedGetResponses, ListSlackPersonalConversationsApiV1SlackPersonalConversationsGetData, ListSlackPersonalConversationsApiV1SlackPersonalConversationsGetResponses, ListSubagentConversationsApiV1AdminSubagentConversationsGetData, ListSubagentConversationsApiV1AdminSubagentConversationsGetErrors, ListSubagentConversationsApiV1AdminSubagentConversationsGetResponses, ListSuppressedEmailsApiV1AdminEmailSuppressionsGetData, ListSuppressedEmailsApiV1AdminEmailSuppressionsGetErrors, ListSuppressedEmailsApiV1AdminEmailSuppressionsGetResponses, ListSystemBroadcastsApiV1AdminBroadcastsGetData, ListSystemBroadcastsApiV1AdminBroadcastsGetErrors, ListSystemBroadcastsApiV1AdminBroadcastsGetResponses, ListTeamsAccessConversationsApiV1TeamsAccessConversationsGetData, ListTeamsAccessConversationsApiV1TeamsAccessConversationsGetResponses, ListUseCasesApiV1AdminUseCasesGetData, ListUseCasesApiV1AdminUseCasesGetErrors, ListUseCasesApiV1AdminUseCasesGetResponses, ListUserIntegrationsApiV1AdminUsersUserIdIntegrationsGetData, ListUserIntegrationsApiV1AdminUsersUserIdIntegrationsGetErrors, ListUserIntegrationsApiV1AdminUsersUserIdIntegrationsGetResponses, ListWebAutomationScriptsApiV1AdminWebAutomationsGetData, ListWebAutomationScriptsApiV1AdminWebAutomationsGetErrors, ListWebAutomationScriptsApiV1AdminWebAutomationsGetResponses, ListWebPurchaseItemsApiV1AdminWebPurchaseInvoicingItemsGetData, ListWebPurchaseItemsApiV1AdminWebPurchaseInvoicingItemsGetErrors, ListWebPurchaseItemsApiV1AdminWebPurchaseInvoicingItemsGetResponses, LoginApiV1AuthLoginGetData, LoginApiV1AuthLoginGetErrors, LoginApiV1AuthLoginGetResponses, LogoutApiV1AuthLogoutPostData, LogoutApiV1AuthLogoutPostResponses, MergeUseCaseApiV1AdminUseCasesUseCaseIdMergePostData, MergeUseCaseApiV1AdminUseCasesUseCaseIdMergePostErrors, MergeUseCaseApiV1AdminUseCasesUseCaseIdMergePostResponses, MicrosoftAuthCallbackApiV1AuthMicrosoftCallbackGetData, MicrosoftAuthCallbackApiV1AuthMicrosoftCallbackGetResponses, MicrosoftLoginApiV1AuthMicrosoftLoginGetData, MicrosoftLoginApiV1AuthMicrosoftLoginGetErrors, MicrosoftLoginApiV1AuthMicrosoftLoginGetResponses, MigrateMembersApiV1OrganizationMembersMigratePostData, MigrateMembersApiV1OrganizationMembersMigratePostErrors, MigrateMembersApiV1OrganizationMembersMigratePostResponses, OidcSecurityLogoutApiV1AuthSecurityEventsOidcOrganizationIdPostData, OidcSecurityLogoutApiV1AuthSecurityEventsOidcOrganizationIdPostErrors, OidcSecurityLogoutApiV1AuthSecurityEventsOidcOrganizationIdPostResponses, OktaAuthCallbackApiV1AuthOktaCallbackGetData, OktaAuthCallbackApiV1AuthOktaCallbackGetResponses, OktaLoginApiV1AuthOktaLoginGetData, OktaLoginApiV1AuthOktaLoginGetErrors, OktaLoginApiV1AuthOktaLoginGetResponses, OpenLandingChatSessionApiV1PublicLandingChatSessionPostData, OpenLandingChatSessionApiV1PublicLandingChatSessionPostErrors, OpenLandingChatSessionApiV1PublicLandingChatSessionPostResponses, OrgBillingCheckoutApiV1OrganizationBillingCheckoutPostData, OrgBillingCheckoutApiV1OrganizationBillingCheckoutPostErrors, OrgBillingCheckoutApiV1OrganizationBillingCheckoutPostResponses, OrgBillingPortalApiV1OrganizationBillingPortalPostData, OrgBillingPortalApiV1OrganizationBillingPortalPostErrors, OrgBillingPortalApiV1OrganizationBillingPortalPostResponses, PauseUserBackgroundEventsApiV1AdminUsersUserIdBackgroundEventsPausePostData, PauseUserBackgroundEventsApiV1AdminUsersUserIdBackgroundEventsPausePostErrors, PauseUserBackgroundEventsApiV1AdminUsersUserIdBackgroundEventsPausePostResponses, PauseUserCalendarSyncApiV1AdminUsersUserIdCalendarSyncPausePostData, PauseUserCalendarSyncApiV1AdminUsersUserIdCalendarSyncPausePostErrors, PauseUserCalendarSyncApiV1AdminUsersUserIdCalendarSyncPausePostResponses, PayWithTravelCardApiV1AdminCatchPaidInvoicingItemsItemIdPayWithTravelCardPostData, PayWithTravelCardApiV1AdminCatchPaidInvoicingItemsItemIdPayWithTravelCardPostErrors, PayWithTravelCardApiV1AdminCatchPaidInvoicingItemsItemIdPayWithTravelCardPostResponses, PipedreamConnectCallbackApiV1IntegrationsIntegrationTypePipedreamCallbackGetData, PipedreamConnectCallbackApiV1IntegrationsIntegrationTypePipedreamCallbackGetErrors, PipedreamConnectCallbackApiV1IntegrationsIntegrationTypePipedreamCallbackGetResponses, PortalApiV1BillingPortalPostData, PortalApiV1BillingPortalPostErrors, PortalApiV1BillingPortalPostResponses, PortalFromSignedLinkApiV1BillingPortalLinkPostData, PortalFromSignedLinkApiV1BillingPortalLinkPostErrors, PortalFromSignedLinkApiV1BillingPortalLinkPostResponses, PostCallApiV1PhoneElevenlabsPostCallPostData, PostCallApiV1PhoneElevenlabsPostCallPostErrors, PostCallApiV1PhoneElevenlabsPostCallPostResponses, PostLandingChatMessageApiV1PublicLandingChatMessagePostData, PostLandingChatMessageApiV1PublicLandingChatMessagePostErrors, PostLandingChatMessageApiV1PublicLandingChatMessagePostResponses, PreviewSalesLeadApiV1AdminSalesLeadsLeadIdPreviewPostData, PreviewSalesLeadApiV1AdminSalesLeadsLeadIdPreviewPostErrors, PreviewSalesLeadApiV1AdminSalesLeadsLeadIdPreviewPostResponses, PreviewUseCasesApiV1AdminUseCasesPreviewUserIdPostData, PreviewUseCasesApiV1AdminUseCasesPreviewUserIdPostErrors, PreviewUseCasesApiV1AdminUseCasesPreviewUserIdPostResponses, PromoteCustomIntegrationApiV1AdminCustomIntegrationsSpecIdPromotePostData, PromoteCustomIntegrationApiV1AdminCustomIntegrationsSpecIdPromotePostErrors, PromoteCustomIntegrationApiV1AdminCustomIntegrationsSpecIdPromotePostResponses, PromoteMemberEndpointApiV1OrganizationMembersUserIdPromotePostData, PromoteMemberEndpointApiV1OrganizationMembersUserIdPromotePostErrors, PromoteMemberEndpointApiV1OrganizationMembersUserIdPromotePostResponses, PromoteOrganizationMemberApiV1AdminOrganizationsOrgIdMembersUserIdPromotePostData, PromoteOrganizationMemberApiV1AdminOrganizationsOrgIdMembersUserIdPromotePostErrors, PromoteOrganizationMemberApiV1AdminOrganizationsOrgIdMembersUserIdPromotePostResponses, ProvisionNumberApiV1DedicatedNumberPostData, ProvisionNumberApiV1DedicatedNumberPostErrors, ProvisionNumberApiV1DedicatedNumberPostResponses, ProxyConversationMediaApiV1AdminMediaProxyGetData, ProxyConversationMediaApiV1AdminMediaProxyGetErrors, ProxyConversationMediaApiV1AdminMediaProxyGetResponses, PurchaseCreditsCheckoutApiV1BillingPurchaseCreditsCheckoutPostData, PurchaseCreditsCheckoutApiV1BillingPurchaseCreditsCheckoutPostErrors, PurchaseCreditsCheckoutApiV1BillingPurchaseCreditsCheckoutPostResponses, PurgeUserDataApiV1AdminUsersUserIdPurgePostData, PurgeUserDataApiV1AdminUsersUserIdPurgePostErrors, PurgeUserDataApiV1AdminUsersUserIdPurgePostResponses, PutAssistantV2MemoryFileApiV1AdminUsersUserIdAssistantV2MemoryPathPutData, PutAssistantV2MemoryFileApiV1AdminUsersUserIdAssistantV2MemoryPathPutErrors, PutAssistantV2MemoryFileApiV1AdminUsersUserIdAssistantV2MemoryPathPutResponses, PutNumbersOnSipTrunkApiV1AdminDedicatedNumbersSipTrunkPostData, PutNumbersOnSipTrunkApiV1AdminDedicatedNumbersSipTrunkPostResponses, RcsWebhookApiV1AssistantWebhooksRcsPostData, RcsWebhookApiV1AssistantWebhooksRcsPostErrors, RcsWebhookApiV1AssistantWebhooksRcsPostResponses, ReactivateMemberApiV1OrganizationMembersUserIdReactivatePostData, ReactivateMemberApiV1OrganizationMembersUserIdReactivatePostErrors, ReactivateMemberApiV1OrganizationMembersUserIdReactivatePostResponses, ReactivateUserApiV1AdminUsersUserIdReactivatePostData, ReactivateUserApiV1AdminUsersUserIdReactivatePostErrors, ReactivateUserApiV1AdminUsersUserIdReactivatePostResponses, ReassignImessageGuestNumberApiV1AdminImessageGuestAssignmentsPostData, ReassignImessageGuestNumberApiV1AdminImessageGuestAssignmentsPostErrors, ReassignImessageGuestNumberApiV1AdminImessageGuestAssignmentsPostResponses, ReassignImessageNumberApiV1AdminImessageAssignmentsPostData, ReassignImessageNumberApiV1AdminImessageAssignmentsPostErrors, ReassignImessageNumberApiV1AdminImessageAssignmentsPostResponses, RebuildCustomIntegrationApiV1AdminCustomIntegrationsSpecIdRebuildPostData, RebuildCustomIntegrationApiV1AdminCustomIntegrationsSpecIdRebuildPostErrors, RebuildCustomIntegrationApiV1AdminCustomIntegrationsSpecIdRebuildPostResponses, RebuildUserProfileApiV1AdminUsersUserIdRebuildProfilePostData, RebuildUserProfileApiV1AdminUsersUserIdRebuildProfilePostErrors, RebuildUserProfileApiV1AdminUsersUserIdRebuildProfilePostResponses, ReceiveMetaLeadApiV1MetaLeadsWebhookPostData, ReceiveMetaLeadApiV1MetaLeadsWebhookPostResponses, ReceivePipedreamTriggerEventApiV1IntegrationsPipedreamTriggersTriggerIdEventsPostData, ReceivePipedreamTriggerEventApiV1IntegrationsPipedreamTriggersTriggerIdEventsPostErrors, ReceivePipedreamTriggerEventApiV1IntegrationsPipedreamTriggersTriggerIdEventsPostResponses, RecordAvailabilityLeadApiV1SchedulingPublicLinkIdAvailabilityLeadPostData, RecordAvailabilityLeadApiV1SchedulingPublicLinkIdAvailabilityLeadPostErrors, RecordAvailabilityLeadApiV1SchedulingPublicLinkIdAvailabilityLeadPostResponses, RecordUserReferralAttributionApiV1AdminUsersUserIdReferralAttributionPostData, RecordUserReferralAttributionApiV1AdminUsersUserIdReferralAttributionPostErrors, RecordUserReferralAttributionApiV1AdminUsersUserIdReferralAttributionPostResponses, RedirectToAttachmentApiV1CalendarAttachmentsFileIdGetData, RedirectToAttachmentApiV1CalendarAttachmentsFileIdGetErrors, RedirectToAttachmentApiV1CalendarAttachmentsFileIdGetResponses, RegenerateSalesLeadDraftApiV1AdminSalesLeadsLeadIdRegeneratePostData, RegenerateSalesLeadDraftApiV1AdminSalesLeadsLeadIdRegeneratePostErrors, RegenerateSalesLeadDraftApiV1AdminSalesLeadsLeadIdRegeneratePostResponses, RegenerateTokenApiV1WebhooksIntegrationsIntegrationIdRegenerateTokenPostData, RegenerateTokenApiV1WebhooksIntegrationsIntegrationIdRegenerateTokenPostErrors, RegenerateTokenApiV1WebhooksIntegrationsIntegrationIdRegenerateTokenPostResponses, RejectPendingUserApiV1AdminPendingUsersPendingUserIdDeleteData, RejectPendingUserApiV1AdminPendingUsersPendingUserIdDeleteErrors, RejectPendingUserApiV1AdminPendingUsersPendingUserIdDeleteResponses, RejectSalesLeadApiV1AdminSalesLeadsLeadIdRejectPostData, RejectSalesLeadApiV1AdminSalesLeadsLeadIdRejectPostErrors, RejectSalesLeadApiV1AdminSalesLeadsLeadIdRejectPostResponses, ReleaseNumberApiV1DedicatedNumberDeleteData, ReleaseNumberApiV1DedicatedNumberDeleteResponses, ReleaseOrganizationAdminSeatApiV1AdminOrganizationsOrgIdMembersUserIdReleaseSeatPostData, ReleaseOrganizationAdminSeatApiV1AdminOrganizationsOrgIdMembersUserIdReleaseSeatPostErrors, ReleaseOrganizationAdminSeatApiV1AdminOrganizationsOrgIdMembersUserIdReleaseSeatPostResponses, ReleaseOrphanApiV1AdminDedicatedNumbersOrphansTwilioSidReleasePostData, ReleaseOrphanApiV1AdminDedicatedNumbersOrphansTwilioSidReleasePostErrors, ReleaseOrphanApiV1AdminDedicatedNumbersOrphansTwilioSidReleasePostResponses, RemoveMemberEndpointApiV1OrganizationMembersUserIdDeleteData, RemoveMemberEndpointApiV1OrganizationMembersUserIdDeleteErrors, RemoveMemberEndpointApiV1OrganizationMembersUserIdDeleteResponses, RemoveOrganizationMemberApiV1AdminOrganizationsOrgIdMembersUserIdDeleteData, RemoveOrganizationMemberApiV1AdminOrganizationsOrgIdMembersUserIdDeleteErrors, RemoveOrganizationMemberApiV1AdminOrganizationsOrgIdMembersUserIdDeleteResponses, RemoveRedactedEntryEndpointApiV1OrganizationRedactedEntriesEntryIdDeleteData, RemoveRedactedEntryEndpointApiV1OrganizationRedactedEntriesEntryIdDeleteErrors, RemoveRedactedEntryEndpointApiV1OrganizationRedactedEntriesEntryIdDeleteResponses, RequestIntegrationApiV1IntegrationsRequestPostData, RequestIntegrationApiV1IntegrationsRequestPostErrors, RequestIntegrationApiV1IntegrationsRequestPostResponses, RequestScopesApiV1AuthRequestScopesGetData, RequestScopesApiV1AuthRequestScopesGetErrors, RequestScopesApiV1AuthRequestScopesGetResponses, RequestSecurityDocsApiV1PublicSecurityDocRequestPostData, RequestSecurityDocsApiV1PublicSecurityDocRequestPostErrors, RequestSecurityDocsApiV1PublicSecurityDocRequestPostResponses, RequestSignInHelpApiV1PublicSignInHelpPostData, RequestSignInHelpApiV1PublicSignInHelpPostErrors, RequestSignInHelpApiV1PublicSignInHelpPostResponses, ResetInviteTemplateApiV1ReferralInviteTemplateDeleteData, ResetInviteTemplateApiV1ReferralInviteTemplateDeleteErrors, ResetInviteTemplateApiV1ReferralInviteTemplateDeleteResponses, ResetUserApiV1AdminUsersUserIdResetPostData, ResetUserApiV1AdminUsersUserIdResetPostErrors, ResetUserApiV1AdminUsersUserIdResetPostResponses, ResetUserQueueApiV1AdminUsersUserIdResetQueuePostData, ResetUserQueueApiV1AdminUsersUserIdResetQueuePostErrors, ResetUserQueueApiV1AdminUsersUserIdResetQueuePostResponses, RestoreOrganizationMemberSeatApiV1AdminOrganizationsOrgIdMembersUserIdRestoreSeatPostData, RestoreOrganizationMemberSeatApiV1AdminOrganizationsOrgIdMembersUserIdRestoreSeatPostErrors, RestoreOrganizationMemberSeatApiV1AdminOrganizationsOrgIdMembersUserIdRestoreSeatPostResponses, ResumeOrganizationSubscriptionApiV1AdminOrganizationsOrgIdSubscriptionResumePostData, ResumeOrganizationSubscriptionApiV1AdminOrganizationsOrgIdSubscriptionResumePostErrors, ResumeOrganizationSubscriptionApiV1AdminOrganizationsOrgIdSubscriptionResumePostResponses, ResumeUserBackgroundEventsApiV1AdminUsersUserIdBackgroundEventsResumePostData, ResumeUserBackgroundEventsApiV1AdminUsersUserIdBackgroundEventsResumePostErrors, ResumeUserBackgroundEventsApiV1AdminUsersUserIdBackgroundEventsResumePostResponses, ResumeUserCalendarSyncApiV1AdminUsersUserIdCalendarSyncResumePostData, ResumeUserCalendarSyncApiV1AdminUsersUserIdCalendarSyncResumePostErrors, ResumeUserCalendarSyncApiV1AdminUsersUserIdCalendarSyncResumePostResponses, RetryRestorationJobEndpointApiV1AdminRestorationJobsJobIdRetryPostData, RetryRestorationJobEndpointApiV1AdminRestorationJobsJobIdRetryPostErrors, RetryRestorationJobEndpointApiV1AdminRestorationJobsJobIdRetryPostResponses, RevertCustomCharacterPictureApiV1AuthCharactersCustomPictureDeleteData, RevertCustomCharacterPictureApiV1AuthCharactersCustomPictureDeleteResponses, RevertFlightInvoiceApiV1AdminFlightInvoicingItemsItemIdRevertPostData, RevertFlightInvoiceApiV1AdminFlightInvoicingItemsItemIdRevertPostErrors, RevertFlightInvoiceApiV1AdminFlightInvoicingItemsItemIdRevertPostResponses, RevertInvoiceApiV1AdminHotelInvoicingItemsItemIdRevertPostData, RevertInvoiceApiV1AdminHotelInvoicingItemsItemIdRevertPostErrors, RevertInvoiceApiV1AdminHotelInvoicingItemsItemIdRevertPostResponses, RevokeInviteEndpointApiV1OrganizationInvitesInviteIdDeleteData, RevokeInviteEndpointApiV1OrganizationInvitesInviteIdDeleteErrors, RevokeInviteEndpointApiV1OrganizationInvitesInviteIdDeleteResponses, RootGetData, RootGetResponses, RotateKeyApiV1ShortcutKeyRotatePostData, RotateKeyApiV1ShortcutKeyRotatePostResponses, SaveInviteTemplateApiV1ReferralInviteTemplatePutData, SaveInviteTemplateApiV1ReferralInviteTemplatePutErrors, SaveInviteTemplateApiV1ReferralInviteTemplatePutResponses, ScopeStatusApiV1AuthScopeStatusGetData, ScopeStatusApiV1AuthScopeStatusGetResponses, SearchHotelsApiV1HotelsSearchGetData, SearchHotelsApiV1HotelsSearchGetErrors, SearchHotelsApiV1HotelsSearchGetResponses, SelectFlightOptionApiV1FlightsOptionsTokenSelectPostData, SelectFlightOptionApiV1FlightsOptionsTokenSelectPostErrors, SelectFlightOptionApiV1FlightsOptionsTokenSelectPostResponses, SelectStayOptionApiV1StaysOptionsTokenSelectPostData, SelectStayOptionApiV1StaysOptionsTokenSelectPostErrors, SelectStayOptionApiV1StaysOptionsTokenSelectPostResponses, SendBroadcastProposalApiV1AdminBroadcastProposalsProposalIdSendPostData, SendBroadcastProposalApiV1AdminBroadcastProposalsProposalIdSendPostErrors, SendBroadcastProposalApiV1AdminBroadcastProposalsProposalIdSendPostResponses, SendEmailCampaignTestApiV1AdminEmailCampaignsTestPostData, SendEmailCampaignTestApiV1AdminEmailCampaignsTestPostErrors, SendEmailCampaignTestApiV1AdminEmailCampaignsTestPostResponses, SendFlightPaymentLinkApiV1AdminFlightInvoicingItemsItemIdSendPaymentLinkPostData, SendFlightPaymentLinkApiV1AdminFlightInvoicingItemsItemIdSendPaymentLinkPostErrors, SendFlightPaymentLinkApiV1AdminFlightInvoicingItemsItemIdSendPaymentLinkPostResponses, SendImessageTestMessageApiV1AdminImessageTestMessagePostData, SendImessageTestMessageApiV1AdminImessageTestMessagePostErrors, SendImessageTestMessageApiV1AdminImessageTestMessagePostResponses, SendImpersonatedMessageApiV1AdminUsersUserIdSendMessagePostData, SendImpersonatedMessageApiV1AdminUsersUserIdSendMessagePostErrors, SendImpersonatedMessageApiV1AdminUsersUserIdSendMessagePostResponses, SendInviteApiV1ReferralInvitePostData, SendInviteApiV1ReferralInvitePostErrors, SendInviteApiV1ReferralInvitePostResponses, SendPaymentLinkApiV1AdminHotelInvoicingItemsItemIdSendPaymentLinkPostData, SendPaymentLinkApiV1AdminHotelInvoicingItemsItemIdSendPaymentLinkPostErrors, SendPaymentLinkApiV1AdminHotelInvoicingItemsItemIdSendPaymentLinkPostResponses, SendTestEmailApiV1AdminSendTestEmailPostData, SendTestEmailApiV1AdminSendTestEmailPostErrors, SendTestEmailApiV1AdminSendTestEmailPostResponses, SendTravelCardLinkApiV1AdminCatchPaidInvoicingItemsItemIdSendTravelCardLinkPostData, SendTravelCardLinkApiV1AdminCatchPaidInvoicingItemsItemIdSendTravelCardLinkPostErrors, SendTravelCardLinkApiV1AdminCatchPaidInvoicingItemsItemIdSendTravelCardLinkPostResponses, SendWebPurchasePaymentLinkApiV1AdminWebPurchaseInvoicingItemsItemIdSendPaymentLinkPostData, SendWebPurchasePaymentLinkApiV1AdminWebPurchaseInvoicingItemsItemIdSendPaymentLinkPostErrors, SendWebPurchasePaymentLinkApiV1AdminWebPurchaseInvoicingItemsItemIdSendPaymentLinkPostResponses, ServeFileApiV1FilesFileIdFilenameGetData, ServeFileApiV1FilesFileIdFilenameGetErrors, ServeFileApiV1FilesFileIdFilenameGetResponses, ServeFileApiV1FilesFileIdGetData, ServeFileApiV1FilesFileIdGetErrors, ServeFileApiV1FilesFileIdGetResponses, ServeFileHeadApiV1FilesFileIdFilenameHeadData, ServeFileHeadApiV1FilesFileIdFilenameHeadErrors, ServeFileHeadApiV1FilesFileIdFilenameHeadResponses, ServeFileHeadApiV1FilesFileIdHeadData, ServeFileHeadApiV1FilesFileIdHeadErrors, ServeFileHeadApiV1FilesFileIdHeadResponses, SetAssistantEmailApiV1AssistantEmailPutData, SetAssistantEmailApiV1AssistantEmailPutErrors, SetAssistantEmailApiV1AssistantEmailPutResponses, SetAutomaticApprovalsApiV1AutomaticApprovalsPutData, SetAutomaticApprovalsApiV1AutomaticApprovalsPutErrors, SetAutomaticApprovalsApiV1AutomaticApprovalsPutResponses, SetAutonomyLevelApiV1AutomaticApprovalsLevelPutData, SetAutonomyLevelApiV1AutomaticApprovalsLevelPutErrors, SetAutonomyLevelApiV1AutomaticApprovalsLevelPutResponses, SetContactTextingConsentApiV1ContactTextingPutData, SetContactTextingConsentApiV1ContactTextingPutErrors, SetContactTextingConsentApiV1ContactTextingPutResponses, SetImessageContactCardApiV1AdminImessageContactCardPostData, SetImessageContactCardApiV1AdminImessageContactCardPostErrors, SetImessageContactCardApiV1AdminImessageContactCardPostResponses, ShareCustomIntegrationApiV1AdminCustomIntegrationsSpecIdSharesPostData, ShareCustomIntegrationApiV1AdminCustomIntegrationsSpecIdSharesPostErrors, ShareCustomIntegrationApiV1AdminCustomIntegrationsSpecIdSharesPostResponses, ShortcutStatusApiV1ShortcutGetData, ShortcutStatusApiV1ShortcutGetResponses, SignOutEverywhereApiV1AuthLogoutEverywherePostData, SignOutEverywhereApiV1AuthLogoutEverywherePostResponses, SkipFlightInvoiceApiV1AdminFlightInvoicingItemsItemIdSkipPostData, SkipFlightInvoiceApiV1AdminFlightInvoicingItemsItemIdSkipPostErrors, SkipFlightInvoiceApiV1AdminFlightInvoicingItemsItemIdSkipPostResponses, SkipInvoiceApiV1AdminHotelInvoicingItemsItemIdSkipPostData, SkipInvoiceApiV1AdminHotelInvoicingItemsItemIdSkipPostErrors, SkipInvoiceApiV1AdminHotelInvoicingItemsItemIdSkipPostResponses, SkipWebPurchaseInvoiceApiV1AdminWebPurchaseInvoicingItemsItemIdSkipPostData, SkipWebPurchaseInvoiceApiV1AdminWebPurchaseInvoicingItemsItemIdSkipPostErrors, SkipWebPurchaseInvoiceApiV1AdminWebPurchaseInvoicingItemsItemIdSkipPostResponses, SlackInteractiveActionsApiV1AssistantWebhooksSlackInteractivePostData, SlackInteractiveActionsApiV1AssistantWebhooksSlackInteractivePostErrors, SlackInteractiveActionsApiV1AssistantWebhooksSlackInteractivePostResponses, SlackWebhookApiV1AssistantWebhooksSlackPostData, SlackWebhookApiV1AssistantWebhooksSlackPostErrors, SlackWebhookApiV1AssistantWebhooksSlackPostResponses, SmsWebhookApiV1AssistantWebhooksSmsPostData, SmsWebhookApiV1AssistantWebhooksSmsPostErrors, SmsWebhookApiV1AssistantWebhooksSmsPostResponses, StartAgentOutgoingBackfillApiV1AdminBackfillAgentOutgoingPostData, StartAgentOutgoingBackfillApiV1AdminBackfillAgentOutgoingPostErrors, StartAgentOutgoingBackfillApiV1AdminBackfillAgentOutgoingPostResponses, StartBlogChatSessionApiV1PublicBlogChatSessionPostData, StartBlogChatSessionApiV1PublicBlogChatSessionPostErrors, StartBlogChatSessionApiV1PublicBlogChatSessionPostResponses, StartCustomIntegrationBuildApiV1AdminCustomIntegrationsBuildsPostData, StartCustomIntegrationBuildApiV1AdminCustomIntegrationsBuildsPostErrors, StartCustomIntegrationBuildApiV1AdminCustomIntegrationsBuildsPostResponses, StartCvChatSessionApiV1PublicCvChatSessionPostData, StartCvChatSessionApiV1PublicCvChatSessionPostErrors, StartCvChatSessionApiV1PublicCvChatSessionPostResponses, StripeWebhookApiV1StripeWebhookPostData, StripeWebhookApiV1StripeWebhookPostResponses, SubmitApprovalApiV1SchedulingLinksLinkIdApprovalPostData, SubmitApprovalApiV1SchedulingLinksLinkIdApprovalPostErrors, SubmitApprovalApiV1SchedulingLinksLinkIdApprovalPostResponses, SubmitConciergeAvailabilityApiV1PublicConciergeTokenAvailabilityPostData, SubmitConciergeAvailabilityApiV1PublicConciergeTokenAvailabilityPostErrors, SubmitConciergeAvailabilityApiV1PublicConciergeTokenAvailabilityPostResponses, SubmitCustomSecretsApiV1IntegrationsCustomSecretsPostData, SubmitCustomSecretsApiV1IntegrationsCustomSecretsPostErrors, SubmitCustomSecretsApiV1IntegrationsCustomSecretsPostResponses, SubmitLocationPingApiV1ShortcutLocationPostData, SubmitLocationPingApiV1ShortcutLocationPostErrors, SubmitLocationPingApiV1ShortcutLocationPostResponses, SubmitSignalApiV1ShortcutSignalPostData, SubmitSignalApiV1ShortcutSignalPostErrors, SubmitSignalApiV1ShortcutSignalPostResponses, SubmitVaultSecretsApiV1VaultSecretsPostData, SubmitVaultSecretsApiV1VaultSecretsPostErrors, SubmitVaultSecretsApiV1VaultSecretsPostResponses, SubmitVoiceNoteApiV1ShortcutVoicePostData, SubmitVoiceNoteApiV1ShortcutVoicePostErrors, SubmitVoiceNoteApiV1ShortcutVoicePostResponses, TerminateMobileChatSessionApiV1AdminMobileChatConversationsChannelIdentifierTerminatePostData, TerminateMobileChatSessionApiV1AdminMobileChatConversationsChannelIdentifierTerminatePostErrors, TerminateMobileChatSessionApiV1AdminMobileChatConversationsChannelIdentifierTerminatePostResponses, TriggerAnalyticsApiV1AdminTriggerAnalyticsPostData, TriggerAnalyticsApiV1AdminTriggerAnalyticsPostResponses, TriggerConflictModelTrainingApiV1AdminTrainConflictModelsPostData, TriggerConflictModelTrainingApiV1AdminTrainConflictModelsPostErrors, TriggerConflictModelTrainingApiV1AdminTrainConflictModelsPostResponses, TriggerSlotModelTrainingApiV1AdminTrainSlotModelsPostData, TriggerSlotModelTrainingApiV1AdminTrainSlotModelsPostErrors, TriggerSlotModelTrainingApiV1AdminTrainSlotModelsPostResponses, TriggerWelcomeMessageApiV1AdminUsersUserIdTriggerWelcomePostData, TriggerWelcomeMessageApiV1AdminUsersUserIdTriggerWelcomePostErrors, TriggerWelcomeMessageApiV1AdminUsersUserIdTriggerWelcomePostResponses, TwimlConnectApiV1PhoneTwimlConnectConversationIdPostData, TwimlConnectApiV1PhoneTwimlConnectConversationIdPostErrors, TwimlConnectApiV1PhoneTwimlConnectConversationIdPostResponses, TwimlStreamEndedApiV1PhoneTwimlStreamEndedConversationIdPostData, TwimlStreamEndedApiV1PhoneTwimlStreamEndedConversationIdPostErrors, TwimlStreamEndedApiV1PhoneTwimlStreamEndedConversationIdPostResponses, UnarchiveCustomIntegrationApiV1AdminCustomIntegrationsSpecIdUnarchivePostData, UnarchiveCustomIntegrationApiV1AdminCustomIntegrationsSpecIdUnarchivePostErrors, UnarchiveCustomIntegrationApiV1AdminCustomIntegrationsSpecIdUnarchivePostResponses, UnblockMobileChatIdentifierApiV1AdminMobileChatConversationsChannelIdentifierBlockDeleteData, UnblockMobileChatIdentifierApiV1AdminMobileChatConversationsChannelIdentifierBlockDeleteErrors, UnblockMobileChatIdentifierApiV1AdminMobileChatConversationsChannelIdentifierBlockDeleteResponses, UnshareCustomIntegrationApiV1AdminCustomIntegrationsSpecIdSharesUserIdDeleteData, UnshareCustomIntegrationApiV1AdminCustomIntegrationsSpecIdSharesUserIdDeleteErrors, UnshareCustomIntegrationApiV1AdminCustomIntegrationsSpecIdSharesUserIdDeleteResponses, UpdateAssistantV2PlanStepApiV1AdminUsersUserIdAssistantV2PlanStepIdPatchData, UpdateAssistantV2PlanStepApiV1AdminUsersUserIdAssistantV2PlanStepIdPatchErrors, UpdateAssistantV2PlanStepApiV1AdminUsersUserIdAssistantV2PlanStepIdPatchResponses, UpdateAssistantV2TriggerApiV1AdminUsersUserIdAssistantV2TriggersTriggerIdPatchData, UpdateAssistantV2TriggerApiV1AdminUsersUserIdAssistantV2TriggersTriggerIdPatchErrors, UpdateAssistantV2TriggerApiV1AdminUsersUserIdAssistantV2TriggersTriggerIdPatchResponses, UpdateCustomCharacterVoiceApiV1AuthCharactersCustomVoicePutData, UpdateCustomCharacterVoiceApiV1AuthCharactersCustomVoicePutErrors, UpdateCustomCharacterVoiceApiV1AuthCharactersCustomVoicePutResponses, UpdateImessagePhoneStatusApiV1AdminImessageStatusPostData, UpdateImessagePhoneStatusApiV1AdminImessageStatusPostErrors, UpdateImessagePhoneStatusApiV1AdminImessageStatusPostResponses, UpdateImessagePoolSettingApiV1AdminImessagePoolSettingsPostData, UpdateImessagePoolSettingApiV1AdminImessagePoolSettingsPostErrors, UpdateImessagePoolSettingApiV1AdminImessagePoolSettingsPostResponses, UpdateIntegrationApiV1WebhooksIntegrationsIntegrationIdPatchData, UpdateIntegrationApiV1WebhooksIntegrationsIntegrationIdPatchErrors, UpdateIntegrationApiV1WebhooksIntegrationsIntegrationIdPatchResponses, UpdateLinkApiV1SchedulingLinksLinkIdPatchData, UpdateLinkApiV1SchedulingLinksLinkIdPatchErrors, UpdateLinkApiV1SchedulingLinksLinkIdPatchResponses, UpdateSalesLeadDraftApiV1AdminSalesLeadsLeadIdPatchData, UpdateSalesLeadDraftApiV1AdminSalesLeadsLeadIdPatchErrors, UpdateSalesLeadDraftApiV1AdminSalesLeadsLeadIdPatchResponses, UpdateSlackPersonalAccessApiV1SlackPersonalAccessPutData, UpdateSlackPersonalAccessApiV1SlackPersonalAccessPutErrors, UpdateSlackPersonalAccessApiV1SlackPersonalAccessPutResponses, UpdateTeamsAccessApiV1TeamsAccessPutData, UpdateTeamsAccessApiV1TeamsAccessPutErrors, UpdateTeamsAccessApiV1TeamsAccessPutResponses, UpdateUseCaseApiV1AdminUseCasesUseCaseIdPatchData, UpdateUseCaseApiV1AdminUseCasesUseCaseIdPatchErrors, UpdateUseCaseApiV1AdminUseCasesUseCaseIdPatchResponses, UpdateUserAssistantCharacterApiV1AuthMeAssistantPutData, UpdateUserAssistantCharacterApiV1AuthMeAssistantPutErrors, UpdateUserAssistantCharacterApiV1AuthMeAssistantPutResponses, UpdateUserAssistantNameApiV1AuthMeAssistantNamePutData, UpdateUserAssistantNameApiV1AuthMeAssistantNamePutErrors, UpdateUserAssistantNameApiV1AuthMeAssistantNamePutResponses, UpdateWebAutomationScriptStatusApiV1AdminWebAutomationsScriptIdStatusPostData, UpdateWebAutomationScriptStatusApiV1AdminWebAutomationsScriptIdStatusPostErrors, UpdateWebAutomationScriptStatusApiV1AdminWebAutomationsScriptIdStatusPostResponses, UpgradeViaMagicLinkApiV1PublicOnboardingUpgradeGetData, UpgradeViaMagicLinkApiV1PublicOnboardingUpgradeGetErrors, UpgradeViaMagicLinkApiV1PublicOnboardingUpgradeGetResponses, UploadCustomCharacterPictureApiV1AuthCharactersCustomPicturePostData, UploadCustomCharacterPictureApiV1AuthCharactersCustomPicturePostErrors, UploadCustomCharacterPictureApiV1AuthCharactersCustomPicturePostResponses, UpsertOrganizationSsoApiV1AdminOrganizationsOrgIdSsoPutData, UpsertOrganizationSsoApiV1AdminOrganizationsOrgIdSsoPutErrors, UpsertOrganizationSsoApiV1AdminOrganizationsOrgIdSsoPutResponses, VerifyCustomIntegrationApiV1AdminCustomIntegrationsSpecIdVerifyPostData, VerifyCustomIntegrationApiV1AdminCustomIntegrationsSpecIdVerifyPostErrors, VerifyCustomIntegrationApiV1AdminCustomIntegrationsSpecIdVerifyPostResponses, VerifyMetaWebhookApiV1MetaLeadsWebhookGetData, VerifyMetaWebhookApiV1MetaLeadsWebhookGetErrors, VerifyMetaWebhookApiV1MetaLeadsWebhookGetResponses, VerifyPublicEmailApiV1SchedulingPublicLinkIdVerifyEmailPostData, VerifyPublicEmailApiV1SchedulingPublicLinkIdVerifyEmailPostErrors, VerifyPublicEmailApiV1SchedulingPublicLinkIdVerifyEmailPostResponses, VerifySmsCodeApiV1SmsVerifyCodePostData, VerifySmsCodeApiV1SmsVerifyCodePostErrors, VerifySmsCodeApiV1SmsVerifyCodePostResponses, VerifySubdomainApiV1AssistantEmailVerifyPostData, VerifySubdomainApiV1AssistantEmailVerifyPostErrors, VerifySubdomainApiV1AssistantEmailVerifyPostResponses, VoiceStatusWebhookApiV1PhoneWebhookVoiceStatusPostData, VoiceStatusWebhookApiV1PhoneWebhookVoiceStatusPostErrors, VoiceStatusWebhookApiV1PhoneWebhookVoiceStatusPostResponses, VoiceWebhookApiV1PhoneWebhookVoicePostData, VoiceWebhookApiV1PhoneWebhookVoicePostErrors, VoiceWebhookApiV1PhoneWebhookVoicePostResponses, WebhookHealthCheckApiV1WebhooksIncomingIntegrationIdGetData, WebhookHealthCheckApiV1WebhooksIncomingIntegrationIdGetErrors, WebhookHealthCheckApiV1WebhooksIncomingIntegrationIdGetResponses, WhatsappMetaVerifyApiV1AssistantWebhooksWhatsappMetaGetData, WhatsappMetaVerifyApiV1AssistantWebhooksWhatsappMetaGetResponses, WhatsappMetaWebhookApiV1AssistantWebhooksWhatsappMetaPostData, WhatsappMetaWebhookApiV1AssistantWebhooksWhatsappMetaPostResponses, WhatsappSipVoiceWebhookApiV1PhoneWebhookWhatsappSipVoicePostData, WhatsappSipVoiceWebhookApiV1PhoneWebhookWhatsappSipVoicePostErrors, WhatsappSipVoiceWebhookApiV1PhoneWebhookWhatsappSipVoicePostResponses, WhatsappVoiceWebhookApiV1PhoneWebhookWhatsappVoicePostData, WhatsappVoiceWebhookApiV1PhoneWebhookWhatsappVoicePostErrors, WhatsappVoiceWebhookApiV1PhoneWebhookWhatsappVoicePostResponses, WhatsappWebhookApiV1AssistantWebhooksWhatsappPostData, WhatsappWebhookApiV1AssistantWebhooksWhatsappPostErrors, WhatsappWebhookApiV1AssistantWebhooksWhatsappPostResponses, ZoomOauthRedirectApiV1AuthZoomCallbackGetData, ZoomOauthRedirectApiV1AuthZoomCallbackGetErrors, ZoomOauthRedirectApiV1AuthZoomCallbackGetResponses, ZoomWebhookApiV1AuthZoomWebhookPostData, ZoomWebhookApiV1AuthZoomWebhookPostResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Health Check
 */
export const healthCheckApiV1HealthGet = <ThrowOnError extends boolean = true>(options?: Options<HealthCheckApiV1HealthGetData, ThrowOnError>): RequestResult<HealthCheckApiV1HealthGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<HealthCheckApiV1HealthGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/health',
    ...options
});

/**
 * Keepalive Check
 *
 * Keepalive endpoint that verifies both app and database connectivity.
 */
export const keepaliveCheckApiV1KeepaliveGet = <ThrowOnError extends boolean = true>(options?: Options<KeepaliveCheckApiV1KeepaliveGetData, ThrowOnError>): RequestResult<KeepaliveCheckApiV1KeepaliveGetResponses, KeepaliveCheckApiV1KeepaliveGetErrors, ThrowOnError> => (options?.client ?? client).get<KeepaliveCheckApiV1KeepaliveGetResponses, KeepaliveCheckApiV1KeepaliveGetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/keepalive',
    ...options
});

/**
 * Detect Email Provider Endpoint
 *
 * Detect the email provider for a given email address via DNS MX records.
 *
 * Also reports whether the domain's organization has enterprise SSO
 * configured, which is what makes the login page offer the SSO button. That
 * lookup is a plain indexed read on a domain the caller already supplied, so
 * it leaks nothing they didn't already know.
 *
 * This endpoint does not require authentication as it is used
 * on the login page before the user has signed in.
 * Rate limited to 5 requests per minute per IP.
 */
export const detectEmailProviderEndpointApiV1AuthDetectEmailProviderPost = <ThrowOnError extends boolean = true>(options: Options<DetectEmailProviderEndpointApiV1AuthDetectEmailProviderPostData, ThrowOnError>): RequestResult<DetectEmailProviderEndpointApiV1AuthDetectEmailProviderPostResponses, DetectEmailProviderEndpointApiV1AuthDetectEmailProviderPostErrors, ThrowOnError> => (options.client ?? client).post<DetectEmailProviderEndpointApiV1AuthDetectEmailProviderPostResponses, DetectEmailProviderEndpointApiV1AuthDetectEmailProviderPostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/auth/detect-email-provider',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Login
 *
 * Initiate Google OAuth login flow.
 *
 * Only requests minimal scopes (openid, profile, email).
 * Additional scopes are requested incrementally via /request-scopes.
 *
 * Args:
 * force_consent: If True, force the consent screen to be shown.
 * ph_session_id: Current PostHog session ID, round-tripped via state so
 * the session recording can be stitched across the OAuth redirect.
 * ph_distinct_id: Current PostHog distinct ID, same purpose as above.
 * source: Entry source (e.g. ``refer`` from the Brand Ambassador page),
 * round-tripped via state so the callback lands the user on the right
 * page (e.g. /refer, skipping onboarding) even if sessionStorage is lost.
 */
export const loginApiV1AuthLoginGet = <ThrowOnError extends boolean = true>(options?: Options<LoginApiV1AuthLoginGetData, ThrowOnError>): RequestResult<LoginApiV1AuthLoginGetResponses, LoginApiV1AuthLoginGetErrors, ThrowOnError> => (options?.client ?? client).get<LoginApiV1AuthLoginGetResponses, LoginApiV1AuthLoginGetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/auth/login',
    ...options
});

/**
 * Cli Login
 *
 * Start a terminal login, to be completed at a loopback address.
 *
 * The browser goes through the ordinary Google flow; what differs is the last
 * hop, where :func:`auth_callback` returns it to ``127.0.0.1:<port>`` carrying
 * a one-time code instead of to the frontend. The caller supplies a PORT and
 * never a URL, so no value it controls can steer the redirect off the loopback
 * interface.
 *
 * ``code_challenge`` is the S256 hash of a secret the terminal keeps, and the
 * exchange demands the secret itself, so a code observed on the way past --
 * in a browser history entry, a local proxy -- cannot be spent by whoever
 * observed it (PKCE, RFC 7636).
 *
 * The residual risk is the one every loopback flow carries and PKCE cannot
 * close: a link crafted with an attacker's own challenge, clicked by a signed-
 * in user, delivers a code to a port on *their* machine, which is only useful
 * to a process already running there. That is the same position as reading the
 * 0600 token file the CLI writes, so the flow adds no reach that local code
 * execution did not already have (RFC 8252 s8.4).
 */
export const cliLoginApiV1AuthCliLoginGet = <ThrowOnError extends boolean = true>(options: Options<CliLoginApiV1AuthCliLoginGetData, ThrowOnError>): RequestResult<CliLoginApiV1AuthCliLoginGetResponses, CliLoginApiV1AuthCliLoginGetErrors, ThrowOnError> => (options.client ?? client).get<CliLoginApiV1AuthCliLoginGetResponses, CliLoginApiV1AuthCliLoginGetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/auth/cli/login',
    ...options
});

/**
 * Cli Token
 *
 * Trade a one-time code plus its verifier for the session token.
 */
export const cliTokenApiV1AuthCliTokenPost = <ThrowOnError extends boolean = true>(options: Options<CliTokenApiV1AuthCliTokenPostData, ThrowOnError>): RequestResult<CliTokenApiV1AuthCliTokenPostResponses, CliTokenApiV1AuthCliTokenPostErrors, ThrowOnError> => (options.client ?? client).post<CliTokenApiV1AuthCliTokenPostResponses, CliTokenApiV1AuthCliTokenPostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/auth/cli/token',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * App Link Entry
 *
 * Every link we hand a user into the app. Always redirects.
 *
 * Reached as ``{app host}/go?...``, which nginx 302s here so the link a user
 * sees is on the app's own domain — see :mod:`app.utils.app_links` for why
 * that matters. Behaviour is documented on :func:`_app_link_redirect`.
 */
export const appLinkEntryApiV1AuthAppLinkGet = <ThrowOnError extends boolean = true>(options?: Options<AppLinkEntryApiV1AuthAppLinkGetData, ThrowOnError>): RequestResult<AppLinkEntryApiV1AuthAppLinkGetResponses, AppLinkEntryApiV1AuthAppLinkGetErrors, ThrowOnError> => (options?.client ?? client).get<AppLinkEntryApiV1AuthAppLinkGetResponses, AppLinkEntryApiV1AuthAppLinkGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/app-link',
    ...options
});

/**
 * Connect Inbox
 *
 * The add-an-inbox link as GET-9017 shipped it, now one destination of many.
 *
 * Kept because it is already sitting in users' chat history: nothing mints it
 * any more, but a link a user was handed last week must not 404. New callers
 * use :func:`~app.utils.app_links.app_link`.
 */
export const connectInboxApiV1AuthConnectInboxGet = <ThrowOnError extends boolean = true>(options?: Options<ConnectInboxApiV1AuthConnectInboxGetData, ThrowOnError>): RequestResult<ConnectInboxApiV1AuthConnectInboxGetResponses, ConnectInboxApiV1AuthConnectInboxGetErrors, ThrowOnError> => (options?.client ?? client).get<ConnectInboxApiV1AuthConnectInboxGetResponses, ConnectInboxApiV1AuthConnectInboxGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/connect-inbox',
    ...options
});

/**
 * Request Scopes
 *
 * Request additional OAuth scope clusters for an authenticated user.
 *
 * This endpoint generates an OAuth URL for incremental scope authorization.
 * The user must already be logged in.
 *
 * Args:
 * scopes: Comma-separated cluster names (e.g., "mail_calendar,meet,docs").
 * return_path: Frontend path to redirect to after scope upgrade.
 * force_consent: Force Google to re-show the granular consent screen.
 * See ``AuthService.get_authorization_url_for_scopes`` for details.
 */
export const requestScopesApiV1AuthRequestScopesGet = <ThrowOnError extends boolean = true>(options?: Options<RequestScopesApiV1AuthRequestScopesGetData, ThrowOnError>): RequestResult<RequestScopesApiV1AuthRequestScopesGetResponses, RequestScopesApiV1AuthRequestScopesGetErrors, ThrowOnError> => (options?.client ?? client).get<RequestScopesApiV1AuthRequestScopesGetResponses, RequestScopesApiV1AuthRequestScopesGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/request-scopes',
    ...options
});

/**
 * Scope Status
 *
 * Get which scope clusters the user has granted.
 *
 * Dispatches by provider: Google uses the tokeninfo-backed check, Microsoft
 * uses a refresh-token-backed liveness probe (Microsoft has no incremental
 * consent, so the only post-signup "scope check" question is whether the
 * grant is still alive). Meet and Docs are Google-only surfaces — they
 * always report False for Microsoft users so the UI doesn't render the
 * "Connect" buttons against a stack that can't satisfy them.
 */
export const scopeStatusApiV1AuthScopeStatusGet = <ThrowOnError extends boolean = true>(options?: Options<ScopeStatusApiV1AuthScopeStatusGetData, ThrowOnError>): RequestResult<ScopeStatusApiV1AuthScopeStatusGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ScopeStatusApiV1AuthScopeStatusGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/scope-status',
    ...options
});

/**
 * Auth Callback
 */
export const authCallbackApiV1AuthCallbackGet = <ThrowOnError extends boolean = true>(options?: Options<AuthCallbackApiV1AuthCallbackGetData, ThrowOnError>): RequestResult<AuthCallbackApiV1AuthCallbackGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<AuthCallbackApiV1AuthCallbackGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/auth/callback',
    ...options
});

/**
 * Microsoft Login
 *
 * Initiate Microsoft OAuth flow.
 *
 * Shared by fresh signups (anonymous) and reconnects (authenticated
 * Microsoft user, e.g. after token revocation). Reconnects are pinned to
 * the signed-in account — login_hint preselects it in the chooser and the
 * callback verifies the returned ``oid`` (GET-8454), so a connected
 * personal account in the same browser can't hijack the session.
 *
 * An explicit ``login_hint`` on the query string names the account the user
 * asked for, mirroring the Google ``/login`` passthrough. It is read off the
 * raw query params rather than declared, so it stays out of the OpenAPI
 * schema and the generated SDKs.
 *
 * Deliberately takes no ``source``: nothing here pins an account, so there is
 * nothing for one to gate. The cost is that a signed-out visitor who reaches
 * ``/login?source=connect-inbox`` from ``/integrations`` and then picks
 * Microsoft lands on the dashboard rather than back on the inbox card --
 * Microsoft's ``state`` is an opaque MSAL token with nowhere to carry the
 * source, and Google recovers it from its own. The assistant's link skips
 * ``/login`` entirely and resumes on both providers, so this is only the
 * typed-or-bookmarked path (GET-9017).
 *
 * That cost is now paid only by a visitor who reached ``/login`` some *other*
 * way: anyone whose journey started at an app link carries
 * :data:`LINK_DESTINATION_COOKIE`, which the callback reads when the state
 * has no source -- so signing in from the login page, or from any attempt
 * other than the one the link started, resumes the destination (GET-15402).
 * A ``source`` parameter here would still be the better fix for the
 * ``/integrations`` -> ``/login`` case the paragraph above describes, since
 * that journey never passes through an app link and so plants no cookie.
 *
 * A hint for a *different* address than the signed-in user is a deliberate
 * account switch, not a reconnect (the personal-email intercept's
 * switch-to-work hand-off keeps the session alive, so a signup on a personal
 * Outlook address arrives here still authenticated). Treating that as a
 * reconnect would preselect the very account the user is trying to leave and
 * pin the callback to it, so the work account they then pick is rejected as a
 * mismatch. Dropping the reconnect there restores the fresh-signup path; a
 * hint that matches the session user is still a reconnect and keeps its pin.
 */
export const microsoftLoginApiV1AuthMicrosoftLoginGet = <ThrowOnError extends boolean = true>(options?: Options<MicrosoftLoginApiV1AuthMicrosoftLoginGetData, ThrowOnError>): RequestResult<MicrosoftLoginApiV1AuthMicrosoftLoginGetResponses, MicrosoftLoginApiV1AuthMicrosoftLoginGetErrors, ThrowOnError> => (options?.client ?? client).get<MicrosoftLoginApiV1AuthMicrosoftLoginGetResponses, MicrosoftLoginApiV1AuthMicrosoftLoginGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/microsoft/login',
    ...options
});

/**
 * Microsoft Auth Callback
 *
 * Handle Microsoft OAuth callback.
 */
export const microsoftAuthCallbackApiV1AuthMicrosoftCallbackGet = <ThrowOnError extends boolean = true>(options?: Options<MicrosoftAuthCallbackApiV1AuthMicrosoftCallbackGetData, ThrowOnError>): RequestResult<MicrosoftAuthCallbackApiV1AuthMicrosoftCallbackGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<MicrosoftAuthCallbackApiV1AuthMicrosoftCallbackGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/auth/microsoft/callback',
    ...options
});

/**
 * Okta Login
 *
 * Start an enterprise SSO login for the organization owning this domain.
 *
 * ``email`` is required because it is what identifies the tenant: unlike
 * Google and Microsoft there is no single Okta app to send everyone to, so
 * the domain selects the organization whose connection we use. The frontend
 * only calls this after ``/detect-email-provider`` has said the domain has
 * SSO, but this re-resolves independently rather than trusting the caller.
 */
export const oktaLoginApiV1AuthOktaLoginGet = <ThrowOnError extends boolean = true>(options: Options<OktaLoginApiV1AuthOktaLoginGetData, ThrowOnError>): RequestResult<OktaLoginApiV1AuthOktaLoginGetResponses, OktaLoginApiV1AuthOktaLoginGetErrors, ThrowOnError> => (options.client ?? client).get<OktaLoginApiV1AuthOktaLoginGetResponses, OktaLoginApiV1AuthOktaLoginGetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/auth/okta/login',
    ...options
});

/**
 * Okta Auth Callback
 *
 * Handle the Okta OIDC callback.
 */
export const oktaAuthCallbackApiV1AuthOktaCallbackGet = <ThrowOnError extends boolean = true>(options?: Options<OktaAuthCallbackApiV1AuthOktaCallbackGetData, ThrowOnError>): RequestResult<OktaAuthCallbackApiV1AuthOktaCallbackGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<OktaAuthCallbackApiV1AuthOktaCallbackGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/auth/okta/callback',
    ...options
});

/**
 * Get Current User
 */
export const getCurrentUserApiV1AuthMeGet = <ThrowOnError extends boolean = true>(options?: Options<GetCurrentUserApiV1AuthMeGetData, ThrowOnError>): RequestResult<GetCurrentUserApiV1AuthMeGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetCurrentUserApiV1AuthMeGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/me',
    ...options
});

/**
 * Get User Assistant Character
 *
 * Get the assistant character for the current user.
 */
export const getUserAssistantCharacterApiV1AuthMeAssistantGet = <ThrowOnError extends boolean = true>(options?: Options<GetUserAssistantCharacterApiV1AuthMeAssistantGetData, ThrowOnError>): RequestResult<GetUserAssistantCharacterApiV1AuthMeAssistantGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetUserAssistantCharacterApiV1AuthMeAssistantGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/me/assistant',
    ...options
});

/**
 * Update User Assistant Character
 *
 * Update the user's selected assistant character.
 *
 * A rename (``assistant_name_override``) deliberately survives a character
 * switch: it is the user's name for THEIR assistant, not a property of the
 * character, so picking Marcus after renaming Uta to Audrey gives Marcus's
 * persona and voice under the name Audrey (GET-14050).
 */
export const updateUserAssistantCharacterApiV1AuthMeAssistantPut = <ThrowOnError extends boolean = true>(options: Options<UpdateUserAssistantCharacterApiV1AuthMeAssistantPutData, ThrowOnError>): RequestResult<UpdateUserAssistantCharacterApiV1AuthMeAssistantPutResponses, UpdateUserAssistantCharacterApiV1AuthMeAssistantPutErrors, ThrowOnError> => (options.client ?? client).put<UpdateUserAssistantCharacterApiV1AuthMeAssistantPutResponses, UpdateUserAssistantCharacterApiV1AuthMeAssistantPutErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/me/assistant',
    ...options
});

/**
 * List Assistant Characters
 *
 * List all available assistant characters.
 *
 * Returns built-in characters for everyone. When authenticated,
 * also includes the user's custom character if one exists.
 */
export const listAssistantCharactersApiV1AuthCharactersGet = <ThrowOnError extends boolean = true>(options?: Options<ListAssistantCharactersApiV1AuthCharactersGetData, ThrowOnError>): RequestResult<ListAssistantCharactersApiV1AuthCharactersGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListAssistantCharactersApiV1AuthCharactersGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/characters',
    ...options
});

/**
 * Delete Custom Character
 *
 * Delete the user's custom character and reset to the default.
 */
export const deleteCustomCharacterApiV1AuthCharactersCustomDelete = <ThrowOnError extends boolean = true>(options?: Options<DeleteCustomCharacterApiV1AuthCharactersCustomDeleteData, ThrowOnError>): RequestResult<DeleteCustomCharacterApiV1AuthCharactersCustomDeleteResponses, unknown, ThrowOnError> => (options?.client ?? client).delete<DeleteCustomCharacterApiV1AuthCharactersCustomDeleteResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/characters/custom',
    ...options
});

/**
 * Create Custom Character
 *
 * Create or update the user's custom character.
 *
 * Each user may have one custom character. Creating a new one
 * replaces the existing one. The character is auto-selected and
 * a profile image is generated in the background.
 */
export const createCustomCharacterApiV1AuthCharactersCustomPost = <ThrowOnError extends boolean = true>(options: Options<CreateCustomCharacterApiV1AuthCharactersCustomPostData, ThrowOnError>): RequestResult<CreateCustomCharacterApiV1AuthCharactersCustomPostResponses, CreateCustomCharacterApiV1AuthCharactersCustomPostErrors, ThrowOnError> => (options.client ?? client).post<CreateCustomCharacterApiV1AuthCharactersCustomPostResponses, CreateCustomCharacterApiV1AuthCharactersCustomPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/characters/custom',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revert Custom Character Picture
 *
 * Drop the uploaded photo and regenerate a headshot in the background.
 *
 * Returns the character with no picture; the frontend polls until the
 * generated one lands, the same way it does after a persona edit.
 */
export const revertCustomCharacterPictureApiV1AuthCharactersCustomPictureDelete = <ThrowOnError extends boolean = true>(options?: Options<RevertCustomCharacterPictureApiV1AuthCharactersCustomPictureDeleteData, ThrowOnError>): RequestResult<RevertCustomCharacterPictureApiV1AuthCharactersCustomPictureDeleteResponses, unknown, ThrowOnError> => (options?.client ?? client).delete<RevertCustomCharacterPictureApiV1AuthCharactersCustomPictureDeleteResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/characters/custom/picture',
    ...options
});

/**
 * Upload Custom Character Picture
 *
 * Replace the user's custom character picture with a photo they upload.
 *
 * The photo lands on its own S3 key, so a generation workflow still in flight
 * cannot overwrite it, and ``profile_picture_uploaded_at`` both records the
 * provenance (edits to the persona no longer regenerate over it) and busts
 * the avatar route's 24h browser cache.
 */
export const uploadCustomCharacterPictureApiV1AuthCharactersCustomPicturePost = <ThrowOnError extends boolean = true>(options: Options<UploadCustomCharacterPictureApiV1AuthCharactersCustomPicturePostData, ThrowOnError>): RequestResult<UploadCustomCharacterPictureApiV1AuthCharactersCustomPicturePostResponses, UploadCustomCharacterPictureApiV1AuthCharactersCustomPicturePostErrors, ThrowOnError> => (options.client ?? client).post<UploadCustomCharacterPictureApiV1AuthCharactersCustomPicturePostResponses, UploadCustomCharacterPictureApiV1AuthCharactersCustomPicturePostErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/characters/custom/picture',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * List Character Voices
 *
 * List the voices a user can pick for their custom character.
 */
export const listCharacterVoicesApiV1AuthCharactersVoicesGet = <ThrowOnError extends boolean = true>(options?: Options<ListCharacterVoicesApiV1AuthCharactersVoicesGetData, ThrowOnError>): RequestResult<ListCharacterVoicesApiV1AuthCharactersVoicesGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListCharacterVoicesApiV1AuthCharactersVoicesGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/auth/characters/voices',
    ...options
});

/**
 * Get Voice Preview Audio
 *
 * Proxy a short audio sample of a voice (generated once, cached in S3).
 *
 * Unauthenticated like the character-picture proxy: voice samples are not
 * user-specific, and a plain <audio> element cannot carry a bearer token.
 *
 * Note this is NOT same-origin with the app (app.<domain> vs api.<domain>), so
 * the frontend's CSP has to name this origin in `media-src` — see the comment
 * in frontend/csp.inc. It falls back to `default-src 'self'` otherwise, and the
 * browser blocks the clip outright with no request and no sound (GET-10702).
 */
export const getVoicePreviewAudioApiV1AuthCharactersVoicesVoiceNamePreviewGet = <ThrowOnError extends boolean = true>(options: Options<GetVoicePreviewAudioApiV1AuthCharactersVoicesVoiceNamePreviewGetData, ThrowOnError>): RequestResult<GetVoicePreviewAudioApiV1AuthCharactersVoicesVoiceNamePreviewGetResponses, GetVoicePreviewAudioApiV1AuthCharactersVoicesVoiceNamePreviewGetErrors, ThrowOnError> => (options.client ?? client).get<GetVoicePreviewAudioApiV1AuthCharactersVoicesVoiceNamePreviewGetResponses, GetVoicePreviewAudioApiV1AuthCharactersVoicesVoiceNamePreviewGetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/auth/characters/voices/{voice_name}/preview',
    ...options
});

/**
 * Update Custom Character Voice
 *
 * Set the voice for the user's custom character.
 *
 * Lets users correct the auto-selected voice (e.g. a female-presenting persona
 * that was voiced by a male voice) without recreating the character (GET-7944).
 */
export const updateCustomCharacterVoiceApiV1AuthCharactersCustomVoicePut = <ThrowOnError extends boolean = true>(options: Options<UpdateCustomCharacterVoiceApiV1AuthCharactersCustomVoicePutData, ThrowOnError>): RequestResult<UpdateCustomCharacterVoiceApiV1AuthCharactersCustomVoicePutResponses, UpdateCustomCharacterVoiceApiV1AuthCharactersCustomVoicePutErrors, ThrowOnError> => (options.client ?? client).put<UpdateCustomCharacterVoiceApiV1AuthCharactersCustomVoicePutResponses, UpdateCustomCharacterVoiceApiV1AuthCharactersCustomVoicePutErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/characters/custom/voice',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update User Assistant Name
 *
 * Rename the user's assistant, or reset it to the character's own name.
 *
 * The Settings-page half of GET-14050; ``rename_assistant`` is the agent's.
 * Both write ``User.assistant_name_override``, which every surface that names
 * the assistant resolves through ``utils/assistant_name.py``. The selected
 * character is untouched: personality, picture and voice stay as they are.
 * A null or blank ``name`` clears the override.
 */
export const updateUserAssistantNameApiV1AuthMeAssistantNamePut = <ThrowOnError extends boolean = true>(options: Options<UpdateUserAssistantNameApiV1AuthMeAssistantNamePutData, ThrowOnError>): RequestResult<UpdateUserAssistantNameApiV1AuthMeAssistantNamePutResponses, UpdateUserAssistantNameApiV1AuthMeAssistantNamePutErrors, ThrowOnError> => (options.client ?? client).put<UpdateUserAssistantNameApiV1AuthMeAssistantNamePutResponses, UpdateUserAssistantNameApiV1AuthMeAssistantNamePutErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/me/assistant/name',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Complete Setup
 *
 * Mark the current user's initial setup as complete.
 */
export const completeSetupApiV1AuthMeCompleteSetupPost = <ThrowOnError extends boolean = true>(options?: Options<CompleteSetupApiV1AuthMeCompleteSetupPostData, ThrowOnError>): RequestResult<CompleteSetupApiV1AuthMeCompleteSetupPostResponses, unknown, ThrowOnError> => (options?.client ?? client).post<CompleteSetupApiV1AuthMeCompleteSetupPostResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/me/complete-setup',
    ...options
});

/**
 * Get Character Profile Picture
 *
 * Proxy a *built-in* character's profile picture from S3.
 *
 * Avoids CORS issues when the frontend fetches the image
 * (e.g., for embedding in vCard).
 *
 * This route is unauthenticated and keyed by sequential integer id, so it is
 * restricted to built-in (public, shared) characters (``user_id IS NULL``).
 * Custom characters — whose pictures are per-user AI-generated headshots
 * (PII) — must NOT be reachable here, or anyone could harvest them by
 * enumerating ids; they 404 (same as a missing character, so the response
 * doesn't reveal that a custom character exists at that id). Custom-character
 * images are exposed only via the opaque-token route
 * ``GET /api/v1/public/assistants/{token}/avatar`` (GET-8078 / GET-8075).
 */
export const getCharacterProfilePictureApiV1AuthCharactersCharacterIdPictureGet = <ThrowOnError extends boolean = true>(options: Options<GetCharacterProfilePictureApiV1AuthCharactersCharacterIdPictureGetData, ThrowOnError>): RequestResult<GetCharacterProfilePictureApiV1AuthCharactersCharacterIdPictureGetResponses, GetCharacterProfilePictureApiV1AuthCharactersCharacterIdPictureGetErrors, ThrowOnError> => (options.client ?? client).get<GetCharacterProfilePictureApiV1AuthCharactersCharacterIdPictureGetResponses, GetCharacterProfilePictureApiV1AuthCharactersCharacterIdPictureGetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/auth/characters/{character_id}/picture',
    ...options
});

/**
 * Logout
 *
 * End this session, including copied cookies and concurrent renewals.
 *
 * No credential is required so expired/absent cookies can still be removed.
 * A failed revocation write propagates as failure; do not acknowledge logout
 * while a copied, valid cookie could still authorize requests.
 */
export const logoutApiV1AuthLogoutPost = <ThrowOnError extends boolean = true>(options?: Options<LogoutApiV1AuthLogoutPostData, ThrowOnError>): RequestResult<LogoutApiV1AuthLogoutPostResponses, unknown, ThrowOnError> => (options?.client ?? client).post<LogoutApiV1AuthLogoutPostResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/logout',
    ...options
});

/**
 * Google Security Event
 *
 * Registered Google Cross-Account Protection receiver (signed SET body).
 */
export const googleSecurityEventApiV1AuthSecurityEventsGooglePost = <ThrowOnError extends boolean = true>(options?: Options<GoogleSecurityEventApiV1AuthSecurityEventsGooglePostData, ThrowOnError>): RequestResult<GoogleSecurityEventApiV1AuthSecurityEventsGooglePostResponses, unknown, ThrowOnError> => (options?.client ?? client).post<GoogleSecurityEventApiV1AuthSecurityEventsGooglePostResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/auth/security-events/google',
    ...options
});

/**
 * Oidc Security Logout
 *
 * Subject-wide OIDC back-channel logout, scoped to a configured tenant.
 */
export const oidcSecurityLogoutApiV1AuthSecurityEventsOidcOrganizationIdPost = <ThrowOnError extends boolean = true>(options: Options<OidcSecurityLogoutApiV1AuthSecurityEventsOidcOrganizationIdPostData, ThrowOnError>): RequestResult<OidcSecurityLogoutApiV1AuthSecurityEventsOidcOrganizationIdPostResponses, OidcSecurityLogoutApiV1AuthSecurityEventsOidcOrganizationIdPostErrors, ThrowOnError> => (options.client ?? client).post<OidcSecurityLogoutApiV1AuthSecurityEventsOidcOrganizationIdPostResponses, OidcSecurityLogoutApiV1AuthSecurityEventsOidcOrganizationIdPostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/auth/security-events/oidc/{organization_id}',
    ...options
});

/**
 * Sign Out Everywhere
 *
 * End every session this user has, on every device.
 *
 * A global revocation complements ordinary logout's per-browser denylist.
 * Clerk-authenticated requests also revoke the provider's active sessions.
 *
 * Bumping ``session_epoch`` invalidates every token minted before now --
 * including the caller's, hence clearing this browser's cookie too, which
 * also keeps the sliding renewal from handing the caller a fresh one on the
 * way out.
 */
export const signOutEverywhereApiV1AuthLogoutEverywherePost = <ThrowOnError extends boolean = true>(options?: Options<SignOutEverywhereApiV1AuthLogoutEverywherePostData, ThrowOnError>): RequestResult<SignOutEverywhereApiV1AuthLogoutEverywherePostResponses, unknown, ThrowOnError> => (options?.client ?? client).post<SignOutEverywhereApiV1AuthLogoutEverywherePostResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/logout/everywhere',
    ...options
});

/**
 * List Connected Email Accounts
 *
 * List the user's connected (personal) inboxes for the settings card.
 *
 * Includes auth-invalidated accounts (flagged ``needs_reauth``) so the UI can
 * prompt a reconnect instead of silently hiding a broken inbox.
 */
export const listConnectedEmailAccountsApiV1AuthConnectEmailAccountsGet = <ThrowOnError extends boolean = true>(options?: Options<ListConnectedEmailAccountsApiV1AuthConnectEmailAccountsGetData, ThrowOnError>): RequestResult<ListConnectedEmailAccountsApiV1AuthConnectEmailAccountsGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListConnectedEmailAccountsApiV1AuthConnectEmailAccountsGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/connect-email/accounts',
    ...options
});

/**
 * Get Addon Pricing
 *
 * The live add-on price shown in the connect modal.
 *
 * 404 when add-on billing isn't configured — no product id, or a product
 * with no active recurring price (``get_active_price`` raises). The modal
 * must never promise a price it can't bill: it renders the paused state and
 * blocks connecting.
 */
export const getAddonPricingApiV1AuthConnectEmailAddonPricingGet = <ThrowOnError extends boolean = true>(options?: Options<GetAddonPricingApiV1AuthConnectEmailAddonPricingGetData, ThrowOnError>): RequestResult<GetAddonPricingApiV1AuthConnectEmailAddonPricingGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetAddonPricingApiV1AuthConnectEmailAddonPricingGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/connect-email/addon-pricing',
    ...options
});

/**
 * Disconnect Connected Email
 *
 * Disconnect (delete) one of the user's connected personal inboxes.
 *
 * Deliberately NOT feature-flag-gated — users must always be able to revoke
 * the assistant's access to a personal inbox, even if the feature is off.
 * The delete cascades to the account's synced/tracked data.
 */
export const disconnectConnectedEmailApiV1AuthConnectEmailAccountsAccountIdDelete = <ThrowOnError extends boolean = true>(options: Options<DisconnectConnectedEmailApiV1AuthConnectEmailAccountsAccountIdDeleteData, ThrowOnError>): RequestResult<DisconnectConnectedEmailApiV1AuthConnectEmailAccountsAccountIdDeleteResponses, DisconnectConnectedEmailApiV1AuthConnectEmailAccountsAccountIdDeleteErrors, ThrowOnError> => (options.client ?? client).delete<DisconnectConnectedEmailApiV1AuthConnectEmailAccountsAccountIdDeleteResponses, DisconnectConnectedEmailApiV1AuthConnectEmailAccountsAccountIdDeleteErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/connect-email/accounts/{account_id}',
    ...options
});

/**
 * Connect Imap Inbox
 *
 * Connect (or re-enter the password for) an IMAP personal inbox.
 *
 * The login is tested BEFORE anything is saved or billed. Pipedream's IMAP
 * app saved credentials untested, so an account iCloud had never accepted
 * sat in Settings as "Connected" while every read failed (GET-17286). A
 * refusal here is a 400 carrying the server's own words, which is what the
 * user needs to fix it (usually: an app-specific password, not the account
 * password).
 *
 * Re-submitting the same server login is a reconnect: it replaces the stored
 * password and clears ``auth_invalid_at``, with billing untouched.
 */
export const connectImapInboxApiV1AuthConnectEmailImapPost = <ThrowOnError extends boolean = true>(options: Options<ConnectImapInboxApiV1AuthConnectEmailImapPostData, ThrowOnError>): RequestResult<ConnectImapInboxApiV1AuthConnectEmailImapPostResponses, ConnectImapInboxApiV1AuthConnectEmailImapPostErrors, ThrowOnError> => (options.client ?? client).post<ConnectImapInboxApiV1AuthConnectEmailImapPostResponses, ConnectImapInboxApiV1AuthConnectEmailImapPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/connect-email/imap',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Connect Email Google Authorize
 *
 * Start connecting a personal Gmail account for the authenticated user.
 */
export const connectEmailGoogleAuthorizeApiV1AuthConnectEmailGoogleAuthorizeGet = <ThrowOnError extends boolean = true>(options?: Options<ConnectEmailGoogleAuthorizeApiV1AuthConnectEmailGoogleAuthorizeGetData, ThrowOnError>): RequestResult<ConnectEmailGoogleAuthorizeApiV1AuthConnectEmailGoogleAuthorizeGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ConnectEmailGoogleAuthorizeApiV1AuthConnectEmailGoogleAuthorizeGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/connect-email/google/authorize',
    ...options
});

/**
 * Connect Email Google Callback
 *
 * Finish connecting: exchange the code and persist the connected account.
 *
 * The single Google-registered callback for BOTH account kinds — the kind
 * rides the state payload (personal flows mint ``knd=personal``; legacy
 * bare-CSRF states default to personal). Trusting it is safe because
 * ``_finish_connect`` rejects any state that doesn't byte-match the CSRF
 * cookie our own authorize endpoint set.
 */
export const connectEmailGoogleCallbackApiV1AuthConnectEmailGoogleCallbackGet = <ThrowOnError extends boolean = true>(options?: Options<ConnectEmailGoogleCallbackApiV1AuthConnectEmailGoogleCallbackGetData, ThrowOnError>): RequestResult<ConnectEmailGoogleCallbackApiV1AuthConnectEmailGoogleCallbackGetResponses, ConnectEmailGoogleCallbackApiV1AuthConnectEmailGoogleCallbackGetErrors, ThrowOnError> => (options?.client ?? client).get<ConnectEmailGoogleCallbackApiV1AuthConnectEmailGoogleCallbackGetResponses, ConnectEmailGoogleCallbackApiV1AuthConnectEmailGoogleCallbackGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/connect-email/google/callback',
    ...options
});

/**
 * Connect Email Assistant Google Authorize
 *
 * Start connecting a dedicated Google Workspace mailbox as the assistant's
 * email identity (no DNS delegation needed — see AssistantMailboxType.EXTERNAL).
 */
export const connectEmailAssistantGoogleAuthorizeApiV1AuthConnectEmailAssistantGoogleAuthorizeGet = <ThrowOnError extends boolean = true>(options?: Options<ConnectEmailAssistantGoogleAuthorizeApiV1AuthConnectEmailAssistantGoogleAuthorizeGetData, ThrowOnError>): RequestResult<ConnectEmailAssistantGoogleAuthorizeApiV1AuthConnectEmailAssistantGoogleAuthorizeGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ConnectEmailAssistantGoogleAuthorizeApiV1AuthConnectEmailAssistantGoogleAuthorizeGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/connect-email/assistant/google/authorize',
    ...options
});

/**
 * Connect Email Microsoft Authorize
 *
 * Start connecting a personal Outlook account for the authenticated user.
 */
export const connectEmailMicrosoftAuthorizeApiV1AuthConnectEmailMicrosoftAuthorizeGet = <ThrowOnError extends boolean = true>(options?: Options<ConnectEmailMicrosoftAuthorizeApiV1AuthConnectEmailMicrosoftAuthorizeGetData, ThrowOnError>): RequestResult<ConnectEmailMicrosoftAuthorizeApiV1AuthConnectEmailMicrosoftAuthorizeGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ConnectEmailMicrosoftAuthorizeApiV1AuthConnectEmailMicrosoftAuthorizeGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/connect-email/microsoft/authorize',
    ...options
});

/**
 * Connect Email Assistant Microsoft Authorize
 *
 * Start connecting a dedicated Microsoft 365 mailbox as the assistant's
 * email identity (no DNS delegation needed — see AssistantMailboxType.EXTERNAL).
 */
export const connectEmailAssistantMicrosoftAuthorizeApiV1AuthConnectEmailAssistantMicrosoftAuthorizeGet = <ThrowOnError extends boolean = true>(options?: Options<ConnectEmailAssistantMicrosoftAuthorizeApiV1AuthConnectEmailAssistantMicrosoftAuthorizeGetData, ThrowOnError>): RequestResult<ConnectEmailAssistantMicrosoftAuthorizeApiV1AuthConnectEmailAssistantMicrosoftAuthorizeGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ConnectEmailAssistantMicrosoftAuthorizeApiV1AuthConnectEmailAssistantMicrosoftAuthorizeGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/connect-email/assistant/microsoft/authorize',
    ...options
});

/**
 * Connect Email Microsoft Callback
 *
 * Finish connecting: exchange the code and persist the Outlook account.
 *
 * The single Azure-registered callback for BOTH account kinds — the kind
 * rides the state payload, exactly as on the Google side, so adding the
 * assistant flow needed no new redirect URI in the app registration.
 */
export const connectEmailMicrosoftCallbackApiV1AuthConnectEmailMicrosoftCallbackGet = <ThrowOnError extends boolean = true>(options?: Options<ConnectEmailMicrosoftCallbackApiV1AuthConnectEmailMicrosoftCallbackGetData, ThrowOnError>): RequestResult<ConnectEmailMicrosoftCallbackApiV1AuthConnectEmailMicrosoftCallbackGetResponses, ConnectEmailMicrosoftCallbackApiV1AuthConnectEmailMicrosoftCallbackGetErrors, ThrowOnError> => (options?.client ?? client).get<ConnectEmailMicrosoftCallbackApiV1AuthConnectEmailMicrosoftCallbackGetResponses, ConnectEmailMicrosoftCallbackApiV1AuthConnectEmailMicrosoftCallbackGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/connect-email/microsoft/callback',
    ...options
});

/**
 * Whatsapp Webhook
 *
 * Handle WhatsApp webhook from Twilio - enqueues processing workflow immediately
 */
export const whatsappWebhookApiV1AssistantWebhooksWhatsappPost = <ThrowOnError extends boolean = true>(options?: Options<WhatsappWebhookApiV1AssistantWebhooksWhatsappPostData, ThrowOnError>): RequestResult<WhatsappWebhookApiV1AssistantWebhooksWhatsappPostResponses, WhatsappWebhookApiV1AssistantWebhooksWhatsappPostErrors, ThrowOnError> => (options?.client ?? client).post<WhatsappWebhookApiV1AssistantWebhooksWhatsappPostResponses, WhatsappWebhookApiV1AssistantWebhooksWhatsappPostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/assistant/webhooks/whatsapp',
    ...options
});

/**
 * Whatsapp Meta Verify
 *
 * Meta's webhook verification handshake: echo ``hub.challenge`` when the
 * verify token matches.
 */
export const whatsappMetaVerifyApiV1AssistantWebhooksWhatsappMetaGet = <ThrowOnError extends boolean = true>(options?: Options<WhatsappMetaVerifyApiV1AssistantWebhooksWhatsappMetaGetData, ThrowOnError>): RequestResult<WhatsappMetaVerifyApiV1AssistantWebhooksWhatsappMetaGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<WhatsappMetaVerifyApiV1AssistantWebhooksWhatsappMetaGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/assistant/webhooks/whatsapp-meta',
    ...options
});

/**
 * Whatsapp Meta Webhook
 *
 * Inbound messages from the WhatsApp Cloud API (Meta direct).
 *
 * Each message is translated to the Twilio-shaped form the existing
 * ``process_whatsapp_webhook_workflow`` consumes, and enqueued under the same
 * idempotent workflow id the Twilio handler uses.
 */
export const whatsappMetaWebhookApiV1AssistantWebhooksWhatsappMetaPost = <ThrowOnError extends boolean = true>(options?: Options<WhatsappMetaWebhookApiV1AssistantWebhooksWhatsappMetaPostData, ThrowOnError>): RequestResult<WhatsappMetaWebhookApiV1AssistantWebhooksWhatsappMetaPostResponses, unknown, ThrowOnError> => (options?.client ?? client).post<WhatsappMetaWebhookApiV1AssistantWebhooksWhatsappMetaPostResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/assistant/webhooks/whatsapp-meta',
    ...options
});

/**
 * Sms Webhook
 *
 * Handle SMS webhook from Twilio - enqueues processing workflow immediately
 */
export const smsWebhookApiV1AssistantWebhooksSmsPost = <ThrowOnError extends boolean = true>(options?: Options<SmsWebhookApiV1AssistantWebhooksSmsPostData, ThrowOnError>): RequestResult<SmsWebhookApiV1AssistantWebhooksSmsPostResponses, SmsWebhookApiV1AssistantWebhooksSmsPostErrors, ThrowOnError> => (options?.client ?? client).post<SmsWebhookApiV1AssistantWebhooksSmsPostResponses, SmsWebhookApiV1AssistantWebhooksSmsPostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/assistant/webhooks/sms',
    ...options
});

/**
 * Rcs Webhook
 *
 * Handle RCS webhook from Twilio - enqueues processing workflow immediately
 */
export const rcsWebhookApiV1AssistantWebhooksRcsPost = <ThrowOnError extends boolean = true>(options?: Options<RcsWebhookApiV1AssistantWebhooksRcsPostData, ThrowOnError>): RequestResult<RcsWebhookApiV1AssistantWebhooksRcsPostResponses, RcsWebhookApiV1AssistantWebhooksRcsPostErrors, ThrowOnError> => (options?.client ?? client).post<RcsWebhookApiV1AssistantWebhooksRcsPostResponses, RcsWebhookApiV1AssistantWebhooksRcsPostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/assistant/webhooks/rcs',
    ...options
});

/**
 * Imessage Webhook
 *
 * Handle iMessage webhook from Linq API - enqueues processing workflow immediately.
 *
 * Linq sends webhook events with HMAC-SHA256 signature verification.
 */
export const imessageWebhookApiV1AssistantWebhooksImessagePost = <ThrowOnError extends boolean = true>(options?: Options<ImessageWebhookApiV1AssistantWebhooksImessagePostData, ThrowOnError>): RequestResult<ImessageWebhookApiV1AssistantWebhooksImessagePostResponses, unknown, ThrowOnError> => (options?.client ?? client).post<ImessageWebhookApiV1AssistantWebhooksImessagePostResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/assistant/webhooks/imessage',
    ...options
});

/**
 * Slack Webhook
 *
 * Handle Slack webhook events - enqueues processing workflow immediately
 */
export const slackWebhookApiV1AssistantWebhooksSlackPost = <ThrowOnError extends boolean = true>(options?: Options<SlackWebhookApiV1AssistantWebhooksSlackPostData, ThrowOnError>): RequestResult<SlackWebhookApiV1AssistantWebhooksSlackPostResponses, SlackWebhookApiV1AssistantWebhooksSlackPostErrors, ThrowOnError> => (options?.client ?? client).post<SlackWebhookApiV1AssistantWebhooksSlackPostResponses, SlackWebhookApiV1AssistantWebhooksSlackPostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/assistant/webhooks/slack',
    ...options
});

/**
 * Slack Interactive Actions
 *
 * Handle Slack interactive actions (button clicks, etc.)
 */
export const slackInteractiveActionsApiV1AssistantWebhooksSlackInteractivePost = <ThrowOnError extends boolean = true>(options?: Options<SlackInteractiveActionsApiV1AssistantWebhooksSlackInteractivePostData, ThrowOnError>): RequestResult<SlackInteractiveActionsApiV1AssistantWebhooksSlackInteractivePostResponses, SlackInteractiveActionsApiV1AssistantWebhooksSlackInteractivePostErrors, ThrowOnError> => (options?.client ?? client).post<SlackInteractiveActionsApiV1AssistantWebhooksSlackInteractivePostResponses, SlackInteractiveActionsApiV1AssistantWebhooksSlackInteractivePostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/assistant/webhooks/slack/interactive',
    ...options
});

/**
 * Get Assistant Email Status
 *
 * Return the assistant's current address + the available options.
 */
export const getAssistantEmailStatusApiV1AssistantEmailGet = <ThrowOnError extends boolean = true>(options?: Options<GetAssistantEmailStatusApiV1AssistantEmailGetData, ThrowOnError>): RequestResult<GetAssistantEmailStatusApiV1AssistantEmailGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetAssistantEmailStatusApiV1AssistantEmailGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/assistant-email',
    ...options
});

/**
 * Set Assistant Email
 *
 * Switch the assistant's address.
 *
 * * ``USER_ALIAS`` — revert to the plus-address (disable any hosted mailbox).
 * * ``CATCH_OWNED`` — allocate a numbered Catch address (active immediately).
 * * ``CATCH_SUBDOMAIN`` — provision the customer subdomain; the response's
 * ``pending_subdomain`` carries the magic link + NS records to send to IT.
 * * ``EXTERNAL`` — re-activate an already-connected assistant mailbox. A
 * first-time connect must go through the OAuth flow
 * (``/api/v1/auth/connect-email/assistant/{google,microsoft}/authorize``),
 * which activates on callback — this PUT only serves the switch-back case.
 */
export const setAssistantEmailApiV1AssistantEmailPut = <ThrowOnError extends boolean = true>(options: Options<SetAssistantEmailApiV1AssistantEmailPutData, ThrowOnError>): RequestResult<SetAssistantEmailApiV1AssistantEmailPutResponses, SetAssistantEmailApiV1AssistantEmailPutErrors, ThrowOnError> => (options.client ?? client).put<SetAssistantEmailApiV1AssistantEmailPutResponses, SetAssistantEmailApiV1AssistantEmailPutErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/assistant-email',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Change Handle
 *
 * Change the local part ("handle") of the user's hosted mailbox.
 *
 * Renames the current Catch-hosted address in place (the domain is untouched).
 * Mail to the old address stops resolving, so the UI warns first. Limited to
 * ``ASSISTANT_EMAIL_HANDLE_CHANGE_MAX`` changes per day per user.
 */
export const changeHandleApiV1AssistantEmailHandlePut = <ThrowOnError extends boolean = true>(options: Options<ChangeHandleApiV1AssistantEmailHandlePutData, ThrowOnError>): RequestResult<ChangeHandleApiV1AssistantEmailHandlePutResponses, ChangeHandleApiV1AssistantEmailHandlePutErrors, ThrowOnError> => (options.client ?? client).put<ChangeHandleApiV1AssistantEmailHandlePutResponses, ChangeHandleApiV1AssistantEmailHandlePutErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/assistant-email/handle',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Dns Instructions
 *
 * Return the NS records IT must add to delegate the subdomain to us.
 */
export const getDnsInstructionsApiV1AssistantEmailDnsInstructionsGet = <ThrowOnError extends boolean = true>(options: Options<GetDnsInstructionsApiV1AssistantEmailDnsInstructionsGetData, ThrowOnError>): RequestResult<GetDnsInstructionsApiV1AssistantEmailDnsInstructionsGetResponses, GetDnsInstructionsApiV1AssistantEmailDnsInstructionsGetErrors, ThrowOnError> => (options.client ?? client).get<GetDnsInstructionsApiV1AssistantEmailDnsInstructionsGetResponses, GetDnsInstructionsApiV1AssistantEmailDnsInstructionsGetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/assistant-email/dns-instructions',
    ...options
});

/**
 * Verify Subdomain
 *
 * Re-check SES verification and activate the mailbox once delegation is up.
 */
export const verifySubdomainApiV1AssistantEmailVerifyPost = <ThrowOnError extends boolean = true>(options: Options<VerifySubdomainApiV1AssistantEmailVerifyPostData, ThrowOnError>): RequestResult<VerifySubdomainApiV1AssistantEmailVerifyPostResponses, VerifySubdomainApiV1AssistantEmailVerifyPostErrors, ThrowOnError> => (options.client ?? client).post<VerifySubdomainApiV1AssistantEmailVerifyPostResponses, VerifySubdomainApiV1AssistantEmailVerifyPostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/assistant-email/verify',
    ...options
});

/**
 * Get Calendar Events
 *
 * Get calendar events for the current week (admin only with impersonation support)
 *
 * Args:
 * impersonate_user_id: Optional user ID to impersonate (admin only)
 * start_date: Optional start date (ISO format), defaults to start of current week
 * end_date: Optional end date (ISO format), defaults to end of current week
 * calendar_id: Calendar ID to fetch events from, defaults to "primary"
 * connected_account_id: Reads ``calendar_id`` from that connected
 * (personal) account instead of the work account — 404 unless it is
 * one of the target user's healthy, calendar-granted accounts. An id
 * rather than "the personal account": a user with several connected
 * inboxes has a calendar list in each (GET-8620, GET-16489).
 */
export const getCalendarEventsApiV1CalendarEventsGet = <ThrowOnError extends boolean = true>(options?: Options<GetCalendarEventsApiV1CalendarEventsGetData, ThrowOnError>): RequestResult<GetCalendarEventsApiV1CalendarEventsGetResponses, GetCalendarEventsApiV1CalendarEventsGetErrors, ThrowOnError> => (options?.client ?? client).get<GetCalendarEventsApiV1CalendarEventsGetResponses, GetCalendarEventsApiV1CalendarEventsGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/calendar/events',
    ...options
});

/**
 * Get Calendar Event
 *
 * Get a specific calendar event by ID (admin only with impersonation support)
 *
 * Args:
 * event_id: The Google Calendar event ID
 * impersonate_user_id: Optional user ID to impersonate (admin only)
 * calendar_id: Calendar ID to fetch event from, defaults to "primary"
 *
 * Returns:
 * Calendar event details including attendees, recurrence, and conference links
 */
export const getCalendarEventApiV1CalendarEventsEventIdGet = <ThrowOnError extends boolean = true>(options: Options<GetCalendarEventApiV1CalendarEventsEventIdGetData, ThrowOnError>): RequestResult<GetCalendarEventApiV1CalendarEventsEventIdGetResponses, GetCalendarEventApiV1CalendarEventsEventIdGetErrors, ThrowOnError> => (options.client ?? client).get<GetCalendarEventApiV1CalendarEventsEventIdGetResponses, GetCalendarEventApiV1CalendarEventsEventIdGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/calendar/events/{event_id}',
    ...options
});

/**
 * Get Calendars
 *
 * Get all calendars for the user (admin only with impersonation support)
 *
 * Args:
 * impersonate_user_id: Optional user ID to impersonate (admin only)
 *
 * Returns:
 * List of calendars available to the user, including shared calendars
 */
export const getCalendarsApiV1CalendarCalendarsGet = <ThrowOnError extends boolean = true>(options?: Options<GetCalendarsApiV1CalendarCalendarsGetData, ThrowOnError>): RequestResult<GetCalendarsApiV1CalendarCalendarsGetResponses, GetCalendarsApiV1CalendarCalendarsGetErrors, ThrowOnError> => (options?.client ?? client).get<GetCalendarsApiV1CalendarCalendarsGetResponses, GetCalendarsApiV1CalendarCalendarsGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/calendar/calendars',
    ...options
});

/**
 * Get Connected Calendars
 *
 * Get every connected (personal) account's calendars (admin only with
 * impersonation support)
 *
 * ``/calendars`` lists the work account only. Each connected inbox carries a
 * calendar list of its own, so each comes back on its own entry, with its
 * calendars or the reason they are missing. One account failing never sinks
 * the others, and is never shown as an account with no calendars.
 *
 * Args:
 * impersonate_user_id: Optional user ID to impersonate (admin only)
 */
export const getConnectedCalendarsApiV1CalendarConnectedCalendarsGet = <ThrowOnError extends boolean = true>(options?: Options<GetConnectedCalendarsApiV1CalendarConnectedCalendarsGetData, ThrowOnError>): RequestResult<GetConnectedCalendarsApiV1CalendarConnectedCalendarsGetResponses, GetConnectedCalendarsApiV1CalendarConnectedCalendarsGetErrors, ThrowOnError> => (options?.client ?? client).get<GetConnectedCalendarsApiV1CalendarConnectedCalendarsGetResponses, GetConnectedCalendarsApiV1CalendarConnectedCalendarsGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/calendar/connected-calendars',
    ...options
});

/**
 * Redirect To Attachment
 *
 * Stream a calendar attachment's bytes through this API.
 *
 * The file is proxied from S3 so the response never exposes the S3 bucket,
 * region, or credentials to the client. (The function name is retained for
 * OpenAPI/SDK stability; it no longer issues a redirect.)
 *
 * Returns:
 * - 200 with the file content served inline on success.
 * - 403 if the signature is invalid or the token has expired.
 * - 410 if the UserFile no longer exists, has passed retention, or its
 * underlying object cannot be fetched from storage.
 */
export const redirectToAttachmentApiV1CalendarAttachmentsFileIdGet = <ThrowOnError extends boolean = true>(options: Options<RedirectToAttachmentApiV1CalendarAttachmentsFileIdGetData, ThrowOnError>): RequestResult<RedirectToAttachmentApiV1CalendarAttachmentsFileIdGetResponses, RedirectToAttachmentApiV1CalendarAttachmentsFileIdGetErrors, ThrowOnError> => (options.client ?? client).get<RedirectToAttachmentApiV1CalendarAttachmentsFileIdGetResponses, RedirectToAttachmentApiV1CalendarAttachmentsFileIdGetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/calendar-attachments/{file_id}',
    ...options
});

/**
 * Get Recent Emails
 *
 * Get recent emails from the last N days.
 *
 * By default fetches metadata only (body will be placeholder text).
 * Use the /emails/{message_id} endpoint to fetch full email content.
 */
export const getRecentEmailsApiV1EmailsGet = <ThrowOnError extends boolean = true>(options?: Options<GetRecentEmailsApiV1EmailsGetData, ThrowOnError>): RequestResult<GetRecentEmailsApiV1EmailsGetResponses, GetRecentEmailsApiV1EmailsGetErrors, ThrowOnError> => (options?.client ?? client).get<GetRecentEmailsApiV1EmailsGetResponses, GetRecentEmailsApiV1EmailsGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/emails',
    ...options
});

/**
 * Get Email By Id
 *
 * Get full details of a specific email by message ID.
 *
 * This endpoint fetches the complete email content including body and attachments.
 */
export const getEmailByIdApiV1EmailsMessageIdGet = <ThrowOnError extends boolean = true>(options: Options<GetEmailByIdApiV1EmailsMessageIdGetData, ThrowOnError>): RequestResult<GetEmailByIdApiV1EmailsMessageIdGetResponses, GetEmailByIdApiV1EmailsMessageIdGetErrors, ThrowOnError> => (options.client ?? client).get<GetEmailByIdApiV1EmailsMessageIdGetResponses, GetEmailByIdApiV1EmailsMessageIdGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/emails/{message_id}',
    ...options
});

/**
 * Get All Users
 *
 * Get all users (admin only - requires @getea.ai or @catchagent.ai email)
 */
export const getAllUsersApiV1AdminUsersGet = <ThrowOnError extends boolean = true>(options?: Options<GetAllUsersApiV1AdminUsersGetData, ThrowOnError>): RequestResult<GetAllUsersApiV1AdminUsersGetResponses, GetAllUsersApiV1AdminUsersGetErrors, ThrowOnError> => (options?.client ?? client).get<GetAllUsersApiV1AdminUsersGetResponses, GetAllUsersApiV1AdminUsersGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users',
    ...options
});

/**
 * Get Non Admin Users
 *
 * Get list of non-admin users with full user details (admin only).
 *
 * Returns complete user information but filtered to exclude admin users.
 * Useful for user impersonation dropdowns in the chat interface.
 */
export const getNonAdminUsersApiV1AdminUsersNonAdminsGet = <ThrowOnError extends boolean = true>(options?: Options<GetNonAdminUsersApiV1AdminUsersNonAdminsGetData, ThrowOnError>): RequestResult<GetNonAdminUsersApiV1AdminUsersNonAdminsGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetNonAdminUsersApiV1AdminUsersNonAdminsGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/non-admins',
    ...options
});

/**
 * Get User Details
 *
 * Get detailed user info including profile, facts and notes (admin only)
 */
export const getUserDetailsApiV1AdminUsersUserIdDetailsGet = <ThrowOnError extends boolean = true>(options: Options<GetUserDetailsApiV1AdminUsersUserIdDetailsGetData, ThrowOnError>): RequestResult<GetUserDetailsApiV1AdminUsersUserIdDetailsGetResponses, GetUserDetailsApiV1AdminUsersUserIdDetailsGetErrors, ThrowOnError> => (options.client ?? client).get<GetUserDetailsApiV1AdminUsersUserIdDetailsGetResponses, GetUserDetailsApiV1AdminUsersUserIdDetailsGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/details',
    ...options
});

/**
 * Get User Acquisition
 *
 * Return where this user came from (admin only).
 *
 * Combines PostHog's first-touch attribution -- the only durable record of
 * the campaign, referrer and landing URL, since none of it is persisted
 * locally -- with the Stripe coupon ledger from our own database.
 *
 * A PostHog outage degrades to ``first_touch_available=False`` rather than
 * failing the request: this panel sits next to a support conversation, and
 * attribution is never worth blocking that on.
 */
export const getUserAcquisitionApiV1AdminUsersUserIdAcquisitionGet = <ThrowOnError extends boolean = true>(options: Options<GetUserAcquisitionApiV1AdminUsersUserIdAcquisitionGetData, ThrowOnError>): RequestResult<GetUserAcquisitionApiV1AdminUsersUserIdAcquisitionGetResponses, GetUserAcquisitionApiV1AdminUsersUserIdAcquisitionGetErrors, ThrowOnError> => (options.client ?? client).get<GetUserAcquisitionApiV1AdminUsersUserIdAcquisitionGetResponses, GetUserAcquisitionApiV1AdminUsersUserIdAcquisitionGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/acquisition',
    ...options
});

/**
 * Get User Google Calendar Settings
 *
 * Return the user's Google Calendar settings (admin only).
 *
 * By default reads from the 3-day Redis cache and falls back to a live
 * Google API call on miss. ``force_refresh=true`` always hits Google and
 * rewrites the cache.
 *
 * Returns ``available=False`` for users on Microsoft, users without
 * Google credentials, or when Google is unreachable.
 */
export const getUserGoogleCalendarSettingsApiV1AdminUsersUserIdGoogleCalendarSettingsGet = <ThrowOnError extends boolean = true>(options: Options<GetUserGoogleCalendarSettingsApiV1AdminUsersUserIdGoogleCalendarSettingsGetData, ThrowOnError>): RequestResult<GetUserGoogleCalendarSettingsApiV1AdminUsersUserIdGoogleCalendarSettingsGetResponses, GetUserGoogleCalendarSettingsApiV1AdminUsersUserIdGoogleCalendarSettingsGetErrors, ThrowOnError> => (options.client ?? client).get<GetUserGoogleCalendarSettingsApiV1AdminUsersUserIdGoogleCalendarSettingsGetResponses, GetUserGoogleCalendarSettingsApiV1AdminUsersUserIdGoogleCalendarSettingsGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/google-calendar-settings',
    ...options
});

/**
 * Deactivate User
 *
 * Deactivate a user (admin only).
 *
 * Requires @getea.ai or @catchagent.ai email.
 *
 * Disables the account, revokes its tokens and messaging integrations, pauses
 * background work, and tears down billing — releasing the member's team seat
 * and cancelling their own Stripe subscription. ``UserManagementService.
 * deactivate_user`` owns the exact sequence; this description deliberately
 * does not re-enumerate it, having twice gone stale as steps were added.
 *
 * Preserves all historical data (messages, preferences, reminders, facts).
 * User must re-authenticate to regain access.
 */
export const deactivateUserApiV1AdminUsersUserIdDeactivatePost = <ThrowOnError extends boolean = true>(options: Options<DeactivateUserApiV1AdminUsersUserIdDeactivatePostData, ThrowOnError>): RequestResult<DeactivateUserApiV1AdminUsersUserIdDeactivatePostResponses, DeactivateUserApiV1AdminUsersUserIdDeactivatePostErrors, ThrowOnError> => (options.client ?? client).post<DeactivateUserApiV1AdminUsersUserIdDeactivatePostResponses, DeactivateUserApiV1AdminUsersUserIdDeactivatePostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/deactivate',
    ...options
});

/**
 * Reactivate User
 *
 * Reactivate a deactivated user (admin only).
 *
 * Requires @getea.ai or @catchagent.ai email.
 *
 * Sets status = ACTIVE to allow the user to log in again.
 * User must re-authenticate through OAuth to restore their tokens and integrations.
 *
 * Does not restore the Stripe subscription deactivation cancelled — the user
 * re-subscribes through the normal checkout flow.
 */
export const reactivateUserApiV1AdminUsersUserIdReactivatePost = <ThrowOnError extends boolean = true>(options: Options<ReactivateUserApiV1AdminUsersUserIdReactivatePostData, ThrowOnError>): RequestResult<ReactivateUserApiV1AdminUsersUserIdReactivatePostResponses, ReactivateUserApiV1AdminUsersUserIdReactivatePostErrors, ThrowOnError> => (options.client ?? client).post<ReactivateUserApiV1AdminUsersUserIdReactivatePostResponses, ReactivateUserApiV1AdminUsersUserIdReactivatePostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/reactivate',
    ...options
});

/**
 * Get User Stats
 *
 * Get comprehensive statistics for a specific user (admin only).
 *
 * Returns metrics including:
 * - Messages sent by the user
 * - Messages sent to the user by the agent
 * - WhatsApp messages sent by the agent
 * - Slack messages sent by the agent
 * - Emails sent outside
 * - Total approval requests
 * - Approval ratio
 */
export const getUserStatsApiV1AdminUsersUserIdStatsGet = <ThrowOnError extends boolean = true>(options: Options<GetUserStatsApiV1AdminUsersUserIdStatsGetData, ThrowOnError>): RequestResult<GetUserStatsApiV1AdminUsersUserIdStatsGetResponses, GetUserStatsApiV1AdminUsersUserIdStatsGetErrors, ThrowOnError> => (options.client ?? client).get<GetUserStatsApiV1AdminUsersUserIdStatsGetResponses, GetUserStatsApiV1AdminUsersUserIdStatsGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/stats',
    ...options
});

/**
 * Grant Subscription
 *
 * Grant a free subscription to a user (admin only).
 */
export const grantSubscriptionApiV1AdminUsersUserIdGrantSubscriptionPost = <ThrowOnError extends boolean = true>(options: Options<GrantSubscriptionApiV1AdminUsersUserIdGrantSubscriptionPostData, ThrowOnError>): RequestResult<GrantSubscriptionApiV1AdminUsersUserIdGrantSubscriptionPostResponses, GrantSubscriptionApiV1AdminUsersUserIdGrantSubscriptionPostErrors, ThrowOnError> => (options.client ?? client).post<GrantSubscriptionApiV1AdminUsersUserIdGrantSubscriptionPostResponses, GrantSubscriptionApiV1AdminUsersUserIdGrantSubscriptionPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/grant-subscription',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Admin Note
 *
 * Create an admin note for a user (admin only).
 */
export const createAdminNoteApiV1AdminUsersUserIdAdminNotesPost = <ThrowOnError extends boolean = true>(options: Options<CreateAdminNoteApiV1AdminUsersUserIdAdminNotesPostData, ThrowOnError>): RequestResult<CreateAdminNoteApiV1AdminUsersUserIdAdminNotesPostResponses, CreateAdminNoteApiV1AdminUsersUserIdAdminNotesPostErrors, ThrowOnError> => (options.client ?? client).post<CreateAdminNoteApiV1AdminUsersUserIdAdminNotesPostResponses, CreateAdminNoteApiV1AdminUsersUserIdAdminNotesPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/admin-notes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Admin Note
 *
 * Delete an admin note (admin only).
 */
export const deleteAdminNoteApiV1AdminUsersUserIdAdminNotesNoteIdDelete = <ThrowOnError extends boolean = true>(options: Options<DeleteAdminNoteApiV1AdminUsersUserIdAdminNotesNoteIdDeleteData, ThrowOnError>): RequestResult<DeleteAdminNoteApiV1AdminUsersUserIdAdminNotesNoteIdDeleteResponses, DeleteAdminNoteApiV1AdminUsersUserIdAdminNotesNoteIdDeleteErrors, ThrowOnError> => (options.client ?? client).delete<DeleteAdminNoteApiV1AdminUsersUserIdAdminNotesNoteIdDeleteResponses, DeleteAdminNoteApiV1AdminUsersUserIdAdminNotesNoteIdDeleteErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/admin-notes/{note_id}',
    ...options
});

/**
 * List Organizations
 *
 * Every team with member/admin counts and billing status, newest first by default.
 *
 * ``sort``/``order`` order by any listed column; ``payment_status`` keeps one
 * subscription status, where ``"none"`` means a team with no status at all.
 */
export const listOrganizationsApiV1AdminOrganizationsGet = <ThrowOnError extends boolean = true>(options?: Options<ListOrganizationsApiV1AdminOrganizationsGetData, ThrowOnError>): RequestResult<ListOrganizationsApiV1AdminOrganizationsGetResponses, ListOrganizationsApiV1AdminOrganizationsGetErrors, ThrowOnError> => (options?.client ?? client).get<ListOrganizationsApiV1AdminOrganizationsGetResponses, ListOrganizationsApiV1AdminOrganizationsGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/organizations',
    ...options
});

/**
 * Get Organization Detail
 *
 * Full picture of one team: members, admins, billing, invoices, domain orphans.
 */
export const getOrganizationDetailApiV1AdminOrganizationsOrgIdGet = <ThrowOnError extends boolean = true>(options: Options<GetOrganizationDetailApiV1AdminOrganizationsOrgIdGetData, ThrowOnError>): RequestResult<GetOrganizationDetailApiV1AdminOrganizationsOrgIdGetResponses, GetOrganizationDetailApiV1AdminOrganizationsOrgIdGetErrors, ThrowOnError> => (options.client ?? client).get<GetOrganizationDetailApiV1AdminOrganizationsOrgIdGetResponses, GetOrganizationDetailApiV1AdminOrganizationsOrgIdGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/organizations/{org_id}',
    ...options
});

/**
 * Add Organization Member
 *
 * Directly add an existing user to the team (operator override, no invite).
 *
 * Bumps the team's Stripe seat count via the same billing reconciliation the
 * self-serve flow uses.
 */
export const addOrganizationMemberApiV1AdminOrganizationsOrgIdMembersPost = <ThrowOnError extends boolean = true>(options: Options<AddOrganizationMemberApiV1AdminOrganizationsOrgIdMembersPostData, ThrowOnError>): RequestResult<AddOrganizationMemberApiV1AdminOrganizationsOrgIdMembersPostResponses, AddOrganizationMemberApiV1AdminOrganizationsOrgIdMembersPostErrors, ThrowOnError> => (options.client ?? client).post<AddOrganizationMemberApiV1AdminOrganizationsOrgIdMembersPostResponses, AddOrganizationMemberApiV1AdminOrganizationsOrgIdMembersPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/organizations/{org_id}/members',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Organization Member
 *
 * Remove a member from the team (last admin is protected by the service).
 */
export const removeOrganizationMemberApiV1AdminOrganizationsOrgIdMembersUserIdDelete = <ThrowOnError extends boolean = true>(options: Options<RemoveOrganizationMemberApiV1AdminOrganizationsOrgIdMembersUserIdDeleteData, ThrowOnError>): RequestResult<RemoveOrganizationMemberApiV1AdminOrganizationsOrgIdMembersUserIdDeleteResponses, RemoveOrganizationMemberApiV1AdminOrganizationsOrgIdMembersUserIdDeleteErrors, ThrowOnError> => (options.client ?? client).delete<RemoveOrganizationMemberApiV1AdminOrganizationsOrgIdMembersUserIdDeleteResponses, RemoveOrganizationMemberApiV1AdminOrganizationsOrgIdMembersUserIdDeleteErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/organizations/{org_id}/members/{user_id}',
    ...options
});

/**
 * Cancel Organization Subscription
 *
 * Wind down the team's Stripe plan at the end of the paid period.
 *
 * For a team nobody is billed through any more (the seat quantity floors at
 * 1, so an emptied team keeps renewing). 400 while members are still
 * covered; a plan already ending reports `already_ending` rather than failing.
 */
export const cancelOrganizationSubscriptionApiV1AdminOrganizationsOrgIdSubscriptionCancelPost = <ThrowOnError extends boolean = true>(options: Options<CancelOrganizationSubscriptionApiV1AdminOrganizationsOrgIdSubscriptionCancelPostData, ThrowOnError>): RequestResult<CancelOrganizationSubscriptionApiV1AdminOrganizationsOrgIdSubscriptionCancelPostResponses, CancelOrganizationSubscriptionApiV1AdminOrganizationsOrgIdSubscriptionCancelPostErrors, ThrowOnError> => (options.client ?? client).post<CancelOrganizationSubscriptionApiV1AdminOrganizationsOrgIdSubscriptionCancelPostResponses, CancelOrganizationSubscriptionApiV1AdminOrganizationsOrgIdSubscriptionCancelPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/organizations/{org_id}/subscription/cancel',
    ...options
});

/**
 * Resume Organization Subscription
 *
 * Un-schedule the team plan's period-end cancellation.
 *
 * For an emptied team that was cancelled and has since refilled. Works on a
 * portal cancellation too, so make sure the admin actually wants the plan
 * back. 400 once the plan has ended; a plan not winding down reports
 * `not_ending` rather than failing.
 */
export const resumeOrganizationSubscriptionApiV1AdminOrganizationsOrgIdSubscriptionResumePost = <ThrowOnError extends boolean = true>(options: Options<ResumeOrganizationSubscriptionApiV1AdminOrganizationsOrgIdSubscriptionResumePostData, ThrowOnError>): RequestResult<ResumeOrganizationSubscriptionApiV1AdminOrganizationsOrgIdSubscriptionResumePostResponses, ResumeOrganizationSubscriptionApiV1AdminOrganizationsOrgIdSubscriptionResumePostErrors, ThrowOnError> => (options.client ?? client).post<ResumeOrganizationSubscriptionApiV1AdminOrganizationsOrgIdSubscriptionResumePostResponses, ResumeOrganizationSubscriptionApiV1AdminOrganizationsOrgIdSubscriptionResumePostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/organizations/{org_id}/subscription/resume',
    ...options
});

/**
 * Promote Organization Member
 *
 * Promote a team member to admin.
 */
export const promoteOrganizationMemberApiV1AdminOrganizationsOrgIdMembersUserIdPromotePost = <ThrowOnError extends boolean = true>(options: Options<PromoteOrganizationMemberApiV1AdminOrganizationsOrgIdMembersUserIdPromotePostData, ThrowOnError>): RequestResult<PromoteOrganizationMemberApiV1AdminOrganizationsOrgIdMembersUserIdPromotePostResponses, PromoteOrganizationMemberApiV1AdminOrganizationsOrgIdMembersUserIdPromotePostErrors, ThrowOnError> => (options.client ?? client).post<PromoteOrganizationMemberApiV1AdminOrganizationsOrgIdMembersUserIdPromotePostResponses, PromoteOrganizationMemberApiV1AdminOrganizationsOrgIdMembersUserIdPromotePostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/organizations/{org_id}/members/{user_id}/promote',
    ...options
});

/**
 * Demote Organization Member
 *
 * Demote a team admin back to member (last admin is protected by the service).
 */
export const demoteOrganizationMemberApiV1AdminOrganizationsOrgIdMembersUserIdDemotePost = <ThrowOnError extends boolean = true>(options: Options<DemoteOrganizationMemberApiV1AdminOrganizationsOrgIdMembersUserIdDemotePostData, ThrowOnError>): RequestResult<DemoteOrganizationMemberApiV1AdminOrganizationsOrgIdMembersUserIdDemotePostResponses, DemoteOrganizationMemberApiV1AdminOrganizationsOrgIdMembersUserIdDemotePostErrors, ThrowOnError> => (options.client ?? client).post<DemoteOrganizationMemberApiV1AdminOrganizationsOrgIdMembersUserIdDemotePostResponses, DemoteOrganizationMemberApiV1AdminOrganizationsOrgIdMembersUserIdDemotePostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/organizations/{org_id}/members/{user_id}/demote',
    ...options
});

/**
 * Release Organization Admin Seat
 *
 * Keep a team admin managing the team, but stop paying for their seat.
 *
 * They can still sign in to run the team and its billing; their own
 * assistant goes behind the paywall. The Stripe seat count drops with a
 * proration credit on the team's next invoice, so refunding the same seat
 * in Stripe as well pays it back twice. Admins only (400 for a member:
 * remove them instead).
 */
export const releaseOrganizationAdminSeatApiV1AdminOrganizationsOrgIdMembersUserIdReleaseSeatPost = <ThrowOnError extends boolean = true>(options: Options<ReleaseOrganizationAdminSeatApiV1AdminOrganizationsOrgIdMembersUserIdReleaseSeatPostData, ThrowOnError>): RequestResult<ReleaseOrganizationAdminSeatApiV1AdminOrganizationsOrgIdMembersUserIdReleaseSeatPostResponses, ReleaseOrganizationAdminSeatApiV1AdminOrganizationsOrgIdMembersUserIdReleaseSeatPostErrors, ThrowOnError> => (options.client ?? client).post<ReleaseOrganizationAdminSeatApiV1AdminOrganizationsOrgIdMembersUserIdReleaseSeatPostResponses, ReleaseOrganizationAdminSeatApiV1AdminOrganizationsOrgIdMembersUserIdReleaseSeatPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/organizations/{org_id}/members/{user_id}/release-seat',
    ...options
});

/**
 * Restore Organization Member Seat
 *
 * Give a seatless team admin their seat back (covered and billed again).
 */
export const restoreOrganizationMemberSeatApiV1AdminOrganizationsOrgIdMembersUserIdRestoreSeatPost = <ThrowOnError extends boolean = true>(options: Options<RestoreOrganizationMemberSeatApiV1AdminOrganizationsOrgIdMembersUserIdRestoreSeatPostData, ThrowOnError>): RequestResult<RestoreOrganizationMemberSeatApiV1AdminOrganizationsOrgIdMembersUserIdRestoreSeatPostResponses, RestoreOrganizationMemberSeatApiV1AdminOrganizationsOrgIdMembersUserIdRestoreSeatPostErrors, ThrowOnError> => (options.client ?? client).post<RestoreOrganizationMemberSeatApiV1AdminOrganizationsOrgIdMembersUserIdRestoreSeatPostResponses, RestoreOrganizationMemberSeatApiV1AdminOrganizationsOrgIdMembersUserIdRestoreSeatPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/organizations/{org_id}/members/{user_id}/restore-seat',
    ...options
});

/**
 * Delete Organization Sso
 *
 * Remove an org's SSO connection.
 *
 * Users already linked keep their accounts and fall back to Google/Microsoft
 * sign-in; deleting the connection revokes the route, not the access.
 */
export const deleteOrganizationSsoApiV1AdminOrganizationsOrgIdSsoDelete = <ThrowOnError extends boolean = true>(options: Options<DeleteOrganizationSsoApiV1AdminOrganizationsOrgIdSsoDeleteData, ThrowOnError>): RequestResult<DeleteOrganizationSsoApiV1AdminOrganizationsOrgIdSsoDeleteResponses, DeleteOrganizationSsoApiV1AdminOrganizationsOrgIdSsoDeleteErrors, ThrowOnError> => (options.client ?? client).delete<DeleteOrganizationSsoApiV1AdminOrganizationsOrgIdSsoDeleteResponses, DeleteOrganizationSsoApiV1AdminOrganizationsOrgIdSsoDeleteErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/organizations/{org_id}/sso',
    ...options
});

/**
 * Get Organization Sso
 *
 * Read an org's SSO connection (never its client secret).
 */
export const getOrganizationSsoApiV1AdminOrganizationsOrgIdSsoGet = <ThrowOnError extends boolean = true>(options: Options<GetOrganizationSsoApiV1AdminOrganizationsOrgIdSsoGetData, ThrowOnError>): RequestResult<GetOrganizationSsoApiV1AdminOrganizationsOrgIdSsoGetResponses, GetOrganizationSsoApiV1AdminOrganizationsOrgIdSsoGetErrors, ThrowOnError> => (options.client ?? client).get<GetOrganizationSsoApiV1AdminOrganizationsOrgIdSsoGetResponses, GetOrganizationSsoApiV1AdminOrganizationsOrgIdSsoGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/organizations/{org_id}/sso',
    ...options
});

/**
 * Upsert Organization Sso
 *
 * Create or update an org's SSO connection.
 *
 * Note the connection being present is not sufficient to switch SSO on for
 * the tenant — the `okta-sso` flag gates it independently, so a connection
 * can be set up and verified before any user is routed through it.
 */
export const upsertOrganizationSsoApiV1AdminOrganizationsOrgIdSsoPut = <ThrowOnError extends boolean = true>(options: Options<UpsertOrganizationSsoApiV1AdminOrganizationsOrgIdSsoPutData, ThrowOnError>): RequestResult<UpsertOrganizationSsoApiV1AdminOrganizationsOrgIdSsoPutResponses, UpsertOrganizationSsoApiV1AdminOrganizationsOrgIdSsoPutErrors, ThrowOnError> => (options.client ?? client).put<UpsertOrganizationSsoApiV1AdminOrganizationsOrgIdSsoPutResponses, UpsertOrganizationSsoApiV1AdminOrganizationsOrgIdSsoPutErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/organizations/{org_id}/sso',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Pause User Background Events
 *
 * Pause background event processing for a user (admin only)
 *
 * This stops the background worker from processing:
 * - Unread emails
 * - Calendar events
 * - Reminders
 *
 * The user can still interact via messages.
 */
export const pauseUserBackgroundEventsApiV1AdminUsersUserIdBackgroundEventsPausePost = <ThrowOnError extends boolean = true>(options: Options<PauseUserBackgroundEventsApiV1AdminUsersUserIdBackgroundEventsPausePostData, ThrowOnError>): RequestResult<PauseUserBackgroundEventsApiV1AdminUsersUserIdBackgroundEventsPausePostResponses, PauseUserBackgroundEventsApiV1AdminUsersUserIdBackgroundEventsPausePostErrors, ThrowOnError> => (options.client ?? client).post<PauseUserBackgroundEventsApiV1AdminUsersUserIdBackgroundEventsPausePostResponses, PauseUserBackgroundEventsApiV1AdminUsersUserIdBackgroundEventsPausePostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/background-events/pause',
    ...options
});

/**
 * Resume User Background Events
 *
 * Resume background event processing for a user (admin only)
 *
 * This allows the background worker to process:
 * - Unread emails
 * - Calendar events
 * - Reminders
 */
export const resumeUserBackgroundEventsApiV1AdminUsersUserIdBackgroundEventsResumePost = <ThrowOnError extends boolean = true>(options: Options<ResumeUserBackgroundEventsApiV1AdminUsersUserIdBackgroundEventsResumePostData, ThrowOnError>): RequestResult<ResumeUserBackgroundEventsApiV1AdminUsersUserIdBackgroundEventsResumePostResponses, ResumeUserBackgroundEventsApiV1AdminUsersUserIdBackgroundEventsResumePostErrors, ThrowOnError> => (options.client ?? client).post<ResumeUserBackgroundEventsApiV1AdminUsersUserIdBackgroundEventsResumePostResponses, ResumeUserBackgroundEventsApiV1AdminUsersUserIdBackgroundEventsResumePostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/background-events/resume',
    ...options
});

/**
 * Pause User Calendar Sync
 *
 * Pause calendar sync for a user (admin only)
 *
 * This stops the periodic calendar snapshot service from syncing calendar events
 * for this user. Calendar changes won't be detected until sync is resumed.
 *
 * The user can still interact via messages and other features.
 */
export const pauseUserCalendarSyncApiV1AdminUsersUserIdCalendarSyncPausePost = <ThrowOnError extends boolean = true>(options: Options<PauseUserCalendarSyncApiV1AdminUsersUserIdCalendarSyncPausePostData, ThrowOnError>): RequestResult<PauseUserCalendarSyncApiV1AdminUsersUserIdCalendarSyncPausePostResponses, PauseUserCalendarSyncApiV1AdminUsersUserIdCalendarSyncPausePostErrors, ThrowOnError> => (options.client ?? client).post<PauseUserCalendarSyncApiV1AdminUsersUserIdCalendarSyncPausePostResponses, PauseUserCalendarSyncApiV1AdminUsersUserIdCalendarSyncPausePostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/calendar-sync/pause',
    ...options
});

/**
 * Resume User Calendar Sync
 *
 * Resume calendar sync for a user (admin only)
 *
 * This allows the periodic calendar snapshot service to resume syncing
 * calendar events for this user.
 */
export const resumeUserCalendarSyncApiV1AdminUsersUserIdCalendarSyncResumePost = <ThrowOnError extends boolean = true>(options: Options<ResumeUserCalendarSyncApiV1AdminUsersUserIdCalendarSyncResumePostData, ThrowOnError>): RequestResult<ResumeUserCalendarSyncApiV1AdminUsersUserIdCalendarSyncResumePostResponses, ResumeUserCalendarSyncApiV1AdminUsersUserIdCalendarSyncResumePostErrors, ThrowOnError> => (options.client ?? client).post<ResumeUserCalendarSyncApiV1AdminUsersUserIdCalendarSyncResumePostResponses, ResumeUserCalendarSyncApiV1AdminUsersUserIdCalendarSyncResumePostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/calendar-sync/resume',
    ...options
});

/**
 * Get All Messages
 *
 * Get all messages with user information (admin only).
 *
 * ``limit`` is bounded for the same reason as ``/conversations/{user_id}``:
 * the query selects the large ``message``/``message_metadata`` JSON columns.
 */
export const getAllMessagesApiV1AdminMessagesGet = <ThrowOnError extends boolean = true>(options?: Options<GetAllMessagesApiV1AdminMessagesGetData, ThrowOnError>): RequestResult<GetAllMessagesApiV1AdminMessagesGetResponses, GetAllMessagesApiV1AdminMessagesGetErrors, ThrowOnError> => (options?.client ?? client).get<GetAllMessagesApiV1AdminMessagesGetResponses, GetAllMessagesApiV1AdminMessagesGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/messages',
    ...options
});

/**
 * Get Conversations
 *
 * Get conversations list grouped by user and channel (admin only)
 */
export const getConversationsApiV1AdminConversationsGet = <ThrowOnError extends boolean = true>(options?: Options<GetConversationsApiV1AdminConversationsGetData, ThrowOnError>): RequestResult<GetConversationsApiV1AdminConversationsGetResponses, GetConversationsApiV1AdminConversationsGetErrors, ThrowOnError> => (options?.client ?? client).get<GetConversationsApiV1AdminConversationsGetResponses, GetConversationsApiV1AdminConversationsGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/conversations',
    ...options
});

/**
 * Get Conversation Detail
 *
 * Get full conversation details for a specific user (admin only).
 *
 * ``limit`` is bounded because the underlying query selects the large
 * ``message``/``message_metadata`` JSON columns; an unbounded row count let a
 * single request pull multi-GB into a pod (the GET-9428 OOM class).
 */
export const getConversationDetailApiV1AdminConversationsUserIdGet = <ThrowOnError extends boolean = true>(options: Options<GetConversationDetailApiV1AdminConversationsUserIdGetData, ThrowOnError>): RequestResult<GetConversationDetailApiV1AdminConversationsUserIdGetResponses, GetConversationDetailApiV1AdminConversationsUserIdGetErrors, ThrowOnError> => (options.client ?? client).get<GetConversationDetailApiV1AdminConversationsUserIdGetResponses, GetConversationDetailApiV1AdminConversationsUserIdGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/conversations/{user_id}',
    ...options
});

/**
 * Get Conversation Statistics
 *
 * Get comprehensive daily conversation and user activity statistics (admin only).
 *
 * Returns metrics for today (00:00-23:59 UTC) to provide consistent daily
 * dashboard snapshots.
 *
 * Returns:
 * ConversationStatisticsResponse with metrics including:
 * - User activity: DAU (daily active users)
 * - Conversations: Total, averages, duration
 * - Messages: Volume, engagement metrics
 * - Tool approvals: Approval rates, response times
 * - Breakdowns: By channel, top users
 *
 * Requires @getea.ai or @catchagent.ai email.
 */
export const getConversationStatisticsApiV1AdminConversationStatisticsGet = <ThrowOnError extends boolean = true>(options?: Options<GetConversationStatisticsApiV1AdminConversationStatisticsGetData, ThrowOnError>): RequestResult<GetConversationStatisticsApiV1AdminConversationStatisticsGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetConversationStatisticsApiV1AdminConversationStatisticsGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/conversation-statistics',
    ...options
});

/**
 * Send Impersonated Message
 *
 * Send a message to a user as if it came from the assistant (admin only)
 *
 * The message will be:
 * 1. Saved to conversation history as an assistant message
 * 2. Sent through the specified communication channel
 */
export const sendImpersonatedMessageApiV1AdminUsersUserIdSendMessagePost = <ThrowOnError extends boolean = true>(options: Options<SendImpersonatedMessageApiV1AdminUsersUserIdSendMessagePostData, ThrowOnError>): RequestResult<SendImpersonatedMessageApiV1AdminUsersUserIdSendMessagePostResponses, SendImpersonatedMessageApiV1AdminUsersUserIdSendMessagePostErrors, ThrowOnError> => (options.client ?? client).post<SendImpersonatedMessageApiV1AdminUsersUserIdSendMessagePostResponses, SendImpersonatedMessageApiV1AdminUsersUserIdSendMessagePostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/send-message',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get User Whatsapp Conversation
 *
 * Get WhatsApp conversation history from Twilio for a specific user (admin only)
 *
 * Fetches the last N messages between the user and the assistant via Twilio.
 * Messages are sorted in chronological order (oldest first).
 *
 * Args:
 * before_date: Optional ISO 8601 timestamp to fetch messages before this date.
 * Used for pagination to load older messages.
 */
export const getUserWhatsappConversationApiV1AdminUsersUserIdWhatsappConversationGet = <ThrowOnError extends boolean = true>(options: Options<GetUserWhatsappConversationApiV1AdminUsersUserIdWhatsappConversationGetData, ThrowOnError>): RequestResult<GetUserWhatsappConversationApiV1AdminUsersUserIdWhatsappConversationGetResponses, GetUserWhatsappConversationApiV1AdminUsersUserIdWhatsappConversationGetErrors, ThrowOnError> => (options.client ?? client).get<GetUserWhatsappConversationApiV1AdminUsersUserIdWhatsappConversationGetResponses, GetUserWhatsappConversationApiV1AdminUsersUserIdWhatsappConversationGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/whatsapp-conversation',
    ...options
});

/**
 * Get User Slack Conversation
 *
 * Get Slack conversation history from Slack API for a specific user (admin only)
 *
 * Fetches the last N messages between the user and the assistant via Slack.
 * Messages are sorted in chronological order (oldest first).
 *
 * Args:
 * before_timestamp: Optional Slack timestamp to fetch messages before this time.
 * Used for pagination to load older messages.
 */
export const getUserSlackConversationApiV1AdminUsersUserIdSlackConversationGet = <ThrowOnError extends boolean = true>(options: Options<GetUserSlackConversationApiV1AdminUsersUserIdSlackConversationGetData, ThrowOnError>): RequestResult<GetUserSlackConversationApiV1AdminUsersUserIdSlackConversationGetResponses, GetUserSlackConversationApiV1AdminUsersUserIdSlackConversationGetErrors, ThrowOnError> => (options.client ?? client).get<GetUserSlackConversationApiV1AdminUsersUserIdSlackConversationGetResponses, GetUserSlackConversationApiV1AdminUsersUserIdSlackConversationGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/slack-conversation',
    ...options
});

/**
 * Get Slack Thread Replies
 *
 * Get thread replies from a user's Slack conversation.
 *
 * Args:
 * user_id: ID of the user
 * thread_ts: Timestamp of the thread parent message
 * db: Database session
 * limit: Maximum number of thread replies to retrieve (default 50)
 * channel_id: Optional channel ID. If not provided, uses the user's DM channel.
 *
 * Returns:
 * SlackConversationResponse with thread messages
 */
export const getSlackThreadRepliesApiV1AdminUsersUserIdSlackThreadThreadTsGet = <ThrowOnError extends boolean = true>(options: Options<GetSlackThreadRepliesApiV1AdminUsersUserIdSlackThreadThreadTsGetData, ThrowOnError>): RequestResult<GetSlackThreadRepliesApiV1AdminUsersUserIdSlackThreadThreadTsGetResponses, GetSlackThreadRepliesApiV1AdminUsersUserIdSlackThreadThreadTsGetErrors, ThrowOnError> => (options.client ?? client).get<GetSlackThreadRepliesApiV1AdminUsersUserIdSlackThreadThreadTsGetResponses, GetSlackThreadRepliesApiV1AdminUsersUserIdSlackThreadThreadTsGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/slack-thread/{thread_ts}',
    ...options
});

/**
 * Get User Slack Channels
 *
 * Get Slack channels with activity for a specific user (admin only).
 *
 * Returns the DM channel plus any channels where the bot has thread
 * associations or communication subagent conversations for this user.
 */
export const getUserSlackChannelsApiV1AdminUsersUserIdSlackChannelsGet = <ThrowOnError extends boolean = true>(options: Options<GetUserSlackChannelsApiV1AdminUsersUserIdSlackChannelsGetData, ThrowOnError>): RequestResult<GetUserSlackChannelsApiV1AdminUsersUserIdSlackChannelsGetResponses, GetUserSlackChannelsApiV1AdminUsersUserIdSlackChannelsGetErrors, ThrowOnError> => (options.client ?? client).get<GetUserSlackChannelsApiV1AdminUsersUserIdSlackChannelsGetResponses, GetUserSlackChannelsApiV1AdminUsersUserIdSlackChannelsGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/slack-channels',
    ...options
});

/**
 * Get Slack Channel Messages
 *
 * Get Slack messages from any channel for a specific user (admin only).
 *
 * Fetches messages from the specified channel. Works with DM channels,
 * public channels, and private channels that the bot is a member of.
 * Messages are sorted in chronological order (oldest first).
 *
 * Args:
 * user_id: ID of the user
 * channel_id: Slack channel ID to fetch messages from
 * limit: Maximum number of messages to return (default 100)
 * before_timestamp: Optional Slack timestamp for pagination
 */
export const getSlackChannelMessagesApiV1AdminUsersUserIdSlackChannelsChannelIdMessagesGet = <ThrowOnError extends boolean = true>(options: Options<GetSlackChannelMessagesApiV1AdminUsersUserIdSlackChannelsChannelIdMessagesGetData, ThrowOnError>): RequestResult<GetSlackChannelMessagesApiV1AdminUsersUserIdSlackChannelsChannelIdMessagesGetResponses, GetSlackChannelMessagesApiV1AdminUsersUserIdSlackChannelsChannelIdMessagesGetErrors, ThrowOnError> => (options.client ?? client).get<GetSlackChannelMessagesApiV1AdminUsersUserIdSlackChannelsChannelIdMessagesGetResponses, GetSlackChannelMessagesApiV1AdminUsersUserIdSlackChannelsChannelIdMessagesGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/slack-channels/{channel_id}/messages',
    ...options
});

/**
 * Get User Slack Users
 *
 * Get workspace user directory for a user's Slack workspace (admin only).
 *
 * Returns user names, avatars, and bot status for all users in the workspace.
 * Cached for 120 seconds since workspace membership changes rarely.
 */
export const getUserSlackUsersApiV1AdminUsersUserIdSlackUsersGet = <ThrowOnError extends boolean = true>(options: Options<GetUserSlackUsersApiV1AdminUsersUserIdSlackUsersGetData, ThrowOnError>): RequestResult<GetUserSlackUsersApiV1AdminUsersUserIdSlackUsersGetResponses, GetUserSlackUsersApiV1AdminUsersUserIdSlackUsersGetErrors, ThrowOnError> => (options.client ?? client).get<GetUserSlackUsersApiV1AdminUsersUserIdSlackUsersGetResponses, GetUserSlackUsersApiV1AdminUsersUserIdSlackUsersGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/slack-users',
    ...options
});

/**
 * Get Whatsapp Conversation By Phone
 *
 * Get WhatsApp conversation history from Twilio for an external phone number.
 *
 * Admin only. Fetches messages between the secondary WhatsApp bot and an external
 * phone. This endpoint is for subagent conversations with external guests, which
 * use the secondary WhatsApp number.
 * Messages are sorted in chronological order (oldest first).
 *
 * Args:
 * phone_number: The external phone number (with country code, e.g., +1234567890)
 * limit: Maximum number of messages to return (default 100)
 * before_date: Optional ISO 8601 timestamp to fetch messages before this date.
 * Used for pagination to load older messages.
 */
export const getWhatsappConversationByPhoneApiV1AdminWhatsappConversationByPhoneGet = <ThrowOnError extends boolean = true>(options: Options<GetWhatsappConversationByPhoneApiV1AdminWhatsappConversationByPhoneGetData, ThrowOnError>): RequestResult<GetWhatsappConversationByPhoneApiV1AdminWhatsappConversationByPhoneGetResponses, GetWhatsappConversationByPhoneApiV1AdminWhatsappConversationByPhoneGetErrors, ThrowOnError> => (options.client ?? client).get<GetWhatsappConversationByPhoneApiV1AdminWhatsappConversationByPhoneGetResponses, GetWhatsappConversationByPhoneApiV1AdminWhatsappConversationByPhoneGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/whatsapp-conversation-by-phone',
    ...options
});

/**
 * Get User Messaging Channels
 *
 * Get configured messaging channels for a user (admin only).
 */
export const getUserMessagingChannelsApiV1AdminUsersUserIdMessagingChannelsGet = <ThrowOnError extends boolean = true>(options: Options<GetUserMessagingChannelsApiV1AdminUsersUserIdMessagingChannelsGetData, ThrowOnError>): RequestResult<GetUserMessagingChannelsApiV1AdminUsersUserIdMessagingChannelsGetResponses, GetUserMessagingChannelsApiV1AdminUsersUserIdMessagingChannelsGetErrors, ThrowOnError> => (options.client ?? client).get<GetUserMessagingChannelsApiV1AdminUsersUserIdMessagingChannelsGetResponses, GetUserMessagingChannelsApiV1AdminUsersUserIdMessagingChannelsGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/messaging-channels',
    ...options
});

/**
 * Get User Phone Calls
 *
 * Get a user's phone calls with transcripts (admin only).
 *
 * Reads ``PhoneCallSession`` rows joined to their subagent conversation
 * (``channel == phone``), newest first, and attaches each conversation's
 * ``exchange_log`` as the transcript. Read-only; feeds the unified
 * conversation timeline in the backoffice.
 *
 * ``limit`` is bounded because ``exchange_log`` is a JSON transcript blob —
 * the same unbounded-rows-times-blob-column hazard as the message readers.
 */
export const getUserPhoneCallsApiV1AdminUsersUserIdPhoneCallsGet = <ThrowOnError extends boolean = true>(options: Options<GetUserPhoneCallsApiV1AdminUsersUserIdPhoneCallsGetData, ThrowOnError>): RequestResult<GetUserPhoneCallsApiV1AdminUsersUserIdPhoneCallsGetResponses, GetUserPhoneCallsApiV1AdminUsersUserIdPhoneCallsGetErrors, ThrowOnError> => (options.client ?? client).get<GetUserPhoneCallsApiV1AdminUsersUserIdPhoneCallsGetResponses, GetUserPhoneCallsApiV1AdminUsersUserIdPhoneCallsGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/phone-calls',
    ...options
});

/**
 * Get User Sms Conversation
 *
 * Get SMS conversation history from Twilio for a specific user (admin only).
 *
 * Fetches messages between all configured SMS numbers and the user's phone.
 */
export const getUserSmsConversationApiV1AdminUsersUserIdSmsConversationGet = <ThrowOnError extends boolean = true>(options: Options<GetUserSmsConversationApiV1AdminUsersUserIdSmsConversationGetData, ThrowOnError>): RequestResult<GetUserSmsConversationApiV1AdminUsersUserIdSmsConversationGetResponses, GetUserSmsConversationApiV1AdminUsersUserIdSmsConversationGetErrors, ThrowOnError> => (options.client ?? client).get<GetUserSmsConversationApiV1AdminUsersUserIdSmsConversationGetResponses, GetUserSmsConversationApiV1AdminUsersUserIdSmsConversationGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/sms-conversation',
    ...options
});

/**
 * Get User Rcs Conversation
 *
 * Get RCS conversation history from Twilio for a specific user (admin only).
 *
 * Fetches messages between the RCS sender and the user's RCS address.
 */
export const getUserRcsConversationApiV1AdminUsersUserIdRcsConversationGet = <ThrowOnError extends boolean = true>(options: Options<GetUserRcsConversationApiV1AdminUsersUserIdRcsConversationGetData, ThrowOnError>): RequestResult<GetUserRcsConversationApiV1AdminUsersUserIdRcsConversationGetResponses, GetUserRcsConversationApiV1AdminUsersUserIdRcsConversationGetErrors, ThrowOnError> => (options.client ?? client).get<GetUserRcsConversationApiV1AdminUsersUserIdRcsConversationGetResponses, GetUserRcsConversationApiV1AdminUsersUserIdRcsConversationGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/rcs-conversation',
    ...options
});

/**
 * Get User Imessage Conversation
 *
 * Get the merged iMessage conversation timeline for a user (admin only).
 *
 * A user can own several iMessage handles (phone + Apple ID emails), each a
 * distinct Linq chat (GET-6960/GET-6981). This merges all of them into one
 * datetime-ordered timeline; every message carries its source ``handle``.
 *
 * Pagination: each call advances every still-active chat by one Linq page and
 * returns that round's messages merge-sorted chronologically. ``next_cursor``
 * is a composite of the per-chat Linq cursors. The frontend de-dupes by id and
 * re-sorts the accumulated set, so cross-chat interleaving stays correct
 * without server-side buffering.
 */
export const getUserImessageConversationApiV1AdminUsersUserIdImessageConversationGet = <ThrowOnError extends boolean = true>(options: Options<GetUserImessageConversationApiV1AdminUsersUserIdImessageConversationGetData, ThrowOnError>): RequestResult<GetUserImessageConversationApiV1AdminUsersUserIdImessageConversationGetResponses, GetUserImessageConversationApiV1AdminUsersUserIdImessageConversationGetErrors, ThrowOnError> => (options.client ?? client).get<GetUserImessageConversationApiV1AdminUsersUserIdImessageConversationGetResponses, GetUserImessageConversationApiV1AdminUsersUserIdImessageConversationGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/imessage-conversation',
    ...options
});

/**
 * Proxy Conversation Media
 *
 * Proxy a provider-hosted conversation attachment through the backend.
 *
 * Linq (iMessage) media needs the ``LINQ_API_KEY`` bearer and Twilio
 * (WhatsApp / SMS / RCS) media needs the account's basic auth, so neither
 * URL can be embedded in the admin UI. This authenticates the admin, allows
 * only URLs matching the channel's anchored pattern, then hands off to
 * ``MediaDownloadService``, which re-validates the host and enforces the
 * global media size cap.
 */
export const proxyConversationMediaApiV1AdminMediaProxyGet = <ThrowOnError extends boolean = true>(options: Options<ProxyConversationMediaApiV1AdminMediaProxyGetData, ThrowOnError>): RequestResult<ProxyConversationMediaApiV1AdminMediaProxyGetResponses, ProxyConversationMediaApiV1AdminMediaProxyGetErrors, ThrowOnError> => (options.client ?? client).get<ProxyConversationMediaApiV1AdminMediaProxyGetResponses, ProxyConversationMediaApiV1AdminMediaProxyGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/media-proxy',
    ...options
});

/**
 * Get User File Content
 *
 * Serve a WhatsApp attachment from the copy we stored.
 *
 * For media the provider keeps no fetchable copy of, which is the owner's
 * Meta WhatsApp chat (GET-19708). Other files are refused, a vault-filled one
 * above all: it carries decrypted vault values, and sending it to its owner is
 * its only way out (GET-8739).
 */
export const getUserFileContentApiV1AdminUserFilesFileIdGet = <ThrowOnError extends boolean = true>(options: Options<GetUserFileContentApiV1AdminUserFilesFileIdGetData, ThrowOnError>): RequestResult<GetUserFileContentApiV1AdminUserFilesFileIdGetResponses, GetUserFileContentApiV1AdminUserFilesFileIdGetErrors, ThrowOnError> => (options.client ?? client).get<GetUserFileContentApiV1AdminUserFilesFileIdGetResponses, GetUserFileContentApiV1AdminUserFilesFileIdGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/user-files/{file_id}',
    ...options
});

/**
 * Get User Email Conversation
 *
 * Get the emails between a user and their assistant, newest first (admin only).
 *
 * Covers every assistant mailbox type. Bodies are not included; fetch one
 * with ``GET /emails/{message_id}`` and ``impersonate_user_id``.
 */
export const getUserEmailConversationApiV1AdminUsersUserIdEmailConversationGet = <ThrowOnError extends boolean = true>(options: Options<GetUserEmailConversationApiV1AdminUsersUserIdEmailConversationGetData, ThrowOnError>): RequestResult<GetUserEmailConversationApiV1AdminUsersUserIdEmailConversationGetResponses, GetUserEmailConversationApiV1AdminUsersUserIdEmailConversationGetErrors, ThrowOnError> => (options.client ?? client).get<GetUserEmailConversationApiV1AdminUsersUserIdEmailConversationGetResponses, GetUserEmailConversationApiV1AdminUsersUserIdEmailConversationGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/email-conversation',
    ...options
});

/**
 * Get Allowed Emails
 *
 * Get all whitelisted emails (admin only).
 *
 * Requires @getea.ai or @catchagent.ai email.
 */
export const getAllowedEmailsApiV1AdminAllowedEmailsGet = <ThrowOnError extends boolean = true>(options?: Options<GetAllowedEmailsApiV1AdminAllowedEmailsGetData, ThrowOnError>): RequestResult<GetAllowedEmailsApiV1AdminAllowedEmailsGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetAllowedEmailsApiV1AdminAllowedEmailsGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/allowed-emails',
    ...options
});

/**
 * Add Allowed Email
 *
 * Add a new email to the whitelist (admin only).
 *
 * Requires @getea.ai or @catchagent.ai email.
 */
export const addAllowedEmailApiV1AdminAllowedEmailsPost = <ThrowOnError extends boolean = true>(options: Options<AddAllowedEmailApiV1AdminAllowedEmailsPostData, ThrowOnError>): RequestResult<AddAllowedEmailApiV1AdminAllowedEmailsPostResponses, AddAllowedEmailApiV1AdminAllowedEmailsPostErrors, ThrowOnError> => (options.client ?? client).post<AddAllowedEmailApiV1AdminAllowedEmailsPostResponses, AddAllowedEmailApiV1AdminAllowedEmailsPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/allowed-emails',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Allowed Email
 *
 * Remove an email from the whitelist (admin only).
 *
 * Requires @getea.ai or @catchagent.ai email.
 */
export const deleteAllowedEmailApiV1AdminAllowedEmailsEmailIdDelete = <ThrowOnError extends boolean = true>(options: Options<DeleteAllowedEmailApiV1AdminAllowedEmailsEmailIdDeleteData, ThrowOnError>): RequestResult<DeleteAllowedEmailApiV1AdminAllowedEmailsEmailIdDeleteResponses, DeleteAllowedEmailApiV1AdminAllowedEmailsEmailIdDeleteErrors, ThrowOnError> => (options.client ?? client).delete<DeleteAllowedEmailApiV1AdminAllowedEmailsEmailIdDeleteResponses, DeleteAllowedEmailApiV1AdminAllowedEmailsEmailIdDeleteErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/allowed-emails/{email_id}',
    ...options
});

/**
 * Grant Subscription By Email
 *
 * Grant a free subscription to a user by email (admin only).
 *
 * If the user exists, grants immediately. If the user hasn't registered yet,
 * stores a pending grant on the AllowedEmail record so it auto-applies on signup.
 */
export const grantSubscriptionByEmailApiV1AdminGrantSubscriptionByEmailPost = <ThrowOnError extends boolean = true>(options: Options<GrantSubscriptionByEmailApiV1AdminGrantSubscriptionByEmailPostData, ThrowOnError>): RequestResult<GrantSubscriptionByEmailApiV1AdminGrantSubscriptionByEmailPostResponses, GrantSubscriptionByEmailApiV1AdminGrantSubscriptionByEmailPostErrors, ThrowOnError> => (options.client ?? client).post<GrantSubscriptionByEmailApiV1AdminGrantSubscriptionByEmailPostResponses, GrantSubscriptionByEmailApiV1AdminGrantSubscriptionByEmailPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/grant-subscription-by-email',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Pending Users
 *
 * Get all pending user registration requests (admin only).
 *
 * Requires @getea.ai or @catchagent.ai email.
 */
export const getPendingUsersApiV1AdminPendingUsersGet = <ThrowOnError extends boolean = true>(options?: Options<GetPendingUsersApiV1AdminPendingUsersGetData, ThrowOnError>): RequestResult<GetPendingUsersApiV1AdminPendingUsersGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetPendingUsersApiV1AdminPendingUsersGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/pending-users',
    ...options
});

/**
 * Approve Pending User
 *
 * Approve a pending user by changing their status to active.
 *
 * Requires @getea.ai or @catchagent.ai email.
 */
export const approvePendingUserApiV1AdminPendingUsersPendingUserIdApprovePost = <ThrowOnError extends boolean = true>(options: Options<ApprovePendingUserApiV1AdminPendingUsersPendingUserIdApprovePostData, ThrowOnError>): RequestResult<ApprovePendingUserApiV1AdminPendingUsersPendingUserIdApprovePostResponses, ApprovePendingUserApiV1AdminPendingUsersPendingUserIdApprovePostErrors, ThrowOnError> => (options.client ?? client).post<ApprovePendingUserApiV1AdminPendingUsersPendingUserIdApprovePostResponses, ApprovePendingUserApiV1AdminPendingUsersPendingUserIdApprovePostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/pending-users/{pending_user_id}/approve',
    ...options
});

/**
 * Reject Pending User
 *
 * Reject a pending user request by deleting the user (admin only).
 *
 * Requires @getea.ai or @catchagent.ai email.
 */
export const rejectPendingUserApiV1AdminPendingUsersPendingUserIdDelete = <ThrowOnError extends boolean = true>(options: Options<RejectPendingUserApiV1AdminPendingUsersPendingUserIdDeleteData, ThrowOnError>): RequestResult<RejectPendingUserApiV1AdminPendingUsersPendingUserIdDeleteResponses, RejectPendingUserApiV1AdminPendingUsersPendingUserIdDeleteErrors, ThrowOnError> => (options.client ?? client).delete<RejectPendingUserApiV1AdminPendingUsersPendingUserIdDeleteResponses, RejectPendingUserApiV1AdminPendingUsersPendingUserIdDeleteErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/pending-users/{pending_user_id}',
    ...options
});

/**
 * Reset User Queue
 *
 * Reset a user's DBOS message queue (admin only).
 *
 * Requires @getea.ai or @catchagent.ai email.
 */
export const resetUserQueueApiV1AdminUsersUserIdResetQueuePost = <ThrowOnError extends boolean = true>(options: Options<ResetUserQueueApiV1AdminUsersUserIdResetQueuePostData, ThrowOnError>): RequestResult<ResetUserQueueApiV1AdminUsersUserIdResetQueuePostResponses, ResetUserQueueApiV1AdminUsersUserIdResetQueuePostErrors, ThrowOnError> => (options.client ?? client).post<ResetUserQueueApiV1AdminUsersUserIdResetQueuePostResponses, ResetUserQueueApiV1AdminUsersUserIdResetQueuePostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/reset-queue',
    ...options
});

/**
 * Clear User History
 *
 * Clear a user's conversation history (admin only).
 *
 * Requires @getea.ai or @catchagent.ai email.
 */
export const clearUserHistoryApiV1AdminUsersUserIdClearHistoryPost = <ThrowOnError extends boolean = true>(options: Options<ClearUserHistoryApiV1AdminUsersUserIdClearHistoryPostData, ThrowOnError>): RequestResult<ClearUserHistoryApiV1AdminUsersUserIdClearHistoryPostResponses, ClearUserHistoryApiV1AdminUsersUserIdClearHistoryPostErrors, ThrowOnError> => (options.client ?? client).post<ClearUserHistoryApiV1AdminUsersUserIdClearHistoryPostResponses, ClearUserHistoryApiV1AdminUsersUserIdClearHistoryPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/clear-history',
    ...options
});

/**
 * Bulk Delete Messages
 *
 * Delete multiple messages for a specific user (admin only).
 *
 * Requires @getea.ai or @catchagent.ai email.
 * Only deletes messages - does not cancel workflows.
 */
export const bulkDeleteMessagesApiV1AdminUsersUserIdMessagesBulkDeletePost = <ThrowOnError extends boolean = true>(options: Options<BulkDeleteMessagesApiV1AdminUsersUserIdMessagesBulkDeletePostData, ThrowOnError>): RequestResult<BulkDeleteMessagesApiV1AdminUsersUserIdMessagesBulkDeletePostResponses, BulkDeleteMessagesApiV1AdminUsersUserIdMessagesBulkDeletePostErrors, ThrowOnError> => (options.client ?? client).post<BulkDeleteMessagesApiV1AdminUsersUserIdMessagesBulkDeletePostResponses, BulkDeleteMessagesApiV1AdminUsersUserIdMessagesBulkDeletePostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/messages/bulk-delete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Rebuild User Profile
 *
 * Rebuild a user's profile from their calendar and email data (admin only).
 *
 * This analyzes the last 14 days of the user's calendar and email history
 * and generates a fresh profile with updated information about their role,
 * timezone, and work patterns.
 */
export const rebuildUserProfileApiV1AdminUsersUserIdRebuildProfilePost = <ThrowOnError extends boolean = true>(options: Options<RebuildUserProfileApiV1AdminUsersUserIdRebuildProfilePostData, ThrowOnError>): RequestResult<RebuildUserProfileApiV1AdminUsersUserIdRebuildProfilePostResponses, RebuildUserProfileApiV1AdminUsersUserIdRebuildProfilePostErrors, ThrowOnError> => (options.client ?? client).post<RebuildUserProfileApiV1AdminUsersUserIdRebuildProfilePostResponses, RebuildUserProfileApiV1AdminUsersUserIdRebuildProfilePostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/rebuild-profile',
    ...options
});

/**
 * Reset User
 *
 * Complete user reset (admin only).
 *
 * Requires @getea.ai or @catchagent.ai email.
 *
 * Performs the following operations:
 * 1. Pauses background events (requires manual resume)
 * 2. Cancels all queued workflows
 * 3. Clears conversation history
 * 4. Deactivates all preferences and playbooks
 * 5. Deactivates all reminders
 * 6. Rebuilds user profile from scratch
 *
 * Seeds none of v1's defaults (preferences, playbooks, email and event rules,
 * reminders): the owner is on assistant v2, which starts from its own skills.
 * The ``default_*_created`` counts in the response are kept at 0 so the
 * response shape does not change.
 */
export const resetUserApiV1AdminUsersUserIdResetPost = <ThrowOnError extends boolean = true>(options: Options<ResetUserApiV1AdminUsersUserIdResetPostData, ThrowOnError>): RequestResult<ResetUserApiV1AdminUsersUserIdResetPostResponses, ResetUserApiV1AdminUsersUserIdResetPostErrors, ThrowOnError> => (options.client ?? client).post<ResetUserApiV1AdminUsersUserIdResetPostResponses, ResetUserApiV1AdminUsersUserIdResetPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/reset',
    ...options
});

/**
 * Trigger Welcome Message
 *
 * Re-trigger the welcome message for a user on a specific channel (admin only).
 *
 * Useful when a user's initial welcome message failed to send due to
 * a race condition or other transient error.
 */
export const triggerWelcomeMessageApiV1AdminUsersUserIdTriggerWelcomePost = <ThrowOnError extends boolean = true>(options: Options<TriggerWelcomeMessageApiV1AdminUsersUserIdTriggerWelcomePostData, ThrowOnError>): RequestResult<TriggerWelcomeMessageApiV1AdminUsersUserIdTriggerWelcomePostResponses, TriggerWelcomeMessageApiV1AdminUsersUserIdTriggerWelcomePostErrors, ThrowOnError> => (options.client ?? client).post<TriggerWelcomeMessageApiV1AdminUsersUserIdTriggerWelcomePostResponses, TriggerWelcomeMessageApiV1AdminUsersUserIdTriggerWelcomePostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/trigger-welcome',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Trigger Conflict Model Training
 *
 * Trigger conflict model training for a specific user or all eligible users.
 */
export const triggerConflictModelTrainingApiV1AdminTrainConflictModelsPost = <ThrowOnError extends boolean = true>(options?: Options<TriggerConflictModelTrainingApiV1AdminTrainConflictModelsPostData, ThrowOnError>): RequestResult<TriggerConflictModelTrainingApiV1AdminTrainConflictModelsPostResponses, TriggerConflictModelTrainingApiV1AdminTrainConflictModelsPostErrors, ThrowOnError> => (options?.client ?? client).post<TriggerConflictModelTrainingApiV1AdminTrainConflictModelsPostResponses, TriggerConflictModelTrainingApiV1AdminTrainConflictModelsPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/train-conflict-models',
    ...options
});

/**
 * Trigger Slot Model Training
 *
 * Trigger slot model training for a specific user or all eligible users.
 *
 * Mirrors `/train-conflict-models`: single-user kicks the workflow directly
 * so the caller gets the workflow_id back; the all-users path fans out via
 * `slot_training_queue` so the rate-limit + concurrency caps apply.
 */
export const triggerSlotModelTrainingApiV1AdminTrainSlotModelsPost = <ThrowOnError extends boolean = true>(options?: Options<TriggerSlotModelTrainingApiV1AdminTrainSlotModelsPostData, ThrowOnError>): RequestResult<TriggerSlotModelTrainingApiV1AdminTrainSlotModelsPostResponses, TriggerSlotModelTrainingApiV1AdminTrainSlotModelsPostErrors, ThrowOnError> => (options?.client ?? client).post<TriggerSlotModelTrainingApiV1AdminTrainSlotModelsPostResponses, TriggerSlotModelTrainingApiV1AdminTrainSlotModelsPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/train-slot-models',
    ...options
});

/**
 * Send Test Email
 *
 * Send a test email via AWS SES (admin only).
 *
 * Useful for verifying SES domain verification and email deliverability.
 */
export const sendTestEmailApiV1AdminSendTestEmailPost = <ThrowOnError extends boolean = true>(options: Options<SendTestEmailApiV1AdminSendTestEmailPostData, ThrowOnError>): RequestResult<SendTestEmailApiV1AdminSendTestEmailPostResponses, SendTestEmailApiV1AdminSendTestEmailPostErrors, ThrowOnError> => (options.client ?? client).post<SendTestEmailApiV1AdminSendTestEmailPostResponses, SendTestEmailApiV1AdminSendTestEmailPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/send-test-email',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start Agent Outgoing Backfill
 *
 * Recover agent-sent email history from Gmail into sent_emails (admin only).
 *
 * Repairs the GET-9100 gap: while the connected-mailbox `SentEmail` row was
 * flag-gated off, agent sends were never recorded, so `/stats` reads 0 for
 * those users' whole tenure. Reads each user's Sent mail for their `+catch`
 * alias and writes the missing `AGENT_OUTGOING` rows.
 *
 * Dry run unless `apply` is true. Idempotent — rows are keyed by Gmail message
 * id — so it is safe to re-run. Scope to one `user_id` and check the counts
 * before running it across everyone.
 */
export const startAgentOutgoingBackfillApiV1AdminBackfillAgentOutgoingPost = <ThrowOnError extends boolean = true>(options: Options<StartAgentOutgoingBackfillApiV1AdminBackfillAgentOutgoingPostData, ThrowOnError>): RequestResult<StartAgentOutgoingBackfillApiV1AdminBackfillAgentOutgoingPostResponses, StartAgentOutgoingBackfillApiV1AdminBackfillAgentOutgoingPostErrors, ThrowOnError> => (options.client ?? client).post<StartAgentOutgoingBackfillApiV1AdminBackfillAgentOutgoingPostResponses, StartAgentOutgoingBackfillApiV1AdminBackfillAgentOutgoingPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/backfill/agent-outgoing',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Exceptions
 *
 * Get exceptions from Logfire (admin only).
 *
 * Requires @getea.ai or @catchagent.ai email.
 */
export const getExceptionsApiV1AdminExceptionsGet = <ThrowOnError extends boolean = true>(options?: Options<GetExceptionsApiV1AdminExceptionsGetData, ThrowOnError>): RequestResult<GetExceptionsApiV1AdminExceptionsGetResponses, GetExceptionsApiV1AdminExceptionsGetErrors, ThrowOnError> => (options?.client ?? client).get<GetExceptionsApiV1AdminExceptionsGetResponses, GetExceptionsApiV1AdminExceptionsGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/exceptions',
    ...options
});

/**
 * Trigger Analytics
 *
 * Execute calendar change analytics and return results (admin only).
 *
 * This endpoint executes the analytics queries, logs to Logfire,
 * and returns the metrics in the response.
 */
export const triggerAnalyticsApiV1AdminTriggerAnalyticsPost = <ThrowOnError extends boolean = true>(options?: Options<TriggerAnalyticsApiV1AdminTriggerAnalyticsPostData, ThrowOnError>): RequestResult<TriggerAnalyticsApiV1AdminTriggerAnalyticsPostResponses, unknown, ThrowOnError> => (options?.client ?? client).post<TriggerAnalyticsApiV1AdminTriggerAnalyticsPostResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/trigger-analytics',
    ...options
});

/**
 * Get Hero Metrics
 *
 * Global product metrics for the PR/morale dashboard (admin only).
 *
 * Serves a cached envelope (even when stale) and refreshes in the
 * background via a DBOS workflow. Returns 425 on cold cache — the
 * frontend's 30s polling will pick up the value once the background
 * refresh finishes. We use a 4xx (not 503) so this expected cold-start
 * state isn't surfaced as an application error in our observability.
 */
export const getHeroMetricsApiV1AdminMetricsHeroGet = <ThrowOnError extends boolean = true>(options?: Options<GetHeroMetricsApiV1AdminMetricsHeroGetData, ThrowOnError>): RequestResult<GetHeroMetricsApiV1AdminMetricsHeroGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetHeroMetricsApiV1AdminMetricsHeroGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/metrics/hero',
    ...options
});

/**
 * List Subagent Conversations
 *
 * List all communication subagent conversations (admin only).
 *
 * Supports filtering by user_id, channel, and status_filter.
 */
export const listSubagentConversationsApiV1AdminSubagentConversationsGet = <ThrowOnError extends boolean = true>(options?: Options<ListSubagentConversationsApiV1AdminSubagentConversationsGetData, ThrowOnError>): RequestResult<ListSubagentConversationsApiV1AdminSubagentConversationsGetResponses, ListSubagentConversationsApiV1AdminSubagentConversationsGetErrors, ThrowOnError> => (options?.client ?? client).get<ListSubagentConversationsApiV1AdminSubagentConversationsGetResponses, ListSubagentConversationsApiV1AdminSubagentConversationsGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/subagent-conversations',
    ...options
});

/**
 * Get Subagent Conversation Detail
 *
 * Get detailed information about a specific subagent conversation (admin only).
 *
 * Includes the full exchange log.
 */
export const getSubagentConversationDetailApiV1AdminSubagentConversationsConversationIdGet = <ThrowOnError extends boolean = true>(options: Options<GetSubagentConversationDetailApiV1AdminSubagentConversationsConversationIdGetData, ThrowOnError>): RequestResult<GetSubagentConversationDetailApiV1AdminSubagentConversationsConversationIdGetResponses, GetSubagentConversationDetailApiV1AdminSubagentConversationsConversationIdGetErrors, ThrowOnError> => (options.client ?? client).get<GetSubagentConversationDetailApiV1AdminSubagentConversationsConversationIdGetResponses, GetSubagentConversationDetailApiV1AdminSubagentConversationsConversationIdGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/subagent-conversations/{conversation_id}',
    ...options
});

/**
 * List Mobile Chat Conversations
 *
 * List recorded pre-auth Marcus channel sessions (admin only).
 */
export const listMobileChatConversationsApiV1AdminMobileChatConversationsGet = <ThrowOnError extends boolean = true>(options?: Options<ListMobileChatConversationsApiV1AdminMobileChatConversationsGetData, ThrowOnError>): RequestResult<ListMobileChatConversationsApiV1AdminMobileChatConversationsGetResponses, ListMobileChatConversationsApiV1AdminMobileChatConversationsGetErrors, ThrowOnError> => (options?.client ?? client).get<ListMobileChatConversationsApiV1AdminMobileChatConversationsGetResponses, ListMobileChatConversationsApiV1AdminMobileChatConversationsGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/mobile-chat-conversations',
    ...options
});

/**
 * Get Mobile Chat Conversation Detail
 *
 * Return the full turn log for one pre-auth Marcus channel session.
 */
export const getMobileChatConversationDetailApiV1AdminMobileChatConversationsChannelIdentifierGet = <ThrowOnError extends boolean = true>(options: Options<GetMobileChatConversationDetailApiV1AdminMobileChatConversationsChannelIdentifierGetData, ThrowOnError>): RequestResult<GetMobileChatConversationDetailApiV1AdminMobileChatConversationsChannelIdentifierGetResponses, GetMobileChatConversationDetailApiV1AdminMobileChatConversationsChannelIdentifierGetErrors, ThrowOnError> => (options.client ?? client).get<GetMobileChatConversationDetailApiV1AdminMobileChatConversationsChannelIdentifierGetResponses, GetMobileChatConversationDetailApiV1AdminMobileChatConversationsChannelIdentifierGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/mobile-chat-conversations/{channel}/{identifier}',
    ...options
});

/**
 * Terminate Mobile Chat Session
 *
 * Drop the live Redis session for one ``(channel, identifier)`` pair.
 *
 * Idempotent: returns ``session_existed=False`` if there was nothing to
 * terminate. The Postgres audit snapshot is intentionally left in
 * place — its job is to outlive Redis exactly like this.
 */
export const terminateMobileChatSessionApiV1AdminMobileChatConversationsChannelIdentifierTerminatePost = <ThrowOnError extends boolean = true>(options: Options<TerminateMobileChatSessionApiV1AdminMobileChatConversationsChannelIdentifierTerminatePostData, ThrowOnError>): RequestResult<TerminateMobileChatSessionApiV1AdminMobileChatConversationsChannelIdentifierTerminatePostResponses, TerminateMobileChatSessionApiV1AdminMobileChatConversationsChannelIdentifierTerminatePostErrors, ThrowOnError> => (options.client ?? client).post<TerminateMobileChatSessionApiV1AdminMobileChatConversationsChannelIdentifierTerminatePostResponses, TerminateMobileChatSessionApiV1AdminMobileChatConversationsChannelIdentifierTerminatePostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/mobile-chat-conversations/{channel}/{identifier}/terminate',
    ...options
});

/**
 * Unblock Mobile Chat Identifier
 *
 * Reverse a block. Idempotent — succeeds even if no block existed.
 */
export const unblockMobileChatIdentifierApiV1AdminMobileChatConversationsChannelIdentifierBlockDelete = <ThrowOnError extends boolean = true>(options: Options<UnblockMobileChatIdentifierApiV1AdminMobileChatConversationsChannelIdentifierBlockDeleteData, ThrowOnError>): RequestResult<UnblockMobileChatIdentifierApiV1AdminMobileChatConversationsChannelIdentifierBlockDeleteResponses, UnblockMobileChatIdentifierApiV1AdminMobileChatConversationsChannelIdentifierBlockDeleteErrors, ThrowOnError> => (options.client ?? client).delete<UnblockMobileChatIdentifierApiV1AdminMobileChatConversationsChannelIdentifierBlockDeleteResponses, UnblockMobileChatIdentifierApiV1AdminMobileChatConversationsChannelIdentifierBlockDeleteErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/mobile-chat-conversations/{channel}/{identifier}/block',
    ...options
});

/**
 * Block Mobile Chat Identifier
 *
 * Block ``(channel, identifier)`` from any further pre-auth engagement.
 *
 * Idempotent: re-posting on an already-blocked identifier updates the
 * reason (if supplied) and returns the existing row. Also drops any
 * live Redis session in the same call so an in-flight conversation
 * stops immediately.
 */
export const blockMobileChatIdentifierApiV1AdminMobileChatConversationsChannelIdentifierBlockPost = <ThrowOnError extends boolean = true>(options: Options<BlockMobileChatIdentifierApiV1AdminMobileChatConversationsChannelIdentifierBlockPostData, ThrowOnError>): RequestResult<BlockMobileChatIdentifierApiV1AdminMobileChatConversationsChannelIdentifierBlockPostResponses, BlockMobileChatIdentifierApiV1AdminMobileChatConversationsChannelIdentifierBlockPostErrors, ThrowOnError> => (options.client ?? client).post<BlockMobileChatIdentifierApiV1AdminMobileChatConversationsChannelIdentifierBlockPostResponses, BlockMobileChatIdentifierApiV1AdminMobileChatConversationsChannelIdentifierBlockPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/mobile-chat-conversations/{channel}/{identifier}/block',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List System Broadcasts
 *
 * List system broadcasts with per-recipient status (admin only).
 */
export const listSystemBroadcastsApiV1AdminBroadcastsGet = <ThrowOnError extends boolean = true>(options?: Options<ListSystemBroadcastsApiV1AdminBroadcastsGetData, ThrowOnError>): RequestResult<ListSystemBroadcastsApiV1AdminBroadcastsGetResponses, ListSystemBroadcastsApiV1AdminBroadcastsGetErrors, ThrowOnError> => (options?.client ?? client).get<ListSystemBroadcastsApiV1AdminBroadcastsGetResponses, ListSystemBroadcastsApiV1AdminBroadcastsGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/broadcasts',
    ...options
});

/**
 * Create System Broadcast
 *
 * Create a system broadcast to selected users' inboxes (admin only).
 */
export const createSystemBroadcastApiV1AdminBroadcastsPost = <ThrowOnError extends boolean = true>(options: Options<CreateSystemBroadcastApiV1AdminBroadcastsPostData, ThrowOnError>): RequestResult<CreateSystemBroadcastApiV1AdminBroadcastsPostResponses, CreateSystemBroadcastApiV1AdminBroadcastsPostErrors, ThrowOnError> => (options.client ?? client).post<CreateSystemBroadcastApiV1AdminBroadcastsPostResponses, CreateSystemBroadcastApiV1AdminBroadcastsPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/broadcasts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Broadcast Proposals
 *
 * List queued configuration-fix proposals, newest first.
 */
export const listBroadcastProposalsApiV1AdminBroadcastProposalsGet = <ThrowOnError extends boolean = true>(options?: Options<ListBroadcastProposalsApiV1AdminBroadcastProposalsGetData, ThrowOnError>): RequestResult<ListBroadcastProposalsApiV1AdminBroadcastProposalsGetResponses, ListBroadcastProposalsApiV1AdminBroadcastProposalsGetErrors, ThrowOnError> => (options?.client ?? client).get<ListBroadcastProposalsApiV1AdminBroadcastProposalsGetResponses, ListBroadcastProposalsApiV1AdminBroadcastProposalsGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/broadcast-proposals',
    ...options
});

/**
 * Send Broadcast Proposal
 *
 * Send a proposal to the user's assistant as a system broadcast.
 *
 * Claim, then mint, then record — in that order, because both failure modes
 * matter and they pull in opposite directions. Reading the row and writing it
 * back after minting would let two admins with the queue open both pass the
 * pending check and send the same broadcast twice; claiming first and never
 * reverting would let a failed mint leave a proposal marked sent that nobody
 * ever received. So the claim is a conditional UPDATE (the pattern
 * ``activate_pending_user`` uses for the same reason), and a mint that
 * delivers nothing puts the row back.
 */
export const sendBroadcastProposalApiV1AdminBroadcastProposalsProposalIdSendPost = <ThrowOnError extends boolean = true>(options: Options<SendBroadcastProposalApiV1AdminBroadcastProposalsProposalIdSendPostData, ThrowOnError>): RequestResult<SendBroadcastProposalApiV1AdminBroadcastProposalsProposalIdSendPostResponses, SendBroadcastProposalApiV1AdminBroadcastProposalsProposalIdSendPostErrors, ThrowOnError> => (options.client ?? client).post<SendBroadcastProposalApiV1AdminBroadcastProposalsProposalIdSendPostResponses, SendBroadcastProposalApiV1AdminBroadcastProposalsProposalIdSendPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/broadcast-proposals/{proposal_id}/send',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Dismiss Broadcast Proposal
 *
 * Reject a proposal without sending anything.
 *
 * The reason is required, and is the only measurement of how often the
 * reviewer is wrong — the number that decides whether this signal is worth
 * keeping.
 *
 * Claimed with the same conditional UPDATE as the send path, and for a
 * sharper reason: a dismiss racing a send would otherwise overwrite the
 * claim, leaving a broadcast that went out recorded as rejected.
 */
export const dismissBroadcastProposalApiV1AdminBroadcastProposalsProposalIdDismissPost = <ThrowOnError extends boolean = true>(options: Options<DismissBroadcastProposalApiV1AdminBroadcastProposalsProposalIdDismissPostData, ThrowOnError>): RequestResult<DismissBroadcastProposalApiV1AdminBroadcastProposalsProposalIdDismissPostResponses, DismissBroadcastProposalApiV1AdminBroadcastProposalsProposalIdDismissPostErrors, ThrowOnError> => (options.client ?? client).post<DismissBroadcastProposalApiV1AdminBroadcastProposalsProposalIdDismissPostResponses, DismissBroadcastProposalApiV1AdminBroadcastProposalsProposalIdDismissPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/broadcast-proposals/{proposal_id}/dismiss',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Restoration Jobs
 *
 * List data restoration jobs (admin only).
 *
 * Returns a paginated list of restoration jobs, optionally filtered by status.
 */
export const listRestorationJobsApiV1AdminRestorationJobsGet = <ThrowOnError extends boolean = true>(options?: Options<ListRestorationJobsApiV1AdminRestorationJobsGetData, ThrowOnError>): RequestResult<ListRestorationJobsApiV1AdminRestorationJobsGetResponses, ListRestorationJobsApiV1AdminRestorationJobsGetErrors, ThrowOnError> => (options?.client ?? client).get<ListRestorationJobsApiV1AdminRestorationJobsGetResponses, ListRestorationJobsApiV1AdminRestorationJobsGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/restoration/jobs',
    ...options
});

/**
 * Create Restoration Job
 *
 * Start a new data restoration job (admin only).
 *
 * Creates a new PITR data restoration job that:
 * 1. Restores the production database to a temporary instance at the specified point
 * 2. Runs the extraction query to retrieve data
 * 3. Inserts the extracted data into the target table (unless dry_run=True)
 * 4. Cleans up the temporary instance
 */
export const createRestorationJobApiV1AdminRestorationJobsPost = <ThrowOnError extends boolean = true>(options: Options<CreateRestorationJobApiV1AdminRestorationJobsPostData, ThrowOnError>): RequestResult<CreateRestorationJobApiV1AdminRestorationJobsPostResponses, CreateRestorationJobApiV1AdminRestorationJobsPostErrors, ThrowOnError> => (options.client ?? client).post<CreateRestorationJobApiV1AdminRestorationJobsPostResponses, CreateRestorationJobApiV1AdminRestorationJobsPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/restoration/jobs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Restoration Job
 *
 * Get details of a specific data restoration job (admin only).
 */
export const getRestorationJobApiV1AdminRestorationJobsJobIdGet = <ThrowOnError extends boolean = true>(options: Options<GetRestorationJobApiV1AdminRestorationJobsJobIdGetData, ThrowOnError>): RequestResult<GetRestorationJobApiV1AdminRestorationJobsJobIdGetResponses, GetRestorationJobApiV1AdminRestorationJobsJobIdGetErrors, ThrowOnError> => (options.client ?? client).get<GetRestorationJobApiV1AdminRestorationJobsJobIdGetResponses, GetRestorationJobApiV1AdminRestorationJobsJobIdGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/restoration/jobs/{job_id}',
    ...options
});

/**
 * Cancel Restoration Job Endpoint
 *
 * Cancel a running data restoration job (admin only).
 *
 * Cancels the DBOS workflow and cleans up the temporary instance if one exists.
 */
export const cancelRestorationJobEndpointApiV1AdminRestorationJobsJobIdCancelPost = <ThrowOnError extends boolean = true>(options: Options<CancelRestorationJobEndpointApiV1AdminRestorationJobsJobIdCancelPostData, ThrowOnError>): RequestResult<CancelRestorationJobEndpointApiV1AdminRestorationJobsJobIdCancelPostResponses, CancelRestorationJobEndpointApiV1AdminRestorationJobsJobIdCancelPostErrors, ThrowOnError> => (options.client ?? client).post<CancelRestorationJobEndpointApiV1AdminRestorationJobsJobIdCancelPostResponses, CancelRestorationJobEndpointApiV1AdminRestorationJobsJobIdCancelPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/restoration/jobs/{job_id}/cancel',
    ...options
});

/**
 * Retry Restoration Job Endpoint
 *
 * Retry a failed/cancelled data restoration job (admin only).
 *
 * Re-runs the insert step using already-extracted data from a previous run.
 * This is useful for testing fixes without waiting for a full PITR restore.
 *
 * The job must:
 * - Be in 'failed' or 'cancelled' status
 * - Have extracted_data from a previous extraction step
 */
export const retryRestorationJobEndpointApiV1AdminRestorationJobsJobIdRetryPost = <ThrowOnError extends boolean = true>(options: Options<RetryRestorationJobEndpointApiV1AdminRestorationJobsJobIdRetryPostData, ThrowOnError>): RequestResult<RetryRestorationJobEndpointApiV1AdminRestorationJobsJobIdRetryPostResponses, RetryRestorationJobEndpointApiV1AdminRestorationJobsJobIdRetryPostErrors, ThrowOnError> => (options.client ?? client).post<RetryRestorationJobEndpointApiV1AdminRestorationJobsJobIdRetryPostResponses, RetryRestorationJobEndpointApiV1AdminRestorationJobsJobIdRetryPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/restoration/jobs/{job_id}/retry',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Sales Leads
 *
 * List sales leads, newest first, optionally filtered by status.
 */
export const listSalesLeadsApiV1AdminSalesLeadsGet = <ThrowOnError extends boolean = true>(options?: Options<ListSalesLeadsApiV1AdminSalesLeadsGetData, ThrowOnError>): RequestResult<ListSalesLeadsApiV1AdminSalesLeadsGetResponses, ListSalesLeadsApiV1AdminSalesLeadsGetErrors, ThrowOnError> => (options?.client ?? client).get<ListSalesLeadsApiV1AdminSalesLeadsGetResponses, ListSalesLeadsApiV1AdminSalesLeadsGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/sales-leads',
    ...options
});

/**
 * Get Sales Lead
 *
 * Fetch a single lead with its drafts and send history.
 */
export const getSalesLeadApiV1AdminSalesLeadsLeadIdGet = <ThrowOnError extends boolean = true>(options: Options<GetSalesLeadApiV1AdminSalesLeadsLeadIdGetData, ThrowOnError>): RequestResult<GetSalesLeadApiV1AdminSalesLeadsLeadIdGetResponses, GetSalesLeadApiV1AdminSalesLeadsLeadIdGetErrors, ThrowOnError> => (options.client ?? client).get<GetSalesLeadApiV1AdminSalesLeadsLeadIdGetResponses, GetSalesLeadApiV1AdminSalesLeadsLeadIdGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/sales-leads/{lead_id}',
    ...options
});

/**
 * Update Sales Lead Draft
 *
 * Save admin edits to a lead's email/SMS drafts and link variant.
 */
export const updateSalesLeadDraftApiV1AdminSalesLeadsLeadIdPatch = <ThrowOnError extends boolean = true>(options: Options<UpdateSalesLeadDraftApiV1AdminSalesLeadsLeadIdPatchData, ThrowOnError>): RequestResult<UpdateSalesLeadDraftApiV1AdminSalesLeadsLeadIdPatchResponses, UpdateSalesLeadDraftApiV1AdminSalesLeadsLeadIdPatchErrors, ThrowOnError> => (options.client ?? client).patch<UpdateSalesLeadDraftApiV1AdminSalesLeadsLeadIdPatchResponses, UpdateSalesLeadDraftApiV1AdminSalesLeadsLeadIdPatchErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/sales-leads/{lead_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Preview Sales Lead
 *
 * Render the final email + SMS for a lead's (unsaved) draft edits.
 *
 * Read-only: applies the in-flight editor state over the stored lead and
 * renders exactly what ``send_outreach`` would, without persisting anything.
 * Unlike PATCH there is no status guard — previewing a sent lead just shows
 * what went out.
 */
export const previewSalesLeadApiV1AdminSalesLeadsLeadIdPreviewPost = <ThrowOnError extends boolean = true>(options: Options<PreviewSalesLeadApiV1AdminSalesLeadsLeadIdPreviewPostData, ThrowOnError>): RequestResult<PreviewSalesLeadApiV1AdminSalesLeadsLeadIdPreviewPostResponses, PreviewSalesLeadApiV1AdminSalesLeadsLeadIdPreviewPostErrors, ThrowOnError> => (options.client ?? client).post<PreviewSalesLeadApiV1AdminSalesLeadsLeadIdPreviewPostResponses, PreviewSalesLeadApiV1AdminSalesLeadsLeadIdPreviewPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/sales-leads/{lead_id}/preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Regenerate Sales Lead Draft
 *
 * Re-run the AI drafting workflow for a lead.
 */
export const regenerateSalesLeadDraftApiV1AdminSalesLeadsLeadIdRegeneratePost = <ThrowOnError extends boolean = true>(options: Options<RegenerateSalesLeadDraftApiV1AdminSalesLeadsLeadIdRegeneratePostData, ThrowOnError>): RequestResult<RegenerateSalesLeadDraftApiV1AdminSalesLeadsLeadIdRegeneratePostResponses, RegenerateSalesLeadDraftApiV1AdminSalesLeadsLeadIdRegeneratePostErrors, ThrowOnError> => (options.client ?? client).post<RegenerateSalesLeadDraftApiV1AdminSalesLeadsLeadIdRegeneratePostResponses, RegenerateSalesLeadDraftApiV1AdminSalesLeadsLeadIdRegeneratePostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/sales-leads/{lead_id}/regenerate',
    ...options
});

/**
 * Approve Sales Lead
 *
 * Send the selected channels for an approved lead and record the outcome.
 *
 * The optional body lets the admin deselect a channel; omitting it sends
 * every ready channel (the pre-selection behavior).
 */
export const approveSalesLeadApiV1AdminSalesLeadsLeadIdApprovePost = <ThrowOnError extends boolean = true>(options: Options<ApproveSalesLeadApiV1AdminSalesLeadsLeadIdApprovePostData, ThrowOnError>): RequestResult<ApproveSalesLeadApiV1AdminSalesLeadsLeadIdApprovePostResponses, ApproveSalesLeadApiV1AdminSalesLeadsLeadIdApprovePostErrors, ThrowOnError> => (options.client ?? client).post<ApproveSalesLeadApiV1AdminSalesLeadsLeadIdApprovePostResponses, ApproveSalesLeadApiV1AdminSalesLeadsLeadIdApprovePostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/sales-leads/{lead_id}/approve',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reject Sales Lead
 *
 * Discard a lead so it no longer shows up for review.
 */
export const rejectSalesLeadApiV1AdminSalesLeadsLeadIdRejectPost = <ThrowOnError extends boolean = true>(options: Options<RejectSalesLeadApiV1AdminSalesLeadsLeadIdRejectPostData, ThrowOnError>): RequestResult<RejectSalesLeadApiV1AdminSalesLeadsLeadIdRejectPostResponses, RejectSalesLeadApiV1AdminSalesLeadsLeadIdRejectPostErrors, ThrowOnError> => (options.client ?? client).post<RejectSalesLeadApiV1AdminSalesLeadsLeadIdRejectPostResponses, RejectSalesLeadApiV1AdminSalesLeadsLeadIdRejectPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/sales-leads/{lead_id}/reject',
    ...options
});

/**
 * Import Sales Leads Csv
 *
 * Import leads from a Meta Ads Manager CSV export and queue drafting.
 *
 * Rows are deduped by email against the database; each newly created lead is
 * enqueued for AI drafting.
 */
export const importSalesLeadsCsvApiV1AdminSalesLeadsImportPost = <ThrowOnError extends boolean = true>(options: Options<ImportSalesLeadsCsvApiV1AdminSalesLeadsImportPostData, ThrowOnError>): RequestResult<ImportSalesLeadsCsvApiV1AdminSalesLeadsImportPostResponses, ImportSalesLeadsCsvApiV1AdminSalesLeadsImportPostErrors, ThrowOnError> => (options.client ?? client).post<ImportSalesLeadsCsvApiV1AdminSalesLeadsImportPostResponses, ImportSalesLeadsCsvApiV1AdminSalesLeadsImportPostErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/sales-leads/import',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Get User Agent Drafts
 *
 * Get all email drafts created by the agent for a user.
 *
 * This endpoint returns drafts that were created via the create_draft_email tool,
 * along with their current status (pending/sent/deleted).
 *
 * If refresh_status=true, the API will make calls to Gmail/Outlook to verify
 * the current status of each pending draft. This is slower but more accurate.
 */
export const getUserAgentDraftsApiV1AdminUsersUserIdDraftsGet = <ThrowOnError extends boolean = true>(options: Options<GetUserAgentDraftsApiV1AdminUsersUserIdDraftsGetData, ThrowOnError>): RequestResult<GetUserAgentDraftsApiV1AdminUsersUserIdDraftsGetResponses, GetUserAgentDraftsApiV1AdminUsersUserIdDraftsGetErrors, ThrowOnError> => (options.client ?? client).get<GetUserAgentDraftsApiV1AdminUsersUserIdDraftsGetResponses, GetUserAgentDraftsApiV1AdminUsersUserIdDraftsGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/drafts',
    ...options
});

/**
 * Get User Agent Draft Diff
 *
 * Compare an agent-created draft to the message the user actually sent.
 */
export const getUserAgentDraftDiffApiV1AdminUsersUserIdDraftsDraftIdDiffGet = <ThrowOnError extends boolean = true>(options: Options<GetUserAgentDraftDiffApiV1AdminUsersUserIdDraftsDraftIdDiffGetData, ThrowOnError>): RequestResult<GetUserAgentDraftDiffApiV1AdminUsersUserIdDraftsDraftIdDiffGetResponses, GetUserAgentDraftDiffApiV1AdminUsersUserIdDraftsDraftIdDiffGetErrors, ThrowOnError> => (options.client ?? client).get<GetUserAgentDraftDiffApiV1AdminUsersUserIdDraftsDraftIdDiffGetResponses, GetUserAgentDraftDiffApiV1AdminUsersUserIdDraftsDraftIdDiffGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/drafts/{draft_id}/diff',
    ...options
});

/**
 * Get Imessage Phone Status
 *
 * Get the current iMessage phone number statuses (admin only).
 *
 * Lists every executive-pool number (occupied slots, today's send count)
 * plus the external line.
 */
export const getImessagePhoneStatusApiV1AdminImessageStatusGet = <ThrowOnError extends boolean = true>(options?: Options<GetImessagePhoneStatusApiV1AdminImessageStatusGetData, ThrowOnError>): RequestResult<GetImessagePhoneStatusApiV1AdminImessageStatusGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetImessagePhoneStatusApiV1AdminImessageStatusGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/imessage/status',
    ...options
});

/**
 * Update Imessage Phone Status
 *
 * Update the iMessage phone number status (admin only).
 */
export const updateImessagePhoneStatusApiV1AdminImessageStatusPost = <ThrowOnError extends boolean = true>(options: Options<UpdateImessagePhoneStatusApiV1AdminImessageStatusPostData, ThrowOnError>): RequestResult<UpdateImessagePhoneStatusApiV1AdminImessageStatusPostResponses, UpdateImessagePhoneStatusApiV1AdminImessageStatusPostErrors, ThrowOnError> => (options.client ?? client).post<UpdateImessagePhoneStatusApiV1AdminImessageStatusPostResponses, UpdateImessagePhoneStatusApiV1AdminImessageStatusPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/imessage/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reassign Imessage Number
 *
 * Move a user's sticky iMessage assignment to another pool number (admin only).
 *
 * The escape hatch for a FLAGGED or retired number. Reassignment starts a
 * NEW iMessage thread for the user (threads are bound to the sender's
 * number), so it is a deliberate manual action, never automatic. Purges the
 * user's cached Linq chat ids — they belong to the old number, and typing
 * indicators / voice memos posted to them would come from the wrong line —
 * and remembers the number they were moved off for ~24h, so delivery
 * failures for sends already in flight stay attributable to them.
 */
export const reassignImessageNumberApiV1AdminImessageAssignmentsPost = <ThrowOnError extends boolean = true>(options: Options<ReassignImessageNumberApiV1AdminImessageAssignmentsPostData, ThrowOnError>): RequestResult<ReassignImessageNumberApiV1AdminImessageAssignmentsPostResponses, ReassignImessageNumberApiV1AdminImessageAssignmentsPostErrors, ThrowOnError> => (options.client ?? client).post<ReassignImessageNumberApiV1AdminImessageAssignmentsPostResponses, ReassignImessageNumberApiV1AdminImessageAssignmentsPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/imessage/assignments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reassign Imessage Guest Number
 *
 * Move one (guest, executive) pair's guest-line number (admin only).
 *
 * The retirement escape hatch for the guest pool, mirroring
 * ``POST /imessage/assignments`` for users: a FLAGGED or config-removed
 * guest number keeps its pairs (the send path never re-reads the pool), so
 * an admin re-points them here. Starts a NEW thread from the guest's point
 * of view. The old (number, handle) chat-id cache entry is purged so Redis
 * stops carrying an entry nothing will refresh.
 */
export const reassignImessageGuestNumberApiV1AdminImessageGuestAssignmentsPost = <ThrowOnError extends boolean = true>(options: Options<ReassignImessageGuestNumberApiV1AdminImessageGuestAssignmentsPostData, ThrowOnError>): RequestResult<ReassignImessageGuestNumberApiV1AdminImessageGuestAssignmentsPostResponses, ReassignImessageGuestNumberApiV1AdminImessageGuestAssignmentsPostErrors, ThrowOnError> => (options.client ?? client).post<ReassignImessageGuestNumberApiV1AdminImessageGuestAssignmentsPostResponses, ReassignImessageGuestNumberApiV1AdminImessageGuestAssignmentsPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/imessage/guest-assignments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Imessage Pool Setting
 *
 * Enable or disable a pool number for NEW assignments (admin only).
 *
 * A remote-config number is disabled by default, so a freshly provisioned
 * number can be test-sent before it starts taking every new connection as
 * the least-loaded pool member. Gates assignment only: a disabled number
 * keeps sending to its already-assigned users, and manual reassignment onto
 * it stays allowed. Env-floor numbers are always enabled and cannot be
 * toggled — they are the PostHog-outage break-glass.
 */
export const updateImessagePoolSettingApiV1AdminImessagePoolSettingsPost = <ThrowOnError extends boolean = true>(options: Options<UpdateImessagePoolSettingApiV1AdminImessagePoolSettingsPostData, ThrowOnError>): RequestResult<UpdateImessagePoolSettingApiV1AdminImessagePoolSettingsPostResponses, UpdateImessagePoolSettingApiV1AdminImessagePoolSettingsPostErrors, ThrowOnError> => (options.client ?? client).post<UpdateImessagePoolSettingApiV1AdminImessagePoolSettingsPostResponses, UpdateImessagePoolSettingApiV1AdminImessagePoolSettingsPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/imessage/pool-settings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set Imessage Contact Card
 *
 * Put the "Catch AI" name and logo on an iMessage pool number (admin only).
 *
 * Without a card the number shows in iMessage as a bare phone number with a
 * grey placeholder; with one, a recipient who has not saved the number sees
 * "Maybe: Catch AI" and the logo. Setting the card is also what turns on the
 * once-a-day share into that number's iMessage chats, and Linq offers no way
 * to remove a card afterwards -- the ``disable-linq-contact-card-share`` kill
 * switch stops the sharing instead. Safe to repeat: an existing card is
 * updated in place. Guest-pool numbers take one too, so a guest the
 * assistant is texting sees "Catch AI" rather than a bare number.
 */
export const setImessageContactCardApiV1AdminImessageContactCardPost = <ThrowOnError extends boolean = true>(options: Options<SetImessageContactCardApiV1AdminImessageContactCardPostData, ThrowOnError>): RequestResult<SetImessageContactCardApiV1AdminImessageContactCardPostResponses, SetImessageContactCardApiV1AdminImessageContactCardPostErrors, ThrowOnError> => (options.client ?? client).post<SetImessageContactCardApiV1AdminImessageContactCardPostResponses, SetImessageContactCardApiV1AdminImessageContactCardPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/imessage/contact-card',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send Imessage Test Message
 *
 * Send a one-off test message over the chosen channel (admin only).
 *
 * ``imessage`` and ``rcs`` both exercise the real Linq send path end-to-end
 * (chat creation, link splitting, the FLAGGED gate, daily-send counting), so
 * they verify a number actually delivers — typically one just added to the
 * ``linq-from-numbers`` remote config and still disabled for assignment; both
 * are restricted to known numbers (pool or external line) as a typo guard.
 * They differ only in ``preferred_service``: ``rcs`` forces the send off
 * iMessage (RCS where the handset supports it, else SMS), which is the same
 * switch the GET-13056 pairing experiment flips, so this is how you verify
 * that arm before enabling it. ``sms`` is the separate Twilio sender.
 */
export const sendImessageTestMessageApiV1AdminImessageTestMessagePost = <ThrowOnError extends boolean = true>(options: Options<SendImessageTestMessageApiV1AdminImessageTestMessagePostData, ThrowOnError>): RequestResult<SendImessageTestMessageApiV1AdminImessageTestMessagePostResponses, SendImessageTestMessageApiV1AdminImessageTestMessagePostErrors, ThrowOnError> => (options.client ?? client).post<SendImessageTestMessageApiV1AdminImessageTestMessagePostResponses, SendImessageTestMessageApiV1AdminImessageTestMessagePostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/imessage/test-message',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Dedicated Numbers
 *
 * All dedicated numbers with their owners and lifecycle dates.
 */
export const listDedicatedNumbersApiV1AdminDedicatedNumbersGet = <ThrowOnError extends boolean = true>(options?: Options<ListDedicatedNumbersApiV1AdminDedicatedNumbersGetData, ThrowOnError>): RequestResult<ListDedicatedNumbersApiV1AdminDedicatedNumbersGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListDedicatedNumbersApiV1AdminDedicatedNumbersGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/dedicated-numbers',
    ...options
});

/**
 * List Orphaned Dedicated Numbers
 *
 * Numbers we own and pay for that provisioning never recorded.
 *
 * Separate from the inventory listing on purpose: this one calls Twilio, so
 * a slow or down Twilio would otherwise take the whole (database-only)
 * inventory table down with it.
 *
 * Returns the service model directly rather than copying it into a local
 * response model. The copy was field-for-field, so every new field on the
 * scan was three edits with a silent omission if one was missed — and the
 * row model (:class:`OrphanedDedicatedNumber`) was already being served
 * straight from the service anyway.
 */
export const listOrphanedDedicatedNumbersApiV1AdminDedicatedNumbersOrphansGet = <ThrowOnError extends boolean = true>(options?: Options<ListOrphanedDedicatedNumbersApiV1AdminDedicatedNumbersOrphansGetData, ThrowOnError>): RequestResult<ListOrphanedDedicatedNumbersApiV1AdminDedicatedNumbersOrphansGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListOrphanedDedicatedNumbersApiV1AdminDedicatedNumbersOrphansGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/dedicated-numbers/orphans',
    ...options
});

/**
 * Release Orphan
 *
 * Release an orphaned number on Twilio (there is no row to delete).
 *
 * Refused if the number has since gained a row, or if its friendly name says
 * it is not a dedicated assistant number at all — a mistyped SID must not be
 * able to release a pool number out from under the shared voice line.
 */
export const releaseOrphanApiV1AdminDedicatedNumbersOrphansTwilioSidReleasePost = <ThrowOnError extends boolean = true>(options: Options<ReleaseOrphanApiV1AdminDedicatedNumbersOrphansTwilioSidReleasePostData, ThrowOnError>): RequestResult<ReleaseOrphanApiV1AdminDedicatedNumbersOrphansTwilioSidReleasePostResponses, ReleaseOrphanApiV1AdminDedicatedNumbersOrphansTwilioSidReleasePostErrors, ThrowOnError> => (options.client ?? client).post<ReleaseOrphanApiV1AdminDedicatedNumbersOrphansTwilioSidReleasePostResponses, ReleaseOrphanApiV1AdminDedicatedNumbersOrphansTwilioSidReleasePostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/dedicated-numbers/orphans/{twilio_sid}/release',
    ...options
});

/**
 * Finalize Release
 *
 * Release a QUARANTINED number on Twilio for real and drop the row.
 *
 * Refused for active rows — the owner must release (quarantine) it first,
 * so an operator can never pull a paid line out from under a user.
 */
export const finalizeReleaseApiV1AdminDedicatedNumbersNumberIdReleasePost = <ThrowOnError extends boolean = true>(options: Options<FinalizeReleaseApiV1AdminDedicatedNumbersNumberIdReleasePostData, ThrowOnError>): RequestResult<FinalizeReleaseApiV1AdminDedicatedNumbersNumberIdReleasePostResponses, FinalizeReleaseApiV1AdminDedicatedNumbersNumberIdReleasePostErrors, ThrowOnError> => (options.client ?? client).post<FinalizeReleaseApiV1AdminDedicatedNumbersNumberIdReleasePostResponses, FinalizeReleaseApiV1AdminDedicatedNumbersNumberIdReleasePostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/dedicated-numbers/{number_id}/release',
    ...options
});

/**
 * Enable Number Texting
 *
 * Put a number bought before texting shipped on the A2P campaign.
 *
 * New numbers join at purchase; this backfills the ones that predate it.
 * ``texting_enabled`` stays false for a number that cannot join (a non-US
 * line, an unconfigured environment, or Twilio refusing it).
 */
export const enableNumberTextingApiV1AdminDedicatedNumbersNumberIdEnableTextingPost = <ThrowOnError extends boolean = true>(options: Options<EnableNumberTextingApiV1AdminDedicatedNumbersNumberIdEnableTextingPostData, ThrowOnError>): RequestResult<EnableNumberTextingApiV1AdminDedicatedNumbersNumberIdEnableTextingPostResponses, EnableNumberTextingApiV1AdminDedicatedNumbersNumberIdEnableTextingPostErrors, ThrowOnError> => (options.client ?? client).post<EnableNumberTextingApiV1AdminDedicatedNumbersNumberIdEnableTextingPostResponses, EnableNumberTextingApiV1AdminDedicatedNumbersNumberIdEnableTextingPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/dedicated-numbers/{number_id}/enable-texting',
    ...options
});

/**
 * Put Numbers On Sip Trunk
 *
 * Register every active number on the SIP trunk and reconcile its inbound.
 *
 * New numbers are registered at purchase; this backfills the ones that
 * predate it, repairs one whose registration failed, and applies a
 * ``phone-gpt-live`` flip in either direction (GET-18850, GET-19047): each
 * number reads ``on_trunk`` or ``off_trunk`` when its inbound was set,
 * ``unchanged`` when the flag could not be read or the trunk is not
 * configured, and ``failed`` when a provider refused (logged per number).
 * Safe to re-run.
 */
export const putNumbersOnSipTrunkApiV1AdminDedicatedNumbersSipTrunkPost = <ThrowOnError extends boolean = true>(options?: Options<PutNumbersOnSipTrunkApiV1AdminDedicatedNumbersSipTrunkPostData, ThrowOnError>): RequestResult<PutNumbersOnSipTrunkApiV1AdminDedicatedNumbersSipTrunkPostResponses, unknown, ThrowOnError> => (options?.client ?? client).post<PutNumbersOnSipTrunkApiV1AdminDedicatedNumbersSipTrunkPostResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/dedicated-numbers/sip-trunk',
    ...options
});

/**
 * Get Stripe Promo Codes
 *
 * List Stripe promotion codes (admin only).
 */
export const getStripePromoCodesApiV1AdminStripePromoCodesGet = <ThrowOnError extends boolean = true>(options?: Options<GetStripePromoCodesApiV1AdminStripePromoCodesGetData, ThrowOnError>): RequestResult<GetStripePromoCodesApiV1AdminStripePromoCodesGetResponses, GetStripePromoCodesApiV1AdminStripePromoCodesGetErrors, ThrowOnError> => (options?.client ?? client).get<GetStripePromoCodesApiV1AdminStripePromoCodesGetResponses, GetStripePromoCodesApiV1AdminStripePromoCodesGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/stripe-promo-codes',
    ...options
});

/**
 * Create Stripe Promo Code
 *
 * Create a Stripe coupon and promotion code in one call (admin only).
 */
export const createStripePromoCodeApiV1AdminStripePromoCodesPost = <ThrowOnError extends boolean = true>(options: Options<CreateStripePromoCodeApiV1AdminStripePromoCodesPostData, ThrowOnError>): RequestResult<CreateStripePromoCodeApiV1AdminStripePromoCodesPostResponses, CreateStripePromoCodeApiV1AdminStripePromoCodesPostErrors, ThrowOnError> => (options.client ?? client).post<CreateStripePromoCodeApiV1AdminStripePromoCodesPostResponses, CreateStripePromoCodeApiV1AdminStripePromoCodesPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/stripe-promo-codes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Deactivate Stripe Promo Code
 *
 * Deactivate a Stripe promotion code (admin only).
 */
export const deactivateStripePromoCodeApiV1AdminStripePromoCodesPromoCodeIdDeactivatePost = <ThrowOnError extends boolean = true>(options: Options<DeactivateStripePromoCodeApiV1AdminStripePromoCodesPromoCodeIdDeactivatePostData, ThrowOnError>): RequestResult<DeactivateStripePromoCodeApiV1AdminStripePromoCodesPromoCodeIdDeactivatePostResponses, DeactivateStripePromoCodeApiV1AdminStripePromoCodesPromoCodeIdDeactivatePostErrors, ThrowOnError> => (options.client ?? client).post<DeactivateStripePromoCodeApiV1AdminStripePromoCodesPromoCodeIdDeactivatePostResponses, DeactivateStripePromoCodeApiV1AdminStripePromoCodesPromoCodeIdDeactivatePostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/stripe-promo-codes/{promo_code_id}/deactivate',
    ...options
});

/**
 * Get Stripe Promo Code Redemptions
 *
 * List users who redeemed a given Stripe coupon (admin only).
 *
 * Reads from the local promo_code_redemptions table, populated by the
 * subscription.created webhook handler and the backfill script.
 */
export const getStripePromoCodeRedemptionsApiV1AdminStripePromoCodesCouponIdRedemptionsGet = <ThrowOnError extends boolean = true>(options: Options<GetStripePromoCodeRedemptionsApiV1AdminStripePromoCodesCouponIdRedemptionsGetData, ThrowOnError>): RequestResult<GetStripePromoCodeRedemptionsApiV1AdminStripePromoCodesCouponIdRedemptionsGetResponses, GetStripePromoCodeRedemptionsApiV1AdminStripePromoCodesCouponIdRedemptionsGetErrors, ThrowOnError> => (options.client ?? client).get<GetStripePromoCodeRedemptionsApiV1AdminStripePromoCodesCouponIdRedemptionsGetResponses, GetStripePromoCodeRedemptionsApiV1AdminStripePromoCodesCouponIdRedemptionsGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/stripe-promo-codes/{coupon_id}/redemptions',
    ...options
});

/**
 * Get Billing Preview
 *
 * Show the conversion this item would be billed at right now.
 *
 * A missing rate is a 200 with ``rate_available=false``, not an error: for
 * an ECB-unquoted currency the modal still has to render, explain why, and
 * offer the override field. Only a genuinely broken request (unknown item,
 * missing user, unsupported paying currency) raises.
 */
export const getBillingPreviewApiV1AdminCatchPaidInvoicingItemsItemIdBillingPreviewGet = <ThrowOnError extends boolean = true>(options: Options<GetBillingPreviewApiV1AdminCatchPaidInvoicingItemsItemIdBillingPreviewGetData, ThrowOnError>): RequestResult<GetBillingPreviewApiV1AdminCatchPaidInvoicingItemsItemIdBillingPreviewGetResponses, GetBillingPreviewApiV1AdminCatchPaidInvoicingItemsItemIdBillingPreviewGetErrors, ThrowOnError> => (options.client ?? client).get<GetBillingPreviewApiV1AdminCatchPaidInvoicingItemsItemIdBillingPreviewGetResponses, GetBillingPreviewApiV1AdminCatchPaidInvoicingItemsItemIdBillingPreviewGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/catch-paid-invoicing/items/{item_id}/billing-preview',
    ...options
});

/**
 * Send Travel Card Link
 *
 * Email a hosted Stripe link that saves a separate travel payment method.
 */
export const sendTravelCardLinkApiV1AdminCatchPaidInvoicingItemsItemIdSendTravelCardLinkPost = <ThrowOnError extends boolean = true>(options: Options<SendTravelCardLinkApiV1AdminCatchPaidInvoicingItemsItemIdSendTravelCardLinkPostData, ThrowOnError>): RequestResult<SendTravelCardLinkApiV1AdminCatchPaidInvoicingItemsItemIdSendTravelCardLinkPostResponses, SendTravelCardLinkApiV1AdminCatchPaidInvoicingItemsItemIdSendTravelCardLinkPostErrors, ThrowOnError> => (options.client ?? client).post<SendTravelCardLinkApiV1AdminCatchPaidInvoicingItemsItemIdSendTravelCardLinkPostResponses, SendTravelCardLinkApiV1AdminCatchPaidInvoicingItemsItemIdSendTravelCardLinkPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/catch-paid-invoicing/items/{item_id}/send-travel-card-link',
    ...options
});

/**
 * Pay With Travel Card
 *
 * Charge the user's explicitly saved travel method while they are offline.
 */
export const payWithTravelCardApiV1AdminCatchPaidInvoicingItemsItemIdPayWithTravelCardPost = <ThrowOnError extends boolean = true>(options: Options<PayWithTravelCardApiV1AdminCatchPaidInvoicingItemsItemIdPayWithTravelCardPostData, ThrowOnError>): RequestResult<PayWithTravelCardApiV1AdminCatchPaidInvoicingItemsItemIdPayWithTravelCardPostResponses, PayWithTravelCardApiV1AdminCatchPaidInvoicingItemsItemIdPayWithTravelCardPostErrors, ThrowOnError> => (options.client ?? client).post<PayWithTravelCardApiV1AdminCatchPaidInvoicingItemsItemIdPayWithTravelCardPostResponses, PayWithTravelCardApiV1AdminCatchPaidInvoicingItemsItemIdPayWithTravelCardPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/catch-paid-invoicing/items/{item_id}/pay-with-travel-card',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Account Payment Method
 *
 * Name what Issue invoice or Charge saved method would charge for this item.
 *
 * For a sent link, resolved on that invoice's own customer, the one Charge
 * saved method charges, so the confirm modal cannot name a different method
 * if coverage changed since the link went out. Otherwise resolved on the
 * current payer, so a team-covered row names the organization's method.
 * Best-effort: the label is advisory, so a Stripe failure reads as "none
 * known" rather than blocking the modal.
 */
export const getAccountPaymentMethodApiV1AdminCatchPaidInvoicingItemsItemIdAccountPaymentMethodGet = <ThrowOnError extends boolean = true>(options: Options<GetAccountPaymentMethodApiV1AdminCatchPaidInvoicingItemsItemIdAccountPaymentMethodGetData, ThrowOnError>): RequestResult<GetAccountPaymentMethodApiV1AdminCatchPaidInvoicingItemsItemIdAccountPaymentMethodGetResponses, GetAccountPaymentMethodApiV1AdminCatchPaidInvoicingItemsItemIdAccountPaymentMethodGetErrors, ThrowOnError> => (options.client ?? client).get<GetAccountPaymentMethodApiV1AdminCatchPaidInvoicingItemsItemIdAccountPaymentMethodGetResponses, GetAccountPaymentMethodApiV1AdminCatchPaidInvoicingItemsItemIdAccountPaymentMethodGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/catch-paid-invoicing/items/{item_id}/account-payment-method',
    ...options
});

/**
 * Charge Saved Method
 *
 * Charge a sent payment-link invoice to the billing account's saved method.
 *
 * Only for a user who asked to be charged: the payment link exists because
 * the account was deliberately not charged. A bank debit answers
 * ``processing``: it is on its way, and the row settles when it clears.
 */
export const chargeSavedMethodApiV1AdminCatchPaidInvoicingItemsItemIdChargeSavedMethodPost = <ThrowOnError extends boolean = true>(options: Options<ChargeSavedMethodApiV1AdminCatchPaidInvoicingItemsItemIdChargeSavedMethodPostData, ThrowOnError>): RequestResult<ChargeSavedMethodApiV1AdminCatchPaidInvoicingItemsItemIdChargeSavedMethodPostResponses, ChargeSavedMethodApiV1AdminCatchPaidInvoicingItemsItemIdChargeSavedMethodPostErrors, ThrowOnError> => (options.client ?? client).post<ChargeSavedMethodApiV1AdminCatchPaidInvoicingItemsItemIdChargeSavedMethodPostResponses, ChargeSavedMethodApiV1AdminCatchPaidInvoicingItemsItemIdChargeSavedMethodPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/catch-paid-invoicing/items/{item_id}/charge-saved-method',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Catch Paid Items
 *
 * List Catch-paid invoice items, newest first.
 */
export const listCatchPaidItemsApiV1AdminHotelInvoicingItemsGet = <ThrowOnError extends boolean = true>(options?: Options<ListCatchPaidItemsApiV1AdminHotelInvoicingItemsGetData, ThrowOnError>): RequestResult<ListCatchPaidItemsApiV1AdminHotelInvoicingItemsGetResponses, ListCatchPaidItemsApiV1AdminHotelInvoicingItemsGetErrors, ThrowOnError> => (options?.client ?? client).get<ListCatchPaidItemsApiV1AdminHotelInvoicingItemsGetResponses, ListCatchPaidItemsApiV1AdminHotelInvoicingItemsGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/hotel-invoicing/items',
    ...options
});

/**
 * Get Catch Paid Item
 *
 * Fetch a single invoice item with raw LiteAPI response for audit.
 */
export const getCatchPaidItemApiV1AdminHotelInvoicingItemsItemIdGet = <ThrowOnError extends boolean = true>(options: Options<GetCatchPaidItemApiV1AdminHotelInvoicingItemsItemIdGetData, ThrowOnError>): RequestResult<GetCatchPaidItemApiV1AdminHotelInvoicingItemsItemIdGetResponses, GetCatchPaidItemApiV1AdminHotelInvoicingItemsItemIdGetErrors, ThrowOnError> => (options.client ?? client).get<GetCatchPaidItemApiV1AdminHotelInvoicingItemsItemIdGetResponses, GetCatchPaidItemApiV1AdminHotelInvoicingItemsItemIdGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/hotel-invoicing/items/{item_id}',
    ...options
});

/**
 * Get Catch Paid Summary
 *
 * Per-(state, currency) totals for the admin dashboard header cards.
 */
export const getCatchPaidSummaryApiV1AdminHotelInvoicingSummaryGet = <ThrowOnError extends boolean = true>(options?: Options<GetCatchPaidSummaryApiV1AdminHotelInvoicingSummaryGetData, ThrowOnError>): RequestResult<GetCatchPaidSummaryApiV1AdminHotelInvoicingSummaryGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetCatchPaidSummaryApiV1AdminHotelInvoicingSummaryGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/hotel-invoicing/summary',
    ...options
});

/**
 * Issue Invoice
 *
 * Create a Stripe ``InvoiceItem`` for this booking and mark it invoiced.
 *
 * The Stripe customer is the effective personal or team-plan customer; the
 * item lands on that customer's next monthly invoice.
 *
 * Idempotent in two layers:
 * * Local: already-``INVOICED`` rows short-circuit with HTTP 409 and the
 * existing ``stripe_invoice_item_id``.
 * * Stripe: a deterministic ``idempotency_key`` per row protects
 * against the (rare) case where Stripe.create succeeded but our DB
 * commit failed.
 */
export const issueInvoiceApiV1AdminHotelInvoicingItemsItemIdIssueInvoicePost = <ThrowOnError extends boolean = true>(options: Options<IssueInvoiceApiV1AdminHotelInvoicingItemsItemIdIssueInvoicePostData, ThrowOnError>): RequestResult<IssueInvoiceApiV1AdminHotelInvoicingItemsItemIdIssueInvoicePostResponses, IssueInvoiceApiV1AdminHotelInvoicingItemsItemIdIssueInvoicePostErrors, ThrowOnError> => (options.client ?? client).post<IssueInvoiceApiV1AdminHotelInvoicingItemsItemIdIssueInvoicePostResponses, IssueInvoiceApiV1AdminHotelInvoicingItemsItemIdIssueInvoicePostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/hotel-invoicing/items/{item_id}/issue-invoice',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send Payment Link
 *
 * Bill this booking with a payment link instead of charging the account.
 *
 * Creates a standalone Stripe invoice the user pays themselves — nothing is
 * charged to the card on file — and emails them its ``hosted_invoice_url``.
 * That URL does not expire, so the email can sit unread indefinitely and
 * still be payable; ``days_until_due`` only drives Stripe's reminder
 * schedule.
 *
 * Mutually exclusive with ``issue-invoice``: both start from
 * ``PENDING_REVIEW`` and either one closes the row to the other.
 */
export const sendPaymentLinkApiV1AdminHotelInvoicingItemsItemIdSendPaymentLinkPost = <ThrowOnError extends boolean = true>(options: Options<SendPaymentLinkApiV1AdminHotelInvoicingItemsItemIdSendPaymentLinkPostData, ThrowOnError>): RequestResult<SendPaymentLinkApiV1AdminHotelInvoicingItemsItemIdSendPaymentLinkPostResponses, SendPaymentLinkApiV1AdminHotelInvoicingItemsItemIdSendPaymentLinkPostErrors, ThrowOnError> => (options.client ?? client).post<SendPaymentLinkApiV1AdminHotelInvoicingItemsItemIdSendPaymentLinkPostResponses, SendPaymentLinkApiV1AdminHotelInvoicingItemsItemIdSendPaymentLinkPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/hotel-invoicing/items/{item_id}/send-payment-link',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Skip Invoice
 *
 * Mark the item as skipped (comp, internal trip, etc.).
 *
 * Requires a non-empty note. Skipped items never become Stripe invoice
 * items and stay in the table for audit.
 */
export const skipInvoiceApiV1AdminHotelInvoicingItemsItemIdSkipPost = <ThrowOnError extends boolean = true>(options: Options<SkipInvoiceApiV1AdminHotelInvoicingItemsItemIdSkipPostData, ThrowOnError>): RequestResult<SkipInvoiceApiV1AdminHotelInvoicingItemsItemIdSkipPostResponses, SkipInvoiceApiV1AdminHotelInvoicingItemsItemIdSkipPostErrors, ThrowOnError> => (options.client ?? client).post<SkipInvoiceApiV1AdminHotelInvoicingItemsItemIdSkipPostResponses, SkipInvoiceApiV1AdminHotelInvoicingItemsItemIdSkipPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/hotel-invoicing/items/{item_id}/skip',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revert Invoice
 *
 * Undo a billing decision that has not yet collected any money.
 *
 * Only valid from ``invoiced`` or ``payment_link_sent``: deletes the loose
 * Stripe line or voids the unpaid standalone invoice and returns the row to
 * ``pending_review``. Requires a note. If real money has already been
 * collected (``paid``), use the refund path instead.
 */
export const revertInvoiceApiV1AdminHotelInvoicingItemsItemIdRevertPost = <ThrowOnError extends boolean = true>(options: Options<RevertInvoiceApiV1AdminHotelInvoicingItemsItemIdRevertPostData, ThrowOnError>): RequestResult<RevertInvoiceApiV1AdminHotelInvoicingItemsItemIdRevertPostResponses, RevertInvoiceApiV1AdminHotelInvoicingItemsItemIdRevertPostErrors, ThrowOnError> => (options.client ?? client).post<RevertInvoiceApiV1AdminHotelInvoicingItemsItemIdRevertPostResponses, RevertInvoiceApiV1AdminHotelInvoicingItemsItemIdRevertPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/hotel-invoicing/items/{item_id}/revert',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Web Purchase Items
 *
 * List Catch-paid web-purchase invoice items, newest first.
 */
export const listWebPurchaseItemsApiV1AdminWebPurchaseInvoicingItemsGet = <ThrowOnError extends boolean = true>(options?: Options<ListWebPurchaseItemsApiV1AdminWebPurchaseInvoicingItemsGetData, ThrowOnError>): RequestResult<ListWebPurchaseItemsApiV1AdminWebPurchaseInvoicingItemsGetResponses, ListWebPurchaseItemsApiV1AdminWebPurchaseInvoicingItemsGetErrors, ThrowOnError> => (options?.client ?? client).get<ListWebPurchaseItemsApiV1AdminWebPurchaseInvoicingItemsGetResponses, ListWebPurchaseItemsApiV1AdminWebPurchaseInvoicingItemsGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/web-purchase-invoicing/items',
    ...options
});

/**
 * Issue Web Purchase Invoice
 *
 * Create a Stripe ``InvoiceItem`` for this purchase and mark it invoiced.
 */
export const issueWebPurchaseInvoiceApiV1AdminWebPurchaseInvoicingItemsItemIdIssueInvoicePost = <ThrowOnError extends boolean = true>(options: Options<IssueWebPurchaseInvoiceApiV1AdminWebPurchaseInvoicingItemsItemIdIssueInvoicePostData, ThrowOnError>): RequestResult<IssueWebPurchaseInvoiceApiV1AdminWebPurchaseInvoicingItemsItemIdIssueInvoicePostResponses, IssueWebPurchaseInvoiceApiV1AdminWebPurchaseInvoicingItemsItemIdIssueInvoicePostErrors, ThrowOnError> => (options.client ?? client).post<IssueWebPurchaseInvoiceApiV1AdminWebPurchaseInvoicingItemsItemIdIssueInvoicePostResponses, IssueWebPurchaseInvoiceApiV1AdminWebPurchaseInvoicingItemsItemIdIssueInvoicePostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/web-purchase-invoicing/items/{item_id}/issue-invoice',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send Web Purchase Payment Link
 *
 * Bill this purchase with a payment link instead of charging the account.
 *
 * The web-purchase twin of ``hotel_invoicing.send_payment_link``: a
 * standalone Stripe invoice the user pays themselves via a non-expiring
 * ``hosted_invoice_url``, emailed to them.
 */
export const sendWebPurchasePaymentLinkApiV1AdminWebPurchaseInvoicingItemsItemIdSendPaymentLinkPost = <ThrowOnError extends boolean = true>(options: Options<SendWebPurchasePaymentLinkApiV1AdminWebPurchaseInvoicingItemsItemIdSendPaymentLinkPostData, ThrowOnError>): RequestResult<SendWebPurchasePaymentLinkApiV1AdminWebPurchaseInvoicingItemsItemIdSendPaymentLinkPostResponses, SendWebPurchasePaymentLinkApiV1AdminWebPurchaseInvoicingItemsItemIdSendPaymentLinkPostErrors, ThrowOnError> => (options.client ?? client).post<SendWebPurchasePaymentLinkApiV1AdminWebPurchaseInvoicingItemsItemIdSendPaymentLinkPostResponses, SendWebPurchasePaymentLinkApiV1AdminWebPurchaseInvoicingItemsItemIdSendPaymentLinkPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/web-purchase-invoicing/items/{item_id}/send-payment-link',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Skip Web Purchase Invoice
 *
 * Mark the item as skipped (comp, internal, etc.). Requires a note.
 */
export const skipWebPurchaseInvoiceApiV1AdminWebPurchaseInvoicingItemsItemIdSkipPost = <ThrowOnError extends boolean = true>(options: Options<SkipWebPurchaseInvoiceApiV1AdminWebPurchaseInvoicingItemsItemIdSkipPostData, ThrowOnError>): RequestResult<SkipWebPurchaseInvoiceApiV1AdminWebPurchaseInvoicingItemsItemIdSkipPostResponses, SkipWebPurchaseInvoiceApiV1AdminWebPurchaseInvoicingItemsItemIdSkipPostErrors, ThrowOnError> => (options.client ?? client).post<SkipWebPurchaseInvoiceApiV1AdminWebPurchaseInvoicingItemsItemIdSkipPostResponses, SkipWebPurchaseInvoiceApiV1AdminWebPurchaseInvoicingItemsItemIdSkipPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/web-purchase-invoicing/items/{item_id}/skip',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Purchase Wallets
 *
 * Every user who has ever held purchase credits, most recently changed first.
 */
export const listPurchaseWalletsApiV1AdminPurchaseWalletsGet = <ThrowOnError extends boolean = true>(options?: Options<ListPurchaseWalletsApiV1AdminPurchaseWalletsGetData, ThrowOnError>): RequestResult<ListPurchaseWalletsApiV1AdminPurchaseWalletsGetResponses, ListPurchaseWalletsApiV1AdminPurchaseWalletsGetErrors, ThrowOnError> => (options?.client ?? client).get<ListPurchaseWalletsApiV1AdminPurchaseWalletsGetResponses, ListPurchaseWalletsApiV1AdminPurchaseWalletsGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/purchase-wallets',
    ...options
});

/**
 * Get Purchase Wallet
 *
 * A user's standing plus their ledger, newest first. A user with no wallet
 * reads as all zeros with an empty ledger.
 */
export const getPurchaseWalletApiV1AdminPurchaseWalletsUserIdGet = <ThrowOnError extends boolean = true>(options: Options<GetPurchaseWalletApiV1AdminPurchaseWalletsUserIdGetData, ThrowOnError>): RequestResult<GetPurchaseWalletApiV1AdminPurchaseWalletsUserIdGetResponses, GetPurchaseWalletApiV1AdminPurchaseWalletsUserIdGetErrors, ThrowOnError> => (options.client ?? client).get<GetPurchaseWalletApiV1AdminPurchaseWalletsUserIdGetResponses, GetPurchaseWalletApiV1AdminPurchaseWalletsUserIdGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/purchase-wallets/{user_id}',
    ...options
});

/**
 * Add Purchase Credits
 *
 * Add credits to (or, with a negative amount, correct) a user's wallet.
 */
export const addPurchaseCreditsApiV1AdminPurchaseWalletsUserIdCreditsPost = <ThrowOnError extends boolean = true>(options: Options<AddPurchaseCreditsApiV1AdminPurchaseWalletsUserIdCreditsPostData, ThrowOnError>): RequestResult<AddPurchaseCreditsApiV1AdminPurchaseWalletsUserIdCreditsPostResponses, AddPurchaseCreditsApiV1AdminPurchaseWalletsUserIdCreditsPostErrors, ThrowOnError> => (options.client ?? client).post<AddPurchaseCreditsApiV1AdminPurchaseWalletsUserIdCreditsPostResponses, AddPurchaseCreditsApiV1AdminPurchaseWalletsUserIdCreditsPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/purchase-wallets/{user_id}/credits',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get User Referral
 *
 * Who referred this user, their own referrals, and their hotel credit.
 */
export const getUserReferralApiV1AdminUsersUserIdReferralGet = <ThrowOnError extends boolean = true>(options: Options<GetUserReferralApiV1AdminUsersUserIdReferralGetData, ThrowOnError>): RequestResult<GetUserReferralApiV1AdminUsersUserIdReferralGetResponses, GetUserReferralApiV1AdminUsersUserIdReferralGetErrors, ThrowOnError> => (options.client ?? client).get<GetUserReferralApiV1AdminUsersUserIdReferralGetResponses, GetUserReferralApiV1AdminUsersUserIdReferralGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/referral',
    ...options
});

/**
 * Record User Referral Attribution
 *
 * Record that this user was referred with ``referral_code``.
 *
 * For a referral checkout never recorded. Idempotent for the same referrer;
 * 409 when the user is already attributed to someone else.
 */
export const recordUserReferralAttributionApiV1AdminUsersUserIdReferralAttributionPost = <ThrowOnError extends boolean = true>(options: Options<RecordUserReferralAttributionApiV1AdminUsersUserIdReferralAttributionPostData, ThrowOnError>): RequestResult<RecordUserReferralAttributionApiV1AdminUsersUserIdReferralAttributionPostResponses, RecordUserReferralAttributionApiV1AdminUsersUserIdReferralAttributionPostErrors, ThrowOnError> => (options.client ?? client).post<RecordUserReferralAttributionApiV1AdminUsersUserIdReferralAttributionPostResponses, RecordUserReferralAttributionApiV1AdminUsersUserIdReferralAttributionPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/referral/attribution',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Flight Invoice Items
 *
 * List Catch-paid flight invoice items, newest first.
 */
export const listFlightInvoiceItemsApiV1AdminFlightInvoicingItemsGet = <ThrowOnError extends boolean = true>(options?: Options<ListFlightInvoiceItemsApiV1AdminFlightInvoicingItemsGetData, ThrowOnError>): RequestResult<ListFlightInvoiceItemsApiV1AdminFlightInvoicingItemsGetResponses, ListFlightInvoiceItemsApiV1AdminFlightInvoicingItemsGetErrors, ThrowOnError> => (options?.client ?? client).get<ListFlightInvoiceItemsApiV1AdminFlightInvoicingItemsGetResponses, ListFlightInvoiceItemsApiV1AdminFlightInvoicingItemsGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/flight-invoicing/items',
    ...options
});

/**
 * Get Flight Invoice Item
 *
 * Fetch a single flight invoice item with the raw Duffel payloads for audit.
 */
export const getFlightInvoiceItemApiV1AdminFlightInvoicingItemsItemIdGet = <ThrowOnError extends boolean = true>(options: Options<GetFlightInvoiceItemApiV1AdminFlightInvoicingItemsItemIdGetData, ThrowOnError>): RequestResult<GetFlightInvoiceItemApiV1AdminFlightInvoicingItemsItemIdGetResponses, GetFlightInvoiceItemApiV1AdminFlightInvoicingItemsItemIdGetErrors, ThrowOnError> => (options.client ?? client).get<GetFlightInvoiceItemApiV1AdminFlightInvoicingItemsItemIdGetResponses, GetFlightInvoiceItemApiV1AdminFlightInvoicingItemsItemIdGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/flight-invoicing/items/{item_id}',
    ...options
});

/**
 * Issue Flight Invoice
 *
 * Create a Stripe ``InvoiceItem`` for this flight and mark it invoiced.
 */
export const issueFlightInvoiceApiV1AdminFlightInvoicingItemsItemIdIssueInvoicePost = <ThrowOnError extends boolean = true>(options: Options<IssueFlightInvoiceApiV1AdminFlightInvoicingItemsItemIdIssueInvoicePostData, ThrowOnError>): RequestResult<IssueFlightInvoiceApiV1AdminFlightInvoicingItemsItemIdIssueInvoicePostResponses, IssueFlightInvoiceApiV1AdminFlightInvoicingItemsItemIdIssueInvoicePostErrors, ThrowOnError> => (options.client ?? client).post<IssueFlightInvoiceApiV1AdminFlightInvoicingItemsItemIdIssueInvoicePostResponses, IssueFlightInvoiceApiV1AdminFlightInvoicingItemsItemIdIssueInvoicePostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/flight-invoicing/items/{item_id}/issue-invoice',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send Flight Payment Link
 *
 * Bill this flight with a payment link instead of charging the account.
 *
 * The flight twin of ``hotel_invoicing.send_payment_link``: a standalone
 * Stripe invoice the user pays themselves via a non-expiring
 * ``hosted_invoice_url``, emailed to them. Nothing is charged to the card
 * on file.
 */
export const sendFlightPaymentLinkApiV1AdminFlightInvoicingItemsItemIdSendPaymentLinkPost = <ThrowOnError extends boolean = true>(options: Options<SendFlightPaymentLinkApiV1AdminFlightInvoicingItemsItemIdSendPaymentLinkPostData, ThrowOnError>): RequestResult<SendFlightPaymentLinkApiV1AdminFlightInvoicingItemsItemIdSendPaymentLinkPostResponses, SendFlightPaymentLinkApiV1AdminFlightInvoicingItemsItemIdSendPaymentLinkPostErrors, ThrowOnError> => (options.client ?? client).post<SendFlightPaymentLinkApiV1AdminFlightInvoicingItemsItemIdSendPaymentLinkPostResponses, SendFlightPaymentLinkApiV1AdminFlightInvoicingItemsItemIdSendPaymentLinkPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/flight-invoicing/items/{item_id}/send-payment-link',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Skip Flight Invoice
 *
 * Mark the item as skipped (comp, internal trip, etc.). Requires a note.
 */
export const skipFlightInvoiceApiV1AdminFlightInvoicingItemsItemIdSkipPost = <ThrowOnError extends boolean = true>(options: Options<SkipFlightInvoiceApiV1AdminFlightInvoicingItemsItemIdSkipPostData, ThrowOnError>): RequestResult<SkipFlightInvoiceApiV1AdminFlightInvoicingItemsItemIdSkipPostResponses, SkipFlightInvoiceApiV1AdminFlightInvoicingItemsItemIdSkipPostErrors, ThrowOnError> => (options.client ?? client).post<SkipFlightInvoiceApiV1AdminFlightInvoicingItemsItemIdSkipPostResponses, SkipFlightInvoiceApiV1AdminFlightInvoicingItemsItemIdSkipPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/flight-invoicing/items/{item_id}/skip',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revert Flight Invoice
 *
 * Undo a billing decision that has not yet collected any money.
 *
 * The flight twin of ``hotel_invoicing.revert_invoice``: only valid from
 * ``invoiced`` or ``payment_link_sent``, deletes the loose Stripe line or
 * voids the unpaid standalone invoice, and returns the row to
 * ``pending_review``. Requires a note. If real money has already been
 * collected (``paid``), use the refund path instead.
 */
export const revertFlightInvoiceApiV1AdminFlightInvoicingItemsItemIdRevertPost = <ThrowOnError extends boolean = true>(options: Options<RevertFlightInvoiceApiV1AdminFlightInvoicingItemsItemIdRevertPostData, ThrowOnError>): RequestResult<RevertFlightInvoiceApiV1AdminFlightInvoicingItemsItemIdRevertPostResponses, RevertFlightInvoiceApiV1AdminFlightInvoicingItemsItemIdRevertPostErrors, ThrowOnError> => (options.client ?? client).post<RevertFlightInvoiceApiV1AdminFlightInvoicingItemsItemIdRevertPostResponses, RevertFlightInvoiceApiV1AdminFlightInvoicingItemsItemIdRevertPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/flight-invoicing/items/{item_id}/revert',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Sent Emails
 *
 * List all sent system emails with optional filtering.
 */
export const listSentEmailsApiV1AdminSentEmailsGet = <ThrowOnError extends boolean = true>(options?: Options<ListSentEmailsApiV1AdminSentEmailsGetData, ThrowOnError>): RequestResult<ListSentEmailsApiV1AdminSentEmailsGetResponses, ListSentEmailsApiV1AdminSentEmailsGetErrors, ThrowOnError> => (options?.client ?? client).get<ListSentEmailsApiV1AdminSentEmailsGetResponses, ListSentEmailsApiV1AdminSentEmailsGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/sent-emails',
    ...options
});

/**
 * List Sent Email Types
 *
 * List the distinct email types actually present in the sent_emails table.
 *
 * Used to populate the admin type filter dynamically instead of a hardcoded
 * list, so it always reflects the types that have really been sent.
 */
export const listSentEmailTypesApiV1AdminSentEmailsTypesGet = <ThrowOnError extends boolean = true>(options?: Options<ListSentEmailTypesApiV1AdminSentEmailsTypesGetData, ThrowOnError>): RequestResult<ListSentEmailTypesApiV1AdminSentEmailsTypesGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListSentEmailTypesApiV1AdminSentEmailsTypesGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/sent-emails/types',
    ...options
});

/**
 * Get Sent Email Detail
 *
 * Get full details of a sent email including body content.
 */
export const getSentEmailDetailApiV1AdminSentEmailsEmailIdGet = <ThrowOnError extends boolean = true>(options: Options<GetSentEmailDetailApiV1AdminSentEmailsEmailIdGetData, ThrowOnError>): RequestResult<GetSentEmailDetailApiV1AdminSentEmailsEmailIdGetResponses, GetSentEmailDetailApiV1AdminSentEmailsEmailIdGetErrors, ThrowOnError> => (options.client ?? client).get<GetSentEmailDetailApiV1AdminSentEmailsEmailIdGetResponses, GetSentEmailDetailApiV1AdminSentEmailsEmailIdGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/sent-emails/{email_id}',
    ...options
});

/**
 * Get Phone Enrichment
 *
 * Resolve a phone number to a person via PDL (Redis-cached, admin only).
 */
export const getPhoneEnrichmentApiV1AdminPhoneEnrichmentGet = <ThrowOnError extends boolean = true>(options: Options<GetPhoneEnrichmentApiV1AdminPhoneEnrichmentGetData, ThrowOnError>): RequestResult<GetPhoneEnrichmentApiV1AdminPhoneEnrichmentGetResponses, GetPhoneEnrichmentApiV1AdminPhoneEnrichmentGetErrors, ThrowOnError> => (options.client ?? client).get<GetPhoneEnrichmentApiV1AdminPhoneEnrichmentGetResponses, GetPhoneEnrichmentApiV1AdminPhoneEnrichmentGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/phone-enrichment',
    ...options
});

/**
 * List Custom Integrations
 *
 * List all custom integrations across users (admin only).
 *
 * Defaults to excluding archived specs unless ``status="archived"`` is
 * passed explicitly.
 */
export const listCustomIntegrationsApiV1AdminCustomIntegrationsGet = <ThrowOnError extends boolean = true>(options?: Options<ListCustomIntegrationsApiV1AdminCustomIntegrationsGetData, ThrowOnError>): RequestResult<ListCustomIntegrationsApiV1AdminCustomIntegrationsGetResponses, ListCustomIntegrationsApiV1AdminCustomIntegrationsGetErrors, ThrowOnError> => (options?.client ?? client).get<ListCustomIntegrationsApiV1AdminCustomIntegrationsGetResponses, ListCustomIntegrationsApiV1AdminCustomIntegrationsGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/custom-integrations/',
    ...options
});

/**
 * List Custom Integration Builds
 *
 * Recent build/fix workflows across users, newest first (admin only).
 *
 * Covers both backoffice-initiated and assistant-initiated builds. Lists the
 * builds recorded when each was started, then reads their workflow statuses
 * from DBOS by id. A build whose workflow never started has no status and is
 * left out.
 */
export const listCustomIntegrationBuildsApiV1AdminCustomIntegrationsBuildsGet = <ThrowOnError extends boolean = true>(options?: Options<ListCustomIntegrationBuildsApiV1AdminCustomIntegrationsBuildsGetData, ThrowOnError>): RequestResult<ListCustomIntegrationBuildsApiV1AdminCustomIntegrationsBuildsGetResponses, ListCustomIntegrationBuildsApiV1AdminCustomIntegrationsBuildsGetErrors, ThrowOnError> => (options?.client ?? client).get<ListCustomIntegrationBuildsApiV1AdminCustomIntegrationsBuildsGetResponses, ListCustomIntegrationBuildsApiV1AdminCustomIntegrationsBuildsGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/custom-integrations/builds',
    ...options
});

/**
 * Start Custom Integration Build
 *
 * Kick off a background build of a new custom integration (admin only).
 *
 * Drives the same builder workflow the assistant's ``create_new_integration``
 * tool uses; follow progress via ``GET /builds``. The spec lands owned by
 * ``user_id``, and their assistant is only notified when ``notify_user`` is
 * set.
 */
export const startCustomIntegrationBuildApiV1AdminCustomIntegrationsBuildsPost = <ThrowOnError extends boolean = true>(options: Options<StartCustomIntegrationBuildApiV1AdminCustomIntegrationsBuildsPostData, ThrowOnError>): RequestResult<StartCustomIntegrationBuildApiV1AdminCustomIntegrationsBuildsPostResponses, StartCustomIntegrationBuildApiV1AdminCustomIntegrationsBuildsPostErrors, ThrowOnError> => (options.client ?? client).post<StartCustomIntegrationBuildApiV1AdminCustomIntegrationsBuildsPostResponses, StartCustomIntegrationBuildApiV1AdminCustomIntegrationsBuildsPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/custom-integrations/builds',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Rebuild Custom Integration
 *
 * Re-run the builder on an existing spec with failure notes (admin only).
 *
 * Same fix mode the assistant's ``fix_integration`` tool uses: the name and
 * credentials are preserved and the generated code is replaced in place
 * (version bumped).
 */
export const rebuildCustomIntegrationApiV1AdminCustomIntegrationsSpecIdRebuildPost = <ThrowOnError extends boolean = true>(options: Options<RebuildCustomIntegrationApiV1AdminCustomIntegrationsSpecIdRebuildPostData, ThrowOnError>): RequestResult<RebuildCustomIntegrationApiV1AdminCustomIntegrationsSpecIdRebuildPostResponses, RebuildCustomIntegrationApiV1AdminCustomIntegrationsSpecIdRebuildPostErrors, ThrowOnError> => (options.client ?? client).post<RebuildCustomIntegrationApiV1AdminCustomIntegrationsSpecIdRebuildPostResponses, RebuildCustomIntegrationApiV1AdminCustomIntegrationsSpecIdRebuildPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/custom-integrations/{spec_id}/rebuild',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verify Custom Integration
 *
 * Run the live canary probe (+ auto-fix loop) on a spec (admin only).
 *
 * The canary fires a real read against the product's API, so the spec must
 * be connected first — 409 otherwise.
 */
export const verifyCustomIntegrationApiV1AdminCustomIntegrationsSpecIdVerifyPost = <ThrowOnError extends boolean = true>(options: Options<VerifyCustomIntegrationApiV1AdminCustomIntegrationsSpecIdVerifyPostData, ThrowOnError>): RequestResult<VerifyCustomIntegrationApiV1AdminCustomIntegrationsSpecIdVerifyPostResponses, VerifyCustomIntegrationApiV1AdminCustomIntegrationsSpecIdVerifyPostErrors, ThrowOnError> => (options.client ?? client).post<VerifyCustomIntegrationApiV1AdminCustomIntegrationsSpecIdVerifyPostResponses, VerifyCustomIntegrationApiV1AdminCustomIntegrationsSpecIdVerifyPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/custom-integrations/{spec_id}/verify',
    ...options
});

/**
 * Create Custom Integration Connect Link
 *
 * Mint the connect link the owning user would get in chat (admin only).
 *
 * Returns the OAuth redirect or a one-shot magic-link credential form per
 * the spec's auth kind, for the admin to copy and hand to the user.
 */
export const createCustomIntegrationConnectLinkApiV1AdminCustomIntegrationsSpecIdConnectLinkPost = <ThrowOnError extends boolean = true>(options: Options<CreateCustomIntegrationConnectLinkApiV1AdminCustomIntegrationsSpecIdConnectLinkPostData, ThrowOnError>): RequestResult<CreateCustomIntegrationConnectLinkApiV1AdminCustomIntegrationsSpecIdConnectLinkPostResponses, CreateCustomIntegrationConnectLinkApiV1AdminCustomIntegrationsSpecIdConnectLinkPostErrors, ThrowOnError> => (options.client ?? client).post<CreateCustomIntegrationConnectLinkApiV1AdminCustomIntegrationsSpecIdConnectLinkPostResponses, CreateCustomIntegrationConnectLinkApiV1AdminCustomIntegrationsSpecIdConnectLinkPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/custom-integrations/{spec_id}/connect-link',
    ...options
});

/**
 * Get Custom Integration Detail
 *
 * Return the full spec, including its generated Python code (admin only).
 */
export const getCustomIntegrationDetailApiV1AdminCustomIntegrationsSpecIdGet = <ThrowOnError extends boolean = true>(options: Options<GetCustomIntegrationDetailApiV1AdminCustomIntegrationsSpecIdGetData, ThrowOnError>): RequestResult<GetCustomIntegrationDetailApiV1AdminCustomIntegrationsSpecIdGetResponses, GetCustomIntegrationDetailApiV1AdminCustomIntegrationsSpecIdGetErrors, ThrowOnError> => (options.client ?? client).get<GetCustomIntegrationDetailApiV1AdminCustomIntegrationsSpecIdGetResponses, GetCustomIntegrationDetailApiV1AdminCustomIntegrationsSpecIdGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/custom-integrations/{spec_id}',
    ...options
});

/**
 * Promote Custom Integration
 *
 * Open a GitHub PR that promotes the spec to a first-party integration.
 */
export const promoteCustomIntegrationApiV1AdminCustomIntegrationsSpecIdPromotePost = <ThrowOnError extends boolean = true>(options: Options<PromoteCustomIntegrationApiV1AdminCustomIntegrationsSpecIdPromotePostData, ThrowOnError>): RequestResult<PromoteCustomIntegrationApiV1AdminCustomIntegrationsSpecIdPromotePostResponses, PromoteCustomIntegrationApiV1AdminCustomIntegrationsSpecIdPromotePostErrors, ThrowOnError> => (options.client ?? client).post<PromoteCustomIntegrationApiV1AdminCustomIntegrationsSpecIdPromotePostResponses, PromoteCustomIntegrationApiV1AdminCustomIntegrationsSpecIdPromotePostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/custom-integrations/{spec_id}/promote',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Archive Custom Integration
 *
 * Soft-archive a spec so the agent stops exposing it (admin only).
 *
 * Idempotent: archiving an already-archived spec returns ``changed=False``.
 * Encrypted credentials are kept so the spec can be revived via the
 * unarchive endpoint.
 */
export const archiveCustomIntegrationApiV1AdminCustomIntegrationsSpecIdArchivePost = <ThrowOnError extends boolean = true>(options: Options<ArchiveCustomIntegrationApiV1AdminCustomIntegrationsSpecIdArchivePostData, ThrowOnError>): RequestResult<ArchiveCustomIntegrationApiV1AdminCustomIntegrationsSpecIdArchivePostResponses, ArchiveCustomIntegrationApiV1AdminCustomIntegrationsSpecIdArchivePostErrors, ThrowOnError> => (options.client ?? client).post<ArchiveCustomIntegrationApiV1AdminCustomIntegrationsSpecIdArchivePostResponses, ArchiveCustomIntegrationApiV1AdminCustomIntegrationsSpecIdArchivePostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/custom-integrations/{spec_id}/archive',
    ...options
});

/**
 * Unarchive Custom Integration
 *
 * Restore an archived spec to READY so the agent can use it again (admin only).
 *
 * Idempotent: unarchiving a spec that isn't archived returns ``changed=False``
 * and leaves its status untouched.
 */
export const unarchiveCustomIntegrationApiV1AdminCustomIntegrationsSpecIdUnarchivePost = <ThrowOnError extends boolean = true>(options: Options<UnarchiveCustomIntegrationApiV1AdminCustomIntegrationsSpecIdUnarchivePostData, ThrowOnError>): RequestResult<UnarchiveCustomIntegrationApiV1AdminCustomIntegrationsSpecIdUnarchivePostResponses, UnarchiveCustomIntegrationApiV1AdminCustomIntegrationsSpecIdUnarchivePostErrors, ThrowOnError> => (options.client ?? client).post<UnarchiveCustomIntegrationApiV1AdminCustomIntegrationsSpecIdUnarchivePostResponses, UnarchiveCustomIntegrationApiV1AdminCustomIntegrationsSpecIdUnarchivePostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/custom-integrations/{spec_id}/unarchive',
    ...options
});

/**
 * List Custom Integration Shares
 *
 * List the users a custom integration is currently shared with (admin only).
 */
export const listCustomIntegrationSharesApiV1AdminCustomIntegrationsSpecIdSharesGet = <ThrowOnError extends boolean = true>(options: Options<ListCustomIntegrationSharesApiV1AdminCustomIntegrationsSpecIdSharesGetData, ThrowOnError>): RequestResult<ListCustomIntegrationSharesApiV1AdminCustomIntegrationsSpecIdSharesGetResponses, ListCustomIntegrationSharesApiV1AdminCustomIntegrationsSpecIdSharesGetErrors, ThrowOnError> => (options.client ?? client).get<ListCustomIntegrationSharesApiV1AdminCustomIntegrationsSpecIdSharesGetResponses, ListCustomIntegrationSharesApiV1AdminCustomIntegrationsSpecIdSharesGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/custom-integrations/{spec_id}/shares',
    ...options
});

/**
 * Share Custom Integration
 *
 * Share a custom integration with specific users (admin only).
 *
 * Idempotent and versioned: re-posting recipients pushes the source's current
 * snapshot to them. Per-recipient conflicts (e.g. the user already has their
 * own same-named integration) are reported in ``conflicts`` rather than
 * failing the whole batch.
 */
export const shareCustomIntegrationApiV1AdminCustomIntegrationsSpecIdSharesPost = <ThrowOnError extends boolean = true>(options: Options<ShareCustomIntegrationApiV1AdminCustomIntegrationsSpecIdSharesPostData, ThrowOnError>): RequestResult<ShareCustomIntegrationApiV1AdminCustomIntegrationsSpecIdSharesPostResponses, ShareCustomIntegrationApiV1AdminCustomIntegrationsSpecIdSharesPostErrors, ThrowOnError> => (options.client ?? client).post<ShareCustomIntegrationApiV1AdminCustomIntegrationsSpecIdSharesPostResponses, ShareCustomIntegrationApiV1AdminCustomIntegrationsSpecIdSharesPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/custom-integrations/{spec_id}/shares',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Unshare Custom Integration
 *
 * Stop sharing a custom integration with a specific user (admin only).
 *
 * Archives the recipient's clone (keeping their entered credentials) so the
 * agent stops exposing it. Returns the refreshed recipient list.
 */
export const unshareCustomIntegrationApiV1AdminCustomIntegrationsSpecIdSharesUserIdDelete = <ThrowOnError extends boolean = true>(options: Options<UnshareCustomIntegrationApiV1AdminCustomIntegrationsSpecIdSharesUserIdDeleteData, ThrowOnError>): RequestResult<UnshareCustomIntegrationApiV1AdminCustomIntegrationsSpecIdSharesUserIdDeleteResponses, UnshareCustomIntegrationApiV1AdminCustomIntegrationsSpecIdSharesUserIdDeleteErrors, ThrowOnError> => (options.client ?? client).delete<UnshareCustomIntegrationApiV1AdminCustomIntegrationsSpecIdSharesUserIdDeleteResponses, UnshareCustomIntegrationApiV1AdminCustomIntegrationsSpecIdSharesUserIdDeleteErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/custom-integrations/{spec_id}/shares/{user_id}',
    ...options
});

/**
 * Get Email Campaign Segment Fields
 *
 * List the whitelisted user fields the segment filter builder can use.
 */
export const getEmailCampaignSegmentFieldsApiV1AdminEmailCampaignsSegmentFieldsGet = <ThrowOnError extends boolean = true>(options?: Options<GetEmailCampaignSegmentFieldsApiV1AdminEmailCampaignsSegmentFieldsGetData, ThrowOnError>): RequestResult<GetEmailCampaignSegmentFieldsApiV1AdminEmailCampaignsSegmentFieldsGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetEmailCampaignSegmentFieldsApiV1AdminEmailCampaignsSegmentFieldsGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/email-campaigns/segment-fields',
    ...options
});

/**
 * Get Email Campaign Audience
 *
 * Return the active users a dispatch would reach: count + preview list.
 *
 * Uses the same recipient filter as dispatch (including any segment
 * conditions), so the backoffice shows the true reach instead of the
 * page-limited list it loads for the picker. The preview list is capped at
 * AUDIENCE_PREVIEW_LIMIT users for manual inspection. Excluded users are
 * subtracted from the count but kept in the preview list, so the backoffice
 * renders them as unchecked rows instead of dropping them.
 */
export const getEmailCampaignAudienceApiV1AdminEmailCampaignsAudiencePost = <ThrowOnError extends boolean = true>(options: Options<GetEmailCampaignAudienceApiV1AdminEmailCampaignsAudiencePostData, ThrowOnError>): RequestResult<GetEmailCampaignAudienceApiV1AdminEmailCampaignsAudiencePostResponses, GetEmailCampaignAudienceApiV1AdminEmailCampaignsAudiencePostErrors, ThrowOnError> => (options.client ?? client).post<GetEmailCampaignAudienceApiV1AdminEmailCampaignsAudiencePostResponses, GetEmailCampaignAudienceApiV1AdminEmailCampaignsAudiencePostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/email-campaigns/audience',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Email Campaign Segment Field Values
 *
 * Autocomplete values for a free-form segment field.
 *
 * Returns distinct values of the field among active users, optionally
 * narrowed by a substring query. Backs the filter builder's multi-value
 * combobox for fields without enumerated options.
 */
export const getEmailCampaignSegmentFieldValuesApiV1AdminEmailCampaignsSegmentFieldValuesPost = <ThrowOnError extends boolean = true>(options: Options<GetEmailCampaignSegmentFieldValuesApiV1AdminEmailCampaignsSegmentFieldValuesPostData, ThrowOnError>): RequestResult<GetEmailCampaignSegmentFieldValuesApiV1AdminEmailCampaignsSegmentFieldValuesPostResponses, GetEmailCampaignSegmentFieldValuesApiV1AdminEmailCampaignsSegmentFieldValuesPostErrors, ThrowOnError> => (options.client ?? client).post<GetEmailCampaignSegmentFieldValuesApiV1AdminEmailCampaignsSegmentFieldValuesPostResponses, GetEmailCampaignSegmentFieldValuesApiV1AdminEmailCampaignsSegmentFieldValuesPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/email-campaigns/segment-field-values',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send Email Campaign Test
 *
 * Send a test of the campaign to the requesting admin's own email.
 *
 * Returns a short-lived signed token that the dispatch endpoint requires,
 * proving this exact content was tested.
 */
export const sendEmailCampaignTestApiV1AdminEmailCampaignsTestPost = <ThrowOnError extends boolean = true>(options: Options<SendEmailCampaignTestApiV1AdminEmailCampaignsTestPostData, ThrowOnError>): RequestResult<SendEmailCampaignTestApiV1AdminEmailCampaignsTestPostResponses, SendEmailCampaignTestApiV1AdminEmailCampaignsTestPostErrors, ThrowOnError> => (options.client ?? client).post<SendEmailCampaignTestApiV1AdminEmailCampaignsTestPostResponses, SendEmailCampaignTestApiV1AdminEmailCampaignsTestPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/email-campaigns/test',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Dispatch Email Campaign
 *
 * Dispatch a previously-tested campaign to users (specific or all active).
 *
 * Requires a valid test token for the exact content; rejects untested content.
 */
export const dispatchEmailCampaignApiV1AdminEmailCampaignsDispatchPost = <ThrowOnError extends boolean = true>(options: Options<DispatchEmailCampaignApiV1AdminEmailCampaignsDispatchPostData, ThrowOnError>): RequestResult<DispatchEmailCampaignApiV1AdminEmailCampaignsDispatchPostResponses, DispatchEmailCampaignApiV1AdminEmailCampaignsDispatchPostErrors, ThrowOnError> => (options.client ?? client).post<DispatchEmailCampaignApiV1AdminEmailCampaignsDispatchPostResponses, DispatchEmailCampaignApiV1AdminEmailCampaignsDispatchPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/email-campaigns/dispatch',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Hosted Mailboxes
 *
 * List Catch-hosted assistant mailboxes with per-mailbox message counts.
 */
export const listHostedMailboxesApiV1AdminHostedEmailMailboxesGet = <ThrowOnError extends boolean = true>(options?: Options<ListHostedMailboxesApiV1AdminHostedEmailMailboxesGetData, ThrowOnError>): RequestResult<ListHostedMailboxesApiV1AdminHostedEmailMailboxesGetResponses, ListHostedMailboxesApiV1AdminHostedEmailMailboxesGetErrors, ThrowOnError> => (options?.client ?? client).get<ListHostedMailboxesApiV1AdminHostedEmailMailboxesGetResponses, ListHostedMailboxesApiV1AdminHostedEmailMailboxesGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/hosted-email/mailboxes',
    ...options
});

/**
 * List Hosted Mailbox Messages
 *
 * List the inbound + outbound messages in a hosted mailbox.
 */
export const listHostedMailboxMessagesApiV1AdminHostedEmailMailboxesMailboxIdMessagesGet = <ThrowOnError extends boolean = true>(options: Options<ListHostedMailboxMessagesApiV1AdminHostedEmailMailboxesMailboxIdMessagesGetData, ThrowOnError>): RequestResult<ListHostedMailboxMessagesApiV1AdminHostedEmailMailboxesMailboxIdMessagesGetResponses, ListHostedMailboxMessagesApiV1AdminHostedEmailMailboxesMailboxIdMessagesGetErrors, ThrowOnError> => (options.client ?? client).get<ListHostedMailboxMessagesApiV1AdminHostedEmailMailboxesMailboxIdMessagesGetResponses, ListHostedMailboxMessagesApiV1AdminHostedEmailMailboxesMailboxIdMessagesGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/hosted-email/mailboxes/{mailbox_id}/messages',
    ...options
});

/**
 * Get Hosted Email Message
 *
 * Get the full body and headers of one hosted-mailbox message.
 */
export const getHostedEmailMessageApiV1AdminHostedEmailMessagesMessageIdGet = <ThrowOnError extends boolean = true>(options: Options<GetHostedEmailMessageApiV1AdminHostedEmailMessagesMessageIdGetData, ThrowOnError>): RequestResult<GetHostedEmailMessageApiV1AdminHostedEmailMessagesMessageIdGetResponses, GetHostedEmailMessageApiV1AdminHostedEmailMessagesMessageIdGetErrors, ThrowOnError> => (options.client ?? client).get<GetHostedEmailMessageApiV1AdminHostedEmailMessagesMessageIdGetResponses, GetHostedEmailMessageApiV1AdminHostedEmailMessagesMessageIdGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/hosted-email/messages/{message_id}',
    ...options
});

/**
 * List Group Chats
 *
 * Group chats a sponsor's assistant is in, newest first.
 */
export const listGroupChatsApiV1AdminGroupChatsGet = <ThrowOnError extends boolean = true>(options?: Options<ListGroupChatsApiV1AdminGroupChatsGetData, ThrowOnError>): RequestResult<ListGroupChatsApiV1AdminGroupChatsGetResponses, ListGroupChatsApiV1AdminGroupChatsGetErrors, ThrowOnError> => (options?.client ?? client).get<ListGroupChatsApiV1AdminGroupChatsGetResponses, ListGroupChatsApiV1AdminGroupChatsGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/group-chats',
    ...options
});

/**
 * Get Group Chat
 *
 * One group and its delegated conversations, newest first, with their logs.
 */
export const getGroupChatApiV1AdminGroupChatsGroupIdGet = <ThrowOnError extends boolean = true>(options: Options<GetGroupChatApiV1AdminGroupChatsGroupIdGetData, ThrowOnError>): RequestResult<GetGroupChatApiV1AdminGroupChatsGroupIdGetResponses, GetGroupChatApiV1AdminGroupChatsGroupIdGetErrors, ThrowOnError> => (options.client ?? client).get<GetGroupChatApiV1AdminGroupChatsGroupIdGetResponses, GetGroupChatApiV1AdminGroupChatsGroupIdGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/group-chats/{group_id}',
    ...options
});

/**
 * List Web Automation Scripts
 *
 * List recorded web-automation scripts across users (admin only).
 */
export const listWebAutomationScriptsApiV1AdminWebAutomationsGet = <ThrowOnError extends boolean = true>(options?: Options<ListWebAutomationScriptsApiV1AdminWebAutomationsGetData, ThrowOnError>): RequestResult<ListWebAutomationScriptsApiV1AdminWebAutomationsGetResponses, ListWebAutomationScriptsApiV1AdminWebAutomationsGetErrors, ThrowOnError> => (options?.client ?? client).get<ListWebAutomationScriptsApiV1AdminWebAutomationsGetResponses, ListWebAutomationScriptsApiV1AdminWebAutomationsGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/web-automations/',
    ...options
});

/**
 * Get Web Automation Script Detail
 *
 * Return one script's recorded steps + recent run history (admin only).
 */
export const getWebAutomationScriptDetailApiV1AdminWebAutomationsScriptIdGet = <ThrowOnError extends boolean = true>(options: Options<GetWebAutomationScriptDetailApiV1AdminWebAutomationsScriptIdGetData, ThrowOnError>): RequestResult<GetWebAutomationScriptDetailApiV1AdminWebAutomationsScriptIdGetResponses, GetWebAutomationScriptDetailApiV1AdminWebAutomationsScriptIdGetErrors, ThrowOnError> => (options.client ?? client).get<GetWebAutomationScriptDetailApiV1AdminWebAutomationsScriptIdGetResponses, GetWebAutomationScriptDetailApiV1AdminWebAutomationsScriptIdGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/web-automations/{script_id}',
    ...options
});

/**
 * Update Web Automation Script Status
 *
 * Retire a script or clear its quarantine (admin only).
 *
 * Setting ``active`` also resets the consecutive-failure counter so the script
 * gets a clean slate before it is replayed again.
 */
export const updateWebAutomationScriptStatusApiV1AdminWebAutomationsScriptIdStatusPost = <ThrowOnError extends boolean = true>(options: Options<UpdateWebAutomationScriptStatusApiV1AdminWebAutomationsScriptIdStatusPostData, ThrowOnError>): RequestResult<UpdateWebAutomationScriptStatusApiV1AdminWebAutomationsScriptIdStatusPostResponses, UpdateWebAutomationScriptStatusApiV1AdminWebAutomationsScriptIdStatusPostErrors, ThrowOnError> => (options.client ?? client).post<UpdateWebAutomationScriptStatusApiV1AdminWebAutomationsScriptIdStatusPostResponses, UpdateWebAutomationScriptStatusApiV1AdminWebAutomationsScriptIdStatusPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/web-automations/{script_id}/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Trialing Users
 *
 * List all users currently in a Stripe trial, enriched for CS/growth triage.
 */
export const getTrialingUsersApiV1AdminTrialingUsersGet = <ThrowOnError extends boolean = true>(options?: Options<GetTrialingUsersApiV1AdminTrialingUsersGetData, ThrowOnError>): RequestResult<GetTrialingUsersApiV1AdminTrialingUsersGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetTrialingUsersApiV1AdminTrialingUsersGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/trialing-users',
    ...options
});

/**
 * Get User Deletion Manifest
 *
 * Dry-run inventory of everything a data purge would touch (admin only).
 *
 * Read-only against our own database (S3 counts come from tracked key
 * columns). Review ``blocked_tables`` (must be empty), the per-table row
 * counts, and the sent_emails retain/delete split before purging.
 */
export const getUserDeletionManifestApiV1AdminUsersUserIdDeletionManifestGet = <ThrowOnError extends boolean = true>(options: Options<GetUserDeletionManifestApiV1AdminUsersUserIdDeletionManifestGetData, ThrowOnError>): RequestResult<GetUserDeletionManifestApiV1AdminUsersUserIdDeletionManifestGetResponses, GetUserDeletionManifestApiV1AdminUsersUserIdDeletionManifestGetErrors, ThrowOnError> => (options.client ?? client).get<GetUserDeletionManifestApiV1AdminUsersUserIdDeletionManifestGetResponses, GetUserDeletionManifestApiV1AdminUsersUserIdDeletionManifestGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/deletion-manifest',
    ...options
});

/**
 * Purge User Data
 *
 * Irreversibly delete a user's personal data everywhere (admin only).
 *
 * User-data hard deletion: FK-graph DB purge with audit-row carve-outs,
 * durable email suppression, S3/Stripe/mem0/DBOS/Redis purges. The account
 * must already be deactivated, and the dry-run manifest should have been
 * reviewed. PostHog person deletion and the Logfire retention posture
 * remain manual runbook steps and are flagged in the returned report.
 */
export const purgeUserDataApiV1AdminUsersUserIdPurgePost = <ThrowOnError extends boolean = true>(options: Options<PurgeUserDataApiV1AdminUsersUserIdPurgePostData, ThrowOnError>): RequestResult<PurgeUserDataApiV1AdminUsersUserIdPurgePostResponses, PurgeUserDataApiV1AdminUsersUserIdPurgePostErrors, ThrowOnError> => (options.client ?? client).post<PurgeUserDataApiV1AdminUsersUserIdPurgePostResponses, PurgeUserDataApiV1AdminUsersUserIdPurgePostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/purge',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Disarm User Provider Switch
 *
 * Cancel an armed provider switch that has not completed (admin only).
 */
export const disarmUserProviderSwitchApiV1AdminUsersUserIdProviderSwitchDelete = <ThrowOnError extends boolean = true>(options: Options<DisarmUserProviderSwitchApiV1AdminUsersUserIdProviderSwitchDeleteData, ThrowOnError>): RequestResult<DisarmUserProviderSwitchApiV1AdminUsersUserIdProviderSwitchDeleteResponses, DisarmUserProviderSwitchApiV1AdminUsersUserIdProviderSwitchDeleteErrors, ThrowOnError> => (options.client ?? client).delete<DisarmUserProviderSwitchApiV1AdminUsersUserIdProviderSwitchDeleteResponses, DisarmUserProviderSwitchApiV1AdminUsersUserIdProviderSwitchDeleteErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/provider-switch',
    ...options
});

/**
 * Arm User Provider Switch
 *
 * Arm a move of the account to the other calendar provider (admin only).
 *
 * The switch completes when the user next signs in with the target provider
 * using the account's own address, within the returned expiry. That sign-in
 * keeps the account (history, settings, billing, integrations) and resets
 * only the state that was specific to the old provider. Relay
 * ``user_instructions`` to the user.
 */
export const armUserProviderSwitchApiV1AdminUsersUserIdProviderSwitchPost = <ThrowOnError extends boolean = true>(options: Options<ArmUserProviderSwitchApiV1AdminUsersUserIdProviderSwitchPostData, ThrowOnError>): RequestResult<ArmUserProviderSwitchApiV1AdminUsersUserIdProviderSwitchPostResponses, ArmUserProviderSwitchApiV1AdminUsersUserIdProviderSwitchPostErrors, ThrowOnError> => (options.client ?? client).post<ArmUserProviderSwitchApiV1AdminUsersUserIdProviderSwitchPostResponses, ArmUserProviderSwitchApiV1AdminUsersUserIdProviderSwitchPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/provider-switch',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Change User Email
 *
 * Change the email address an account is registered under (admin only).
 *
 * Updates the address, writes an admin note and updates the user's Stripe
 * customers. Refused (409) when another account or a connected inbox holds
 * the address, when it would grant staff access or hit an SSO-enforced
 * domain, and, for a different sign-in account, when the user has mail and
 * calendar access (connect the new address as a second inbox instead). Relay
 * ``user_instructions`` to the user.
 */
export const changeUserEmailApiV1AdminUsersUserIdEmailPost = <ThrowOnError extends boolean = true>(options: Options<ChangeUserEmailApiV1AdminUsersUserIdEmailPostData, ThrowOnError>): RequestResult<ChangeUserEmailApiV1AdminUsersUserIdEmailPostResponses, ChangeUserEmailApiV1AdminUsersUserIdEmailPostErrors, ThrowOnError> => (options.client ?? client).post<ChangeUserEmailApiV1AdminUsersUserIdEmailPostResponses, ChangeUserEmailApiV1AdminUsersUserIdEmailPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/email',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Disconnect User Pipedream Connection
 *
 * Disconnect one of a user's Pipedream catalog apps (admin only).
 *
 * The same disconnect as the user's own Settings button: the app's triggers
 * are removed, the account is revoked at Pipedream, and the connection is
 * deleted. ``connection_id`` is an ``id`` from the user's ``pipedream_apps``.
 */
export const disconnectUserPipedreamConnectionApiV1AdminUsersUserIdPipedreamConnectionsConnectionIdDelete = <ThrowOnError extends boolean = true>(options: Options<DisconnectUserPipedreamConnectionApiV1AdminUsersUserIdPipedreamConnectionsConnectionIdDeleteData, ThrowOnError>): RequestResult<DisconnectUserPipedreamConnectionApiV1AdminUsersUserIdPipedreamConnectionsConnectionIdDeleteResponses, DisconnectUserPipedreamConnectionApiV1AdminUsersUserIdPipedreamConnectionsConnectionIdDeleteErrors, ThrowOnError> => (options.client ?? client).delete<DisconnectUserPipedreamConnectionApiV1AdminUsersUserIdPipedreamConnectionsConnectionIdDeleteResponses, DisconnectUserPipedreamConnectionApiV1AdminUsersUserIdPipedreamConnectionsConnectionIdDeleteErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/pipedream-connections/{connection_id}',
    ...options
});

/**
 * List User Integrations
 *
 * Everything connected to the user that can be disconnected (admin only).
 */
export const listUserIntegrationsApiV1AdminUsersUserIdIntegrationsGet = <ThrowOnError extends boolean = true>(options: Options<ListUserIntegrationsApiV1AdminUsersUserIdIntegrationsGetData, ThrowOnError>): RequestResult<ListUserIntegrationsApiV1AdminUsersUserIdIntegrationsGetResponses, ListUserIntegrationsApiV1AdminUsersUserIdIntegrationsGetErrors, ThrowOnError> => (options.client ?? client).get<ListUserIntegrationsApiV1AdminUsersUserIdIntegrationsGetResponses, ListUserIntegrationsApiV1AdminUsersUserIdIntegrationsGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/integrations',
    ...options
});

/**
 * Disconnect User Integrations
 *
 * Disconnect some or all of a user's integrations (admin only).
 *
 * Each one is disconnected independently and reported in ``outcomes``; one
 * failing does not stop the rest. Disconnecting the primary Google/Microsoft
 * account signs the user out everywhere, and they reconnect by signing in.
 * An outcome with ``user_action_required`` names a step only the user can
 * take, such as withdrawing a Microsoft grant.
 */
export const disconnectUserIntegrationsApiV1AdminUsersUserIdIntegrationsDisconnectPost = <ThrowOnError extends boolean = true>(options: Options<DisconnectUserIntegrationsApiV1AdminUsersUserIdIntegrationsDisconnectPostData, ThrowOnError>): RequestResult<DisconnectUserIntegrationsApiV1AdminUsersUserIdIntegrationsDisconnectPostResponses, DisconnectUserIntegrationsApiV1AdminUsersUserIdIntegrationsDisconnectPostErrors, ThrowOnError> => (options.client ?? client).post<DisconnectUserIntegrationsApiV1AdminUsersUserIdIntegrationsDisconnectPostResponses, DisconnectUserIntegrationsApiV1AdminUsersUserIdIntegrationsDisconnectPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/integrations/disconnect',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Suppressed Emails
 *
 * Suppressed addresses, newest first; ``email`` checks one address.
 *
 * An empty ``entries`` for a given ``email`` is the answer to "why is this
 * account getting no mail" being *no*.
 */
export const listSuppressedEmailsApiV1AdminEmailSuppressionsGet = <ThrowOnError extends boolean = true>(options?: Options<ListSuppressedEmailsApiV1AdminEmailSuppressionsGetData, ThrowOnError>): RequestResult<ListSuppressedEmailsApiV1AdminEmailSuppressionsGetResponses, ListSuppressedEmailsApiV1AdminEmailSuppressionsGetErrors, ThrowOnError> => (options?.client ?? client).get<ListSuppressedEmailsApiV1AdminEmailSuppressionsGetResponses, ListSuppressedEmailsApiV1AdminEmailSuppressionsGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/email-suppressions',
    ...options
});

/**
 * Lift Suppressed Email
 *
 * Let Catch email one suppressed address again (admin only).
 *
 * Never do this for an address suppressed by a data-subject erasure request:
 * the entry is how that request keeps being honored after the account row is
 * gone. The legitimate case is an address purged only to free it. The
 * response is the lifted entry, so the caller sees the provenance of what
 * they just undid; the row is kept (soft-lifted) for the same reason.
 */
export const liftSuppressedEmailApiV1AdminEmailSuppressionsLiftPost = <ThrowOnError extends boolean = true>(options: Options<LiftSuppressedEmailApiV1AdminEmailSuppressionsLiftPostData, ThrowOnError>): RequestResult<LiftSuppressedEmailApiV1AdminEmailSuppressionsLiftPostResponses, LiftSuppressedEmailApiV1AdminEmailSuppressionsLiftPostErrors, ThrowOnError> => (options.client ?? client).post<LiftSuppressedEmailApiV1AdminEmailSuppressionsLiftPostResponses, LiftSuppressedEmailApiV1AdminEmailSuppressionsLiftPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/email-suppressions/lift',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Assistant V2 Overview
 *
 * What v2 holds for this owner, in counts.
 */
export const getAssistantV2OverviewApiV1AdminUsersUserIdAssistantV2Get = <ThrowOnError extends boolean = true>(options: Options<GetAssistantV2OverviewApiV1AdminUsersUserIdAssistantV2GetData, ThrowOnError>): RequestResult<GetAssistantV2OverviewApiV1AdminUsersUserIdAssistantV2GetResponses, GetAssistantV2OverviewApiV1AdminUsersUserIdAssistantV2GetErrors, ThrowOnError> => (options.client ?? client).get<GetAssistantV2OverviewApiV1AdminUsersUserIdAssistantV2GetResponses, GetAssistantV2OverviewApiV1AdminUsersUserIdAssistantV2GetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/assistant-v2',
    ...options
});

/**
 * List Assistant V2 Memory
 *
 * The owner's memory files (``main/rules.md``, ``main/MEMORY.md``, ...).
 */
export const listAssistantV2MemoryApiV1AdminUsersUserIdAssistantV2MemoryGet = <ThrowOnError extends boolean = true>(options: Options<ListAssistantV2MemoryApiV1AdminUsersUserIdAssistantV2MemoryGetData, ThrowOnError>): RequestResult<ListAssistantV2MemoryApiV1AdminUsersUserIdAssistantV2MemoryGetResponses, ListAssistantV2MemoryApiV1AdminUsersUserIdAssistantV2MemoryGetErrors, ThrowOnError> => (options.client ?? client).get<ListAssistantV2MemoryApiV1AdminUsersUserIdAssistantV2MemoryGetResponses, ListAssistantV2MemoryApiV1AdminUsersUserIdAssistantV2MemoryGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/assistant-v2/memory',
    ...options
});

/**
 * Delete Assistant V2 Memory File
 *
 * Delete a memory file at the version you saw.
 */
export const deleteAssistantV2MemoryFileApiV1AdminUsersUserIdAssistantV2MemoryPathDelete = <ThrowOnError extends boolean = true>(options: Options<DeleteAssistantV2MemoryFileApiV1AdminUsersUserIdAssistantV2MemoryPathDeleteData, ThrowOnError>): RequestResult<DeleteAssistantV2MemoryFileApiV1AdminUsersUserIdAssistantV2MemoryPathDeleteResponses, DeleteAssistantV2MemoryFileApiV1AdminUsersUserIdAssistantV2MemoryPathDeleteErrors, ThrowOnError> => (options.client ?? client).delete<DeleteAssistantV2MemoryFileApiV1AdminUsersUserIdAssistantV2MemoryPathDeleteResponses, DeleteAssistantV2MemoryFileApiV1AdminUsersUserIdAssistantV2MemoryPathDeleteErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/assistant-v2/memory/{path}',
    ...options
});

/**
 * Get Assistant V2 Memory File
 *
 * One memory file with its content and version.
 */
export const getAssistantV2MemoryFileApiV1AdminUsersUserIdAssistantV2MemoryPathGet = <ThrowOnError extends boolean = true>(options: Options<GetAssistantV2MemoryFileApiV1AdminUsersUserIdAssistantV2MemoryPathGetData, ThrowOnError>): RequestResult<GetAssistantV2MemoryFileApiV1AdminUsersUserIdAssistantV2MemoryPathGetResponses, GetAssistantV2MemoryFileApiV1AdminUsersUserIdAssistantV2MemoryPathGetErrors, ThrowOnError> => (options.client ?? client).get<GetAssistantV2MemoryFileApiV1AdminUsersUserIdAssistantV2MemoryPathGetResponses, GetAssistantV2MemoryFileApiV1AdminUsersUserIdAssistantV2MemoryPathGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/assistant-v2/memory/{path}',
    ...options
});

/**
 * Put Assistant V2 Memory File
 *
 * Create or replace a memory file.
 *
 * Give the version you edited, or null to create; a file that changed since
 * (a run wrote it) is refused with 409 rather than overwritten.
 */
export const putAssistantV2MemoryFileApiV1AdminUsersUserIdAssistantV2MemoryPathPut = <ThrowOnError extends boolean = true>(options: Options<PutAssistantV2MemoryFileApiV1AdminUsersUserIdAssistantV2MemoryPathPutData, ThrowOnError>): RequestResult<PutAssistantV2MemoryFileApiV1AdminUsersUserIdAssistantV2MemoryPathPutResponses, PutAssistantV2MemoryFileApiV1AdminUsersUserIdAssistantV2MemoryPathPutErrors, ThrowOnError> => (options.client ?? client).put<PutAssistantV2MemoryFileApiV1AdminUsersUserIdAssistantV2MemoryPathPutResponses, PutAssistantV2MemoryFileApiV1AdminUsersUserIdAssistantV2MemoryPathPutErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/assistant-v2/memory/{path}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Assistant V2 Triggers
 *
 * The owner's triggers, active first. Times are UTC.
 */
export const listAssistantV2TriggersApiV1AdminUsersUserIdAssistantV2TriggersGet = <ThrowOnError extends boolean = true>(options: Options<ListAssistantV2TriggersApiV1AdminUsersUserIdAssistantV2TriggersGetData, ThrowOnError>): RequestResult<ListAssistantV2TriggersApiV1AdminUsersUserIdAssistantV2TriggersGetResponses, ListAssistantV2TriggersApiV1AdminUsersUserIdAssistantV2TriggersGetErrors, ThrowOnError> => (options.client ?? client).get<ListAssistantV2TriggersApiV1AdminUsersUserIdAssistantV2TriggersGetResponses, ListAssistantV2TriggersApiV1AdminUsersUserIdAssistantV2TriggersGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/assistant-v2/triggers',
    ...options
});

/**
 * Create Assistant V2 Trigger
 *
 * Create a trigger, validated as the agent's ``triggers_create`` is.
 */
export const createAssistantV2TriggerApiV1AdminUsersUserIdAssistantV2TriggersPost = <ThrowOnError extends boolean = true>(options: Options<CreateAssistantV2TriggerApiV1AdminUsersUserIdAssistantV2TriggersPostData, ThrowOnError>): RequestResult<CreateAssistantV2TriggerApiV1AdminUsersUserIdAssistantV2TriggersPostResponses, CreateAssistantV2TriggerApiV1AdminUsersUserIdAssistantV2TriggersPostErrors, ThrowOnError> => (options.client ?? client).post<CreateAssistantV2TriggerApiV1AdminUsersUserIdAssistantV2TriggersPostResponses, CreateAssistantV2TriggerApiV1AdminUsersUserIdAssistantV2TriggersPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/assistant-v2/triggers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Assistant V2 Trigger
 *
 * Edit a trigger, or switch it on or off.
 *
 * Switching a cron trigger on schedules its next time from now, so a missed
 * occurrence does not fire at once. An ``at`` trigger needs a future ``at``.
 * ``calendars`` replaces the other calendars a calendar trigger reads.
 */
export const updateAssistantV2TriggerApiV1AdminUsersUserIdAssistantV2TriggersTriggerIdPatch = <ThrowOnError extends boolean = true>(options: Options<UpdateAssistantV2TriggerApiV1AdminUsersUserIdAssistantV2TriggersTriggerIdPatchData, ThrowOnError>): RequestResult<UpdateAssistantV2TriggerApiV1AdminUsersUserIdAssistantV2TriggersTriggerIdPatchResponses, UpdateAssistantV2TriggerApiV1AdminUsersUserIdAssistantV2TriggersTriggerIdPatchErrors, ThrowOnError> => (options.client ?? client).patch<UpdateAssistantV2TriggerApiV1AdminUsersUserIdAssistantV2TriggersTriggerIdPatchResponses, UpdateAssistantV2TriggerApiV1AdminUsersUserIdAssistantV2TriggersTriggerIdPatchErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/assistant-v2/triggers/{trigger_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Assistant V2 Trigger Runs
 *
 * What the owner's triggers did when fired, newest first, in their timezone.
 */
export const listAssistantV2TriggerRunsApiV1AdminUsersUserIdAssistantV2TriggerRunsGet = <ThrowOnError extends boolean = true>(options: Options<ListAssistantV2TriggerRunsApiV1AdminUsersUserIdAssistantV2TriggerRunsGetData, ThrowOnError>): RequestResult<ListAssistantV2TriggerRunsApiV1AdminUsersUserIdAssistantV2TriggerRunsGetResponses, ListAssistantV2TriggerRunsApiV1AdminUsersUserIdAssistantV2TriggerRunsGetErrors, ThrowOnError> => (options.client ?? client).get<ListAssistantV2TriggerRunsApiV1AdminUsersUserIdAssistantV2TriggerRunsGetResponses, ListAssistantV2TriggerRunsApiV1AdminUsersUserIdAssistantV2TriggerRunsGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/assistant-v2/trigger-runs',
    ...options
});

/**
 * Get Assistant V2 Plan
 *
 * The owner's plan: the open work the agent tracks, in order.
 */
export const getAssistantV2PlanApiV1AdminUsersUserIdAssistantV2PlanGet = <ThrowOnError extends boolean = true>(options: Options<GetAssistantV2PlanApiV1AdminUsersUserIdAssistantV2PlanGetData, ThrowOnError>): RequestResult<GetAssistantV2PlanApiV1AdminUsersUserIdAssistantV2PlanGetResponses, GetAssistantV2PlanApiV1AdminUsersUserIdAssistantV2PlanGetErrors, ThrowOnError> => (options.client ?? client).get<GetAssistantV2PlanApiV1AdminUsersUserIdAssistantV2PlanGetResponses, GetAssistantV2PlanApiV1AdminUsersUserIdAssistantV2PlanGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/assistant-v2/plan',
    ...options
});

/**
 * Create Assistant V2 Plan Step
 *
 * Add a step at the end of the plan.
 */
export const createAssistantV2PlanStepApiV1AdminUsersUserIdAssistantV2PlanPost = <ThrowOnError extends boolean = true>(options: Options<CreateAssistantV2PlanStepApiV1AdminUsersUserIdAssistantV2PlanPostData, ThrowOnError>): RequestResult<CreateAssistantV2PlanStepApiV1AdminUsersUserIdAssistantV2PlanPostResponses, CreateAssistantV2PlanStepApiV1AdminUsersUserIdAssistantV2PlanPostErrors, ThrowOnError> => (options.client ?? client).post<CreateAssistantV2PlanStepApiV1AdminUsersUserIdAssistantV2PlanPostResponses, CreateAssistantV2PlanStepApiV1AdminUsersUserIdAssistantV2PlanPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/assistant-v2/plan',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Assistant V2 Plan Step
 *
 * Remove a step from the plan. Returns the step as it was.
 *
 * A step with steps under it is refused; steps depending on it stop doing so.
 */
export const deleteAssistantV2PlanStepApiV1AdminUsersUserIdAssistantV2PlanStepIdDelete = <ThrowOnError extends boolean = true>(options: Options<DeleteAssistantV2PlanStepApiV1AdminUsersUserIdAssistantV2PlanStepIdDeleteData, ThrowOnError>): RequestResult<DeleteAssistantV2PlanStepApiV1AdminUsersUserIdAssistantV2PlanStepIdDeleteResponses, DeleteAssistantV2PlanStepApiV1AdminUsersUserIdAssistantV2PlanStepIdDeleteErrors, ThrowOnError> => (options.client ?? client).delete<DeleteAssistantV2PlanStepApiV1AdminUsersUserIdAssistantV2PlanStepIdDeleteResponses, DeleteAssistantV2PlanStepApiV1AdminUsersUserIdAssistantV2PlanStepIdDeleteErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/assistant-v2/plan/{step_id}',
    ...options
});

/**
 * Update Assistant V2 Plan Step
 *
 * Change a step's text or status.
 */
export const updateAssistantV2PlanStepApiV1AdminUsersUserIdAssistantV2PlanStepIdPatch = <ThrowOnError extends boolean = true>(options: Options<UpdateAssistantV2PlanStepApiV1AdminUsersUserIdAssistantV2PlanStepIdPatchData, ThrowOnError>): RequestResult<UpdateAssistantV2PlanStepApiV1AdminUsersUserIdAssistantV2PlanStepIdPatchResponses, UpdateAssistantV2PlanStepApiV1AdminUsersUserIdAssistantV2PlanStepIdPatchErrors, ThrowOnError> => (options.client ?? client).patch<UpdateAssistantV2PlanStepApiV1AdminUsersUserIdAssistantV2PlanStepIdPatchResponses, UpdateAssistantV2PlanStepApiV1AdminUsersUserIdAssistantV2PlanStepIdPatchErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/assistant-v2/plan/{step_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Assistant V2 Events
 *
 * What reached the owner's v2 loop, newest first.
 */
export const listAssistantV2EventsApiV1AdminUsersUserIdAssistantV2EventsGet = <ThrowOnError extends boolean = true>(options: Options<ListAssistantV2EventsApiV1AdminUsersUserIdAssistantV2EventsGetData, ThrowOnError>): RequestResult<ListAssistantV2EventsApiV1AdminUsersUserIdAssistantV2EventsGetResponses, ListAssistantV2EventsApiV1AdminUsersUserIdAssistantV2EventsGetErrors, ThrowOnError> => (options.client ?? client).get<ListAssistantV2EventsApiV1AdminUsersUserIdAssistantV2EventsGetResponses, ListAssistantV2EventsApiV1AdminUsersUserIdAssistantV2EventsGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/assistant-v2/events',
    ...options
});

/**
 * List Auto Approval Policies
 *
 * List an owner's v1 auto-approval policies, active first then newest.
 */
export const listAutoApprovalPoliciesApiV1AdminUsersUserIdAutoApprovalPoliciesGet = <ThrowOnError extends boolean = true>(options: Options<ListAutoApprovalPoliciesApiV1AdminUsersUserIdAutoApprovalPoliciesGetData, ThrowOnError>): RequestResult<ListAutoApprovalPoliciesApiV1AdminUsersUserIdAutoApprovalPoliciesGetResponses, ListAutoApprovalPoliciesApiV1AdminUsersUserIdAutoApprovalPoliciesGetErrors, ThrowOnError> => (options.client ?? client).get<ListAutoApprovalPoliciesApiV1AdminUsersUserIdAutoApprovalPoliciesGetResponses, ListAutoApprovalPoliciesApiV1AdminUsersUserIdAutoApprovalPoliciesGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/auto-approval-policies',
    ...options
});

/**
 * Delete Auto Approval Policy
 *
 * Hard-delete one of the owner's v1 auto-approval policies.
 */
export const deleteAutoApprovalPolicyApiV1AdminUsersUserIdAutoApprovalPoliciesPolicyIdDelete = <ThrowOnError extends boolean = true>(options: Options<DeleteAutoApprovalPolicyApiV1AdminUsersUserIdAutoApprovalPoliciesPolicyIdDeleteData, ThrowOnError>): RequestResult<DeleteAutoApprovalPolicyApiV1AdminUsersUserIdAutoApprovalPoliciesPolicyIdDeleteResponses, DeleteAutoApprovalPolicyApiV1AdminUsersUserIdAutoApprovalPoliciesPolicyIdDeleteErrors, ThrowOnError> => (options.client ?? client).delete<DeleteAutoApprovalPolicyApiV1AdminUsersUserIdAutoApprovalPoliciesPolicyIdDeleteResponses, DeleteAutoApprovalPolicyApiV1AdminUsersUserIdAutoApprovalPoliciesPolicyIdDeleteErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/auto-approval-policies/{policy_id}',
    ...options
});

/**
 * Adopt Legacy Dbos Workflows
 *
 * Promote DBOS 3.x and adopt the workflows the 2.31 pods left.
 *
 * Run after the last 2.31 pod has drained (see "Rolling 3.0 deploy" in
 * ``dev-docs/DBOS.md``). Always run it once with ``dry_run`` first. It refuses
 * (409, or the report's ``refused`` on a dry run) while any legacy row changed
 * in the last few minutes, never touches a terminal row, and is safe to run
 * again after a partial failure.
 */
export const adoptLegacyDbosWorkflowsApiV1AdminDbosLegacyAdoptionPost = <ThrowOnError extends boolean = true>(options: Options<AdoptLegacyDbosWorkflowsApiV1AdminDbosLegacyAdoptionPostData, ThrowOnError>): RequestResult<AdoptLegacyDbosWorkflowsApiV1AdminDbosLegacyAdoptionPostResponses, AdoptLegacyDbosWorkflowsApiV1AdminDbosLegacyAdoptionPostErrors, ThrowOnError> => (options.client ?? client).post<AdoptLegacyDbosWorkflowsApiV1AdminDbosLegacyAdoptionPostResponses, AdoptLegacyDbosWorkflowsApiV1AdminDbosLegacyAdoptionPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/dbos/legacy-adoption',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Use Cases
 *
 * Use cases, most owners first, with how many owners and organizations do each,
 * how often it was offered and taken up, and a few owners' own versions.
 */
export const listUseCasesApiV1AdminUseCasesGet = <ThrowOnError extends boolean = true>(options?: Options<ListUseCasesApiV1AdminUseCasesGetData, ThrowOnError>): RequestResult<ListUseCasesApiV1AdminUseCasesGetResponses, ListUseCasesApiV1AdminUseCasesGetErrors, ThrowOnError> => (options?.client ?? client).get<ListUseCasesApiV1AdminUseCasesGetResponses, ListUseCasesApiV1AdminUseCasesGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/use-cases',
    ...options
});

/**
 * Update Use Case
 *
 * Edit a use case's text, or publish, reject or retire it.
 *
 * Publishing makes it visible to owners' agents at their next suggestion;
 * rejecting keeps it so the miner records new sightings against it instead
 * of proposing it again.
 */
export const updateUseCaseApiV1AdminUseCasesUseCaseIdPatch = <ThrowOnError extends boolean = true>(options: Options<UpdateUseCaseApiV1AdminUseCasesUseCaseIdPatchData, ThrowOnError>): RequestResult<UpdateUseCaseApiV1AdminUseCasesUseCaseIdPatchResponses, UpdateUseCaseApiV1AdminUseCasesUseCaseIdPatchErrors, ThrowOnError> => (options.client ?? client).patch<UpdateUseCaseApiV1AdminUseCasesUseCaseIdPatchResponses, UpdateUseCaseApiV1AdminUseCasesUseCaseIdPatchErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/use-cases/{use_case_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Merge Use Case
 *
 * Fold this use case into ``into_id``: its sightings and offers move and it is
 * deleted.
 */
export const mergeUseCaseApiV1AdminUseCasesUseCaseIdMergePost = <ThrowOnError extends boolean = true>(options: Options<MergeUseCaseApiV1AdminUseCasesUseCaseIdMergePostData, ThrowOnError>): RequestResult<MergeUseCaseApiV1AdminUseCasesUseCaseIdMergePostResponses, MergeUseCaseApiV1AdminUseCasesUseCaseIdMergePostErrors, ThrowOnError> => (options.client ?? client).post<MergeUseCaseApiV1AdminUseCasesUseCaseIdMergePostResponses, MergeUseCaseApiV1AdminUseCasesUseCaseIdMergePostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/use-cases/{use_case_id}/merge',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Preview Use Cases
 *
 * Run the miner on one owner's last week and return what it finds, writing
 * nothing, to judge its output on real data.
 */
export const previewUseCasesApiV1AdminUseCasesPreviewUserIdPost = <ThrowOnError extends boolean = true>(options: Options<PreviewUseCasesApiV1AdminUseCasesPreviewUserIdPostData, ThrowOnError>): RequestResult<PreviewUseCasesApiV1AdminUseCasesPreviewUserIdPostResponses, PreviewUseCasesApiV1AdminUseCasesPreviewUserIdPostErrors, ThrowOnError> => (options.client ?? client).post<PreviewUseCasesApiV1AdminUseCasesPreviewUserIdPostResponses, PreviewUseCasesApiV1AdminUseCasesPreviewUserIdPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/use-cases/preview/{user_id}',
    ...options
});

/**
 * Ingest Broadcast Proposals
 *
 * Queue configuration-fix proposals for admin review.
 */
export const ingestBroadcastProposalsApiV1InternalBroadcastProposalsPost = <ThrowOnError extends boolean = true>(options: Options<IngestBroadcastProposalsApiV1InternalBroadcastProposalsPostData, ThrowOnError>): RequestResult<IngestBroadcastProposalsApiV1InternalBroadcastProposalsPostResponses, IngestBroadcastProposalsApiV1InternalBroadcastProposalsPostErrors, ThrowOnError> => (options.client ?? client).post<IngestBroadcastProposalsApiV1InternalBroadcastProposalsPostResponses, IngestBroadcastProposalsApiV1InternalBroadcastProposalsPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/internal/broadcast-proposals',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Whatsapp Status
 *
 * Get the current WhatsApp integration status for the user
 */
export const getWhatsappStatusApiV1WhatsappStatusGet = <ThrowOnError extends boolean = true>(options?: Options<GetWhatsappStatusApiV1WhatsappStatusGetData, ThrowOnError>): RequestResult<GetWhatsappStatusApiV1WhatsappStatusGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetWhatsappStatusApiV1WhatsappStatusGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/whatsapp/status',
    ...options
});

/**
 * Generate Verification Code
 *
 * Generate a verification code for WhatsApp pairing
 */
export const generateVerificationCodeApiV1WhatsappGenerateCodePost = <ThrowOnError extends boolean = true>(options?: Options<GenerateVerificationCodeApiV1WhatsappGenerateCodePostData, ThrowOnError>): RequestResult<GenerateVerificationCodeApiV1WhatsappGenerateCodePostResponses, unknown, ThrowOnError> => (options?.client ?? client).post<GenerateVerificationCodeApiV1WhatsappGenerateCodePostResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/whatsapp/generate-code',
    ...options
});

/**
 * Disconnect Whatsapp
 *
 * Disconnect WhatsApp integration for the user
 */
export const disconnectWhatsappApiV1WhatsappDisconnectDelete = <ThrowOnError extends boolean = true>(options?: Options<DisconnectWhatsappApiV1WhatsappDisconnectDeleteData, ThrowOnError>): RequestResult<DisconnectWhatsappApiV1WhatsappDisconnectDeleteResponses, unknown, ThrowOnError> => (options?.client ?? client).delete<DisconnectWhatsappApiV1WhatsappDisconnectDeleteResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/whatsapp/disconnect',
    ...options
});

/**
 * Get Sms Status
 *
 * Get the current SMS integration status for the user.
 */
export const getSmsStatusApiV1SmsStatusGet = <ThrowOnError extends boolean = true>(options?: Options<GetSmsStatusApiV1SmsStatusGetData, ThrowOnError>): RequestResult<GetSmsStatusApiV1SmsStatusGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetSmsStatusApiV1SmsStatusGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/sms/status',
    ...options
});

/**
 * Generate Verification Code
 *
 * Generate a 6-character verification code and send it via SMS.
 */
export const generateVerificationCodeApiV1SmsGenerateCodePost = <ThrowOnError extends boolean = true>(options: Options<GenerateVerificationCodeApiV1SmsGenerateCodePostData, ThrowOnError>): RequestResult<GenerateVerificationCodeApiV1SmsGenerateCodePostResponses, GenerateVerificationCodeApiV1SmsGenerateCodePostErrors, ThrowOnError> => (options.client ?? client).post<GenerateVerificationCodeApiV1SmsGenerateCodePostResponses, GenerateVerificationCodeApiV1SmsGenerateCodePostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/sms/generate-code',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verify Sms Code
 *
 * Verify a 6-character SMS code and link the phone number to the user's account.
 */
export const verifySmsCodeApiV1SmsVerifyCodePost = <ThrowOnError extends boolean = true>(options: Options<VerifySmsCodeApiV1SmsVerifyCodePostData, ThrowOnError>): RequestResult<VerifySmsCodeApiV1SmsVerifyCodePostResponses, VerifySmsCodeApiV1SmsVerifyCodePostErrors, ThrowOnError> => (options.client ?? client).post<VerifySmsCodeApiV1SmsVerifyCodePostResponses, VerifySmsCodeApiV1SmsVerifyCodePostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/sms/verify-code',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Disconnect Sms
 *
 * Disconnect SMS, preserving the phone number and WhatsApp verification.
 */
export const disconnectSmsApiV1SmsDisconnectDelete = <ThrowOnError extends boolean = true>(options?: Options<DisconnectSmsApiV1SmsDisconnectDeleteData, ThrowOnError>): RequestResult<DisconnectSmsApiV1SmsDisconnectDeleteResponses, unknown, ThrowOnError> => (options?.client ?? client).delete<DisconnectSmsApiV1SmsDisconnectDeleteResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/sms/disconnect',
    ...options
});

/**
 * Get Contact Texting Consent
 *
 * Whether, and since when, the assistant may text the owner's contacts.
 */
export const getContactTextingConsentApiV1ContactTextingGet = <ThrowOnError extends boolean = true>(options?: Options<GetContactTextingConsentApiV1ContactTextingGetData, ThrowOnError>): RequestResult<GetContactTextingConsentApiV1ContactTextingGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetContactTextingConsentApiV1ContactTextingGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/contact-texting',
    ...options
});

/**
 * Set Contact Texting Consent
 *
 * Give or withdraw the consent. Giving it again keeps the first timestamp.
 */
export const setContactTextingConsentApiV1ContactTextingPut = <ThrowOnError extends boolean = true>(options: Options<SetContactTextingConsentApiV1ContactTextingPutData, ThrowOnError>): RequestResult<SetContactTextingConsentApiV1ContactTextingPutResponses, SetContactTextingConsentApiV1ContactTextingPutErrors, ThrowOnError> => (options.client ?? client).put<SetContactTextingConsentApiV1ContactTextingPutResponses, SetContactTextingConsentApiV1ContactTextingPutErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/contact-texting',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Imessage Status
 *
 * Get the current iMessage integration status for the user.
 */
export const getImessageStatusApiV1ImessageStatusGet = <ThrowOnError extends boolean = true>(options?: Options<GetImessageStatusApiV1ImessageStatusGetData, ThrowOnError>): RequestResult<GetImessageStatusApiV1ImessageStatusGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetImessageStatusApiV1ImessageStatusGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/imessage/status',
    ...options
});

/**
 * Generate Verification Code
 *
 * Start pairing: return a deep link that pre-fills a verification code.
 */
export const generateVerificationCodeApiV1ImessageGenerateCodePost = <ThrowOnError extends boolean = true>(options: Options<GenerateVerificationCodeApiV1ImessageGenerateCodePostData, ThrowOnError>): RequestResult<GenerateVerificationCodeApiV1ImessageGenerateCodePostResponses, GenerateVerificationCodeApiV1ImessageGenerateCodePostErrors, ThrowOnError> => (options.client ?? client).post<GenerateVerificationCodeApiV1ImessageGenerateCodePostResponses, GenerateVerificationCodeApiV1ImessageGenerateCodePostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/imessage/generate-code',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Disconnect Imessage
 *
 * Disconnect iMessage integration.
 *
 * With ``?identifier=`` set, disconnects just that one handle (the user may
 * own several); otherwise disconnects every handle.
 */
export const disconnectImessageApiV1ImessageDisconnectDelete = <ThrowOnError extends boolean = true>(options?: Options<DisconnectImessageApiV1ImessageDisconnectDeleteData, ThrowOnError>): RequestResult<DisconnectImessageApiV1ImessageDisconnectDeleteResponses, DisconnectImessageApiV1ImessageDisconnectDeleteErrors, ThrowOnError> => (options?.client ?? client).delete<DisconnectImessageApiV1ImessageDisconnectDeleteResponses, DisconnectImessageApiV1ImessageDisconnectDeleteErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/imessage/disconnect',
    ...options
});

/**
 * Get Slack Status
 *
 * Get the current Slack integration status for the user
 */
export const getSlackStatusApiV1SlackStatusGet = <ThrowOnError extends boolean = true>(options?: Options<GetSlackStatusApiV1SlackStatusGetData, ThrowOnError>): RequestResult<GetSlackStatusApiV1SlackStatusGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetSlackStatusApiV1SlackStatusGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/slack/status',
    ...options
});

/**
 * Initiate Slack Oauth
 *
 * Initiate Slack OAuth flow
 */
export const initiateSlackOauthApiV1SlackOauthInitiatePost = <ThrowOnError extends boolean = true>(options?: Options<InitiateSlackOauthApiV1SlackOauthInitiatePostData, ThrowOnError>): RequestResult<InitiateSlackOauthApiV1SlackOauthInitiatePostResponses, unknown, ThrowOnError> => (options?.client ?? client).post<InitiateSlackOauthApiV1SlackOauthInitiatePostResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/slack/oauth/initiate',
    ...options
});

/**
 * Handle Slack Oauth Callback
 *
 * Handle Slack OAuth callback
 */
export const handleSlackOauthCallbackApiV1SlackOauthCallbackPost = <ThrowOnError extends boolean = true>(options: Options<HandleSlackOauthCallbackApiV1SlackOauthCallbackPostData, ThrowOnError>): RequestResult<HandleSlackOauthCallbackApiV1SlackOauthCallbackPostResponses, HandleSlackOauthCallbackApiV1SlackOauthCallbackPostErrors, ThrowOnError> => (options.client ?? client).post<HandleSlackOauthCallbackApiV1SlackOauthCallbackPostResponses, HandleSlackOauthCallbackApiV1SlackOauthCallbackPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/slack/oauth/callback',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Disconnect Slack
 *
 * Disconnect Slack integration for the user
 */
export const disconnectSlackApiV1SlackDisconnectDelete = <ThrowOnError extends boolean = true>(options?: Options<DisconnectSlackApiV1SlackDisconnectDeleteData, ThrowOnError>): RequestResult<DisconnectSlackApiV1SlackDisconnectDeleteResponses, unknown, ThrowOnError> => (options?.client ?? client).delete<DisconnectSlackApiV1SlackDisconnectDeleteResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/slack/disconnect',
    ...options
});

/**
 * Get Slack Personal Status
 *
 * Whether the user has connected their own Slack account (read-only).
 */
export const getSlackPersonalStatusApiV1SlackPersonalStatusGet = <ThrowOnError extends boolean = true>(options?: Options<GetSlackPersonalStatusApiV1SlackPersonalStatusGetData, ThrowOnError>): RequestResult<GetSlackPersonalStatusApiV1SlackPersonalStatusGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetSlackPersonalStatusApiV1SlackPersonalStatusGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/slack/personal/status',
    ...options
});

/**
 * Initiate Slack Personal Oauth
 *
 * Start the user-scope-only OAuth flow.
 */
export const initiateSlackPersonalOauthApiV1SlackPersonalOauthInitiatePost = <ThrowOnError extends boolean = true>(options?: Options<InitiateSlackPersonalOauthApiV1SlackPersonalOauthInitiatePostData, ThrowOnError>): RequestResult<InitiateSlackPersonalOauthApiV1SlackPersonalOauthInitiatePostResponses, unknown, ThrowOnError> => (options?.client ?? client).post<InitiateSlackPersonalOauthApiV1SlackPersonalOauthInitiatePostResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/slack/personal/oauth/initiate',
    ...options
});

/**
 * Handle Slack Personal Oauth Callback
 *
 * Exchange the code for a read-only user token and store it.
 */
export const handleSlackPersonalOauthCallbackApiV1SlackPersonalOauthCallbackPost = <ThrowOnError extends boolean = true>(options: Options<HandleSlackPersonalOauthCallbackApiV1SlackPersonalOauthCallbackPostData, ThrowOnError>): RequestResult<HandleSlackPersonalOauthCallbackApiV1SlackPersonalOauthCallbackPostResponses, HandleSlackPersonalOauthCallbackApiV1SlackPersonalOauthCallbackPostErrors, ThrowOnError> => (options.client ?? client).post<HandleSlackPersonalOauthCallbackApiV1SlackPersonalOauthCallbackPostResponses, HandleSlackPersonalOauthCallbackApiV1SlackPersonalOauthCallbackPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/slack/personal/oauth/callback',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Slack Personal Conversations
 *
 * Every conversation the user's token can see, flagged by the grant.
 */
export const listSlackPersonalConversationsApiV1SlackPersonalConversationsGet = <ThrowOnError extends boolean = true>(options?: Options<ListSlackPersonalConversationsApiV1SlackPersonalConversationsGetData, ThrowOnError>): RequestResult<ListSlackPersonalConversationsApiV1SlackPersonalConversationsGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListSlackPersonalConversationsApiV1SlackPersonalConversationsGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/slack/personal/conversations',
    ...options
});

/**
 * Update Slack Personal Access
 *
 * Replace the opt-in / opt-out list.
 */
export const updateSlackPersonalAccessApiV1SlackPersonalAccessPut = <ThrowOnError extends boolean = true>(options: Options<UpdateSlackPersonalAccessApiV1SlackPersonalAccessPutData, ThrowOnError>): RequestResult<UpdateSlackPersonalAccessApiV1SlackPersonalAccessPutResponses, UpdateSlackPersonalAccessApiV1SlackPersonalAccessPutErrors, ThrowOnError> => (options.client ?? client).put<UpdateSlackPersonalAccessApiV1SlackPersonalAccessPutResponses, UpdateSlackPersonalAccessApiV1SlackPersonalAccessPutErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/slack/personal/access',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Disconnect Slack Personal
 *
 * Revoke the token at Slack and retire the grant.
 */
export const disconnectSlackPersonalApiV1SlackPersonalDisconnectDelete = <ThrowOnError extends boolean = true>(options?: Options<DisconnectSlackPersonalApiV1SlackPersonalDisconnectDeleteData, ThrowOnError>): RequestResult<DisconnectSlackPersonalApiV1SlackPersonalDisconnectDeleteResponses, unknown, ThrowOnError> => (options?.client ?? client).delete<DisconnectSlackPersonalApiV1SlackPersonalDisconnectDeleteResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/slack/personal/disconnect',
    ...options
});

/**
 * Get Teams Access Status
 *
 * The permission on the user's Teams connection, if they have one.
 */
export const getTeamsAccessStatusApiV1TeamsAccessStatusGet = <ThrowOnError extends boolean = true>(options?: Options<GetTeamsAccessStatusApiV1TeamsAccessStatusGetData, ThrowOnError>): RequestResult<GetTeamsAccessStatusApiV1TeamsAccessStatusGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetTeamsAccessStatusApiV1TeamsAccessStatusGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/teams/access/status',
    ...options
});

/**
 * List Teams Access Conversations
 *
 * Every chat and channel the connection can see, flagged by the grant.
 */
export const listTeamsAccessConversationsApiV1TeamsAccessConversationsGet = <ThrowOnError extends boolean = true>(options?: Options<ListTeamsAccessConversationsApiV1TeamsAccessConversationsGetData, ThrowOnError>): RequestResult<ListTeamsAccessConversationsApiV1TeamsAccessConversationsGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListTeamsAccessConversationsApiV1TeamsAccessConversationsGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/teams/access/conversations',
    ...options
});

/**
 * Update Teams Access
 *
 * Replace the opt-in / opt-out list.
 */
export const updateTeamsAccessApiV1TeamsAccessPut = <ThrowOnError extends boolean = true>(options: Options<UpdateTeamsAccessApiV1TeamsAccessPutData, ThrowOnError>): RequestResult<UpdateTeamsAccessApiV1TeamsAccessPutResponses, UpdateTeamsAccessApiV1TeamsAccessPutErrors, ThrowOnError> => (options.client ?? client).put<UpdateTeamsAccessApiV1TeamsAccessPutResponses, UpdateTeamsAccessApiV1TeamsAccessPutErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/teams/access',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Zoom Status
 *
 * Get the current Zoom integration status for the user.
 */
export const getZoomStatusApiV1AuthZoomStatusGet = <ThrowOnError extends boolean = true>(options?: Options<GetZoomStatusApiV1AuthZoomStatusGetData, ThrowOnError>): RequestResult<GetZoomStatusApiV1AuthZoomStatusGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetZoomStatusApiV1AuthZoomStatusGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/zoom/status',
    ...options
});

/**
 * Initiate Zoom Oauth
 *
 * Initiate Zoom OAuth flow.
 */
export const initiateZoomOauthApiV1AuthZoomOauthInitiatePost = <ThrowOnError extends boolean = true>(options?: Options<InitiateZoomOauthApiV1AuthZoomOauthInitiatePostData, ThrowOnError>): RequestResult<InitiateZoomOauthApiV1AuthZoomOauthInitiatePostResponses, unknown, ThrowOnError> => (options?.client ?? client).post<InitiateZoomOauthApiV1AuthZoomOauthInitiatePostResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/zoom/oauth/initiate',
    ...options
});

/**
 * Handle Zoom Oauth Callback
 *
 * Handle Zoom OAuth callback.
 */
export const handleZoomOauthCallbackApiV1AuthZoomOauthCallbackPost = <ThrowOnError extends boolean = true>(options: Options<HandleZoomOauthCallbackApiV1AuthZoomOauthCallbackPostData, ThrowOnError>): RequestResult<HandleZoomOauthCallbackApiV1AuthZoomOauthCallbackPostResponses, HandleZoomOauthCallbackApiV1AuthZoomOauthCallbackPostErrors, ThrowOnError> => (options.client ?? client).post<HandleZoomOauthCallbackApiV1AuthZoomOauthCallbackPostResponses, HandleZoomOauthCallbackApiV1AuthZoomOauthCallbackPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/zoom/oauth/callback',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Zoom Oauth Redirect
 *
 * Handle Zoom OAuth redirect and forward to frontend callback page.
 *
 * Zoom redirects here after user authorizes. This endpoint redirects to the
 * frontend callback page which handles the token exchange via the POST endpoint.
 */
export const zoomOauthRedirectApiV1AuthZoomCallbackGet = <ThrowOnError extends boolean = true>(options?: Options<ZoomOauthRedirectApiV1AuthZoomCallbackGetData, ThrowOnError>): RequestResult<ZoomOauthRedirectApiV1AuthZoomCallbackGetResponses, ZoomOauthRedirectApiV1AuthZoomCallbackGetErrors, ThrowOnError> => (options?.client ?? client).get<ZoomOauthRedirectApiV1AuthZoomCallbackGetResponses, ZoomOauthRedirectApiV1AuthZoomCallbackGetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/auth/zoom/callback',
    ...options
});

/**
 * Disconnect Zoom
 *
 * Disconnect Zoom integration for the user.
 */
export const disconnectZoomApiV1AuthZoomDisconnectDelete = <ThrowOnError extends boolean = true>(options?: Options<DisconnectZoomApiV1AuthZoomDisconnectDeleteData, ThrowOnError>): RequestResult<DisconnectZoomApiV1AuthZoomDisconnectDeleteResponses, unknown, ThrowOnError> => (options?.client ?? client).delete<DisconnectZoomApiV1AuthZoomDisconnectDeleteResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/zoom/disconnect',
    ...options
});

/**
 * Zoom Webhook
 *
 * Handle Zoom webhook events.
 *
 * Handles:
 * - endpoint.url_validation: Responds to Zoom's URL validation challenge
 * - app_deauthorized: Cleans up user data when app is uninstalled
 * - Other events: Logs and acknowledges
 */
export const zoomWebhookApiV1AuthZoomWebhookPost = <ThrowOnError extends boolean = true>(options?: Options<ZoomWebhookApiV1AuthZoomWebhookPostData, ThrowOnError>): RequestResult<ZoomWebhookApiV1AuthZoomWebhookPostResponses, unknown, ThrowOnError> => (options?.client ?? client).post<ZoomWebhookApiV1AuthZoomWebhookPostResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/auth/zoom/webhook',
    ...options
});

/**
 * Voice Webhook
 *
 * Handle incoming Twilio Voice webhook (call initiated).
 *
 * This is called when:
 * 1. An incoming call arrives to our Twilio number
 * 2. An outgoing call we initiated is answered
 *
 * Returns TwiML to connect the call to our WebSocket stream.
 */
export const voiceWebhookApiV1PhoneWebhookVoicePost = <ThrowOnError extends boolean = true>(options?: Options<VoiceWebhookApiV1PhoneWebhookVoicePostData, ThrowOnError>): RequestResult<VoiceWebhookApiV1PhoneWebhookVoicePostResponses, VoiceWebhookApiV1PhoneWebhookVoicePostErrors, ThrowOnError> => (options?.client ?? client).post<VoiceWebhookApiV1PhoneWebhookVoicePostResponses, VoiceWebhookApiV1PhoneWebhookVoicePostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/phone/webhook/voice',
    ...options
});

/**
 * Whatsapp Voice Webhook
 *
 * Handle an incoming WhatsApp Business Calling voice webhook.
 *
 * Twilio delivers WhatsApp calls "in the same manner as inbound calls to a
 * Twilio phone number", so this shares the PSTN handler body. The deltas:
 * the caller's ``whatsapp:+E164`` address is stripped to the bare E.164 (so
 * contact and executive self-contact matching work unchanged), the call
 * session is tagged ``transport=whatsapp``, and connecting is gated per-user
 * on the ``whatsapp-business-calling`` flag — flag-off callers are rejected
 * before any conversation row is created.
 *
 * The sender's ``voice_application_sid`` must point at a TwiML app whose
 * Request URL is this endpoint (with ``?token=<webhook_token>``); that wiring
 * is configured in the Twilio/Meta console, not here. Phase 1 is inbound only.
 *
 * **The guest/executive line split deliberately does not extend here yet
 * (GET-9560).** WhatsApp calls arrive on the WhatsApp sender, a different
 * number space from the PSTN voice lines, so ``resolve_inbound_line`` never
 * matches a guest-line number and every WhatsApp call resolves to the
 * executive line. That is the correct behavior for phase 1, not an oversight:
 * WhatsApp calling is inbound-only, so no assistant ever dials a guest over
 * WhatsApp, so no guest has a WhatsApp callback to place. The collision the
 * split removes cannot arise on a leg where we never make the outbound call.
 *
 * Extending it would mean provisioning a second WhatsApp sender (the exact
 * shape ``twilio_whatsapp_number_secondary`` already has for messaging) and is
 * only worth doing when outbound WhatsApp calling ships — at which point the
 * guest leg gets that secondary sender and the discriminator here becomes
 * ``is_from_secondary_number`` on the dialed address, matching the messaging
 * path one-for-one.
 */
export const whatsappVoiceWebhookApiV1PhoneWebhookWhatsappVoicePost = <ThrowOnError extends boolean = true>(options?: Options<WhatsappVoiceWebhookApiV1PhoneWebhookWhatsappVoicePostData, ThrowOnError>): RequestResult<WhatsappVoiceWebhookApiV1PhoneWebhookWhatsappVoicePostResponses, WhatsappVoiceWebhookApiV1PhoneWebhookWhatsappVoicePostErrors, ThrowOnError> => (options?.client ?? client).post<WhatsappVoiceWebhookApiV1PhoneWebhookWhatsappVoicePostResponses, WhatsappVoiceWebhookApiV1PhoneWebhookWhatsappVoicePostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/phone/webhook/whatsapp-voice',
    ...options
});

/**
 * Whatsapp Sip Voice Webhook
 *
 * Handle a WhatsApp call on the Meta-direct number, bridged over SIP.
 *
 * Meta's Calling API in SIP mode sends the owner's call to a Twilio SIP domain
 * whose voice URL is this endpoint, so it arrives as an ordinary Twilio voice
 * webhook with ``sip:`` addresses. It is tagged ``transport=whatsapp`` and gated
 * on ``whatsapp-meta-direct``, the flag that moves the owner's WhatsApp chat to
 * that number. Setup is in ``dev-docs/WHATSAPP_META_DIRECT.md``.
 */
export const whatsappSipVoiceWebhookApiV1PhoneWebhookWhatsappSipVoicePost = <ThrowOnError extends boolean = true>(options?: Options<WhatsappSipVoiceWebhookApiV1PhoneWebhookWhatsappSipVoicePostData, ThrowOnError>): RequestResult<WhatsappSipVoiceWebhookApiV1PhoneWebhookWhatsappSipVoicePostResponses, WhatsappSipVoiceWebhookApiV1PhoneWebhookWhatsappSipVoicePostErrors, ThrowOnError> => (options?.client ?? client).post<WhatsappSipVoiceWebhookApiV1PhoneWebhookWhatsappSipVoicePostResponses, WhatsappSipVoiceWebhookApiV1PhoneWebhookWhatsappSipVoicePostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/phone/webhook/whatsapp-sip-voice',
    ...options
});

/**
 * Dedicated Number Sms Webhook
 *
 * Route a text sent to a dedicated number.
 *
 * The owner texting their own texting-enabled line (it joined the A2P
 * campaign, GET-16926) reaches their assistant through the ordinary SMS
 * workflow, which replies from this same line (``select_sms_from_number_for``).
 * Anyone else's text, with guest texting on for the owner, starts or joins an
 * assistant conversation answered from the line
 * (``process_dedicated_line_guest_sms_workflow``); our campaign (CIY48ZU)
 * covers replies to a contact who texted the line first. Otherwise it goes to
 * the owner's inbox and nothing is texted back.
 *
 * The number rides in the contact card as a ``TEL;TYPE=CELL`` entry, so
 * every phone that saves the card offers a Message button next to Call.
 * Before this endpoint existed the number had no ``SmsUrl`` at all, which
 * does NOT bounce the text: Twilio accepts it, fires no webhook, and the
 * sender gets silence with a delivered receipt.
 */
export const dedicatedNumberSmsWebhookApiV1PhoneWebhookDedicatedSmsPost = <ThrowOnError extends boolean = true>(options?: Options<DedicatedNumberSmsWebhookApiV1PhoneWebhookDedicatedSmsPostData, ThrowOnError>): RequestResult<DedicatedNumberSmsWebhookApiV1PhoneWebhookDedicatedSmsPostResponses, DedicatedNumberSmsWebhookApiV1PhoneWebhookDedicatedSmsPostErrors, ThrowOnError> => (options?.client ?? client).post<DedicatedNumberSmsWebhookApiV1PhoneWebhookDedicatedSmsPostResponses, DedicatedNumberSmsWebhookApiV1PhoneWebhookDedicatedSmsPostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/phone/webhook/dedicated-sms',
    ...options
});

/**
 * Voice Status Webhook
 *
 * Handle Twilio call status callbacks.
 *
 * Called when call status changes (initiated, ringing, answered, completed).
 */
export const voiceStatusWebhookApiV1PhoneWebhookVoiceStatusPost = <ThrowOnError extends boolean = true>(options?: Options<VoiceStatusWebhookApiV1PhoneWebhookVoiceStatusPostData, ThrowOnError>): RequestResult<VoiceStatusWebhookApiV1PhoneWebhookVoiceStatusPostResponses, VoiceStatusWebhookApiV1PhoneWebhookVoiceStatusPostErrors, ThrowOnError> => (options?.client ?? client).post<VoiceStatusWebhookApiV1PhoneWebhookVoiceStatusPostResponses, VoiceStatusWebhookApiV1PhoneWebhookVoiceStatusPostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/phone/webhook/voice/status',
    ...options
});

/**
 * Twiml Connect
 *
 * Generate TwiML to connect a call to the WebSocket stream.
 *
 * Called by Twilio when an outbound call is answered.
 */
export const twimlConnectApiV1PhoneTwimlConnectConversationIdPost = <ThrowOnError extends boolean = true>(options: Options<TwimlConnectApiV1PhoneTwimlConnectConversationIdPostData, ThrowOnError>): RequestResult<TwimlConnectApiV1PhoneTwimlConnectConversationIdPostResponses, TwimlConnectApiV1PhoneTwimlConnectConversationIdPostErrors, ThrowOnError> => (options.client ?? client).post<TwimlConnectApiV1PhoneTwimlConnectConversationIdPostResponses, TwimlConnectApiV1PhoneTwimlConnectConversationIdPostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/phone/twiml/connect/{conversation_id}',
    ...options
});

/**
 * Twiml Stream Ended
 *
 * Tell Twilio what to do once a call's media stream has ended.
 */
export const twimlStreamEndedApiV1PhoneTwimlStreamEndedConversationIdPost = <ThrowOnError extends boolean = true>(options: Options<TwimlStreamEndedApiV1PhoneTwimlStreamEndedConversationIdPostData, ThrowOnError>): RequestResult<TwimlStreamEndedApiV1PhoneTwimlStreamEndedConversationIdPostResponses, TwimlStreamEndedApiV1PhoneTwimlStreamEndedConversationIdPostErrors, ThrowOnError> => (options.client ?? client).post<TwimlStreamEndedApiV1PhoneTwimlStreamEndedConversationIdPostResponses, TwimlStreamEndedApiV1PhoneTwimlStreamEndedConversationIdPostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/phone/twiml/stream-ended/{conversation_id}',
    ...options
});

/**
 * Conversation Initiation
 *
 * Decide whether to answer an inbound SIP call, and configure it if so.
 *
 * Mirrors the PSTN webhook's routing exactly — same line resolution, same
 * robocall screen, same conversation lookup — because the decision of *who may
 * reach the assistant* must not depend on which transport carried the call.
 * What differs is only the answer's shape: JSON configuration instead of
 * connect TwiML.
 *
 * Authenticated on the bearer secret, not a signature, for the same reason the
 * tool routes are: this is **not** a registered platform webhook. It is
 * configured by URL under `conversation_initiation_client_data_webhook`, whose
 * only headers are the ones we put in its `request_headers` — so ElevenLabs
 * never signs it. Only the post-call delivery is a registered webhook, and it
 * is the one that carries `ElevenLabs-Signature`. Requiring a signature here
 * rejected every inbound call with a 403, which ElevenLabs surfaces as
 * `1011 Error retrieving conversation initiation data from webhook` and the
 * caller hears as a call that fails to connect (GET-12417).
 */
export const conversationInitiationApiV1PhoneElevenlabsConversationInitiationPost = <ThrowOnError extends boolean = true>(options?: Options<ConversationInitiationApiV1PhoneElevenlabsConversationInitiationPostData, ThrowOnError>): RequestResult<ConversationInitiationApiV1PhoneElevenlabsConversationInitiationPostResponses, ConversationInitiationApiV1PhoneElevenlabsConversationInitiationPostErrors, ThrowOnError> => (options?.client ?? client).post<ConversationInitiationApiV1PhoneElevenlabsConversationInitiationPostResponses, ConversationInitiationApiV1PhoneElevenlabsConversationInitiationPostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/phone/elevenlabs/conversation-initiation',
    ...options
});

/**
 * Agent Tool
 *
 * Run one of the agent's tools for a SIP call.
 *
 * The same ``run_phone_tool`` the bridge dispatches to, so a tool behaves
 * identically on both transports. What this route has to reconstruct is the
 * *state* the bridge holds in memory: the transcript, and where the follow-up
 * task's anchor window begins.
 */
export const agentToolApiV1PhoneElevenlabsToolToolNamePost = <ThrowOnError extends boolean = true>(options: Options<AgentToolApiV1PhoneElevenlabsToolToolNamePostData, ThrowOnError>): RequestResult<AgentToolApiV1PhoneElevenlabsToolToolNamePostResponses, AgentToolApiV1PhoneElevenlabsToolToolNamePostErrors, ThrowOnError> => (options.client ?? client).post<AgentToolApiV1PhoneElevenlabsToolToolNamePostResponses, AgentToolApiV1PhoneElevenlabsToolToolNamePostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/phone/elevenlabs/tool/{tool_name}',
    ...options
});

/**
 * Post Call
 *
 * Persist the finished call and tell the workflow it ended.
 *
 * On the bridge this is the socket teardown's job (`handle_twilio_disconnect`),
 * and it matters for the same reason: without it the parent phone workflow
 * waits out its event timeout instead of learning the call is over (GET-9236).
 * A `complete_goal` or `request_context` earlier in the call has already sent
 * its own event; this one is unconditional and the workflow treats a second
 * terminal event for a finished conversation as a no-op.
 */
export const postCallApiV1PhoneElevenlabsPostCallPost = <ThrowOnError extends boolean = true>(options?: Options<PostCallApiV1PhoneElevenlabsPostCallPostData, ThrowOnError>): RequestResult<PostCallApiV1PhoneElevenlabsPostCallPostResponses, PostCallApiV1PhoneElevenlabsPostCallPostErrors, ThrowOnError> => (options?.client ?? client).post<PostCallApiV1PhoneElevenlabsPostCallPostResponses, PostCallApiV1PhoneElevenlabsPostCallPostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/phone/elevenlabs/post-call',
    ...options
});

/**
 * Release Number
 *
 * Release the user's dedicated number (prorated credit for the add-on).
 */
export const releaseNumberApiV1DedicatedNumberDelete = <ThrowOnError extends boolean = true>(options?: Options<ReleaseNumberApiV1DedicatedNumberDeleteData, ThrowOnError>): RequestResult<ReleaseNumberApiV1DedicatedNumberDeleteResponses, unknown, ThrowOnError> => (options?.client ?? client).delete<ReleaseNumberApiV1DedicatedNumberDeleteResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/dedicated-number',
    ...options
});

/**
 * Dedicated Number Status
 *
 * Current state: flag availability, the number if provisioned, price.
 */
export const dedicatedNumberStatusApiV1DedicatedNumberGet = <ThrowOnError extends boolean = true>(options?: Options<DedicatedNumberStatusApiV1DedicatedNumberGetData, ThrowOnError>): RequestResult<DedicatedNumberStatusApiV1DedicatedNumberGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<DedicatedNumberStatusApiV1DedicatedNumberGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/dedicated-number',
    ...options
});

/**
 * Provision Number
 *
 * Buy + wire + bill a dedicated number for the current user.
 */
export const provisionNumberApiV1DedicatedNumberPost = <ThrowOnError extends boolean = true>(options: Options<ProvisionNumberApiV1DedicatedNumberPostData, ThrowOnError>): RequestResult<ProvisionNumberApiV1DedicatedNumberPostResponses, ProvisionNumberApiV1DedicatedNumberPostErrors, ThrowOnError> => (options.client ?? client).post<ProvisionNumberApiV1DedicatedNumberPostResponses, ProvisionNumberApiV1DedicatedNumberPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/dedicated-number',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Download Contact Card
 *
 * The assistant's vCard as a downloadable ``.vcf``.
 *
 * Offered beside the dedicated number because that number is what the card
 * embeds as its primary ``TEL`` — ``build_voice_call_card`` prefers it over
 * the shared pool, so saving this card is how the user (and anyone they hand
 * it to) ends up dialing their private line. It works without the add-on too,
 * embedding the pooled voice number instead.
 *
 * Nothing is persisted: the agent path stores a ``UserFile`` because it has
 * to attach one to a message, but a download just needs the bytes.
 */
export const downloadContactCardApiV1DedicatedNumberContactCardGet = <ThrowOnError extends boolean = true>(options?: Options<DownloadContactCardApiV1DedicatedNumberContactCardGetData, ThrowOnError>): RequestResult<DownloadContactCardApiV1DedicatedNumberContactCardGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<DownloadContactCardApiV1DedicatedNumberContactCardGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/dedicated-number/contact-card',
    ...options
});

/**
 * Automatic Approvals Status
 *
 * Whether automatic approvals are on, and whether the user can change it.
 */
export const automaticApprovalsStatusApiV1AutomaticApprovalsGet = <ThrowOnError extends boolean = true>(options?: Options<AutomaticApprovalsStatusApiV1AutomaticApprovalsGetData, ThrowOnError>): RequestResult<AutomaticApprovalsStatusApiV1AutomaticApprovalsGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<AutomaticApprovalsStatusApiV1AutomaticApprovalsGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/automatic-approvals',
    ...options
});

/**
 * Set Automatic Approvals
 *
 * Turn automatic approvals on or off for the caller.
 *
 * The two-rung view of the level, kept for clients that predate the level
 * endpoint: on is ``balanced``, off is ``confirm``. Unlike the agent tool,
 * enabling here needs no approval card — the click is the consent, and it
 * happened on a page the user opened themselves.
 */
export const setAutomaticApprovalsApiV1AutomaticApprovalsPut = <ThrowOnError extends boolean = true>(options: Options<SetAutomaticApprovalsApiV1AutomaticApprovalsPutData, ThrowOnError>): RequestResult<SetAutomaticApprovalsApiV1AutomaticApprovalsPutResponses, SetAutomaticApprovalsApiV1AutomaticApprovalsPutErrors, ThrowOnError> => (options.client ?? client).put<SetAutomaticApprovalsApiV1AutomaticApprovalsPutResponses, SetAutomaticApprovalsApiV1AutomaticApprovalsPutErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/automatic-approvals',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set Autonomy Level
 *
 * Choose the autonomy level (`models/autonomy.py`) for the caller.
 *
 * The hands-off rung is refused, not silently downgraded, when the user's
 * `hands-off-autonomy` flag is off — the card never offers it then, so a
 * request for it is a stale client or a hand-written call.
 */
export const setAutonomyLevelApiV1AutomaticApprovalsLevelPut = <ThrowOnError extends boolean = true>(options: Options<SetAutonomyLevelApiV1AutomaticApprovalsLevelPutData, ThrowOnError>): RequestResult<SetAutonomyLevelApiV1AutomaticApprovalsLevelPutResponses, SetAutonomyLevelApiV1AutomaticApprovalsLevelPutErrors, ThrowOnError> => (options.client ?? client).put<SetAutonomyLevelApiV1AutomaticApprovalsLevelPutResponses, SetAutonomyLevelApiV1AutomaticApprovalsLevelPutErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/automatic-approvals/level',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Public Assistant Profile
 *
 * Return the public persona (name, bio, avatar URL) for a profile token.
 *
 * ``name`` and ``sig`` come from a renamed assistant's signature link; an
 * unsigned or tampered name is ignored and the character's own name shown.
 */
export const getPublicAssistantProfileApiV1PublicAssistantsPublicTokenGet = <ThrowOnError extends boolean = true>(options: Options<GetPublicAssistantProfileApiV1PublicAssistantsPublicTokenGetData, ThrowOnError>): RequestResult<GetPublicAssistantProfileApiV1PublicAssistantsPublicTokenGetResponses, GetPublicAssistantProfileApiV1PublicAssistantsPublicTokenGetErrors, ThrowOnError> => (options.client ?? client).get<GetPublicAssistantProfileApiV1PublicAssistantsPublicTokenGetResponses, GetPublicAssistantProfileApiV1PublicAssistantsPublicTokenGetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/public/assistants/{public_token}',
    ...options
});

/**
 * Get Public Assistant Avatar
 *
 * Stream a character's avatar image from S3 by public token.
 *
 * Proxies the private S3 object so the raw key is never exposed and the
 * profile page can render the photo without auth or a remote-CORS dance.
 */
export const getPublicAssistantAvatarApiV1PublicAssistantsPublicTokenAvatarGet = <ThrowOnError extends boolean = true>(options: Options<GetPublicAssistantAvatarApiV1PublicAssistantsPublicTokenAvatarGetData, ThrowOnError>): RequestResult<GetPublicAssistantAvatarApiV1PublicAssistantsPublicTokenAvatarGetResponses, GetPublicAssistantAvatarApiV1PublicAssistantsPublicTokenAvatarGetErrors, ThrowOnError> => (options.client ?? client).get<GetPublicAssistantAvatarApiV1PublicAssistantsPublicTokenAvatarGetResponses, GetPublicAssistantAvatarApiV1PublicAssistantsPublicTokenAvatarGetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/public/assistants/{public_token}/avatar',
    ...options
});

/**
 * Start Blog Chat Session
 */
export const startBlogChatSessionApiV1PublicBlogChatSessionPost = <ThrowOnError extends boolean = true>(options: Options<StartBlogChatSessionApiV1PublicBlogChatSessionPostData, ThrowOnError>): RequestResult<StartBlogChatSessionApiV1PublicBlogChatSessionPostResponses, StartBlogChatSessionApiV1PublicBlogChatSessionPostErrors, ThrowOnError> => (options.client ?? client).post<StartBlogChatSessionApiV1PublicBlogChatSessionPostResponses, StartBlogChatSessionApiV1PublicBlogChatSessionPostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/public/blog-chat/session',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start Cv Chat Session
 */
export const startCvChatSessionApiV1PublicCvChatSessionPost = <ThrowOnError extends boolean = true>(options: Options<StartCvChatSessionApiV1PublicCvChatSessionPostData, ThrowOnError>): RequestResult<StartCvChatSessionApiV1PublicCvChatSessionPostResponses, StartCvChatSessionApiV1PublicCvChatSessionPostErrors, ThrowOnError> => (options.client ?? client).post<StartCvChatSessionApiV1PublicCvChatSessionPostResponses, StartCvChatSessionApiV1PublicCvChatSessionPostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/public/cv-chat/session',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Open Landing Chat Session
 *
 * Open a fresh conversation. Cheap — no model call here.
 */
export const openLandingChatSessionApiV1PublicLandingChatSessionPost = <ThrowOnError extends boolean = true>(options?: Options<OpenLandingChatSessionApiV1PublicLandingChatSessionPostData, ThrowOnError>): RequestResult<OpenLandingChatSessionApiV1PublicLandingChatSessionPostResponses, OpenLandingChatSessionApiV1PublicLandingChatSessionPostErrors, ThrowOnError> => (options?.client ?? client).post<OpenLandingChatSessionApiV1PublicLandingChatSessionPostResponses, OpenLandingChatSessionApiV1PublicLandingChatSessionPostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/public/landing-chat/session',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Post Landing Chat Message
 *
 * Stream Marcus's next reply as Server-Sent Events.
 *
 * Frame schema (one ``event:`` + one ``data:`` per frame):
 *
 * * ``chunk`` ``{"text": "..."}`` — raw text token (markers stripped
 * before send so the client only ever sees user-visible text).
 * * ``reply`` ``{"messages": [...], "chips": [...], "cta": "..."}``
 * — final structured reply once parsing completes.
 * * ``error`` ``{"reason": "..."}`` — non-fatal: a fallback ``reply``
 * frame follows.
 * * ``done`` ``{}`` — terminator.
 */
export const postLandingChatMessageApiV1PublicLandingChatMessagePost = <ThrowOnError extends boolean = true>(options: Options<PostLandingChatMessageApiV1PublicLandingChatMessagePostData, ThrowOnError>): RequestResult<PostLandingChatMessageApiV1PublicLandingChatMessagePostResponses, PostLandingChatMessageApiV1PublicLandingChatMessagePostErrors, ThrowOnError> => (options.client ?? client).post<PostLandingChatMessageApiV1PublicLandingChatMessagePostResponses, PostLandingChatMessageApiV1PublicLandingChatMessagePostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/public/landing-chat/message',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Upgrade Via Magic Link
 *
 * Click target for Marcus's magic OAuth link.
 *
 * Resolves the token to its pre-auth session, writes a httponly cookie
 * so the OAuth callback can find it, and 302s into the appropriate
 * provider's OAuth start route. The cookie's max-age is 10 minutes —
 * enough to absorb a slow OAuth handoff but short enough that an
 * abandoned tap doesn't sit around forever.
 *
 * A missing / expired token redirects to the login page with an error,
 * rather than 4xx-ing — the user got here from an SMS, not a JS app,
 * so a hard error page is hostile.
 */
export const upgradeViaMagicLinkApiV1PublicOnboardingUpgradeGet = <ThrowOnError extends boolean = true>(options?: Options<UpgradeViaMagicLinkApiV1PublicOnboardingUpgradeGetData, ThrowOnError>): RequestResult<UpgradeViaMagicLinkApiV1PublicOnboardingUpgradeGetResponses, UpgradeViaMagicLinkApiV1PublicOnboardingUpgradeGetErrors, ThrowOnError> => (options?.client ?? client).get<UpgradeViaMagicLinkApiV1PublicOnboardingUpgradeGetResponses, UpgradeViaMagicLinkApiV1PublicOnboardingUpgradeGetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/public/onboarding/upgrade',
    ...options
});

/**
 * Request Security Docs
 *
 * Forward a security-documentation request to the security inbox.
 *
 * Returns ``ok: true`` once the notification is sent. On SES failure we
 * surface a 502 so the form can show its "email us directly" fallback —
 * the recipient is our own fixed inbox, so reporting failure leaks nothing.
 *
 * A populated honeypot field short-circuits to a silent ``ok: true``: we
 * send nothing but don't signal the trap, so the bot can't learn to evade it.
 */
export const requestSecurityDocsApiV1PublicSecurityDocRequestPost = <ThrowOnError extends boolean = true>(options: Options<RequestSecurityDocsApiV1PublicSecurityDocRequestPostData, ThrowOnError>): RequestResult<RequestSecurityDocsApiV1PublicSecurityDocRequestPostResponses, RequestSecurityDocsApiV1PublicSecurityDocRequestPostErrors, ThrowOnError> => (options.client ?? client).post<RequestSecurityDocsApiV1PublicSecurityDocRequestPostResponses, RequestSecurityDocsApiV1PublicSecurityDocRequestPostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/public/security/doc-request',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Request Sign In Help
 *
 * Forward a sign-in help request to the support inbox.
 *
 * A 502 on SES failure lets the form fall back to "email support directly";
 * the recipient is our own fixed inbox, so reporting the failure leaks
 * nothing. A populated honeypot returns a silent ``ok`` and sends nothing.
 */
export const requestSignInHelpApiV1PublicSignInHelpPost = <ThrowOnError extends boolean = true>(options: Options<RequestSignInHelpApiV1PublicSignInHelpPostData, ThrowOnError>): RequestResult<RequestSignInHelpApiV1PublicSignInHelpPostResponses, RequestSignInHelpApiV1PublicSignInHelpPostErrors, ThrowOnError> => (options.client ?? client).post<RequestSignInHelpApiV1PublicSignInHelpPostResponses, RequestSignInHelpApiV1PublicSignInHelpPostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/public/sign-in-help',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Concierge Thread Context
 */
export const getConciergeThreadContextApiV1PublicConciergeTokenGet = <ThrowOnError extends boolean = true>(options: Options<GetConciergeThreadContextApiV1PublicConciergeTokenGetData, ThrowOnError>): RequestResult<GetConciergeThreadContextApiV1PublicConciergeTokenGetResponses, GetConciergeThreadContextApiV1PublicConciergeTokenGetErrors, ThrowOnError> => (options.client ?? client).get<GetConciergeThreadContextApiV1PublicConciergeTokenGetResponses, GetConciergeThreadContextApiV1PublicConciergeTokenGetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/public/concierge/{token}',
    ...options
});

/**
 * Submit Concierge Availability
 */
export const submitConciergeAvailabilityApiV1PublicConciergeTokenAvailabilityPost = <ThrowOnError extends boolean = true>(options: Options<SubmitConciergeAvailabilityApiV1PublicConciergeTokenAvailabilityPostData, ThrowOnError>): RequestResult<SubmitConciergeAvailabilityApiV1PublicConciergeTokenAvailabilityPostResponses, SubmitConciergeAvailabilityApiV1PublicConciergeTokenAvailabilityPostErrors, ThrowOnError> => (options.client ?? client).post<SubmitConciergeAvailabilityApiV1PublicConciergeTokenAvailabilityPostResponses, SubmitConciergeAvailabilityApiV1PublicConciergeTokenAvailabilityPostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/public/concierge/{token}/availability',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Webhook Health Check
 */
export const webhookHealthCheckApiV1WebhooksIncomingIntegrationIdGet = <ThrowOnError extends boolean = true>(options: Options<WebhookHealthCheckApiV1WebhooksIncomingIntegrationIdGetData, ThrowOnError>): RequestResult<WebhookHealthCheckApiV1WebhooksIncomingIntegrationIdGetResponses, WebhookHealthCheckApiV1WebhooksIncomingIntegrationIdGetErrors, ThrowOnError> => (options.client ?? client).get<WebhookHealthCheckApiV1WebhooksIncomingIntegrationIdGetResponses, WebhookHealthCheckApiV1WebhooksIncomingIntegrationIdGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/webhooks/incoming/{integration_id}',
    ...options
});

/**
 * Incoming Webhook
 */
export const incomingWebhookApiV1WebhooksIncomingIntegrationIdPost = <ThrowOnError extends boolean = true>(options: Options<IncomingWebhookApiV1WebhooksIncomingIntegrationIdPostData, ThrowOnError>): RequestResult<IncomingWebhookApiV1WebhooksIncomingIntegrationIdPostResponses, IncomingWebhookApiV1WebhooksIncomingIntegrationIdPostErrors, ThrowOnError> => (options.client ?? client).post<IncomingWebhookApiV1WebhooksIncomingIntegrationIdPostResponses, IncomingWebhookApiV1WebhooksIncomingIntegrationIdPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/webhooks/incoming/{integration_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Integrations
 */
export const listIntegrationsApiV1WebhooksIntegrationsGet = <ThrowOnError extends boolean = true>(options?: Options<ListIntegrationsApiV1WebhooksIntegrationsGetData, ThrowOnError>): RequestResult<ListIntegrationsApiV1WebhooksIntegrationsGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListIntegrationsApiV1WebhooksIntegrationsGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/webhooks/integrations',
    ...options
});

/**
 * Create Integration
 */
export const createIntegrationApiV1WebhooksIntegrationsPost = <ThrowOnError extends boolean = true>(options: Options<CreateIntegrationApiV1WebhooksIntegrationsPostData, ThrowOnError>): RequestResult<CreateIntegrationApiV1WebhooksIntegrationsPostResponses, CreateIntegrationApiV1WebhooksIntegrationsPostErrors, ThrowOnError> => (options.client ?? client).post<CreateIntegrationApiV1WebhooksIntegrationsPostResponses, CreateIntegrationApiV1WebhooksIntegrationsPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/webhooks/integrations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Integration
 */
export const deleteIntegrationApiV1WebhooksIntegrationsIntegrationIdDelete = <ThrowOnError extends boolean = true>(options: Options<DeleteIntegrationApiV1WebhooksIntegrationsIntegrationIdDeleteData, ThrowOnError>): RequestResult<DeleteIntegrationApiV1WebhooksIntegrationsIntegrationIdDeleteResponses, DeleteIntegrationApiV1WebhooksIntegrationsIntegrationIdDeleteErrors, ThrowOnError> => (options.client ?? client).delete<DeleteIntegrationApiV1WebhooksIntegrationsIntegrationIdDeleteResponses, DeleteIntegrationApiV1WebhooksIntegrationsIntegrationIdDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/webhooks/integrations/{integration_id}',
    ...options
});

/**
 * Update Integration
 */
export const updateIntegrationApiV1WebhooksIntegrationsIntegrationIdPatch = <ThrowOnError extends boolean = true>(options: Options<UpdateIntegrationApiV1WebhooksIntegrationsIntegrationIdPatchData, ThrowOnError>): RequestResult<UpdateIntegrationApiV1WebhooksIntegrationsIntegrationIdPatchResponses, UpdateIntegrationApiV1WebhooksIntegrationsIntegrationIdPatchErrors, ThrowOnError> => (options.client ?? client).patch<UpdateIntegrationApiV1WebhooksIntegrationsIntegrationIdPatchResponses, UpdateIntegrationApiV1WebhooksIntegrationsIntegrationIdPatchErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/webhooks/integrations/{integration_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Regenerate Token
 */
export const regenerateTokenApiV1WebhooksIntegrationsIntegrationIdRegenerateTokenPost = <ThrowOnError extends boolean = true>(options: Options<RegenerateTokenApiV1WebhooksIntegrationsIntegrationIdRegenerateTokenPostData, ThrowOnError>): RequestResult<RegenerateTokenApiV1WebhooksIntegrationsIntegrationIdRegenerateTokenPostResponses, RegenerateTokenApiV1WebhooksIntegrationsIntegrationIdRegenerateTokenPostErrors, ThrowOnError> => (options.client ?? client).post<RegenerateTokenApiV1WebhooksIntegrationsIntegrationIdRegenerateTokenPostResponses, RegenerateTokenApiV1WebhooksIntegrationsIntegrationIdRegenerateTokenPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/webhooks/integrations/{integration_id}/regenerate-token',
    ...options
});

/**
 * Serve File
 *
 * Serve a user file via proxy.
 *
 * This endpoint serves user files to external services (like Twilio/WhatsApp)
 * that cannot access S3 presigned URLs directly. The URL must be signed with
 * a valid HMAC signature.
 *
 * Args:
 * file_id: The file UUID
 * user_id: The user ID who owns the file
 * expires: Unix timestamp when the URL expires
 * sig: HMAC signature for URL validation
 * filename: Optional filename from URL path (for Twilio compatibility)
 *
 * Returns:
 * File content as a response with appropriate content type
 *
 * Raises:
 * HTTPException: If signature is invalid, URL is expired, or file not found
 */
export const serveFileApiV1FilesFileIdFilenameGet = <ThrowOnError extends boolean = true>(options: Options<ServeFileApiV1FilesFileIdFilenameGetData, ThrowOnError>): RequestResult<ServeFileApiV1FilesFileIdFilenameGetResponses, ServeFileApiV1FilesFileIdFilenameGetErrors, ThrowOnError> => (options.client ?? client).get<ServeFileApiV1FilesFileIdFilenameGetResponses, ServeFileApiV1FilesFileIdFilenameGetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/files/{file_id}/{filename}',
    ...options
});

/**
 * Serve File Head
 *
 * Return file headers without body (for Twilio/WhatsApp media URL validation).
 *
 * Twilio sends HEAD requests to validate Content-Type before fetching files.
 * This endpoint returns the same headers as GET but without the file content.
 *
 * Args:
 * file_id: The file UUID
 * user_id: The user ID who owns the file
 * expires: Unix timestamp when the URL expires
 * sig: HMAC signature for URL validation
 * filename: Optional filename from URL path
 *
 * Returns:
 * Empty response with appropriate headers (Content-Type, Content-Length)
 *
 * Raises:
 * HTTPException: If signature is invalid, URL is expired, or file not found
 */
export const serveFileHeadApiV1FilesFileIdFilenameHead = <ThrowOnError extends boolean = true>(options: Options<ServeFileHeadApiV1FilesFileIdFilenameHeadData, ThrowOnError>): RequestResult<ServeFileHeadApiV1FilesFileIdFilenameHeadResponses, ServeFileHeadApiV1FilesFileIdFilenameHeadErrors, ThrowOnError> => (options.client ?? client).head<ServeFileHeadApiV1FilesFileIdFilenameHeadResponses, ServeFileHeadApiV1FilesFileIdFilenameHeadErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/files/{file_id}/{filename}',
    ...options
});

/**
 * Serve File
 *
 * Serve a user file via proxy.
 *
 * This endpoint serves user files to external services (like Twilio/WhatsApp)
 * that cannot access S3 presigned URLs directly. The URL must be signed with
 * a valid HMAC signature.
 *
 * Args:
 * file_id: The file UUID
 * user_id: The user ID who owns the file
 * expires: Unix timestamp when the URL expires
 * sig: HMAC signature for URL validation
 * filename: Optional filename from URL path (for Twilio compatibility)
 *
 * Returns:
 * File content as a response with appropriate content type
 *
 * Raises:
 * HTTPException: If signature is invalid, URL is expired, or file not found
 */
export const serveFileApiV1FilesFileIdGet = <ThrowOnError extends boolean = true>(options: Options<ServeFileApiV1FilesFileIdGetData, ThrowOnError>): RequestResult<ServeFileApiV1FilesFileIdGetResponses, ServeFileApiV1FilesFileIdGetErrors, ThrowOnError> => (options.client ?? client).get<ServeFileApiV1FilesFileIdGetResponses, ServeFileApiV1FilesFileIdGetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/files/{file_id}',
    ...options
});

/**
 * Serve File Head
 *
 * Return file headers without body (for Twilio/WhatsApp media URL validation).
 *
 * Twilio sends HEAD requests to validate Content-Type before fetching files.
 * This endpoint returns the same headers as GET but without the file content.
 *
 * Args:
 * file_id: The file UUID
 * user_id: The user ID who owns the file
 * expires: Unix timestamp when the URL expires
 * sig: HMAC signature for URL validation
 * filename: Optional filename from URL path
 *
 * Returns:
 * Empty response with appropriate headers (Content-Type, Content-Length)
 *
 * Raises:
 * HTTPException: If signature is invalid, URL is expired, or file not found
 */
export const serveFileHeadApiV1FilesFileIdHead = <ThrowOnError extends boolean = true>(options: Options<ServeFileHeadApiV1FilesFileIdHeadData, ThrowOnError>): RequestResult<ServeFileHeadApiV1FilesFileIdHeadResponses, ServeFileHeadApiV1FilesFileIdHeadErrors, ThrowOnError> => (options.client ?? client).head<ServeFileHeadApiV1FilesFileIdHeadResponses, ServeFileHeadApiV1FilesFileIdHeadErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/files/{file_id}',
    ...options
});

/**
 * List Pipedream Apps
 *
 * Browse every Pipedream app that exposes actions Catch can execute.
 */
export const listPipedreamAppsApiV1IntegrationsPipedreamAppsGet = <ThrowOnError extends boolean = true>(options?: Options<ListPipedreamAppsApiV1IntegrationsPipedreamAppsGetData, ThrowOnError>): RequestResult<ListPipedreamAppsApiV1IntegrationsPipedreamAppsGetResponses, ListPipedreamAppsApiV1IntegrationsPipedreamAppsGetErrors, ThrowOnError> => (options?.client ?? client).get<ListPipedreamAppsApiV1IntegrationsPipedreamAppsGetResponses, ListPipedreamAppsApiV1IntegrationsPipedreamAppsGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/integrations/pipedream/apps',
    ...options
});

/**
 * List Pipedream Connections
 *
 * List the current user's generic Pipedream app connections.
 */
export const listPipedreamConnectionsApiV1IntegrationsPipedreamConnectionsGet = <ThrowOnError extends boolean = true>(options?: Options<ListPipedreamConnectionsApiV1IntegrationsPipedreamConnectionsGetData, ThrowOnError>): RequestResult<ListPipedreamConnectionsApiV1IntegrationsPipedreamConnectionsGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListPipedreamConnectionsApiV1IntegrationsPipedreamConnectionsGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/integrations/pipedream/connections',
    ...options
});

/**
 * Create Generic Pipedream Connect Url
 *
 * Start managed auth for any action-backed Pipedream catalog app.
 */
export const createGenericPipedreamConnectUrlApiV1IntegrationsPipedreamAppsAppSlugConnectTokenPost = <ThrowOnError extends boolean = true>(options: Options<CreateGenericPipedreamConnectUrlApiV1IntegrationsPipedreamAppsAppSlugConnectTokenPostData, ThrowOnError>): RequestResult<CreateGenericPipedreamConnectUrlApiV1IntegrationsPipedreamAppsAppSlugConnectTokenPostResponses, CreateGenericPipedreamConnectUrlApiV1IntegrationsPipedreamAppsAppSlugConnectTokenPostErrors, ThrowOnError> => (options.client ?? client).post<CreateGenericPipedreamConnectUrlApiV1IntegrationsPipedreamAppsAppSlugConnectTokenPostResponses, CreateGenericPipedreamConnectUrlApiV1IntegrationsPipedreamAppsAppSlugConnectTokenPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/integrations/pipedream/apps/{app_slug}/connect-token',
    ...options
});

/**
 * Generic Pipedream Connect Callback
 *
 * Finalize generic managed auth and return control to the integrations UI.
 */
export const genericPipedreamConnectCallbackApiV1IntegrationsPipedreamAppsCallbackGet = <ThrowOnError extends boolean = true>(options?: Options<GenericPipedreamConnectCallbackApiV1IntegrationsPipedreamAppsCallbackGetData, ThrowOnError>): RequestResult<GenericPipedreamConnectCallbackApiV1IntegrationsPipedreamAppsCallbackGetResponses, GenericPipedreamConnectCallbackApiV1IntegrationsPipedreamAppsCallbackGetErrors, ThrowOnError> => (options?.client ?? client).get<GenericPipedreamConnectCallbackApiV1IntegrationsPipedreamAppsCallbackGetResponses, GenericPipedreamConnectCallbackApiV1IntegrationsPipedreamAppsCallbackGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/integrations/pipedream/apps/callback',
    ...options
});

/**
 * Disconnect Pipedream App
 *
 * Disconnect one generic Pipedream app account.
 */
export const disconnectPipedreamAppApiV1IntegrationsPipedreamConnectionsConnectionIdDelete = <ThrowOnError extends boolean = true>(options: Options<DisconnectPipedreamAppApiV1IntegrationsPipedreamConnectionsConnectionIdDeleteData, ThrowOnError>): RequestResult<DisconnectPipedreamAppApiV1IntegrationsPipedreamConnectionsConnectionIdDeleteResponses, DisconnectPipedreamAppApiV1IntegrationsPipedreamConnectionsConnectionIdDeleteErrors, ThrowOnError> => (options.client ?? client).delete<DisconnectPipedreamAppApiV1IntegrationsPipedreamConnectionsConnectionIdDeleteResponses, DisconnectPipedreamAppApiV1IntegrationsPipedreamConnectionsConnectionIdDeleteErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/integrations/pipedream/connections/{connection_id}',
    ...options
});

/**
 * Get Integration Status
 *
 * Get the current connection status for an integration.
 */
export const getIntegrationStatusApiV1IntegrationsIntegrationTypeStatusGet = <ThrowOnError extends boolean = true>(options: Options<GetIntegrationStatusApiV1IntegrationsIntegrationTypeStatusGetData, ThrowOnError>): RequestResult<GetIntegrationStatusApiV1IntegrationsIntegrationTypeStatusGetResponses, GetIntegrationStatusApiV1IntegrationsIntegrationTypeStatusGetErrors, ThrowOnError> => (options.client ?? client).get<GetIntegrationStatusApiV1IntegrationsIntegrationTypeStatusGetResponses, GetIntegrationStatusApiV1IntegrationsIntegrationTypeStatusGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/integrations/{integration_type}/status',
    ...options
});

/**
 * List Integration Instances
 *
 * List every connected instance of an integration for the current user.
 *
 * Unlike ``/status`` (which reports an aggregate connected flag), this returns
 * one entry per connection so the UI can render multiple accounts of the same
 * type, each with its own label and disconnect control.
 */
export const listIntegrationInstancesApiV1IntegrationsIntegrationTypeInstancesGet = <ThrowOnError extends boolean = true>(options: Options<ListIntegrationInstancesApiV1IntegrationsIntegrationTypeInstancesGetData, ThrowOnError>): RequestResult<ListIntegrationInstancesApiV1IntegrationsIntegrationTypeInstancesGetResponses, ListIntegrationInstancesApiV1IntegrationsIntegrationTypeInstancesGetErrors, ThrowOnError> => (options.client ?? client).get<ListIntegrationInstancesApiV1IntegrationsIntegrationTypeInstancesGetResponses, ListIntegrationInstancesApiV1IntegrationsIntegrationTypeInstancesGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/integrations/{integration_type}/instances',
    ...options
});

/**
 * Get Integration Auth Url
 *
 * Get the OAuth authorization URL to connect an integration.
 *
 * Returns a URL the frontend opens in a popup (desktop) or navigates the
 * top-level tab to (mobile, ``return_mode=redirect``).
 */
export const getIntegrationAuthUrlApiV1IntegrationsIntegrationTypeAuthGet = <ThrowOnError extends boolean = true>(options: Options<GetIntegrationAuthUrlApiV1IntegrationsIntegrationTypeAuthGetData, ThrowOnError>): RequestResult<GetIntegrationAuthUrlApiV1IntegrationsIntegrationTypeAuthGetResponses, GetIntegrationAuthUrlApiV1IntegrationsIntegrationTypeAuthGetErrors, ThrowOnError> => (options.client ?? client).get<GetIntegrationAuthUrlApiV1IntegrationsIntegrationTypeAuthGetResponses, GetIntegrationAuthUrlApiV1IntegrationsIntegrationTypeAuthGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/integrations/{integration_type}/auth',
    ...options
});

/**
 * Connect Discovered Integration
 *
 * Start a discovered-mode connect from a user-provided resource URL.
 *
 * Unlike ``GET /{type}/auth`` (static integrations, no user input), discovered
 * integrations have the user paste their own resource URL; the backend
 * discovers the OAuth server from it, runs Dynamic Client Registration, and
 * returns an authorization URL for the frontend popup.
 */
export const connectDiscoveredIntegrationApiV1IntegrationsIntegrationTypeConnectPost = <ThrowOnError extends boolean = true>(options: Options<ConnectDiscoveredIntegrationApiV1IntegrationsIntegrationTypeConnectPostData, ThrowOnError>): RequestResult<ConnectDiscoveredIntegrationApiV1IntegrationsIntegrationTypeConnectPostResponses, ConnectDiscoveredIntegrationApiV1IntegrationsIntegrationTypeConnectPostErrors, ThrowOnError> => (options.client ?? client).post<ConnectDiscoveredIntegrationApiV1IntegrationsIntegrationTypeConnectPostResponses, ConnectDiscoveredIntegrationApiV1IntegrationsIntegrationTypeConnectPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/integrations/{integration_type}/connect',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Pipedream Connect Url
 *
 * Start a Pipedream-brokered connect; return the hosted Connect Link URL.
 *
 * Mirrors ``GET /{type}/auth`` for self-hosted OAuth: returns a URL the
 * frontend opens in a popup. Pipedream then redirects the popup to our
 * ``/pipedream/callback``, which finalizes the connection and closes the popup.
 */
export const createPipedreamConnectUrlApiV1IntegrationsIntegrationTypePipedreamConnectTokenPost = <ThrowOnError extends boolean = true>(options: Options<CreatePipedreamConnectUrlApiV1IntegrationsIntegrationTypePipedreamConnectTokenPostData, ThrowOnError>): RequestResult<CreatePipedreamConnectUrlApiV1IntegrationsIntegrationTypePipedreamConnectTokenPostResponses, CreatePipedreamConnectUrlApiV1IntegrationsIntegrationTypePipedreamConnectTokenPostErrors, ThrowOnError> => (options.client ?? client).post<CreatePipedreamConnectUrlApiV1IntegrationsIntegrationTypePipedreamConnectTokenPostResponses, CreatePipedreamConnectUrlApiV1IntegrationsIntegrationTypePipedreamConnectTokenPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/integrations/{integration_type}/pipedream/connect-token',
    ...options
});

/**
 * Integration Oauth Callback
 *
 * Handle OAuth callback from an integration provider.
 *
 * This endpoint is called by the provider after user authentication. It
 * exchanges the authorization code for tokens, then hands control back to the
 * client either by closing the popup (desktop) or 302-redirecting the
 * top-level tab into the app (mobile) — see ``return_mode`` on the auth URL.
 *
 * Two checks bind the flow to the person who started it (security audit
 * finding 9). The ``state`` cookie proves the callback landed in the *same
 * browser* that requested the authorization URL, and the session assertion
 * proves that browser is still signed in as the user the stored state names.
 * Without them the provider's tokens are filed against whichever ``user_id``
 * the state carries — so an attacker could start a connect on their own
 * account, send the URL to a victim, and harvest the victim's tokens.
 */
export const integrationOauthCallbackApiV1IntegrationsIntegrationTypeCallbackGet = <ThrowOnError extends boolean = true>(options: Options<IntegrationOauthCallbackApiV1IntegrationsIntegrationTypeCallbackGetData, ThrowOnError>): RequestResult<IntegrationOauthCallbackApiV1IntegrationsIntegrationTypeCallbackGetResponses, IntegrationOauthCallbackApiV1IntegrationsIntegrationTypeCallbackGetErrors, ThrowOnError> => (options.client ?? client).get<IntegrationOauthCallbackApiV1IntegrationsIntegrationTypeCallbackGetResponses, IntegrationOauthCallbackApiV1IntegrationsIntegrationTypeCallbackGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/integrations/{integration_type}/callback',
    ...options
});

/**
 * Pipedream Connect Callback
 *
 * Handle the redirect back from Pipedream's hosted Connect Link.
 *
 * Pipedream redirects the popup here after the user authorizes
 * (``outcome=success``) or cancels/fails (``outcome=error``). On success we
 * finalize (resolve + persist the connected account), then hand control back
 * to the client the same way the OAuth callback does — popup ``postMessage`` +
 * ``window.close`` (desktop) or a full-page redirect into the app (mobile).
 */
export const pipedreamConnectCallbackApiV1IntegrationsIntegrationTypePipedreamCallbackGet = <ThrowOnError extends boolean = true>(options: Options<PipedreamConnectCallbackApiV1IntegrationsIntegrationTypePipedreamCallbackGetData, ThrowOnError>): RequestResult<PipedreamConnectCallbackApiV1IntegrationsIntegrationTypePipedreamCallbackGetResponses, PipedreamConnectCallbackApiV1IntegrationsIntegrationTypePipedreamCallbackGetErrors, ThrowOnError> => (options.client ?? client).get<PipedreamConnectCallbackApiV1IntegrationsIntegrationTypePipedreamCallbackGetResponses, PipedreamConnectCallbackApiV1IntegrationsIntegrationTypePipedreamCallbackGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/integrations/{integration_type}/pipedream/callback',
    ...options
});

/**
 * Disconnect Integration
 *
 * Disconnect an integration instance for the user.
 */
export const disconnectIntegrationApiV1IntegrationsIntegrationTypeDisconnectDelete = <ThrowOnError extends boolean = true>(options: Options<DisconnectIntegrationApiV1IntegrationsIntegrationTypeDisconnectDeleteData, ThrowOnError>): RequestResult<DisconnectIntegrationApiV1IntegrationsIntegrationTypeDisconnectDeleteResponses, DisconnectIntegrationApiV1IntegrationsIntegrationTypeDisconnectDeleteErrors, ThrowOnError> => (options.client ?? client).delete<DisconnectIntegrationApiV1IntegrationsIntegrationTypeDisconnectDeleteResponses, DisconnectIntegrationApiV1IntegrationsIntegrationTypeDisconnectDeleteErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/integrations/{integration_type}/disconnect',
    ...options
});

/**
 * Request Integration
 *
 * Submit a request for a new integration, creating a Linear feature ticket.
 */
export const requestIntegrationApiV1IntegrationsRequestPost = <ThrowOnError extends boolean = true>(options: Options<RequestIntegrationApiV1IntegrationsRequestPostData, ThrowOnError>): RequestResult<RequestIntegrationApiV1IntegrationsRequestPostResponses, RequestIntegrationApiV1IntegrationsRequestPostErrors, ThrowOnError> => (options.client ?? client).post<RequestIntegrationApiV1IntegrationsRequestPostResponses, RequestIntegrationApiV1IntegrationsRequestPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/integrations/request',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Custom Secret Request
 *
 * Return metadata for a secret-entry form. Auth is via the signed token.
 */
export const getCustomSecretRequestApiV1IntegrationsCustomSecretRequestTokenGet = <ThrowOnError extends boolean = true>(options: Options<GetCustomSecretRequestApiV1IntegrationsCustomSecretRequestTokenGetData, ThrowOnError>): RequestResult<GetCustomSecretRequestApiV1IntegrationsCustomSecretRequestTokenGetResponses, GetCustomSecretRequestApiV1IntegrationsCustomSecretRequestTokenGetErrors, ThrowOnError> => (options.client ?? client).get<GetCustomSecretRequestApiV1IntegrationsCustomSecretRequestTokenGetResponses, GetCustomSecretRequestApiV1IntegrationsCustomSecretRequestTokenGetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/integrations/custom/secret-request/{token}',
    ...options
});

/**
 * Submit Custom Secrets
 *
 * Consume a magic-link token and persist the user-entered secret values.
 */
export const submitCustomSecretsApiV1IntegrationsCustomSecretsPost = <ThrowOnError extends boolean = true>(options: Options<SubmitCustomSecretsApiV1IntegrationsCustomSecretsPostData, ThrowOnError>): RequestResult<SubmitCustomSecretsApiV1IntegrationsCustomSecretsPostResponses, SubmitCustomSecretsApiV1IntegrationsCustomSecretsPostErrors, ThrowOnError> => (options.client ?? client).post<SubmitCustomSecretsApiV1IntegrationsCustomSecretsPostResponses, SubmitCustomSecretsApiV1IntegrationsCustomSecretsPostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/integrations/custom/secrets',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Custom Oauth Auth Url
 *
 * Redirect the user to the OAuth authorization URL for a custom integration.
 *
 * The integration builder agent shares the link to this endpoint with the user
 * in chat. Clicking it from a browser must send them straight into the OAuth
 * flow — returning JSON would just render as raw text in the address bar.
 *
 * The chat link is opened in whatever browser the messaging app hands it to,
 * where there is no Catch session cookie, so it carries a signed ``token``
 * query param that authenticates the request. The authenticated frontend
 * instead relies on its session cookie/bearer and hits the bare URL.
 */
export const getCustomOauthAuthUrlApiV1IntegrationsCustomSpecIdAuthGet = <ThrowOnError extends boolean = true>(options: Options<GetCustomOauthAuthUrlApiV1IntegrationsCustomSpecIdAuthGetData, ThrowOnError>): RequestResult<GetCustomOauthAuthUrlApiV1IntegrationsCustomSpecIdAuthGetResponses, GetCustomOauthAuthUrlApiV1IntegrationsCustomSpecIdAuthGetErrors, ThrowOnError> => (options.client ?? client).get<GetCustomOauthAuthUrlApiV1IntegrationsCustomSpecIdAuthGetResponses, GetCustomOauthAuthUrlApiV1IntegrationsCustomSpecIdAuthGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/integrations/custom/{spec_id}/auth',
    ...options
});

/**
 * Custom Oauth Callback
 *
 * Handle OAuth callback for a user-authored custom integration.
 */
export const customOauthCallbackApiV1IntegrationsCustomOauthCallbackGet = <ThrowOnError extends boolean = true>(options?: Options<CustomOauthCallbackApiV1IntegrationsCustomOauthCallbackGetData, ThrowOnError>): RequestResult<CustomOauthCallbackApiV1IntegrationsCustomOauthCallbackGetResponses, CustomOauthCallbackApiV1IntegrationsCustomOauthCallbackGetErrors, ThrowOnError> => (options?.client ?? client).get<CustomOauthCallbackApiV1IntegrationsCustomOauthCallbackGetResponses, CustomOauthCallbackApiV1IntegrationsCustomOauthCallbackGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/integrations/custom/oauth/callback',
    ...options
});

/**
 * List Custom Integrations Endpoint
 *
 * List the authenticated user's user-authored integrations.
 *
 * Gated behind the ``custom-integration-builder`` or ``custom-api-connections``
 * PostHog flag so the UI only surfaces this list for users who can create
 * these specs in the first place.
 */
export const listCustomIntegrationsEndpointApiV1IntegrationsCustomGet = <ThrowOnError extends boolean = true>(options?: Options<ListCustomIntegrationsEndpointApiV1IntegrationsCustomGetData, ThrowOnError>): RequestResult<ListCustomIntegrationsEndpointApiV1IntegrationsCustomGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListCustomIntegrationsEndpointApiV1IntegrationsCustomGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/integrations/custom',
    ...options
});

/**
 * Delete Custom Integration Endpoint
 *
 * Archive a user-authored integration so it disappears from the UI/agent.
 *
 * Mirrors the ``delete_custom_integration`` agent tool. Stored credentials
 * are not erased — admins can restore the spec by flipping its status back
 * if needed.
 */
export const deleteCustomIntegrationEndpointApiV1IntegrationsCustomSpecIdDelete = <ThrowOnError extends boolean = true>(options: Options<DeleteCustomIntegrationEndpointApiV1IntegrationsCustomSpecIdDeleteData, ThrowOnError>): RequestResult<DeleteCustomIntegrationEndpointApiV1IntegrationsCustomSpecIdDeleteResponses, DeleteCustomIntegrationEndpointApiV1IntegrationsCustomSpecIdDeleteErrors, ThrowOnError> => (options.client ?? client).delete<DeleteCustomIntegrationEndpointApiV1IntegrationsCustomSpecIdDeleteResponses, DeleteCustomIntegrationEndpointApiV1IntegrationsCustomSpecIdDeleteErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/integrations/custom/{spec_id}',
    ...options
});

/**
 * Create Custom Secret Request Endpoint
 *
 * Create a one-shot magic-link for entering credential values.
 *
 * Returns a URL on the frontend (``/integrations/enter-secret?token=…``) that
 * the UI redirects to so the user can fill in their credential values.
 * Used for API key, basic-auth, and OAuth specs whose provider requires
 * user-supplied client credentials. Pure-OAuth specs (DCR or shared
 * static client) should use ``GET /custom/{spec_id}/auth`` instead.
 */
export const createCustomSecretRequestEndpointApiV1IntegrationsCustomSpecIdSecretRequestPost = <ThrowOnError extends boolean = true>(options: Options<CreateCustomSecretRequestEndpointApiV1IntegrationsCustomSpecIdSecretRequestPostData, ThrowOnError>): RequestResult<CreateCustomSecretRequestEndpointApiV1IntegrationsCustomSpecIdSecretRequestPostResponses, CreateCustomSecretRequestEndpointApiV1IntegrationsCustomSpecIdSecretRequestPostErrors, ThrowOnError> => (options.client ?? client).post<CreateCustomSecretRequestEndpointApiV1IntegrationsCustomSpecIdSecretRequestPostResponses, CreateCustomSecretRequestEndpointApiV1IntegrationsCustomSpecIdSecretRequestPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/integrations/custom/{spec_id}/secret-request',
    ...options
});

/**
 * List Featured Integrations
 *
 * Pipedream apps the integrations page renders as first-party tiles.
 *
 * Deliberately says nothing about whether the user has connected them. The
 * page already holds the live connection list (one shared read, used to
 * disconnect and to answer a settled connect), so returning ``connected``
 * here would be a second answer to the same question that goes stale the
 * moment somebody connects one — unlike ``/promoted``, whose connection state
 * has no client-side source.
 *
 * Not gated on ``generic-pipedream-integrations``: it is a static catalogue,
 * it names nothing private, and the client is what decides whether to show a
 * tile — while the connect endpoints behind those tiles enforce the flag for
 * real. Gating it would turn a flag read into a page-load dependency for a
 * list that is the same for everybody.
 */
export const listFeaturedIntegrationsApiV1IntegrationsFeaturedGet = <ThrowOnError extends boolean = true>(options?: Options<ListFeaturedIntegrationsApiV1IntegrationsFeaturedGetData, ThrowOnError>): RequestResult<ListFeaturedIntegrationsApiV1IntegrationsFeaturedGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListFeaturedIntegrationsApiV1IntegrationsFeaturedGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/integrations/featured',
    ...options
});

/**
 * List Promoted Integrations
 *
 * List promoted (monty-backed) integrations with per-user connection status.
 *
 * Drives the dynamic ``PromotedIntegrationsSection`` on the frontend.
 * Connection state is derived per user from the clone spec (if any) and the
 * presence of all required secret rows.
 */
export const listPromotedIntegrationsApiV1IntegrationsPromotedGet = <ThrowOnError extends boolean = true>(options?: Options<ListPromotedIntegrationsApiV1IntegrationsPromotedGetData, ThrowOnError>): RequestResult<ListPromotedIntegrationsApiV1IntegrationsPromotedGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListPromotedIntegrationsApiV1IntegrationsPromotedGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/integrations/promoted',
    ...options
});

/**
 * Ensure Promoted Spec Endpoint
 *
 * Materialize the user's clone of a promoted integration if absent.
 *
 * The frontend calls this once before kicking off the connect flow — the
 * returned ``spec_id`` is then passed to the existing
 * ``/integrations/custom/{spec_id}/secret-request`` or
 * ``/integrations/custom/{spec_id}/auth`` endpoints. Repeat calls are
 * idempotent (return the existing spec).
 */
export const ensurePromotedSpecEndpointApiV1IntegrationsPromotedNameEnsureSpecPost = <ThrowOnError extends boolean = true>(options: Options<EnsurePromotedSpecEndpointApiV1IntegrationsPromotedNameEnsureSpecPostData, ThrowOnError>): RequestResult<EnsurePromotedSpecEndpointApiV1IntegrationsPromotedNameEnsureSpecPostResponses, EnsurePromotedSpecEndpointApiV1IntegrationsPromotedNameEnsureSpecPostErrors, ThrowOnError> => (options.client ?? client).post<EnsurePromotedSpecEndpointApiV1IntegrationsPromotedNameEnsureSpecPostResponses, EnsurePromotedSpecEndpointApiV1IntegrationsPromotedNameEnsureSpecPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/integrations/promoted/{name}/ensure-spec',
    ...options
});

/**
 * Disconnect Promoted Integration Endpoint
 *
 * Archive the user's clone of a promoted integration so it can be reconnected.
 *
 * The connected promoted tile has no ``spec_id`` to hand to
 * ``DELETE /custom/{spec_id}`` — and that endpoint also gates on the
 * custom-integration-builder flag, which promoted integrations must bypass
 * (they're available to everyone, mirroring the connect path's
 * ``_require_custom_integration_access``). So disconnect is keyed by the
 * registry ``name`` and archives the clone directly. Stored credentials are
 * kept; reconnecting re-runs OAuth, which overwrites the (now-stale) token.
 */
export const disconnectPromotedIntegrationEndpointApiV1IntegrationsPromotedNameDisconnectDelete = <ThrowOnError extends boolean = true>(options: Options<DisconnectPromotedIntegrationEndpointApiV1IntegrationsPromotedNameDisconnectDeleteData, ThrowOnError>): RequestResult<DisconnectPromotedIntegrationEndpointApiV1IntegrationsPromotedNameDisconnectDeleteResponses, DisconnectPromotedIntegrationEndpointApiV1IntegrationsPromotedNameDisconnectDeleteErrors, ThrowOnError> => (options.client ?? client).delete<DisconnectPromotedIntegrationEndpointApiV1IntegrationsPromotedNameDisconnectDeleteResponses, DisconnectPromotedIntegrationEndpointApiV1IntegrationsPromotedNameDisconnectDeleteErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/integrations/promoted/{name}/disconnect',
    ...options
});

/**
 * List Shared Integrations
 *
 * List custom integrations an admin shared with the authenticated user.
 *
 * Ungated, mirroring ``GET /integrations/promoted``: a recipient need not have
 * the ``custom-integration-builder`` flag — they didn't author the integration,
 * they only connect their own credentials to the snapshot clone shared with
 * them. Drives the frontend's "Shared with you" section; each entry's ``id`` is
 * the clone ``spec_id`` the existing ``/custom/{spec_id}/secret-request`` and
 * ``/custom/{spec_id}/auth`` connect endpoints accept.
 */
export const listSharedIntegrationsApiV1IntegrationsSharedGet = <ThrowOnError extends boolean = true>(options?: Options<ListSharedIntegrationsApiV1IntegrationsSharedGetData, ThrowOnError>): RequestResult<ListSharedIntegrationsApiV1IntegrationsSharedGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListSharedIntegrationsApiV1IntegrationsSharedGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/integrations/shared',
    ...options
});

/**
 * Receive Pipedream Trigger Event
 *
 * Accept one signed delivery for a deployed trigger and triage it.
 */
export const receivePipedreamTriggerEventApiV1IntegrationsPipedreamTriggersTriggerIdEventsPost = <ThrowOnError extends boolean = true>(options: Options<ReceivePipedreamTriggerEventApiV1IntegrationsPipedreamTriggersTriggerIdEventsPostData, ThrowOnError>): RequestResult<ReceivePipedreamTriggerEventApiV1IntegrationsPipedreamTriggersTriggerIdEventsPostResponses, ReceivePipedreamTriggerEventApiV1IntegrationsPipedreamTriggersTriggerIdEventsPostErrors, ThrowOnError> => (options.client ?? client).post<ReceivePipedreamTriggerEventApiV1IntegrationsPipedreamTriggersTriggerIdEventsPostResponses, ReceivePipedreamTriggerEventApiV1IntegrationsPipedreamTriggersTriggerIdEventsPostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/integrations/pipedream/triggers/{trigger_id}/events',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Integration Suggestions
 *
 * Return this user's best not-connected, not-dismissed suggestions.
 */
export const getIntegrationSuggestionsApiV1IntegrationSuggestionsGet = <ThrowOnError extends boolean = true>(options?: Options<GetIntegrationSuggestionsApiV1IntegrationSuggestionsGetData, ThrowOnError>): RequestResult<GetIntegrationSuggestionsApiV1IntegrationSuggestionsGetResponses, GetIntegrationSuggestionsApiV1IntegrationSuggestionsGetErrors, ThrowOnError> => (options?.client ?? client).get<GetIntegrationSuggestionsApiV1IntegrationSuggestionsGetResponses, GetIntegrationSuggestionsApiV1IntegrationSuggestionsGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/integration-suggestions',
    ...options
});

/**
 * Dismiss Integration Suggestion
 *
 * Hide one suggestion for good.
 *
 * Survives every rescan — see the note on ``IntegrationSuggestion``. Without
 * this the same handful of suggestions come back every 30 days and the row
 * becomes furniture people stop seeing.
 */
export const dismissIntegrationSuggestionApiV1IntegrationSuggestionsCatalogKeyDismissPost = <ThrowOnError extends boolean = true>(options: Options<DismissIntegrationSuggestionApiV1IntegrationSuggestionsCatalogKeyDismissPostData, ThrowOnError>): RequestResult<DismissIntegrationSuggestionApiV1IntegrationSuggestionsCatalogKeyDismissPostResponses, DismissIntegrationSuggestionApiV1IntegrationSuggestionsCatalogKeyDismissPostErrors, ThrowOnError> => (options.client ?? client).post<DismissIntegrationSuggestionApiV1IntegrationSuggestionsCatalogKeyDismissPostResponses, DismissIntegrationSuggestionApiV1IntegrationSuggestionsCatalogKeyDismissPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/integration-suggestions/{catalog_key}/dismiss',
    ...options
});

/**
 * List Links
 */
export const listLinksApiV1SchedulingLinksGet = <ThrowOnError extends boolean = true>(options?: Options<ListLinksApiV1SchedulingLinksGetData, ThrowOnError>): RequestResult<ListLinksApiV1SchedulingLinksGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListLinksApiV1SchedulingLinksGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/scheduling/links',
    ...options
});

/**
 * Create Link
 */
export const createLinkApiV1SchedulingLinksPost = <ThrowOnError extends boolean = true>(options: Options<CreateLinkApiV1SchedulingLinksPostData, ThrowOnError>): RequestResult<CreateLinkApiV1SchedulingLinksPostResponses, CreateLinkApiV1SchedulingLinksPostErrors, ThrowOnError> => (options.client ?? client).post<CreateLinkApiV1SchedulingLinksPostResponses, CreateLinkApiV1SchedulingLinksPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/scheduling/links',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Link
 */
export const deleteLinkApiV1SchedulingLinksLinkIdDelete = <ThrowOnError extends boolean = true>(options: Options<DeleteLinkApiV1SchedulingLinksLinkIdDeleteData, ThrowOnError>): RequestResult<DeleteLinkApiV1SchedulingLinksLinkIdDeleteResponses, DeleteLinkApiV1SchedulingLinksLinkIdDeleteErrors, ThrowOnError> => (options.client ?? client).delete<DeleteLinkApiV1SchedulingLinksLinkIdDeleteResponses, DeleteLinkApiV1SchedulingLinksLinkIdDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/scheduling/links/{link_id}',
    ...options
});

/**
 * Get Link
 */
export const getLinkApiV1SchedulingLinksLinkIdGet = <ThrowOnError extends boolean = true>(options: Options<GetLinkApiV1SchedulingLinksLinkIdGetData, ThrowOnError>): RequestResult<GetLinkApiV1SchedulingLinksLinkIdGetResponses, GetLinkApiV1SchedulingLinksLinkIdGetErrors, ThrowOnError> => (options.client ?? client).get<GetLinkApiV1SchedulingLinksLinkIdGetResponses, GetLinkApiV1SchedulingLinksLinkIdGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/scheduling/links/{link_id}',
    ...options
});

/**
 * Update Link
 */
export const updateLinkApiV1SchedulingLinksLinkIdPatch = <ThrowOnError extends boolean = true>(options: Options<UpdateLinkApiV1SchedulingLinksLinkIdPatchData, ThrowOnError>): RequestResult<UpdateLinkApiV1SchedulingLinksLinkIdPatchResponses, UpdateLinkApiV1SchedulingLinksLinkIdPatchErrors, ThrowOnError> => (options.client ?? client).patch<UpdateLinkApiV1SchedulingLinksLinkIdPatchResponses, UpdateLinkApiV1SchedulingLinksLinkIdPatchErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/scheduling/links/{link_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Pending Approvals
 *
 * Links awaiting the current user's approval as a co-host.
 */
export const listPendingApprovalsApiV1SchedulingApprovalsPendingGet = <ThrowOnError extends boolean = true>(options?: Options<ListPendingApprovalsApiV1SchedulingApprovalsPendingGetData, ThrowOnError>): RequestResult<ListPendingApprovalsApiV1SchedulingApprovalsPendingGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListPendingApprovalsApiV1SchedulingApprovalsPendingGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/scheduling/approvals/pending',
    ...options
});

/**
 * Submit Approval
 *
 * Approve or decline a pending scheduling-link request as a co-host.
 */
export const submitApprovalApiV1SchedulingLinksLinkIdApprovalPost = <ThrowOnError extends boolean = true>(options: Options<SubmitApprovalApiV1SchedulingLinksLinkIdApprovalPostData, ThrowOnError>): RequestResult<SubmitApprovalApiV1SchedulingLinksLinkIdApprovalPostResponses, SubmitApprovalApiV1SchedulingLinksLinkIdApprovalPostErrors, ThrowOnError> => (options.client ?? client).post<SubmitApprovalApiV1SchedulingLinksLinkIdApprovalPostResponses, SubmitApprovalApiV1SchedulingLinksLinkIdApprovalPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/scheduling/links/{link_id}/approval',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Public Link
 */
export const getPublicLinkApiV1SchedulingPublicLinkIdGet = <ThrowOnError extends boolean = true>(options: Options<GetPublicLinkApiV1SchedulingPublicLinkIdGetData, ThrowOnError>): RequestResult<GetPublicLinkApiV1SchedulingPublicLinkIdGetResponses, GetPublicLinkApiV1SchedulingPublicLinkIdGetErrors, ThrowOnError> => (options.client ?? client).get<GetPublicLinkApiV1SchedulingPublicLinkIdGetResponses, GetPublicLinkApiV1SchedulingPublicLinkIdGetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/scheduling/public/{link_id}',
    ...options
});

/**
 * Get Public Link For Invitee
 *
 * Token-bound public read for INVITEE_BOUND links.
 *
 * Returns the same shape as the OPEN path plus the resolved invitee
 * identity, so the frontend can prefill (and lock) the booker's name/email.
 * Works on OPEN links too — the token just acts as a friendly prefill hint.
 */
export const getPublicLinkForInviteeApiV1SchedulingPublicLinkIdITokenGet = <ThrowOnError extends boolean = true>(options: Options<GetPublicLinkForInviteeApiV1SchedulingPublicLinkIdITokenGetData, ThrowOnError>): RequestResult<GetPublicLinkForInviteeApiV1SchedulingPublicLinkIdITokenGetResponses, GetPublicLinkForInviteeApiV1SchedulingPublicLinkIdITokenGetErrors, ThrowOnError> => (options.client ?? client).get<GetPublicLinkForInviteeApiV1SchedulingPublicLinkIdITokenGetResponses, GetPublicLinkForInviteeApiV1SchedulingPublicLinkIdITokenGetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/scheduling/public/{link_id}/i/{token}',
    ...options
});

/**
 * Get Public Link Slots
 */
export const getPublicLinkSlotsApiV1SchedulingPublicLinkIdSlotsGet = <ThrowOnError extends boolean = true>(options: Options<GetPublicLinkSlotsApiV1SchedulingPublicLinkIdSlotsGetData, ThrowOnError>): RequestResult<GetPublicLinkSlotsApiV1SchedulingPublicLinkIdSlotsGetResponses, GetPublicLinkSlotsApiV1SchedulingPublicLinkIdSlotsGetErrors, ThrowOnError> => (options.client ?? client).get<GetPublicLinkSlotsApiV1SchedulingPublicLinkIdSlotsGetResponses, GetPublicLinkSlotsApiV1SchedulingPublicLinkIdSlotsGetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/scheduling/public/{link_id}/slots',
    ...options
});

/**
 * Book Public Slot
 */
export const bookPublicSlotApiV1SchedulingPublicLinkIdBookPost = <ThrowOnError extends boolean = true>(options: Options<BookPublicSlotApiV1SchedulingPublicLinkIdBookPostData, ThrowOnError>): RequestResult<BookPublicSlotApiV1SchedulingPublicLinkIdBookPostResponses, BookPublicSlotApiV1SchedulingPublicLinkIdBookPostErrors, ThrowOnError> => (options.client ?? client).post<BookPublicSlotApiV1SchedulingPublicLinkIdBookPostResponses, BookPublicSlotApiV1SchedulingPublicLinkIdBookPostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/scheduling/public/{link_id}/book',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verify Public Email
 *
 * Advisory, never-blocking email check for the public booking form.
 *
 * Returns a normalized verdict plus an optional "did you mean ...?" typo
 * suggestion. The form surfaces these as an inline hint; it never blocks a
 * booking. Degrades to an unchecked UNKNOWN verdict when ZeroBounce is
 * unavailable.
 */
export const verifyPublicEmailApiV1SchedulingPublicLinkIdVerifyEmailPost = <ThrowOnError extends boolean = true>(options: Options<VerifyPublicEmailApiV1SchedulingPublicLinkIdVerifyEmailPostData, ThrowOnError>): RequestResult<VerifyPublicEmailApiV1SchedulingPublicLinkIdVerifyEmailPostResponses, VerifyPublicEmailApiV1SchedulingPublicLinkIdVerifyEmailPostErrors, ThrowOnError> => (options.client ?? client).post<VerifyPublicEmailApiV1SchedulingPublicLinkIdVerifyEmailPostResponses, VerifyPublicEmailApiV1SchedulingPublicLinkIdVerifyEmailPostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/scheduling/public/{link_id}/verify-email',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Record Availability Lead
 *
 * A visitor connected their calendar for the availability overlay.
 *
 * 404 covers both "no such link" and "overlay off for this owner" so the
 * public surface exposes no flag oracle.
 */
export const recordAvailabilityLeadApiV1SchedulingPublicLinkIdAvailabilityLeadPost = <ThrowOnError extends boolean = true>(options: Options<RecordAvailabilityLeadApiV1SchedulingPublicLinkIdAvailabilityLeadPostData, ThrowOnError>): RequestResult<RecordAvailabilityLeadApiV1SchedulingPublicLinkIdAvailabilityLeadPostResponses, RecordAvailabilityLeadApiV1SchedulingPublicLinkIdAvailabilityLeadPostErrors, ThrowOnError> => (options.client ?? client).post<RecordAvailabilityLeadApiV1SchedulingPublicLinkIdAvailabilityLeadPostResponses, RecordAvailabilityLeadApiV1SchedulingPublicLinkIdAvailabilityLeadPostErrors, ThrowOnError>({
    url: '/api/v1/scheduling/public/{link_id}/availability-lead',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Contact Link Owner
 */
export const contactLinkOwnerApiV1SchedulingPublicLinkIdContactPost = <ThrowOnError extends boolean = true>(options: Options<ContactLinkOwnerApiV1SchedulingPublicLinkIdContactPostData, ThrowOnError>): RequestResult<ContactLinkOwnerApiV1SchedulingPublicLinkIdContactPostResponses, ContactLinkOwnerApiV1SchedulingPublicLinkIdContactPostErrors, ThrowOnError> => (options.client ?? client).post<ContactLinkOwnerApiV1SchedulingPublicLinkIdContactPostResponses, ContactLinkOwnerApiV1SchedulingPublicLinkIdContactPostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/scheduling/public/{link_id}/contact',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Cast Public Poll Votes
 *
 * Record (or replace) an invitee's votes on a POLL scheduling link.
 */
export const castPublicPollVotesApiV1SchedulingPublicLinkIdVotesPost = <ThrowOnError extends boolean = true>(options: Options<CastPublicPollVotesApiV1SchedulingPublicLinkIdVotesPostData, ThrowOnError>): RequestResult<CastPublicPollVotesApiV1SchedulingPublicLinkIdVotesPostResponses, CastPublicPollVotesApiV1SchedulingPublicLinkIdVotesPostErrors, ThrowOnError> => (options.client ?? client).post<CastPublicPollVotesApiV1SchedulingPublicLinkIdVotesPostResponses, CastPublicPollVotesApiV1SchedulingPublicLinkIdVotesPostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/scheduling/public/{link_id}/votes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Link Poll Results
 *
 * Slot-by-slot vote tally for a POLL scheduling link (owner-only).
 */
export const getLinkPollResultsApiV1SchedulingLinksLinkIdPollResultsGet = <ThrowOnError extends boolean = true>(options: Options<GetLinkPollResultsApiV1SchedulingLinksLinkIdPollResultsGetData, ThrowOnError>): RequestResult<GetLinkPollResultsApiV1SchedulingLinksLinkIdPollResultsGetResponses, GetLinkPollResultsApiV1SchedulingLinksLinkIdPollResultsGetErrors, ThrowOnError> => (options.client ?? client).get<GetLinkPollResultsApiV1SchedulingLinksLinkIdPollResultsGetResponses, GetLinkPollResultsApiV1SchedulingLinksLinkIdPollResultsGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/scheduling/links/{link_id}/poll-results',
    ...options
});

/**
 * Finalize Scheduling Poll
 *
 * Pick the winning slot for a POLL link and create the calendar event.
 */
export const finalizeSchedulingPollApiV1SchedulingLinksLinkIdFinalizePost = <ThrowOnError extends boolean = true>(options: Options<FinalizeSchedulingPollApiV1SchedulingLinksLinkIdFinalizePostData, ThrowOnError>): RequestResult<FinalizeSchedulingPollApiV1SchedulingLinksLinkIdFinalizePostResponses, FinalizeSchedulingPollApiV1SchedulingLinksLinkIdFinalizePostErrors, ThrowOnError> => (options.client ?? client).post<FinalizeSchedulingPollApiV1SchedulingLinksLinkIdFinalizePostResponses, FinalizeSchedulingPollApiV1SchedulingLinksLinkIdFinalizePostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/scheduling/links/{link_id}/finalize',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Shortcut Status
 *
 * The user's current key and where replies land.
 */
export const shortcutStatusApiV1ShortcutGet = <ThrowOnError extends boolean = true>(options?: Options<ShortcutStatusApiV1ShortcutGetData, ThrowOnError>): RequestResult<ShortcutStatusApiV1ShortcutGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ShortcutStatusApiV1ShortcutGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/shortcut',
    ...options
});

/**
 * Rotate Key
 *
 * Invalidate the key on every device and issue a new one.
 */
export const rotateKeyApiV1ShortcutKeyRotatePost = <ThrowOnError extends boolean = true>(options?: Options<RotateKeyApiV1ShortcutKeyRotatePostData, ThrowOnError>): RequestResult<RotateKeyApiV1ShortcutKeyRotatePostResponses, unknown, ThrowOnError> => (options?.client ?? client).post<RotateKeyApiV1ShortcutKeyRotatePostResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/shortcut/key/rotate',
    ...options
});

/**
 * Submit Voice Note
 *
 * Transcribe a recording from the Shortcut and hand it to the assistant.
 */
export const submitVoiceNoteApiV1ShortcutVoicePost = <ThrowOnError extends boolean = true>(options: Options<SubmitVoiceNoteApiV1ShortcutVoicePostData, ThrowOnError>): RequestResult<SubmitVoiceNoteApiV1ShortcutVoicePostResponses, SubmitVoiceNoteApiV1ShortcutVoicePostErrors, ThrowOnError> => (options.client ?? client).post<SubmitVoiceNoteApiV1ShortcutVoicePostResponses, SubmitVoiceNoteApiV1ShortcutVoicePostErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/api/v1/shortcut/voice',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Submit Signal
 *
 * The owner's phone posts a named signal.
 *
 * An automation of the owner's own decided when: a geofence, the car's
 * Bluetooth, a charger, an NFC tag, a Focus. Catch sees the name and
 * nothing else. It is remembered, so the assistant knows the automation
 * is wired, and handed to the signal triggers waiting on it. With none
 * waiting it ends here: a signal is not a message and wakes nobody.
 */
export const submitSignalApiV1ShortcutSignalPost = <ThrowOnError extends boolean = true>(options: Options<SubmitSignalApiV1ShortcutSignalPostData, ThrowOnError>): RequestResult<SubmitSignalApiV1ShortcutSignalPostResponses, SubmitSignalApiV1ShortcutSignalPostErrors, ThrowOnError> => (options.client ?? client).post<SubmitSignalApiV1ShortcutSignalPostResponses, SubmitSignalApiV1ShortcutSignalPostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/shortcut/signal',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Submit Location Ping
 *
 * The owner's phone reports arriving at or leaving a named place.
 *
 * The signal ``<transition>:<place>``, as the published Arrive/Leave
 * Shortcuts send it. The phone's own geofence decided; Catch never sees
 * coordinates.
 */
export const submitLocationPingApiV1ShortcutLocationPost = <ThrowOnError extends boolean = true>(options: Options<SubmitLocationPingApiV1ShortcutLocationPostData, ThrowOnError>): RequestResult<SubmitLocationPingApiV1ShortcutLocationPostResponses, SubmitLocationPingApiV1ShortcutLocationPostErrors, ThrowOnError> => (options.client ?? client).post<SubmitLocationPingApiV1ShortcutLocationPostResponses, SubmitLocationPingApiV1ShortcutLocationPostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/shortcut/location',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Pricing
 *
 * Get the current subscription price from Stripe.
 *
 * Public endpoint — no authentication required.
 */
export const getPricingApiV1BillingPricingGet = <ThrowOnError extends boolean = true>(options?: Options<GetPricingApiV1BillingPricingGetData, ThrowOnError>): RequestResult<GetPricingApiV1BillingPricingGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetPricingApiV1BillingPricingGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/billing/pricing',
    ...options
});

/**
 * Get Subscription Status
 *
 * Get the current user's subscription status.
 */
export const getSubscriptionStatusApiV1BillingSubscriptionGet = <ThrowOnError extends boolean = true>(options?: Options<GetSubscriptionStatusApiV1BillingSubscriptionGetData, ThrowOnError>): RequestResult<GetSubscriptionStatusApiV1BillingSubscriptionGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetSubscriptionStatusApiV1BillingSubscriptionGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/billing/subscription',
    ...options
});

/**
 * Checkout
 *
 * Create a Stripe Checkout session for subscribing.
 */
export const checkoutApiV1BillingCheckoutPost = <ThrowOnError extends boolean = true>(options: Options<CheckoutApiV1BillingCheckoutPostData, ThrowOnError>): RequestResult<CheckoutApiV1BillingCheckoutPostResponses, CheckoutApiV1BillingCheckoutPostErrors, ThrowOnError> => (options.client ?? client).post<CheckoutApiV1BillingCheckoutPostResponses, CheckoutApiV1BillingCheckoutPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/billing/checkout',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Purchase Credits
 *
 * The wallet balance and the amounts it can be topped up by.
 */
export const getPurchaseCreditsApiV1BillingPurchaseCreditsGet = <ThrowOnError extends boolean = true>(options?: Options<GetPurchaseCreditsApiV1BillingPurchaseCreditsGetData, ThrowOnError>): RequestResult<GetPurchaseCreditsApiV1BillingPurchaseCreditsGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetPurchaseCreditsApiV1BillingPurchaseCreditsGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/billing/purchase-credits',
    ...options
});

/**
 * Purchase Credits Checkout
 *
 * Create the embedded Checkout session that buys purchase credits.
 *
 * Nothing is credited here — the wallet moves only when Stripe reports the
 * invoice paid. A user who closes the modal mid-payment has therefore changed
 * nothing, and a payment that succeeds credits them even if they never come
 * back to the page.
 */
export const purchaseCreditsCheckoutApiV1BillingPurchaseCreditsCheckoutPost = <ThrowOnError extends boolean = true>(options: Options<PurchaseCreditsCheckoutApiV1BillingPurchaseCreditsCheckoutPostData, ThrowOnError>): RequestResult<PurchaseCreditsCheckoutApiV1BillingPurchaseCreditsCheckoutPostResponses, PurchaseCreditsCheckoutApiV1BillingPurchaseCreditsCheckoutPostErrors, ThrowOnError> => (options.client ?? client).post<PurchaseCreditsCheckoutApiV1BillingPurchaseCreditsCheckoutPostResponses, PurchaseCreditsCheckoutApiV1BillingPurchaseCreditsCheckoutPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/billing/purchase-credits/checkout',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Portal
 *
 * Create a Stripe Customer Portal session for managing subscription.
 *
 * A team-covered user has no personal billing to manage; admins are redirected
 * to their org's portal and everyone else gets a 409 saying so, rather than
 * being handed an empty portal on a freshly minted customer (GET-10264).
 */
export const portalApiV1BillingPortalPost = <ThrowOnError extends boolean = true>(options: Options<PortalApiV1BillingPortalPostData, ThrowOnError>): RequestResult<PortalApiV1BillingPortalPostResponses, PortalApiV1BillingPortalPostErrors, ThrowOnError> => (options.client ?? client).post<PortalApiV1BillingPortalPostResponses, PortalApiV1BillingPortalPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/billing/portal',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Apply Promotion Code
 *
 * Apply a promotion code to the user's existing subscription.
 *
 * Checkout is the only place Stripe lets a code be typed, and the Customer
 * Portal has no equivalent for a live subscription, so this is the path for
 * a code handed to someone already paying. Nothing is written locally: the
 * ``customer.subscription.updated`` webhook records the redemption.
 */
export const applyPromotionCodeApiV1BillingPromotionCodePost = <ThrowOnError extends boolean = true>(options: Options<ApplyPromotionCodeApiV1BillingPromotionCodePostData, ThrowOnError>): RequestResult<ApplyPromotionCodeApiV1BillingPromotionCodePostResponses, ApplyPromotionCodeApiV1BillingPromotionCodePostErrors, ThrowOnError> => (options.client ?? client).post<ApplyPromotionCodeApiV1BillingPromotionCodePostResponses, ApplyPromotionCodeApiV1BillingPromotionCodePostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/billing/promotion-code',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Portal From Signed Link
 *
 * Exchange a signed Catch link for a fresh Stripe portal session.
 *
 * The signed link is sent over chat and may open in a browser without a Catch
 * login cookie, so the short-lived token itself authorizes access to the
 * user's Stripe-hosted portal, including invoices and subscription
 * cancellation. Stripe still owns the portal session and its controls.
 */
export const portalFromSignedLinkApiV1BillingPortalLinkPost = <ThrowOnError extends boolean = true>(options: Options<PortalFromSignedLinkApiV1BillingPortalLinkPostData, ThrowOnError>): RequestResult<PortalFromSignedLinkApiV1BillingPortalLinkPostResponses, PortalFromSignedLinkApiV1BillingPortalLinkPostErrors, ThrowOnError> => (options.client ?? client).post<PortalFromSignedLinkApiV1BillingPortalLinkPostResponses, PortalFromSignedLinkApiV1BillingPortalLinkPostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/billing/portal-link',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Organization Access
 *
 * Team-board availability + caller's org standing (drives the nav entry).
 */
export const getOrganizationAccessApiV1OrganizationAccessGet = <ThrowOnError extends boolean = true>(options?: Options<GetOrganizationAccessApiV1OrganizationAccessGetData, ThrowOnError>): RequestResult<GetOrganizationAccessApiV1OrganizationAccessGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetOrganizationAccessApiV1OrganizationAccessGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organization/access',
    ...options
});

/**
 * Get My Organization
 *
 * The caller's organization card (members and admins alike).
 */
export const getMyOrganizationApiV1OrganizationGet = <ThrowOnError extends boolean = true>(options?: Options<GetMyOrganizationApiV1OrganizationGetData, ThrowOnError>): RequestResult<GetMyOrganizationApiV1OrganizationGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetMyOrganizationApiV1OrganizationGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organization',
    ...options
});

/**
 * Create Organization Endpoint
 *
 * Create a team with the caller as its admin.
 */
export const createOrganizationEndpointApiV1OrganizationPost = <ThrowOnError extends boolean = true>(options: Options<CreateOrganizationEndpointApiV1OrganizationPostData, ThrowOnError>): RequestResult<CreateOrganizationEndpointApiV1OrganizationPostResponses, CreateOrganizationEndpointApiV1OrganizationPostErrors, ThrowOnError> => (options.client ?? client).post<CreateOrganizationEndpointApiV1OrganizationPostResponses, CreateOrganizationEndpointApiV1OrganizationPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organization',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Team Skills
 *
 * The team's live skills and the caller's visible pending changes (read-only).
 *
 * Admins see every pending proposal; other members see their own.
 */
export const getTeamSkillsApiV1OrganizationTeamSkillsGet = <ThrowOnError extends boolean = true>(options?: Options<GetTeamSkillsApiV1OrganizationTeamSkillsGetData, ThrowOnError>): RequestResult<GetTeamSkillsApiV1OrganizationTeamSkillsGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetTeamSkillsApiV1OrganizationTeamSkillsGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organization/team-skills',
    ...options
});

/**
 * Get Members
 *
 * The management view of every member (role, account state, billing).
 */
export const getMembersApiV1OrganizationMembersGet = <ThrowOnError extends boolean = true>(options?: Options<GetMembersApiV1OrganizationMembersGetData, ThrowOnError>): RequestResult<GetMembersApiV1OrganizationMembersGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetMembersApiV1OrganizationMembersGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organization/members',
    ...options
});

/**
 * Get Pending Invites
 */
export const getPendingInvitesApiV1OrganizationInvitesGet = <ThrowOnError extends boolean = true>(options?: Options<GetPendingInvitesApiV1OrganizationInvitesGetData, ThrowOnError>): RequestResult<GetPendingInvitesApiV1OrganizationInvitesGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetPendingInvitesApiV1OrganizationInvitesGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organization/invites',
    ...options
});

/**
 * Create Invites
 *
 * Invite emails to the team; every invite is accepted by the invitee.
 */
export const createInvitesApiV1OrganizationInvitesPost = <ThrowOnError extends boolean = true>(options: Options<CreateInvitesApiV1OrganizationInvitesPostData, ThrowOnError>): RequestResult<CreateInvitesApiV1OrganizationInvitesPostResponses, CreateInvitesApiV1OrganizationInvitesPostErrors, ThrowOnError> => (options.client ?? client).post<CreateInvitesApiV1OrganizationInvitesPostResponses, CreateInvitesApiV1OrganizationInvitesPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organization/invites',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get My Invites
 *
 * Pending team invites addressed to the caller.
 *
 * Auth-only (no board gate): the invite is itself the grant, and the
 * onboarding billing step reads this before the user could qualify any
 * other way.
 */
export const getMyInvitesApiV1OrganizationInvitesMineGet = <ThrowOnError extends boolean = true>(options?: Options<GetMyInvitesApiV1OrganizationInvitesMineGetData, ThrowOnError>): RequestResult<GetMyInvitesApiV1OrganizationInvitesMineGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetMyInvitesApiV1OrganizationInvitesMineGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organization/invites/mine',
    ...options
});

/**
 * Accept Invite Endpoint
 *
 * Join the team that invited you (the consent half of the invite flow).
 *
 * Auth-only (no board gate) so an invitee can accept from anywhere — the
 * Team page or the onboarding billing step; the service only honors invites
 * addressed to the caller's own email.
 */
export const acceptInviteEndpointApiV1OrganizationInvitesInviteIdAcceptPost = <ThrowOnError extends boolean = true>(options: Options<AcceptInviteEndpointApiV1OrganizationInvitesInviteIdAcceptPostData, ThrowOnError>): RequestResult<AcceptInviteEndpointApiV1OrganizationInvitesInviteIdAcceptPostResponses, AcceptInviteEndpointApiV1OrganizationInvitesInviteIdAcceptPostErrors, ThrowOnError> => (options.client ?? client).post<AcceptInviteEndpointApiV1OrganizationInvitesInviteIdAcceptPostResponses, AcceptInviteEndpointApiV1OrganizationInvitesInviteIdAcceptPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organization/invites/{invite_id}/accept',
    ...options
});

/**
 * Decline Invite Endpoint
 *
 * Turn down a team invite. Auth-only, mirroring the accept endpoint.
 */
export const declineInviteEndpointApiV1OrganizationInvitesInviteIdDeclinePost = <ThrowOnError extends boolean = true>(options: Options<DeclineInviteEndpointApiV1OrganizationInvitesInviteIdDeclinePostData, ThrowOnError>): RequestResult<DeclineInviteEndpointApiV1OrganizationInvitesInviteIdDeclinePostResponses, DeclineInviteEndpointApiV1OrganizationInvitesInviteIdDeclinePostErrors, ThrowOnError> => (options.client ?? client).post<DeclineInviteEndpointApiV1OrganizationInvitesInviteIdDeclinePostResponses, DeclineInviteEndpointApiV1OrganizationInvitesInviteIdDeclinePostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organization/invites/{invite_id}/decline',
    ...options
});

/**
 * Leave Organization Endpoint
 *
 * Leave your team; your account returns to individual billing.
 */
export const leaveOrganizationEndpointApiV1OrganizationLeavePost = <ThrowOnError extends boolean = true>(options?: Options<LeaveOrganizationEndpointApiV1OrganizationLeavePostData, ThrowOnError>): RequestResult<LeaveOrganizationEndpointApiV1OrganizationLeavePostResponses, unknown, ThrowOnError> => (options?.client ?? client).post<LeaveOrganizationEndpointApiV1OrganizationLeavePostResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organization/leave',
    ...options
});

/**
 * Decline Auto Join Endpoint
 *
 * Declare that this company directory isn't a company ("it's just me").
 *
 * Auth-only, deliberately: the caller is asking us to stop doing something to
 * their own account, and gating that behind the team board would mean a person
 * the board is closed to could be auto-enrolled with no way to say no.
 *
 * Everything it can affect is the caller's own directory, and it refuses
 * outright once anyone else is on the team (see
 * ``declare_not_an_organization``), so it is never a route to dissolving
 * somebody else's.
 */
export const declineAutoJoinEndpointApiV1OrganizationAutoJoinDeclinePost = <ThrowOnError extends boolean = true>(options?: Options<DeclineAutoJoinEndpointApiV1OrganizationAutoJoinDeclinePostData, ThrowOnError>): RequestResult<DeclineAutoJoinEndpointApiV1OrganizationAutoJoinDeclinePostResponses, unknown, ThrowOnError> => (options?.client ?? client).post<DeclineAutoJoinEndpointApiV1OrganizationAutoJoinDeclinePostResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organization/auto-join/decline',
    ...options
});

/**
 * Revoke Invite Endpoint
 */
export const revokeInviteEndpointApiV1OrganizationInvitesInviteIdDelete = <ThrowOnError extends boolean = true>(options: Options<RevokeInviteEndpointApiV1OrganizationInvitesInviteIdDeleteData, ThrowOnError>): RequestResult<RevokeInviteEndpointApiV1OrganizationInvitesInviteIdDeleteResponses, RevokeInviteEndpointApiV1OrganizationInvitesInviteIdDeleteErrors, ThrowOnError> => (options.client ?? client).delete<RevokeInviteEndpointApiV1OrganizationInvitesInviteIdDeleteResponses, RevokeInviteEndpointApiV1OrganizationInvitesInviteIdDeleteErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organization/invites/{invite_id}',
    ...options
});

/**
 * Get Eligible Users
 *
 * Existing accounts on the org's domain that can be invited in.
 */
export const getEligibleUsersApiV1OrganizationEligibleUsersGet = <ThrowOnError extends boolean = true>(options?: Options<GetEligibleUsersApiV1OrganizationEligibleUsersGetData, ThrowOnError>): RequestResult<GetEligibleUsersApiV1OrganizationEligibleUsersGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetEligibleUsersApiV1OrganizationEligibleUsersGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organization/eligible-users',
    ...options
});

/**
 * Migrate Members
 *
 * Send membership invites to existing same-domain accounts (consent-based).
 */
export const migrateMembersApiV1OrganizationMembersMigratePost = <ThrowOnError extends boolean = true>(options: Options<MigrateMembersApiV1OrganizationMembersMigratePostData, ThrowOnError>): RequestResult<MigrateMembersApiV1OrganizationMembersMigratePostResponses, MigrateMembersApiV1OrganizationMembersMigratePostErrors, ThrowOnError> => (options.client ?? client).post<MigrateMembersApiV1OrganizationMembersMigratePostResponses, MigrateMembersApiV1OrganizationMembersMigratePostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organization/members/migrate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Deactivate Member
 *
 * Close a member's Catch account (org-admin variant of the staff flow).
 */
export const deactivateMemberApiV1OrganizationMembersUserIdDeactivatePost = <ThrowOnError extends boolean = true>(options: Options<DeactivateMemberApiV1OrganizationMembersUserIdDeactivatePostData, ThrowOnError>): RequestResult<DeactivateMemberApiV1OrganizationMembersUserIdDeactivatePostResponses, DeactivateMemberApiV1OrganizationMembersUserIdDeactivatePostErrors, ThrowOnError> => (options.client ?? client).post<DeactivateMemberApiV1OrganizationMembersUserIdDeactivatePostResponses, DeactivateMemberApiV1OrganizationMembersUserIdDeactivatePostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organization/members/{user_id}/deactivate',
    ...options
});

/**
 * Reactivate Member
 *
 * Reopen a deactivated member's account (they re-auth to reconnect).
 */
export const reactivateMemberApiV1OrganizationMembersUserIdReactivatePost = <ThrowOnError extends boolean = true>(options: Options<ReactivateMemberApiV1OrganizationMembersUserIdReactivatePostData, ThrowOnError>): RequestResult<ReactivateMemberApiV1OrganizationMembersUserIdReactivatePostResponses, ReactivateMemberApiV1OrganizationMembersUserIdReactivatePostErrors, ThrowOnError> => (options.client ?? client).post<ReactivateMemberApiV1OrganizationMembersUserIdReactivatePostResponses, ReactivateMemberApiV1OrganizationMembersUserIdReactivatePostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organization/members/{user_id}/reactivate',
    ...options
});

/**
 * Promote Member Endpoint
 *
 * Promote an active member of the caller's team to team admin.
 */
export const promoteMemberEndpointApiV1OrganizationMembersUserIdPromotePost = <ThrowOnError extends boolean = true>(options: Options<PromoteMemberEndpointApiV1OrganizationMembersUserIdPromotePostData, ThrowOnError>): RequestResult<PromoteMemberEndpointApiV1OrganizationMembersUserIdPromotePostResponses, PromoteMemberEndpointApiV1OrganizationMembersUserIdPromotePostErrors, ThrowOnError> => (options.client ?? client).post<PromoteMemberEndpointApiV1OrganizationMembersUserIdPromotePostResponses, PromoteMemberEndpointApiV1OrganizationMembersUserIdPromotePostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organization/members/{user_id}/promote',
    ...options
});

/**
 * Remove Member Endpoint
 *
 * Take a member off the team (their account lives on, individually billed).
 */
export const removeMemberEndpointApiV1OrganizationMembersUserIdDelete = <ThrowOnError extends boolean = true>(options: Options<RemoveMemberEndpointApiV1OrganizationMembersUserIdDeleteData, ThrowOnError>): RequestResult<RemoveMemberEndpointApiV1OrganizationMembersUserIdDeleteResponses, RemoveMemberEndpointApiV1OrganizationMembersUserIdDeleteErrors, ThrowOnError> => (options.client ?? client).delete<RemoveMemberEndpointApiV1OrganizationMembersUserIdDeleteResponses, RemoveMemberEndpointApiV1OrganizationMembersUserIdDeleteErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organization/members/{user_id}',
    ...options
});

/**
 * Get Organization Stats
 *
 * Team-wide totals + per-member usage for the stats section.
 */
export const getOrganizationStatsApiV1OrganizationStatsGet = <ThrowOnError extends boolean = true>(options?: Options<GetOrganizationStatsApiV1OrganizationStatsGetData, ThrowOnError>): RequestResult<GetOrganizationStatsApiV1OrganizationStatsGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetOrganizationStatsApiV1OrganizationStatsGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organization/stats',
    ...options
});

/**
 * Get Redacted Entries
 *
 * The domains and addresses whose mail and meetings are private for this
 * team, each with who added it and when.
 *
 * Admin-only, like every other org-wide setting: the list itself names the
 * counterparties an admin considers sensitive — and, for an address, often
 * someone who asked to be forgotten — which is not something a member needs
 * in order to read a masked inbox.
 */
export const getRedactedEntriesApiV1OrganizationRedactedEntriesGet = <ThrowOnError extends boolean = true>(options?: Options<GetRedactedEntriesApiV1OrganizationRedactedEntriesGetData, ThrowOnError>): RequestResult<GetRedactedEntriesApiV1OrganizationRedactedEntriesGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetRedactedEntriesApiV1OrganizationRedactedEntriesGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organization/redacted-entries',
    ...options
});

/**
 * Add Redacted Entries Endpoint
 *
 * Make domains or addresses private for the whole team.
 *
 * Adds to the list rather than replacing it, so each entry keeps the record
 * of who added it and when; values already there keep their original record.
 * Input is normalized (``@Acme.com`` → ``acme.com``, ``Jane+news@Acme.com``
 * → ``jane@acme.com``) and the request is refused outright if any value is
 * neither a domain nor an address: silently dropping one would leave an
 * admin believing a person was private when nobody was.
 */
export const addRedactedEntriesEndpointApiV1OrganizationRedactedEntriesPost = <ThrowOnError extends boolean = true>(options: Options<AddRedactedEntriesEndpointApiV1OrganizationRedactedEntriesPostData, ThrowOnError>): RequestResult<AddRedactedEntriesEndpointApiV1OrganizationRedactedEntriesPostResponses, AddRedactedEntriesEndpointApiV1OrganizationRedactedEntriesPostErrors, ThrowOnError> => (options.client ?? client).post<AddRedactedEntriesEndpointApiV1OrganizationRedactedEntriesPostResponses, AddRedactedEntriesEndpointApiV1OrganizationRedactedEntriesPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organization/redacted-entries',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Redacted Entry Endpoint
 *
 * Stop keeping one domain or address private.
 */
export const removeRedactedEntryEndpointApiV1OrganizationRedactedEntriesEntryIdDelete = <ThrowOnError extends boolean = true>(options: Options<RemoveRedactedEntryEndpointApiV1OrganizationRedactedEntriesEntryIdDeleteData, ThrowOnError>): RequestResult<RemoveRedactedEntryEndpointApiV1OrganizationRedactedEntriesEntryIdDeleteResponses, RemoveRedactedEntryEndpointApiV1OrganizationRedactedEntriesEntryIdDeleteErrors, ThrowOnError> => (options.client ?? client).delete<RemoveRedactedEntryEndpointApiV1OrganizationRedactedEntriesEntryIdDeleteResponses, RemoveRedactedEntryEndpointApiV1OrganizationRedactedEntriesEntryIdDeleteErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organization/redacted-entries/{entry_id}',
    ...options
});

/**
 * Org Billing Checkout
 *
 * Start the per-seat team subscription.
 *
 * Usually embedded Stripe Checkout. An admin already paying individually
 * instead has their own subscription adopted as the team plan — no Checkout,
 * and the response carries no client secret (the board warned them via
 * ``billing.will_adopt_admin_plan``).
 */
export const orgBillingCheckoutApiV1OrganizationBillingCheckoutPost = <ThrowOnError extends boolean = true>(options: Options<OrgBillingCheckoutApiV1OrganizationBillingCheckoutPostData, ThrowOnError>): RequestResult<OrgBillingCheckoutApiV1OrganizationBillingCheckoutPostResponses, OrgBillingCheckoutApiV1OrganizationBillingCheckoutPostErrors, ThrowOnError> => (options.client ?? client).post<OrgBillingCheckoutApiV1OrganizationBillingCheckoutPostResponses, OrgBillingCheckoutApiV1OrganizationBillingCheckoutPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organization/billing/checkout',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Billing Portal
 *
 * Stripe Customer Portal for the team's card, invoices, and cancellation.
 */
export const orgBillingPortalApiV1OrganizationBillingPortalPost = <ThrowOnError extends boolean = true>(options: Options<OrgBillingPortalApiV1OrganizationBillingPortalPostData, ThrowOnError>): RequestResult<OrgBillingPortalApiV1OrganizationBillingPortalPostResponses, OrgBillingPortalApiV1OrganizationBillingPortalPostErrors, ThrowOnError> => (options.client ?? client).post<OrgBillingPortalApiV1OrganizationBillingPortalPostResponses, OrgBillingPortalApiV1OrganizationBillingPortalPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organization/billing/portal',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Referral Link
 *
 * Return the user's stable referral link (created on first use).
 */
export const getReferralLinkApiV1ReferralLinkGet = <ThrowOnError extends boolean = true>(options?: Options<GetReferralLinkApiV1ReferralLinkGetData, ThrowOnError>): RequestResult<GetReferralLinkApiV1ReferralLinkGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetReferralLinkApiV1ReferralLinkGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/referral/link',
    ...options
});

/**
 * Get Referral Status
 *
 * Return the user's referral standing plus the active reward programme.
 *
 * Backs the in-app referral strip/spotlight progress display ("2 qualifying →
 * $400 hotel credit earned").
 */
export const getReferralStatusApiV1ReferralStatusGet = <ThrowOnError extends boolean = true>(options?: Options<GetReferralStatusApiV1ReferralStatusGetData, ThrowOnError>): RequestResult<GetReferralStatusApiV1ReferralStatusGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetReferralStatusApiV1ReferralStatusGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/referral/status',
    ...options
});

/**
 * Get Suggestions
 *
 * Return the top people to refer, ranked by role then meeting/email frequency.
 *
 * Rate-limited as a backstop on Apollo spend: each cache miss triggers ~10
 * enrichments.
 */
export const getSuggestionsApiV1ReferralSuggestionsGet = <ThrowOnError extends boolean = true>(options?: Options<GetSuggestionsApiV1ReferralSuggestionsGetData, ThrowOnError>): RequestResult<GetSuggestionsApiV1ReferralSuggestionsGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetSuggestionsApiV1ReferralSuggestionsGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/referral/suggestions',
    ...options
});

/**
 * Get Network
 *
 * Return the user's broad referral network for the full referral page.
 *
 * Served from the durable ledger the background scanner accumulates (up to a
 * few hundred contacts per page, ranked by meeting/email frequency, no Apollo
 * enrichment — see ``get_referral_network``), plus the pool/progress counts.
 * Opening the page also kicks the scanner (deduped per 15-min bucket) so the
 * ledger keeps growing toward the user's full network while they work through
 * it. Rate-limited as a coarse abuse backstop only — a client polling this to
 * watch the scan progress should pace itself against the scanner's 15-minute
 * dedup bucket, since nothing it returns can change faster than that.
 */
export const getNetworkApiV1ReferralNetworkGet = <ThrowOnError extends boolean = true>(options?: Options<GetNetworkApiV1ReferralNetworkGetData, ThrowOnError>): RequestResult<GetNetworkApiV1ReferralNetworkGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetNetworkApiV1ReferralNetworkGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/referral/network',
    ...options
});

/**
 * Dismiss Contact
 *
 * Mark a network contact as not relevant so it never resurfaces.
 *
 * Idempotent. Generously rate-limited (it's one cheap insert), but capped so
 * the endpoint can't be used as a write amplifier.
 */
export const dismissContactApiV1ReferralDismissPost = <ThrowOnError extends boolean = true>(options: Options<DismissContactApiV1ReferralDismissPostData, ThrowOnError>): RequestResult<DismissContactApiV1ReferralDismissPostResponses, DismissContactApiV1ReferralDismissPostErrors, ThrowOnError> => (options.client ?? client).post<DismissContactApiV1ReferralDismissPostResponses, DismissContactApiV1ReferralDismissPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/referral/dismiss',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Invite Preview
 *
 * Return the user's editable invite (their override, or the default).
 *
 * The body carries the {name}/{link}/{code} tokens verbatim so the /refer
 * editor shows exactly what will be sent (and personalized) for each recipient.
 * Scoped to ``program`` because the two programmes have different defaults and
 * a saved override only applies to the one it was written for — so the editor
 * shows the ambassador default to a standard-era customiser rather than
 * silently offering them copy that would never be sent.
 */
export const getInvitePreviewApiV1ReferralInvitePreviewGet = <ThrowOnError extends boolean = true>(options?: Options<GetInvitePreviewApiV1ReferralInvitePreviewGetData, ThrowOnError>): RequestResult<GetInvitePreviewApiV1ReferralInvitePreviewGetResponses, GetInvitePreviewApiV1ReferralInvitePreviewGetErrors, ThrowOnError> => (options?.client ?? client).get<GetInvitePreviewApiV1ReferralInvitePreviewGetResponses, GetInvitePreviewApiV1ReferralInvitePreviewGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/referral/invite-preview',
    ...options
});

/**
 * Reset Invite Template
 *
 * Clear the user's override so the invite reverts to the default template.
 */
export const resetInviteTemplateApiV1ReferralInviteTemplateDelete = <ThrowOnError extends boolean = true>(options?: Options<ResetInviteTemplateApiV1ReferralInviteTemplateDeleteData, ThrowOnError>): RequestResult<ResetInviteTemplateApiV1ReferralInviteTemplateDeleteResponses, ResetInviteTemplateApiV1ReferralInviteTemplateDeleteErrors, ThrowOnError> => (options?.client ?? client).delete<ResetInviteTemplateApiV1ReferralInviteTemplateDeleteResponses, ResetInviteTemplateApiV1ReferralInviteTemplateDeleteErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/referral/invite-template',
    ...options
});

/**
 * Save Invite Template
 *
 * Persist the user's custom invite subject + body (with tokens).
 *
 * Tags the override with the programme it was authored under. There is a
 * single slot, so without the tag an ambassador-era body would later go out
 * on a standard send promising the friend $200 they never earn.
 */
export const saveInviteTemplateApiV1ReferralInviteTemplatePut = <ThrowOnError extends boolean = true>(options: Options<SaveInviteTemplateApiV1ReferralInviteTemplatePutData, ThrowOnError>): RequestResult<SaveInviteTemplateApiV1ReferralInviteTemplatePutResponses, SaveInviteTemplateApiV1ReferralInviteTemplatePutErrors, ThrowOnError> => (options.client ?? client).put<SaveInviteTemplateApiV1ReferralInviteTemplatePutResponses, SaveInviteTemplateApiV1ReferralInviteTemplatePutErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/referral/invite-template',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Invites
 *
 * Return the people this user has already invited (newest first).
 *
 * Backs the referral strip's "Invited" sub-section so a sent invite shows a
 * persistent status across reloads instead of resetting to the send button.
 */
export const getInvitesApiV1ReferralInvitesGet = <ThrowOnError extends boolean = true>(options?: Options<GetInvitesApiV1ReferralInvitesGetData, ThrowOnError>): RequestResult<GetInvitesApiV1ReferralInvitesGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetInvitesApiV1ReferralInvitesGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/referral/invites',
    ...options
});

/**
 * Send Invite
 *
 * Email a pre-written personal referral invite from the user's own address.
 *
 * Each call sends an email from the user's mailbox to an arbitrary recipient,
 * so it's governed two ways: a durable **per-user daily cap**
 * (``_MAX_INVITES_PER_DAY``) that paces a large network over multiple sittings
 * to protect the sending mailbox's deliverability, and a coarse per-IP
 * ``@limiter`` backstop against outright abuse.
 */
export const sendInviteApiV1ReferralInvitePost = <ThrowOnError extends boolean = true>(options: Options<SendInviteApiV1ReferralInvitePostData, ThrowOnError>): RequestResult<SendInviteApiV1ReferralInvitePostResponses, SendInviteApiV1ReferralInvitePostErrors, ThrowOnError> => (options.client ?? client).post<SendInviteApiV1ReferralInvitePostResponses, SendInviteApiV1ReferralInvitePostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/referral/invite',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get My Stats
 *
 * Return the authenticated user's assistant activity stats.
 */
export const getMyStatsApiV1StatsMeGet = <ThrowOnError extends boolean = true>(options?: Options<GetMyStatsApiV1StatsMeGetData, ThrowOnError>): RequestResult<GetMyStatsApiV1StatsMeGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetMyStatsApiV1StatsMeGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/stats/me',
    ...options
});

/**
 * Search Hotels
 *
 * Search hotels by city/country.
 */
export const searchHotelsApiV1HotelsSearchGet = <ThrowOnError extends boolean = true>(options: Options<SearchHotelsApiV1HotelsSearchGetData, ThrowOnError>): RequestResult<SearchHotelsApiV1HotelsSearchGetResponses, SearchHotelsApiV1HotelsSearchGetErrors, ThrowOnError> => (options.client ?? client).get<SearchHotelsApiV1HotelsSearchGetResponses, SearchHotelsApiV1HotelsSearchGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/hotels/search',
    ...options
});

/**
 * Get Rate Info
 *
 * Return the cheapest refundable offer for a hotel/date range.
 *
 * Does NOT create a prebook — safe to call on page load.
 */
export const getRateInfoApiV1HotelsRateInfoPost = <ThrowOnError extends boolean = true>(options: Options<GetRateInfoApiV1HotelsRateInfoPostData, ThrowOnError>): RequestResult<GetRateInfoApiV1HotelsRateInfoPostResponses, GetRateInfoApiV1HotelsRateInfoPostErrors, ThrowOnError> => (options.client ?? client).post<GetRateInfoApiV1HotelsRateInfoPostResponses, GetRateInfoApiV1HotelsRateInfoPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/hotels/rate-info',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Prebook
 *
 * Create a prebook with usePaymentSdk=true.
 *
 * Returns the Stripe client_secret the frontend uses to confirm payment.
 * The prebook expires fast (<2 min observed) — confirmPayment + /rates/book
 * must follow quickly.
 */
export const createPrebookApiV1HotelsPrebookPost = <ThrowOnError extends boolean = true>(options: Options<CreatePrebookApiV1HotelsPrebookPostData, ThrowOnError>): RequestResult<CreatePrebookApiV1HotelsPrebookPostResponses, CreatePrebookApiV1HotelsPrebookPostErrors, ThrowOnError> => (options.client ?? client).post<CreatePrebookApiV1HotelsPrebookPostResponses, CreatePrebookApiV1HotelsPrebookPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/hotels/prebook',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Complete Booking
 *
 * Redeem a prebook after Stripe authorizes.
 *
 * DB session lifetime is intentionally NOT a FastAPI dependency here. Per
 * CLAUDE.md the session must not stay open across external calls — and
 * /rates/book is observed at 30–40s typical, up to ~190s with 2014
 * retries. Pattern: auth + idempotency check in one short session →
 * LiteAPI call (no session) → persist in a fresh short session.
 *
 * Idempotency: ``prebook_id`` has a UNIQUE constraint; an F5 on the
 * Stripe-redirect URL re-fires this endpoint and gets back the existing
 * row instead of writing a spurious PREBOOK_FAILED.
 */
export const completeBookingApiV1HotelsCompleteBookingPost = <ThrowOnError extends boolean = true>(options: Options<CompleteBookingApiV1HotelsCompleteBookingPostData, ThrowOnError>): RequestResult<CompleteBookingApiV1HotelsCompleteBookingPostResponses, CompleteBookingApiV1HotelsCompleteBookingPostErrors, ThrowOnError> => (options.client ?? client).post<CompleteBookingApiV1HotelsCompleteBookingPostResponses, CompleteBookingApiV1HotelsCompleteBookingPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/hotels/complete-booking',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Cancel Booking
 *
 * Cancel an existing booking (the user's own, or any if admin).
 */
export const cancelBookingApiV1HotelsCancelBookingPkPost = <ThrowOnError extends boolean = true>(options: Options<CancelBookingApiV1HotelsCancelBookingPkPostData, ThrowOnError>): RequestResult<CancelBookingApiV1HotelsCancelBookingPkPostResponses, CancelBookingApiV1HotelsCancelBookingPkPostErrors, ThrowOnError> => (options.client ?? client).post<CancelBookingApiV1HotelsCancelBookingPkPostResponses, CancelBookingApiV1HotelsCancelBookingPkPostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/hotels/cancel/{booking_pk}',
    ...options
});

/**
 * List My Bookings
 *
 * List the current user's hotel bookings (most recent first).
 */
export const listMyBookingsApiV1HotelsBookingsGet = <ThrowOnError extends boolean = true>(options?: Options<ListMyBookingsApiV1HotelsBookingsGetData, ThrowOnError>): RequestResult<ListMyBookingsApiV1HotelsBookingsGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListMyBookingsApiV1HotelsBookingsGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/hotels/bookings',
    ...options
});

/**
 * Admin Test Full Cycle
 *
 * Admin-only: run search → cheapest-refundable → prebook with usePaymentSdk=true.
 *
 * Stops short of /rates/book (which would require a real Stripe charge).
 * Used by the backoffice playground to validate the upstream flow against
 * LiteAPI without touching real money.
 *
 * Returns the rate-info + prebook payload so the operator can either:
 * - Eyeball that everything looks right, or
 * - Take the secret_key into the frontend modal at /book-hotel to test the
 * full Stripe-deferred-mode flow on a tiny refundable rate.
 */
export const adminTestFullCycleApiV1HotelsTestFullCyclePost = <ThrowOnError extends boolean = true>(options: Options<AdminTestFullCycleApiV1HotelsTestFullCyclePostData, ThrowOnError>): RequestResult<AdminTestFullCycleApiV1HotelsTestFullCyclePostResponses, AdminTestFullCycleApiV1HotelsTestFullCyclePostErrors, ThrowOnError> => (options.client ?? client).post<AdminTestFullCycleApiV1HotelsTestFullCyclePostResponses, AdminTestFullCycleApiV1HotelsTestFullCyclePostErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/hotels/test/full-cycle',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Stay Options
 *
 * Return the proposed options for the public map page.
 */
export const getStayOptionsApiV1StaysOptionsTokenGet = <ThrowOnError extends boolean = true>(options: Options<GetStayOptionsApiV1StaysOptionsTokenGetData, ThrowOnError>): RequestResult<GetStayOptionsApiV1StaysOptionsTokenGetResponses, GetStayOptionsApiV1StaysOptionsTokenGetErrors, ThrowOnError> => (options.client ?? client).get<GetStayOptionsApiV1StaysOptionsTokenGetResponses, GetStayOptionsApiV1StaysOptionsTokenGetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/stays/options/{token}',
    ...options
});

/**
 * Select Stay Option
 *
 * Record the user's pick and hand back to the assistant on its channel.
 */
export const selectStayOptionApiV1StaysOptionsTokenSelectPost = <ThrowOnError extends boolean = true>(options: Options<SelectStayOptionApiV1StaysOptionsTokenSelectPostData, ThrowOnError>): RequestResult<SelectStayOptionApiV1StaysOptionsTokenSelectPostResponses, SelectStayOptionApiV1StaysOptionsTokenSelectPostErrors, ThrowOnError> => (options.client ?? client).post<SelectStayOptionApiV1StaysOptionsTokenSelectPostResponses, SelectStayOptionApiV1StaysOptionsTokenSelectPostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/stays/options/{token}/select',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Flight Options
 *
 * Return the proposed options for the public flights page.
 */
export const getFlightOptionsApiV1FlightsOptionsTokenGet = <ThrowOnError extends boolean = true>(options: Options<GetFlightOptionsApiV1FlightsOptionsTokenGetData, ThrowOnError>): RequestResult<GetFlightOptionsApiV1FlightsOptionsTokenGetResponses, GetFlightOptionsApiV1FlightsOptionsTokenGetErrors, ThrowOnError> => (options.client ?? client).get<GetFlightOptionsApiV1FlightsOptionsTokenGetResponses, GetFlightOptionsApiV1FlightsOptionsTokenGetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/flights/options/{token}',
    ...options
});

/**
 * Select Flight Option
 *
 * Record the user's pick and hand back to the assistant on its channel.
 */
export const selectFlightOptionApiV1FlightsOptionsTokenSelectPost = <ThrowOnError extends boolean = true>(options: Options<SelectFlightOptionApiV1FlightsOptionsTokenSelectPostData, ThrowOnError>): RequestResult<SelectFlightOptionApiV1FlightsOptionsTokenSelectPostResponses, SelectFlightOptionApiV1FlightsOptionsTokenSelectPostErrors, ThrowOnError> => (options.client ?? client).post<SelectFlightOptionApiV1FlightsOptionsTokenSelectPostResponses, SelectFlightOptionApiV1FlightsOptionsTokenSelectPostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/flights/options/{token}/select',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Trips
 *
 * Return every display-safe flight and stay authorized by a private link.
 */
export const getTripsApiV1TripsTokenGet = <ThrowOnError extends boolean = true>(options: Options<GetTripsApiV1TripsTokenGetData, ThrowOnError>): RequestResult<GetTripsApiV1TripsTokenGetResponses, GetTripsApiV1TripsTokenGetErrors, ThrowOnError> => (options.client ?? client).get<GetTripsApiV1TripsTokenGetResponses, GetTripsApiV1TripsTokenGetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/trips/{token}',
    ...options
});

/**
 * List My Views
 *
 * List the signed-in user's pages: the default ones, then the newest first.
 *
 * ``q`` keeps only pages whose title holds every word in it.
 */
export const listMyViewsApiV1ViewsGet = <ThrowOnError extends boolean = true>(options?: Options<ListMyViewsApiV1ViewsGetData, ThrowOnError>): RequestResult<ListMyViewsApiV1ViewsGetResponses, ListMyViewsApiV1ViewsGetErrors, ThrowOnError> => (options?.client ?? client).get<ListMyViewsApiV1ViewsGetResponses, ListMyViewsApiV1ViewsGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/views',
    ...options
});

/**
 * Get My View
 *
 * Return one of the signed-in user's views with its sources resolved now.
 *
 * With ``fresh`` (the default) the snippet sources that are due run again
 * before the page returns; a snippet rests for a while after each run.
 * ``force`` (the owner pressing Refresh) runs them without that rest. Without
 * ``fresh`` they come from their last saved run at once, so the page can show
 * that while it asks for fresh data.
 */
export const getMyViewApiV1ViewsViewIdGet = <ThrowOnError extends boolean = true>(options: Options<GetMyViewApiV1ViewsViewIdGetData, ThrowOnError>): RequestResult<GetMyViewApiV1ViewsViewIdGetResponses, GetMyViewApiV1ViewsViewIdGetErrors, ThrowOnError> => (options.client ?? client).get<GetMyViewApiV1ViewsViewIdGetResponses, GetMyViewApiV1ViewsViewIdGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/views/{view_id}',
    ...options
});

/**
 * Stripe Webhook
 *
 * Handle incoming Stripe webhook events.
 *
 * Verifies the event signature, then dispatches to the appropriate handler.
 * No auth required — uses Stripe signature verification instead.
 */
export const stripeWebhookApiV1StripeWebhookPost = <ThrowOnError extends boolean = true>(options?: Options<StripeWebhookApiV1StripeWebhookPostData, ThrowOnError>): RequestResult<StripeWebhookApiV1StripeWebhookPostResponses, unknown, ThrowOnError> => (options?.client ?? client).post<StripeWebhookApiV1StripeWebhookPostResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/stripe/webhook',
    ...options
});

/**
 * Get Vault Secret Request
 *
 * Return the fields a vault entry form should collect. Auth is the token.
 */
export const getVaultSecretRequestApiV1VaultSecretRequestTokenGet = <ThrowOnError extends boolean = true>(options: Options<GetVaultSecretRequestApiV1VaultSecretRequestTokenGetData, ThrowOnError>): RequestResult<GetVaultSecretRequestApiV1VaultSecretRequestTokenGetResponses, GetVaultSecretRequestApiV1VaultSecretRequestTokenGetErrors, ThrowOnError> => (options.client ?? client).get<GetVaultSecretRequestApiV1VaultSecretRequestTokenGetResponses, GetVaultSecretRequestApiV1VaultSecretRequestTokenGetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/vault/secret-request/{token}',
    ...options
});

/**
 * Submit Vault Secrets
 *
 * Consume a magic-link token and persist the user-entered vault values.
 */
export const submitVaultSecretsApiV1VaultSecretsPost = <ThrowOnError extends boolean = true>(options: Options<SubmitVaultSecretsApiV1VaultSecretsPostData, ThrowOnError>): RequestResult<SubmitVaultSecretsApiV1VaultSecretsPostResponses, SubmitVaultSecretsApiV1VaultSecretsPostErrors, ThrowOnError> => (options.client ?? client).post<SubmitVaultSecretsApiV1VaultSecretsPostResponses, SubmitVaultSecretsApiV1VaultSecretsPostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/vault/secrets',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Brex Webhook
 *
 * Handle ``EXPENSE_PAYMENT_UPDATED`` to settle a web purchase.
 */
export const brexWebhookApiV1BrexWebhookPost = <ThrowOnError extends boolean = true>(options?: Options<BrexWebhookApiV1BrexWebhookPostData, ThrowOnError>): RequestResult<BrexWebhookApiV1BrexWebhookPostResponses, BrexWebhookApiV1BrexWebhookPostErrors, ThrowOnError> => (options?.client ?? client).post<BrexWebhookApiV1BrexWebhookPostResponses, BrexWebhookApiV1BrexWebhookPostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/brex/webhook',
    ...options
});

/**
 * Airwallex Webhook
 *
 * Handle ``issuing.transaction.succeeded`` to settle a purchase.
 */
export const airwallexWebhookApiV1AirwallexWebhookPost = <ThrowOnError extends boolean = true>(options?: Options<AirwallexWebhookApiV1AirwallexWebhookPostData, ThrowOnError>): RequestResult<AirwallexWebhookApiV1AirwallexWebhookPostResponses, AirwallexWebhookApiV1AirwallexWebhookPostErrors, ThrowOnError> => (options?.client ?? client).post<AirwallexWebhookApiV1AirwallexWebhookPostResponses, AirwallexWebhookApiV1AirwallexWebhookPostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/airwallex/webhook',
    ...options
});

/**
 * Duffel Webhook
 *
 * Handle a Duffel webhook delivery.
 *
 * Verifies the signature, then processes airline-initiated changes. Other
 * event types are acknowledged (200) and ignored.
 */
export const duffelWebhookApiV1DuffelWebhookPost = <ThrowOnError extends boolean = true>(options?: Options<DuffelWebhookApiV1DuffelWebhookPostData, ThrowOnError>): RequestResult<DuffelWebhookApiV1DuffelWebhookPostResponses, DuffelWebhookApiV1DuffelWebhookPostErrors, ThrowOnError> => (options?.client ?? client).post<DuffelWebhookApiV1DuffelWebhookPostResponses, DuffelWebhookApiV1DuffelWebhookPostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/duffel/webhook',
    ...options
});

/**
 * Apollo Phone Webhook
 *
 * Receive a completed phone reveal and route it to the user who asked.
 *
 * Returns 200 for every authenticated delivery, including ones it cannot use.
 * Apollo retries non-2xx responses, and none of the "cannot use" cases get
 * better on a retry — an expired correlation record and an unreadable envelope
 * are both permanent. Only a genuine delivery failure is worth a retry, so only
 * that raises.
 */
export const apolloPhoneWebhookApiV1ApolloWebhookPost = <ThrowOnError extends boolean = true>(options?: Options<ApolloPhoneWebhookApiV1ApolloWebhookPostData, ThrowOnError>): RequestResult<ApolloPhoneWebhookApiV1ApolloWebhookPostResponses, ApolloPhoneWebhookApiV1ApolloWebhookPostErrors, ThrowOnError> => (options?.client ?? client).post<ApolloPhoneWebhookApiV1ApolloWebhookPostResponses, ApolloPhoneWebhookApiV1ApolloWebhookPostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/apollo/webhook',
    ...options
});

/**
 * Verify Meta Webhook
 *
 * Meta webhook handshake — echo the challenge when the verify token matches.
 */
export const verifyMetaWebhookApiV1MetaLeadsWebhookGet = <ThrowOnError extends boolean = true>(options?: Options<VerifyMetaWebhookApiV1MetaLeadsWebhookGetData, ThrowOnError>): RequestResult<VerifyMetaWebhookApiV1MetaLeadsWebhookGetResponses, VerifyMetaWebhookApiV1MetaLeadsWebhookGetErrors, ThrowOnError> => (options?.client ?? client).get<VerifyMetaWebhookApiV1MetaLeadsWebhookGetResponses, VerifyMetaWebhookApiV1MetaLeadsWebhookGetErrors, ThrowOnError>({
    responseType: 'text',
    url: '/api/v1/meta/leads/webhook',
    ...options
});

/**
 * Receive Meta Lead
 *
 * Receive a Meta ``leadgen`` webhook, verify it, and enqueue ingestion.
 *
 * Returns 200 immediately; the Graph API fetch + drafting happen in a workflow.
 */
export const receiveMetaLeadApiV1MetaLeadsWebhookPost = <ThrowOnError extends boolean = true>(options?: Options<ReceiveMetaLeadApiV1MetaLeadsWebhookPostData, ThrowOnError>): RequestResult<ReceiveMetaLeadApiV1MetaLeadsWebhookPostResponses, unknown, ThrowOnError> => (options?.client ?? client).post<ReceiveMetaLeadApiV1MetaLeadsWebhookPostResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/meta/leads/webhook',
    ...options
});

/**
 * Handle Ses Event
 *
 * Handle SES event notifications delivered via SNS.
 */
export const handleSesEventApiV1WebhooksSesEventsPost = <ThrowOnError extends boolean = true>(options?: Options<HandleSesEventApiV1WebhooksSesEventsPostData, ThrowOnError>): RequestResult<HandleSesEventApiV1WebhooksSesEventsPostResponses, unknown, ThrowOnError> => (options?.client ?? client).post<HandleSesEventApiV1WebhooksSesEventsPostResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/webhooks/ses-events',
    ...options
});

/**
 * Handle Inbound Email
 *
 * Receive an SES inbound-email notification via SNS.
 */
export const handleInboundEmailApiV1WebhooksInboundEmailPost = <ThrowOnError extends boolean = true>(options?: Options<HandleInboundEmailApiV1WebhooksInboundEmailPostData, ThrowOnError>): RequestResult<HandleInboundEmailApiV1WebhooksInboundEmailPostResponses, unknown, ThrowOnError> => (options?.client ?? client).post<HandleInboundEmailApiV1WebhooksInboundEmailPostResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/webhooks/inbound-email',
    ...options
});

/**
 * Root
 */
export const rootGet = <ThrowOnError extends boolean = true>(options?: Options<RootGetData, ThrowOnError>): RequestResult<RootGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<RootGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/',
    ...options
});
